import { clubPath, clubUrl } from '../clubhouse';
import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { SocietePortalPanel, SocieteGuestHint } from '../components/portal/SocietePortalPanel';
import { SocieteGuestsForm, PartnerChips, FavoriteStar } from '../components/portal/SocieteGuestsForm';
import ReactDOM from 'react-dom';
import { createPortal } from 'react-dom';
import { format, parseISO, startOfWeek, endOfWeek, addWeeks, subWeeks, addDays, isSameDay, isToday, isBefore } from 'date-fns';
import { fr } from 'date-fns/locale';
import { useSearchParams } from 'react-router-dom';
import { 
  Calendar, Clock, User, ChevronLeft, ChevronRight, LogOut,
  CheckCircle2, XCircle, AlertCircle, Users, CalendarDays,
  Home, Newspaper, History, Menu, X, MapPin, Euro, Loader2, CreditCard, UserPlus, Link2, Unlink, Lock, BookOpen, Check, Send, FileText, FileSignature, Download, Trophy, Globe, ShoppingBag, Package, RefreshCw, Bell, BellOff, Smartphone, Share, MoreVertical, Plus, Sun, Cloud, CloudRain, CloudSun, Snowflake, Zap, Gauge, Mail, Eye, Flag, Truck, Search, Pencil, UtensilsCrossed, Wallet, Shield, Phone, ChevronDown, ArrowLeftRight, Image as ImageIcon, Edit3, DollarSign, Building2, Sparkles, Gift, Receipt, Play
} from 'lucide-react';
import { toast } from 'sonner';
import CoursListCalendar from '../components/shared/CoursListCalendar';
import FeaturedDealsCarousel from '../components/shared/FeaturedDealsCarousel';
import { PromoPopup } from '../components/shared/PromoPopup';
import GolfSchoolPortal from './GolfSchoolPortal';
import PortalWalletWidget from './portal/PortalWalletWidget';
// iter313 — Section Practice (jetons + QR + achat) — désormais intégrée dans l'onglet Boutique
import PortalPracticeTab from './portal/PortalPracticeTab';
// iter314 — Boutons Apple/Google Wallet pour le QR Practice
import WalletButtonsPractice from './portal/WalletButtonsPractice';
// iter316.55 — Onglet Jouer (scorecard + leaderboard)
import PortalScorecardTab from './portal/PortalScorecardTab';
// iter313.3 — QR code pour l'affichage inline dans Boutique + Mon Compte
import { QRCodeSVG } from 'qrcode.react';
import ClientPortalContracts from '../components/contracts/ClientPortalContracts';
import SponsorRewardsPanel from '../components/contracts/SponsorRewardsPanel';
import CotisationCallCard from '../components/portal/CotisationCallCard';
import { AccountPayChoice, splitAccount, payLabel } from '../components/portal/AccountPayChoice';
import { WalletTopupCard } from '../components/portal/WalletTopupCard';
import { GiftCardActivateCard } from '../components/portal/GiftCardActivateCard';
import { BalancesRecapCard } from '../components/portal/BalancesRecapCard';
import { IndivSlotCard, IndivWeekChip } from '../components/portal/IndivSlotCard';
import CancelTeeTimeDialog from '../components/portal/CancelTeeTimeDialog';
import RescheduleTeeTime from '../components/portal/RescheduleTeeTime';
import { FavoritePartnersCard } from '../components/portal/FavoritePartnersCard';
import { PortalPrivacyCard } from '../components/portal/PortalPrivacyCard';
import { UpcomingCard } from '../components/portal/UpcomingCard';
import { SlotPromoBadge } from '../components/portal/SlotPromoBadge';

// Invitations réellement offertes sur le créneau : règle société (joueurs restants ET invités restants, flight BIRDY) moins le représentant s'il joue aussi
const offeredGuestsFor = (p, repAlsoPlays) => {
  if (!p || !p.invitation) return 0;
  const repCounts = repAlsoPlays && !(p.rep_slot_times || []).length ? 1 : 0;
  return Math.max(0, Math.min(p.remaining_guests ?? 0, p.remaining ?? 0) - repCounts);
};
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Badge } from '../components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import usePushNotifications from '../hooks/usePushNotifications';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { ScrollArea } from '../components/ui/scroll-area';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../components/ui/dialog';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '../components/ui/sheet';
import { Skeleton } from '../components/ui/skeleton';
import { EventGallery } from '../components/EventGallery';
import { PortalPdfViewer } from '../components/PortalPdfViewer';
import { Calendar as CalendarPicker } from '../components/ui/calendar';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../components/ui/popover';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import { cartIsMemberRate, cartUnitPrice } from '../utils/cartPricing';
import { fittingPortalStatus } from '../components/taylormade/portalStatus';
import { usePortalTracking, useTrackPortalItem, trackPortalItem } from '../hooks/usePortalTracking';
import { useSwipe } from '../hooks/useSwipe';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Couverture compétition : URL (/api/public/competitions/{id}/cover), data-URL ou base64 brut
export const resolveCoverSrc = (cover) => {
  if (!cover) return '';
  if (cover.startsWith('data:') || cover.startsWith('http')) return cover;
  if (cover.startsWith('/api/')) return `${API_URL}${cover}`;
  return `data:image/jpeg;base64,${cover}`;
};

// Helper pour appels authentifiés avec refresh automatique
const authenticatedFetch = async (url, options = {}) => {
  let token = localStorage.getItem('client_portal_token');
  
  const makeRequest = async (authToken) => {
    const headers = { ...options.headers };
    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    }
    return fetch(url, { ...options, headers });
  };
  
  let res = await makeRequest(token);
  
  // Si 401, essayer de rafraîchir le token
  if (res.status === 401) {
    const refreshToken = localStorage.getItem('client_portal_refresh_token');
    if (refreshToken) {
      try {
        const refreshRes = await fetch(`${API_URL}/api/client-portal/auth/refresh`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refresh_token: refreshToken })
        });
        
        if (refreshRes.ok) {
          const data = await refreshRes.json();
          localStorage.setItem('client_portal_token', data.access_token);
          if (data.refresh_token) {
            localStorage.setItem('client_portal_refresh_token', data.refresh_token);
          }
          // Réessayer avec le nouveau token
          res = await makeRequest(data.access_token);
        }
      } catch (e) {
        console.warn('Refresh token failed:', e);
      }
    }
  }
  
  return res;
};

// Wrapper pour simplifier les appels avec token - utilise authenticatedFetch automatiquement
const fetchWithToken = (url, token, options = {}) => {
  // Ignorer le token passé en paramètre, utiliser celui du localStorage via authenticatedFetch
  return authenticatedFetch(url, options);
};

// API pour le portail client
const clientPortalApi = {
  // Charger les paramètres du portail publiquement (pour afficher le logo sur la page de login)
  getPublicSettings: async () => {
    try {
      const res = await authenticatedFetch(`${API_URL}/api/client-portal/public-settings`);
      if (!res.ok) return null;
      return res.json();
    } catch (e) {
      return null;
    }
  },
  
  login: async (email, password, client_id = null) => {
    let res;
    const body = { email, password };
    if (client_id) body.client_id = client_id;
    try {
      res = await fetch(`${API_URL}/api/client-portal/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
    } catch (e) {
      console.error('Network error:', e);
      throw new Error('Erreur de connexion au serveur');
    }
    
    // Si la réponse est OK, on parse le JSON et on retourne
    if (res.ok) {
      try {
        return await res.json();
      } catch (e) {
        throw new Error('Réponse invalide du serveur');
      }
    }
    
    // Pour les erreurs HTTP (401, 422, etc.), essayer de lire le message
    let errorMessage = 'Email ou mot de passe incorrect';
    try {
      const errorData = await res.json();
      if (errorData.detail) {
        errorMessage = errorData.detail;
      }
    } catch (e) {
      // Si on ne peut pas lire le JSON, utiliser le message par défaut
      // basé sur le status code
      if (res.status === 401) {
        errorMessage = 'Email ou mot de passe incorrect';
      } else if (res.status === 403) {
        errorMessage = 'Compte désactivé';
      } else {
        errorMessage = `Erreur serveur (${res.status})`;
      }
    }
    throw new Error(errorMessage);
  },
  
  getProfile: async (token) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/me`);
    if (!res.ok) throw new Error('Non authentifié');
    return res.json();
  },

  updateProfile: async (token, data) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/profile`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.detail || 'Erreur lors de la mise à jour');
    }
    return res.json();
  },
  
  getSessions: async (token, startDate, endDate) => {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/sessions?${params}`);
    if (!res.ok) throw new Error('Erreur lors du chargement');
    return res.json();
  },
  
  getMyRegistrations: async (token) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/my-registrations?include_family=false`);
    if (!res.ok) throw new Error('Erreur lors du chargement');
    return res.json();
  },

  getRegistrationsHistory: async (token) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/registrations/history`);
    if (!res.ok) throw new Error('Erreur lors du chargement');
    return res.json();
  },

  getPaymentHistory: async (token) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/payment-history`);
    if (!res.ok) throw new Error('Erreur lors du chargement');
    return res.json();
  },

  getNews: async (token) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/news`);
    if (!res.ok) return []; // Silently fail if no news endpoint
    return res.json();
  },
  
  // Paramètres du portail (pour les champs visibles)
  getPortalSettings: async (token) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/settings`);
    if (!res.ok) return null; // Silently fail
    return res.json();
  },
  
  // Compétitions ouvertes aux inscriptions
  getCompetitions: async (token) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/competitions`);
    if (!res.ok) return { competitions: [], client_is_member: false };
    return res.json();
  },
  
  // Récupérer les participants d'une compétition
  getCompetitionParticipants: async (token, competitionId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/competitions/${competitionId}/participants`);
    if (!res.ok) return { participants: [] };
    return res.json();
  },
  
  // Inscription à une compétition (avec accompagnants pour afterworks gratuits)
  registerCompetition: async (token, competitionId, payload = {}) => {
    const body = typeof payload === 'string'
      ? { notes: payload }
      : {
          notes: payload.notes || '',
          partner_name: payload.partner_name || '',
          guests_count: payload.guests_count || 0,
          guest_client_ids: payload.guest_client_ids || [],
          custom_options_selected: payload.custom_options_selected || [],
        };
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/competitions/${competitionId}/register`, {
      method: 'POST',
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.detail || 'Erreur lors de l\'inscription');
    }
    return res.json();
  },

  // Recherche d'accompagnants pour afterwork gratuit
  searchGuestsForCompetition: async (token, competitionId, query) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/competitions/${competitionId}/guests/search?q=${encodeURIComponent(query)}`);
    if (!res.ok) return [];
    return res.json();
  },
  
  // Créer une session de paiement Stripe pour une compétition
  createCompetitionPaymentSession: async (token, competitionId, { partnerId = '', payForPartner = false, notes = '', newClient = null, custom_options_selected = [], useAccount = true } = {}) => {
    const body = { use_account: !!useAccount };
    if (partnerId) body.partner_id = partnerId;
    if (payForPartner) body.pay_for_partner = true;
    if (notes) body.notes = notes;
    if (newClient) body.new_client = newClient;
    if (custom_options_selected.length > 0) body.custom_options_selected = custom_options_selected;
    
    const res = await fetch(`${API_URL}/api/competitions/${competitionId}/payment/create-session`, {
      method: 'POST',
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    const resClone = res.clone();
    try {
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.detail || 'Erreur lors de la création du paiement');
      }
      return data;
    } catch (e) {
      if (e.message && !e.message.includes('JSON')) {
        throw e;
      }
      const text = await resClone.text();
      console.error('[CompetitionPayment] Response:', text);
      throw new Error("Erreur lors du traitement de la réponse");
    }
  },
  
  // Rechercher un partenaire pour compétition double
  searchPartner: async (token, competitionId, query) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/competitions/search-partner?competition_id=${competitionId}&query=${encodeURIComponent(query)}`);
    if (!res.ok) return { results: [] };
    return res.json();
  },
  
  // Payer sa propre inscription (pour partenaire inscrit avec awaiting_payment)
  payMyRegistration: async (token, competitionId, useAccount = true) => {
    const res = await fetch(`${API_URL}/api/competitions/${competitionId}/payment/pay-my-registration`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ use_account: !!useAccount })
    });
    const resClone = res.clone();
    try {
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Erreur');
      return data;
    } catch (e) {
      if (e.message && !e.message.includes('JSON') && !e.message.includes('body stream')) throw e;
      const text = await resClone.text();
      console.error('[payMyRegistration] Response:', text);
      throw new Error('Erreur lors du paiement');
    }
  },
  
  // Annuler inscription à une compétition
  cancelCompetitionRegistration: async (token, competitionId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/competitions/${competitionId}/register`, {
      method: 'DELETE'
    });
    const resClone = res.clone();
    try {
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Erreur lors de l\'annulation');
      return data;
    } catch (e) {
      if (e.message && !e.message.includes('JSON') && !e.message.includes('body stream')) throw e;
      const text = await resClone.text();
      console.error('[cancelCompetition] Response:', text);
      throw new Error('Erreur lors de l\'annulation');
    }
  },
  
  // ========== STAGES PORTAIL ==========
  getStages: async (token) => {
    const res = await authenticatedFetch(`${API_URL}/api/portal/stages`);
    if (!res.ok) return { stages: [], client_is_member: false };
    return res.json();
  },
  
  // Créer une session de paiement pour un stage (gère gratuit vs payant)
  createStagePaymentSession: async (token, stageId, useAccount = true) => {
    console.log('[StagePayment] Creating payment session for stage:', stageId);
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/stages/${stageId}/payment/create-session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ use_account: !!useAccount })
    });
    console.log('[StagePayment] Response status:', res.status);
    const resClone = res.clone();
    try {
      const data = await res.json();
      console.log('[StagePayment] Parsed data:', data);
      if (!res.ok) {
        throw new Error(data.detail || "Erreur lors de la création du paiement");
      }
      return data;
    } catch (e) {
      if (e.message && !e.message.includes('JSON') && !e.message.includes('body stream')) {
        throw e;
      }
      console.error('[StagePayment] Parse error:', e);
      const text = await resClone.text();
      console.error('[StagePayment] Response:', text);
      throw new Error("Erreur lors du traitement de la réponse");
    }
  },
  
  registerStage: async (token, stageId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/stages/${stageId}/register`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json'
      }
    });
    const resClone = res.clone();
    try {
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.detail || "Erreur lors de l'inscription");
      }
      return data;
    } catch (e) {
      if (e.message && !e.message.includes('JSON') && !e.message.includes('body stream')) throw e;
      const text = await resClone.text();
      console.error('[registerStage] Response:', text);
      throw new Error("Erreur lors de l'inscription");
    }
  },
  
  cancelStageRegistration: async (token, stageId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/stages/${stageId}/register`, {
      method: 'DELETE'
    });
    const resClone = res.clone();
    try {
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.detail || "Erreur lors de l'annulation");
      }
      return data;
    } catch (e) {
      if (e.message && !e.message.includes('JSON') && !e.message.includes('body stream')) throw e;
      const text = await resClone.text();
      console.error('[cancelStageRegistration] Response:', text);
      throw new Error("Erreur lors de l'annulation");
    }
  },
  
  // ========== FITTING ORDERS (Taylor Made) ==========
  getFittingOrders: async (token) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/fitting-orders`);
    if (!res.ok) throw new Error('Erreur lors du chargement des commandes');
    return res.json();
  },
  
  validateFittingOrder: async (token, orderId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/fitting-orders/${orderId}/validate`, {
      method: 'PUT',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.detail || 'Erreur lors de la validation');
    }
    return data;
  },
  
  createFittingOrderPayment: async (token, orderId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/fitting-orders/${orderId}/create-payment`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const resClone = res.clone();
    try {
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.detail || 'Erreur lors de la création du paiement');
      }
      return data;
    } catch (e) {
      console.error('[FittingPayment] Error:', e);
      const text = await resClone.text();
      console.error('[FittingPayment] Response:', text);
      throw new Error('Erreur lors du traitement de la réponse');
    }
  },
  
  getFittingOrderPaymentStatus: async (token, orderId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/fitting-orders/${orderId}/payment-status`);
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Erreur lors de la vérification du paiement');
    return data;
  },
  
  // ========== PAIEMENT COTISATION ==========
  getSubscriptionPrices: async (token) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/subscription/prices`);
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Erreur lors du chargement des tarifs');
    return data;
  },
  
  createSubscriptionPayment: async (token, cotisationType = null) => {
    console.log('[Subscription] Creating payment for type:', cotisationType);
    const params = cotisationType ? `?cotisation_type=${encodeURIComponent(cotisationType)}` : '';
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/subscription/create-payment${params}`, {
      method: 'POST',
      headers: { 
        'Authorization': `Bearer ${token}`
      }
    });
    console.log('[Subscription] Response status:', res.status);
    const resClone = res.clone();
    try {
      const data = await res.json();
      console.log('[Subscription] Parsed data:', data);
      if (!res.ok) throw new Error(data.detail || 'Erreur lors de la création du paiement');
      return data;
    } catch (e) {
      console.error('[Subscription] Error:', e);
      const text = await resClone.text();
      console.error('[Subscription] Response:', text);
      throw new Error('Erreur lors du traitement de la réponse');
    }
  },
  
  getSubscriptionPaymentStatus: async (token, transactionId, sessionId = null) => {
    let url = `${API_URL}/api/client-portal/subscription/payment-status/${transactionId}`;
    if (sessionId) url += `?session_id=${encodeURIComponent(sessionId)}`;
    const res = await fetch(url, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Erreur lors de la vérification du paiement');
    return data;
  },
  
  // Documents du client
  getDocuments: async (token) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/documents`);
    if (!res.ok) throw new Error('Erreur lors du chargement des documents');
    return res.json();
  },
  
  // Télécharger un document
  downloadDocument: async (token, documentId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/documents/${documentId}/download`);
    if (!res.ok) throw new Error('Erreur lors du téléchargement');
    return res.blob();
  },
  
  // Obtenir le prix d'une session pour un membre spécifique
  getSessionPriceForMember: async (token, sessionId, forClientId) => {
    let url = `${API_URL}/api/client-portal/session/${sessionId}/price`;
    if (forClientId) {
      url += `?for_client_id=${forClientId}`;
    }
    const res = await fetch(url, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) throw new Error('Erreur lors du chargement du prix');
    return res.json();
  },

  // Obtenir les détails complets d'une session
  getSessionDetail: async (token, sessionId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/session/${sessionId}`);
    if (!res.ok) throw new Error('Erreur lors du chargement de la session');
    return res.json();
  },
  
  // API Famille
  getFamily: async (token) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/family`);
    if (!res.ok) throw new Error('Erreur lors du chargement');
    return res.json();
  },
  
  searchFamilyMember: async (token, query) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/family/search?query=${encodeURIComponent(query)}`);
    if (!res.ok) throw new Error('Erreur lors de la recherche');
    return res.json();
  },
  
  // Envoyer une demande de liaison famille (avec confirmation)
  sendFamilyRequest: async (token, memberId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/family/request`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      },
      body: JSON.stringify({ member_id: memberId })
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.detail || 'Erreur lors de l\'envoi de la demande');
    }
    return data;
  },
  
  // Accepter une demande de liaison famille
  acceptFamilyRequest: async (token, requestId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/family/request/${requestId}/accept`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.detail || 'Erreur lors de l\'acceptation');
    }
    return data;
  },
  
  // Refuser une demande de liaison famille
  declineFamilyRequest: async (token, requestId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/family/request/${requestId}/decline`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.detail || 'Erreur lors du refus');
    }
    return data;
  },
  
  // Annuler une demande envoyée
  cancelFamilyRequest: async (token, requestId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/family/request/${requestId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.detail || 'Erreur lors de l\'annulation');
    }
    return data;
  },
  
  unlinkFamilyMember: async (token, memberId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/family/${memberId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.detail || 'Erreur lors de la suppression du lien');
    }
    return data;
  },
  
  register: async (token, sessionId, clientId, forClientId = null, useCarnet = false) => {
    // Construire le body en n'incluant que les champs avec des valeurs
    const body = { session_id: sessionId, use_carnet: useCarnet };
    if (clientId) body.client_id = clientId;
    if (forClientId) body.for_client_id = forClientId;
    
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/register`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      },
      body: JSON.stringify(body)
    });
    
    // Parse JSON directement
    let data;
    try {
      data = await res.json();
    } catch (e) {
      if (!res.ok) {
        // Messages d'erreur améliorés selon le code HTTP
        if (res.status === 403) {
          throw new Error('Accès refusé. Votre cotisation est peut-être expirée ou vous n\'avez pas les droits pour vous inscrire à ce cours.');
        }
        if (res.status === 422) {
          throw new Error('Données de requête invalides');
        }
        throw new Error(`Erreur serveur (${res.status})`);
      }
      throw new Error('Erreur de communication avec le serveur');
    }
    
    if (!res.ok) {
      let errorMsg = 'Erreur lors de l\'inscription';
      
      // Messages d'erreur spécifiques selon le code HTTP
      if (res.status === 403) {
        errorMsg = data?.detail || 'Accès refusé. Votre cotisation est peut-être expirée ou vous n\'avez pas les droits pour vous inscrire à ce cours.';
      } else if (data && data.detail) {
        errorMsg = Array.isArray(data.detail) 
          ? data.detail.map(e => e.msg || e).join(', ')
          : data.detail;
      }
      throw new Error(errorMsg);
    }
    return data;
  },
  
  cancelRegistration: async (token, registrationId) => {
    const res = await authenticatedFetch(`${API_URL}/api/client-portal/registrations/${registrationId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.detail || 'Erreur lors de l\'annulation');
    }
    return data;
  },

  // API Stripe pour les paiements
  createPaymentCheckout: async (token, sessionId) => {
    console.log('[Payment] Creating checkout for session:', sessionId);
    const res = await fetch(`${API_URL}/api/payments/checkout`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      },
      body: JSON.stringify({ 
        session_id: sessionId, 
        origin_url: window.location.origin 
      })
    });
    console.log('[Payment] Response status:', res.status);
    // Clone response to prevent "body stream already read" errors
    const resClone = res.clone();
    try {
      const data = await res.json();
      console.log('[Payment] Parsed data:', data);
      if (!res.ok) {
        throw new Error(data.detail || 'Erreur lors de la création du paiement');
      }
      return data;
    } catch (e) {
      // If first parse fails, try the clone
      console.error('[Payment] Parse error:', e);
      const text = await resClone.text();
      console.error('[Payment] Response text:', text);
      throw new Error('Erreur lors du traitement de la réponse du serveur');
    }
  },

  getPaymentStatus: async (token, checkoutSessionId) => {
    const res = await fetch(`${API_URL}/api/payments/status/${checkoutSessionId}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.detail || 'Erreur lors de la vérification du paiement');
    }
    return data;
  }
};

// Composant pour la vue jour (mobile)
const DayView = ({ date, sessions, onSessionClick, isLoading, indivs = [], onIndivClick }) => {
  if (isLoading) {
    return (
      <div className="space-y-3 p-4">
        {[1, 2, 3].map(i => (
          <Skeleton key={i} className="h-24 w-full rounded-xl" />
        ))}
      </div>
    );
  }

  const daySessions = sessions.filter(s => {
    const sessionDate = parseISO(s.datetime);
    return isSameDay(sessionDate, date);
  });
  // Cours individuels disponibles du jour, mélangés par heure avec les collectifs
  const sessionIds = new Set(daySessions.map(s => s.id));
  const dayIndivs = indivs.filter(c => c.datetime && !sessionIds.has(c.id) && isSameDay(parseISO(c.datetime), date));
  const items = [
    ...daySessions.map(s => ({ kind: 'session', dt: s.datetime, data: s })),
    ...dayIndivs.map(c => ({ kind: 'indiv', dt: c.datetime, data: c })),
  ].sort((a, b) => new Date(a.dt) - new Date(b.dt));

  return (
    <div className="space-y-2 p-3">
      {items.length === 0 ? (
        <div className="text-center py-12">
          <CalendarDays className="w-12 h-12 mx-auto text-neutral-300 mb-3" />
          <p className="text-neutral-500">Aucun cours disponible ce jour</p>
        </div>
      ) : (
        items.map(it => (it.kind === 'indiv'
          ? <IndivSlotCard key={`indiv-${it.data.id}`} slot={it.data} onClick={() => onIndivClick?.(it.data)} />
          : <SessionCard key={it.data.id} session={it.data} onClick={() => onSessionClick(it.data)} />))
      )}
    </div>
  );
};

// Couleurs par mois pour les stages (pas de violet)
const MONTH_COLORS = {
  1:  { accent: '#3B82F6', bg: '#EFF6FF', light: 'bg-blue-100',    text: 'text-blue-700',    border: 'border-blue-300',    bar: 'bg-blue-500',    hover: 'hover:border-blue-300' },
  2:  { accent: '#14B8A6', bg: '#F0FDFA', light: 'bg-teal-100',    text: 'text-teal-700',    border: 'border-teal-300',    bar: 'bg-teal-500',    hover: 'hover:border-teal-300' },
  3:  { accent: '#10B981', bg: '#ECFDF5', light: 'bg-emerald-100', text: 'text-emerald-700', border: 'border-emerald-300', bar: 'bg-emerald-500', hover: 'hover:border-emerald-300' },
  4:  { accent: '#0EA5E9', bg: '#F0F9FF', light: 'bg-sky-100',     text: 'text-sky-700',     border: 'border-sky-300',     bar: 'bg-sky-500',     hover: 'hover:border-sky-300' },
  5:  { accent: '#F59E0B', bg: '#FFFBEB', light: 'bg-amber-100',   text: 'text-amber-700',   border: 'border-amber-300',   bar: 'bg-amber-500',   hover: 'hover:border-amber-300' },
  6:  { accent: '#F97316', bg: '#FFF7ED', light: 'bg-orange-100',  text: 'text-orange-700',  border: 'border-orange-300',  bar: 'bg-orange-500',  hover: 'hover:border-orange-300' },
  7:  { accent: '#EF4444', bg: '#FEF2F2', light: 'bg-red-100',     text: 'text-red-700',     border: 'border-red-300',     bar: 'bg-red-500',     hover: 'hover:border-red-300' },
  8:  { accent: '#EC4899', bg: '#FDF2F8', light: 'bg-pink-100',    text: 'text-pink-700',    border: 'border-pink-300',    bar: 'bg-pink-500',    hover: 'hover:border-pink-300' },
  9:  { accent: '#06B6D4', bg: '#ECFEFF', light: 'bg-cyan-100',    text: 'text-cyan-700',    border: 'border-cyan-300',    bar: 'bg-cyan-500',    hover: 'hover:border-cyan-300' },
  10: { accent: '#6366F1', bg: '#EEF2FF', light: 'bg-indigo-100',  text: 'text-indigo-700',  border: 'border-indigo-300',  bar: 'bg-indigo-500',  hover: 'hover:border-indigo-300' },
  11: { accent: '#64748B', bg: '#F8FAFC', light: 'bg-slate-100',   text: 'text-slate-700',   border: 'border-slate-300',   bar: 'bg-slate-500',   hover: 'hover:border-slate-300' },
  12: { accent: '#DC2626', bg: '#FEF2F2', light: 'bg-red-100',     text: 'text-red-700',     border: 'border-red-300',     bar: 'bg-red-600',     hover: 'hover:border-red-300' },
};

const getStageMonthColor = (dateStr) => {
  if (!dateStr) return MONTH_COLORS[1];
  try {
    const month = parseISO(dateStr).getMonth() + 1;
    return MONTH_COLORS[month] || MONTH_COLORS[1];
  } catch { return MONTH_COLORS[1]; }
};

// Composant carte de session - Style identique aux pros
const SessionCard = ({ session, onClick }) => {
  const sessionDate = parseISO(session.datetime);
  const endTime = new Date(sessionDate.getTime() + (session.duration_minutes || 60) * 60000);
  const isFull = session.max_participants && (session.registration_count || session.registrations_count || session.registered_count || 0) >= session.max_participants;
  const spotsLeft = session.max_participants ? session.max_participants - (session.registration_count || session.registrations_count || session.registered_count || 0) : null;
  
  // Style différent selon le type d'événement
  const isCompetition = session.is_competition || session.event_type === 'competition';
  const isStage = session.is_stage || session.event_type === 'stage';
  
  let sessionColor = session.employee_color || '#1B8066';
  let bgColor = sessionColor + '15';
  let typeIcon = null;
  let typeBadge = null;
  
  if (isCompetition) {
    sessionColor = '#F59E0B'; // Orange pour compétitions
    bgColor = '#FEF3C7'; // Fond jaune clair
    typeIcon = <Trophy size={12} className="text-amber-600" />;
    typeBadge = <span className="text-[9px] bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded-full font-medium">Compétition</span>;
  } else if (isStage) {
    const mc = getStageMonthColor(session.start_date || session.datetime);
    sessionColor = mc.accent;
    bgColor = mc.bg;
    typeIcon = <CalendarDays size={12} style={{ color: mc.accent }} />;
    typeBadge = <span className={`text-[9px] ${mc.light} ${mc.text} px-1.5 py-0.5 rounded-full font-medium`}>Stage</span>;
  }
  
  return (
    <button
      data-testid={`session-card-${session.id}`}
      onClick={onClick}
      className={`w-full text-left rounded-lg overflow-hidden transition-all active:scale-[0.99] ${
        session.is_registered 
          ? 'ring-2 ring-primary/40' 
          : isFull
            ? 'opacity-60'
            : 'hover:shadow-md'
      }`}
      style={{ 
        backgroundColor: bgColor,
        borderLeft: `4px solid ${sessionColor}`
      }}
    >
      <div className="px-3 py-2.5">
        {/* Badge type (pour compétitions/stages) */}
        {typeBadge && (
          <div className="mb-1 flex items-center gap-1">
            {typeIcon}
            {typeBadge}
          </div>
        )}
        
        {/* Ligne 1: Nom du cours + Badge inscrit */}
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-semibold text-neutral-900 text-sm leading-tight">
            {session.course_name}
          </h3>
          {session.is_registered && (
            <Badge className="bg-primary text-white flex-shrink-0 text-[10px] px-1.5 py-0.5">
              <CheckCircle2 size={10} className="mr-0.5" />
              Inscrit
            </Badge>
          )}
        </div>
        
        {/* Ligne 2: Horaires ou info stage */}
        <p className="text-xs text-neutral-600 mt-0.5">
          {isCompetition || isStage ? (
            format(sessionDate, 'EEEE d MMMM', { locale: fr })
          ) : (
            <>{format(sessionDate, 'HH:mm')} – {format(endTime, 'HH:mm')}</>
          )}
          {isStage && session.sessions_count > 1 && (
            <span style={{ color: getStageMonthColor(session.start_date || session.datetime).accent }} className="ml-1">({session.sessions_count} sessions)</span>
          )}
        </p>
        
        {/* Ligne 3: Pro + Places */}
        <div className="flex items-center justify-between mt-1">
          {session.employee_name ? (
            <p className="text-xs text-neutral-500 truncate">
              {session.employee_name}
            </p>
          ) : (
            <span />
          )}
          
          {/* Badge disponibilité - masqué pour les cours individuels */}
          {session.course_type !== 'individuel' && (
            <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${
              isFull 
                ? 'bg-red-100 text-red-600' 
                : 'bg-emerald-100 text-emerald-700'
            }`}>
              {isFull ? 'Complet' : 'Dispos'}
            </span>
          )}
        </div>
      </div>
    </button>
  );
};


// Formater la durée en heures
const formatDuration = (minutes) => {
  if (!minutes) return '1h';
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours === 0) return `${mins}min`;
  if (mins === 0) return `${hours}h`;
  return `${hours}h${mins.toString().padStart(2, '0')}`;
};

// Calculer les heures à débiter du carnet (précision demi-heure, identique au backend)
const calcCarnetDebit = (durationMinutes) => {
  const d = durationMinutes || 60;
  return Math.max(0.5, Math.round(d / 30) / 2);
};

// iter316.35 — Formatage de la date de naissance pour l'affichage : "15 mars 1985"
const formatBirthday = (raw) => {
  if (!raw) return '';
  try {
    const s = String(raw).slice(0, 10);
    const [y, m, d] = s.split('-').map(Number);
    if (!y || !m || !d) return raw;
    const dt = new Date(Date.UTC(y, m - 1, d));
    return dt.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
  } catch {
    return raw;
  }
};



// Composant de recherche d'accompagnant
const CompanionSearchField = ({ idx, token, onSelect }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [newClient, setNewClient] = useState({ first_name: '', last_name: '', email: '', phone: '' });
  const [loading, setLoading] = useState(false);

  const search = async (q) => {
    setQuery(q);
    if (q.length < 2) { setResults([]); return; }
    try {
      const res = await fetch(`${API_URL}/api/tee-times/portal/search-clients?q=${encodeURIComponent(q)}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setResults(data);
      }
    } catch (e) { console.error(e); }
  };

  const createClient = async () => {
    if (!newClient.first_name || !newClient.last_name) return;
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/tee-times/portal/create-companion`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(newClient)
      });
      if (res.ok) {
        const data = await res.json();
        onSelect(data);
        setShowCreate(false);
      }
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  if (showCreate) {
    return (
      <div className="border rounded-lg p-3 bg-neutral-50 space-y-2">
        <p className="text-xs font-semibold text-neutral-700">Nouveau client extérieur</p>
        <div className="grid grid-cols-2 gap-2">
          <input type="text" placeholder="Prénom *" className="border rounded-lg px-2 py-1.5 text-sm" value={newClient.first_name} onChange={e => setNewClient(p => ({ ...p, first_name: e.target.value }))} />
          <input type="text" placeholder="Nom *" className="border rounded-lg px-2 py-1.5 text-sm" value={newClient.last_name} onChange={e => setNewClient(p => ({ ...p, last_name: e.target.value }))} />
        </div>
        <input type="email" placeholder="Email" className="w-full border rounded-lg px-2 py-1.5 text-sm" value={newClient.email} onChange={e => setNewClient(p => ({ ...p, email: e.target.value }))} />
        <input type="tel" placeholder="Téléphone" className="w-full border rounded-lg px-2 py-1.5 text-sm" value={newClient.phone} onChange={e => setNewClient(p => ({ ...p, phone: e.target.value }))} />
        <div className="flex gap-2">
          <button onClick={() => setShowCreate(false)} className="flex-1 py-1.5 rounded-lg border text-xs font-medium text-neutral-600">Annuler</button>
          <button onClick={createClient} disabled={loading || !newClient.first_name || !newClient.last_name} className="flex-1 py-1.5 rounded-lg text-xs font-medium text-white disabled:opacity-50" style={{ backgroundColor: '#2E6A4C' }}>
            {loading ? '...' : 'Créer'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="relative">
      <input
        type="text"
        placeholder={`Rechercher joueur ${idx + 2}...`}
        className="w-full border rounded-lg px-3 py-2 text-sm"
        value={query}
        onChange={e => search(e.target.value)}
        data-testid={`tt-companion-search-${idx}`}
      />
      {(results.length > 0 || query.length >= 2) && (
        <div className="absolute z-20 top-full mt-1 w-full bg-white border rounded-lg shadow-lg max-h-48 overflow-y-auto">
          {results.map(c => (
            <button key={c.id} onClick={() => onSelect(c)} className="w-full text-left px-3 py-2 hover:bg-neutral-50 border-b last:border-0">
              <p className="text-sm font-medium">{c.first_name} {c.last_name}</p>
              <p className="text-[10px] text-neutral-500">{c.group}{c.email ? ` · ${c.email}` : ''}</p>
            </button>
          ))}
          <button onClick={() => setShowCreate(true)} className="w-full text-left px-3 py-2 hover:bg-emerald-50 text-emerald-700 text-sm font-medium">
            + Nouveau client extérieur
          </button>
        </div>
      )}
    </div>
  );
};




const ClientPortal = () => {
  // Auth state
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [client, setClient] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('client_portal_token'));
  const isAdminViewing = Boolean(localStorage.getItem('access_token') && localStorage.getItem('client_portal_token'));
  
  // UI state
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTabRaw] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get('tab') || 'dashboard';
    // Rétro-compatibilité : ancien lien ?tab=contrats → nouvelle rubrique dans "Compte"
    return raw === 'contrats' ? 'account' : raw;
  });
  // Fréquentation : connexions, pages et clics du membre (pas quand l'équipe consulte le portail à sa place)
  usePortalTracking({
    enabled: isAuthenticated && !isAdminViewing && !localStorage.getItem('client_portal_impersonating'),
    clientId: client?.id,
    page: activeTab,
  });
  // === Tee Times (Départs) ===
  const [teeTimeEnabled, setTeeTimeEnabled] = useState(false);
  const [teeTimeSettings, setTeeTimeSettings] = useState(null);
  const [teeTimeSlots, setTeeTimeSlots] = useState([]);
  const [teeTimeDayLimit, setTeeTimeDayLimit] = useState('');
  const [teeTimeMyBookings, setTeeTimeMyBookings] = useState([]);
  const [teeTimeDate, setTeeTimeDate] = useState(new Date());
  const [teeTimeLoading, setTeeTimeLoading] = useState(false);
  const [teeTimeBookingForm, setTeeTimeBookingForm] = useState({ players_count: 1, notes: '', use_carnet: false, player_names: [], cart_count: 0, cart_onsite: false });
  // Compte client (solde prépayé) : utilisé en premier pour tout paiement portail, le reste part sur Stripe
  const [accountBalance, setAccountBalance] = useState(0);
  const [useAccountPay, setUseAccountPay] = useState(true);
  const [ttQuote, setTtQuote] = useState(null);
  const [ttQuoteLoading, setTtQuoteLoading] = useState(false);
  const [ttCalOpen, setTtCalOpen] = useState(false);
  const loadAccountBalance = async () => {
    try {
      const r = await fetch(`${API_URL}/api/pos/portal/my-account`, { headers: { Authorization: `Bearer ${token}` } });
      if (r.ok) { const d = await r.json(); setAccountBalance(Number(d.balance) || 0); }
    } catch (e) { /* silent */ }
  };
  const [showTeeTimeBookingModal, setShowTeeTimeBookingModal] = useState(false);
  const [selectedTeeTimeSlot, setSelectedTeeTimeSlot] = useState(null);
  const [teeTimeBookingLoading, setTeeTimeBookingLoading] = useState(false);
  const [teeTimeSubTab, setTeeTimeSubTab] = useState(() => (new URLSearchParams(window.location.search).get('sub') === 'reservations' ? 'reservations' : 'planning'));
  // Phase 2 Sociétés — réservation invité
  const [societeGuestMode, setSocieteGuestMode] = useState(false);
  const [societeGuestPreview, setSocieteGuestPreview] = useState(null);
  const [societeGuests, setSocieteGuests] = useState([]);
  const [repAlsoPlays, setRepAlsoPlays] = useState(false);
  const [expandedSlotTime, setExpandedSlotTime] = useState(null);
  const [cotisationCallVisible, setCotisationCallVisible] = useState(false);
  const [frequentPartners, setFrequentPartners] = useState([]);
  const [societeGuestsList, setSocieteGuestsList] = useState([]);
  const [societeGuestsLoaded, setSocieteGuestsLoaded] = useState(false);
  const [pendingGuestRebook, setPendingGuestRebook] = useState(null);
  // Modification de réservation
  const [modifyBooking, setModifyBooking] = useState(null); // booking en cours de modif
  const [cancelTeeTimeBooking, setCancelTeeTimeBooking] = useState(null); // résa en cours d'annulation (choix remboursement)
  const [upcomingRefresh, setUpcomingRefresh] = useState(0); // force le rechargement de « Mes prochains rendez-vous »
  const [modifyForm, setModifyForm] = useState({ mode: null, memberSearch: '', memberResults: [], guest: { first_name: '', last_name: '', email: '', phone: '' }, cartsToAdd: 0 });
  const [modifyLoading, setModifyLoading] = useState(false);
  const [selectedNewsId, setSelectedNewsId] = useState(null);
  const [newsLightbox, setNewsLightbox] = useState(null);
  const [showIndivList, setShowIndivList] = useState(false);
  const [coursSubTab, setCoursSubTab] = useState('calendar'); // 'calendar', 'reservations', 'indiv'
  
  const setActiveTab = (tab) => {
    setSelectedNewsId(null);
    setShowIndivList(false);
    if (tab === 'cours') {
      setCoursSubTab('calendar');
    }
    if (tab === 'departs') {
      setTeeTimeSubTab('planning');
    }
    setActiveTabRaw(tab);
  };
  
  const openNewsDetail = (newsId) => {
    setSelectedNewsId(newsId);
    setActiveTabRaw('news');
  };
  
  const goToCoursDate = (dateStr) => {
    if (dateStr) {
      setCurrentDate(parseISO(dateStr));
    }
    setShowIndivList(false);
    setActiveTabRaw('cours');
  };
  const [currentDate, setCurrentDate] = useState(new Date());
  const [viewMode, setViewMode] = useState('day'); // 'day' ou 'week'
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  
  // Portes Ouvertes state
  const [portesOuvertesEnabled, setPortesOuvertesEnabled] = useState(false);
  
  // Portal settings (visibility config, carnet info)
  const [portalSettings, setPortalSettings] = useState(null);
  
  // Push notifications
  const { supported: pushSupported, isSubscribed: pushSubscribed, loading: pushLoading, subscribe: pushSubscribe, unsubscribe: pushUnsubscribe, iosNeedsPwa } = usePushNotifications(client?.id, 'client');

  // PWA install prompt (Chrome/Edge/Android)
  const [installPromptEvent, setInstallPromptEvent] = useState(null);
  const [isPwaInstalled, setIsPwaInstalled] = useState(false);

  useEffect(() => {
    // Détection PWA déjà installée (standalone mode)
    const checkStandalone = () => {
      const isStandalone =
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true;
      setIsPwaInstalled(isStandalone);
    };
    checkStandalone();

    // Capture du beforeinstallprompt (Chrome/Edge/Android)
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setInstallPromptEvent(e);
    };
    window.addEventListener('beforeinstallprompt', handleBeforeInstall);

    // Après installation, cache l'event et met à jour l'état
    const handleAppInstalled = () => {
      setInstallPromptEvent(null);
      setIsPwaInstalled(true);
      try { toast.success('Application installée avec succès !'); } catch (e) {}
    };
    window.addEventListener('appinstalled', handleAppInstalled);

    // Pré-enregistre le service worker pour activer l'installabilité PWA
    // (nécessaire côté navigateur avant de proposer beforeinstallprompt)
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw-push.js', { updateViaCache: 'none' })
        .catch(() => { /* silencieux — le SW push sera aussi enregistré via subscribe */ });
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const triggerInstallPwa = useCallback(async () => {
    if (!installPromptEvent) return false;
    try {
      installPromptEvent.prompt();
      const choice = await installPromptEvent.userChoice;
      if (choice.outcome === 'accepted') {
        setInstallPromptEvent(null);
        return true;
      }
      return false;
    } catch (err) {
      console.error('[PWA] Install prompt error:', err);
      return false;
    }
  }, [installPromptEvent]);
  
  // Dashboard data
  const [dashboardData, setDashboardData] = useState(null);
  const [dashboardLoading, setDashboardLoading] = useState(false);

  // Data state
  const [sessions, setSessions] = useState([]);
  const [myRegistrations, setMyRegistrations] = useState([]);
  const [registrationsHistory, setRegistrationsHistory] = useState({ upcoming: [], past: [] });
  const [news, setNews] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  
  // Competitions state
  const [competitions, setCompetitions] = useState([]);
  const [showMyCompRegistrations, setShowMyCompRegistrations] = useState(false);
  const [filterCompType, setFilterCompType] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('type') || 'all';
  });
  const [coverImageZoom, setCoverImageZoom] = useState(null);
  const [selectedCustomOptions, setSelectedCustomOptions] = useState([]);
  const [showMyStageRegistrations, setShowMyStageRegistrations] = useState(false);
  const [indivProFilter, setIndivProFilter] = useState('');
  // iter314 — Filtre par règle Yield (déclenché depuis le CTA "Réserver" d'une Bonne Affaire virtuelle)
  const [indivYieldFilter, setIndivYieldFilter] = useState('');
  const [clientIsMember, setClientIsMember] = useState(false);
  const [isAcademyMember, setIsAcademyMember] = useState(false);
  const [scorecardModuleEnabled, setScorecardModuleEnabled] = useState(false);
  const [selectedCompetition, setSelectedCompetition] = useState(null);
  const [showCompetitionModal, setShowCompetitionModal] = useState(false);
  const [competitionPartnerName, setCompetitionPartnerName] = useState('');
  const [competitionRegistrationLoading, setCompetitionRegistrationLoading] = useState(false);
  const [competitionNotes, setCompetitionNotes] = useState('');
  // États accompagnants (afterworks gratuits)
  const [afterworkGuestsCount, setAfterworkGuestsCount] = useState(0);
  const [selectedAfterworkGuests, setSelectedAfterworkGuests] = useState([]);
  const [afterworkGuestSearch, setAfterworkGuestSearch] = useState('');
  const [afterworkGuestResults, setAfterworkGuestResults] = useState([]);
  const [afterworkGuestSearching, setAfterworkGuestSearching] = useState(false);
  const [showCompetitionParticipantsModal, setShowCompetitionParticipantsModal] = useState(false);
  // Visionneuse PDF intégrée (résultats / départs) avec bouton retour — évite de perdre le portail en PWA
  const [pdfViewer, setPdfViewer] = useState(null);
  const openPdf = (url, title) => { if (url) setPdfViewer({ url, title }); };
  const [competitionParticipants, setCompetitionParticipants] = useState([]);
  const [participantsTotalSeats, setParticipantsTotalSeats] = useState(0);
  const [loadingParticipants, setLoadingParticipants] = useState(false);
  
  // Double competition partner search state
  const [partnerSearchQuery, setPartnerSearchQuery] = useState('');
  const [partnerSearchResults, setPartnerSearchResults] = useState([]);
  const [partnerSearchLoading, setPartnerSearchLoading] = useState(false);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [payForPartner, setPayForPartner] = useState(true);
  const [isDoubleParticipantsView, setIsDoubleParticipantsView] = useState(false);
  const [externalPartnerMode, setExternalPartnerMode] = useState(false);
  const [externalPartnerData, setExternalPartnerData] = useState({ first_name: '', last_name: '', email: '', phone: '' });
  
  // Fitting Orders state (commandes Taylor Made)
  const [fittingOrders, setFittingOrders] = useState([]);
  const [selectedFittingOrder, setSelectedFittingOrder] = useState(null);
  const [showFittingOrderModal, setShowFittingOrderModal] = useState(false);
  const [fittingOrderLoading, setFittingOrderLoading] = useState(false);
  
  
  // Documents
  const [documents, setDocuments] = useState([]);
  const [documentsLoading, setDocumentsLoading] = useState(false);
  
  // Packs de cours
  const [coursePacks, setCoursePacks] = useState([]);
  const [packsLoading, setPacksLoading] = useState(false);
  const [purchasingPack, setPurchasingPack] = useState(null);
  
  // iter313.3 — Practice (jetons + QR + packs)
  const [practiceData, setPracticeData] = useState(null); // { balance, qr_value, packs_available }
  const [purchasingPracticePack, setPurchasingPracticePack] = useState(null);
  const [showPracticeQrFullscreen, setShowPracticeQrFullscreen] = useState(false);
  
  // Historique des paiements
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [paymentHistoryLoading, setPaymentHistoryLoading] = useState(false);
  
  // Stages
  const [stages, setStages] = useState([]);
  const [stagesLoading, setStagesLoading] = useState(false);
  const [selectedStage, setSelectedStage] = useState(null);
  const [showStageModal, setShowStageModal] = useState(false);

  // Auto-scroll vers le mois courant (ou premier futur) lors de l'ouverture des onglets Événements/Stages
  useEffect(() => {
    if (activeTab !== 'competitions' && activeTab !== 'stages') return;
    // Attendre le rendu des sections (grouping par mois)
    const timer = setTimeout(() => {
      const prefix = activeTab === 'competitions' ? 'comp-month-' : 'stage-month-';
      const now = new Date();
      const currentKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
      const sections = Array.from(document.querySelectorAll(`[id^="${prefix}"]`));
      if (sections.length === 0) return;
      // 1. Chercher exactement le mois courant
      let target = sections.find(el => el.dataset.monthKey === currentKey);
      // 2. Sinon, chercher le premier mois >= mois courant
      if (!target) {
        target = sections.find(el => (el.dataset.monthKey || '') >= currentKey);
      }
      // 3. Sinon (tous les mois sont passés), rester en haut
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [activeTab, competitions.length, stages.length, showMyCompRegistrations, showMyStageRegistrations, filterCompType]);
  
  // Password change state
  const [showPasswordChange, setShowPasswordChange] = useState(false);
  // Compteur de contrats en attente de signature (pour badge sur bouton Compte)
  const [pendingContractsCount, setPendingContractsCount] = useState(0);
  // Highlight pulse sur la section contrats à l'arrivée sur l'onglet Compte
  const [contractsHighlight, setContractsHighlight] = useState(false);
  const [contractsRefreshKey, setContractsRefreshKey] = useState(0);
  // Ref pour scroller vers la section contrats depuis un email (?tab=contrats redirigé sur account)
  const contratsSectionRef = useRef(null);
  // Mandat SEPA demandé depuis la carte « Ma cotisation » : recharge la liste des contrats et met en avant la signature
  const handleMandateRequested = useCallback(() => {
    setContractsRefreshKey((k) => k + 1);
    setTimeout(() => {
      contratsSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setContractsHighlight(true);
      setTimeout(() => setContractsHighlight(false), 6000);
    }, 600);
  }, []);
  useEffect(() => {
    // Si on entre sur l'onglet Compte et qu'il y a un contrat en attente → highlight + scroll
    if (activeTab !== 'account') { setContractsHighlight(false); return; }
    const params = new URLSearchParams(window.location.search);
    const wantsContrats = params.get('tab') === 'contrats' || pendingContractsCount > 0;
    if (wantsContrats && pendingContractsCount > 0) {
      const t = setTimeout(() => {
        contratsSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setContractsHighlight(true);
        // Retire le highlight après l'animation (3 x 1.6s = ~5s)
        setTimeout(() => setContractsHighlight(false), 6000);
      }, 400);
      return () => clearTimeout(t);
    }
  }, [activeTab, pendingContractsCount]);
  // Restaurant
  const [showRestaurantReserve, setShowRestaurantReserve] = useState(false);
  const [showRestaurantMenu, setShowRestaurantMenu] = useState(false);
  const [restaurantReservation, setRestaurantReservation] = useState(null);
  const [restaurantSlots, setRestaurantSlots] = useState([]);
  const [restaurantMenuData, setRestaurantMenuData] = useState(null);
  const [restaurantForm, setRestaurantForm] = useState({ date: '', time: '', covers: 2, note: '' });
  const [restaurantLoading, setRestaurantLoading] = useState(false);
  const [passwordForm, setPasswordForm] = useState({ current: '', newPassword: '', confirm: '' });
  
  // Profile edit state
  const [editingProfile, setEditingProfile] = useState(false);
  const [profileForm, setProfileForm] = useState({ first_name: '', last_name: '', birth_date: '' });
  const [savingProfile, setSavingProfile] = useState(false);
  
  // Paiement cotisation
  const [subscriptionPriceInfo, setSubscriptionPriceInfo] = useState(null);
  const [subscriptionPaymentLoading, setSubscriptionPaymentLoading] = useState(false);
  
  // Login form
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginStep, setLoginStep] = useState('email'); // 'email' | 'password' | 'select-profile'
  const [loginProfiles, setLoginProfiles] = useState([]);
  const [linkedProfiles, setLinkedProfiles] = useState(null); // profils liés au compte connecté
  const [rememberMe, setRememberMe] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [settingsLoading, setSettingsLoading] = useState(true);
  const [signupStep, setSignupStep] = useState('email'); // 'email' | 'select-profile' | 'full-form'
  const [signupEmail, setSignupEmail] = useState('');
  const [emailProfiles, setEmailProfiles] = useState([]);
  const [selectedProfileId, setSelectedProfileId] = useState(null);
  const [checkingEmail, setCheckingEmail] = useState(false);
  const [signupForm, setSignupForm] = useState({ 
    first_name: '', 
    last_name: '', 
    email: '', 
    phone: '',
    password: '', 
    confirmPassword: '' 
  });
  const [signupLoading, setSignupLoading] = useState(false);
  const [showVerification, setShowVerification] = useState(false);
  const [verificationEmail, setVerificationEmail] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0);
  
  // Modal
  const [selectedSession, setSelectedSession] = useState(null);
  const [showSessionModal, setShowSessionModal] = useState(false);
  const [registerLoading, setRegisterLoading] = useState(false);

  // Fréquentation : chaque contenu ouvert est compté avec son titre (qui l'a consulté, combien de fois)
  const openedNews = selectedNewsId ? news.find((n) => n.id === selectedNewsId) : null;
  useTrackPortalItem('news', selectedNewsId, openedNews?.title);
  useTrackPortalItem('competition', selectedCompetition?.id || selectedCompetition?._id, selectedCompetition?.name, showCompetitionModal);
  useTrackPortalItem('stage', selectedStage?.id || selectedStage?._id, selectedStage?.name, showStageModal);
  const sessionDate = selectedSession?.datetime ? parseISO(selectedSession.datetime) : null;
  const sessionLabel = selectedSession && `${selectedSession.course_name || 'Cours'}${sessionDate && !Number.isNaN(sessionDate.getTime()) ? ` · ${format(sessionDate, 'dd/MM/yyyy HH:mm')}` : ''}`;
  useTrackPortalItem('cours', selectedSession?.id || selectedSession?._id, sessionLabel, showSessionModal);

  // URL params pour gérer le retour Stripe
  const [searchParams, setSearchParams] = useSearchParams();

  // Responsive: détecter mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      setViewMode(mobile ? 'day' : 'week');
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Vérifier si les Portes Ouvertes sont activées
  useEffect(() => {
    const checkPortesOuvertes = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/portes-ouvertes/status`);
        const data = await res.json();
        setPortesOuvertesEnabled(data.enabled || false);
      } catch (e) {
        console.log('Portes Ouvertes check failed:', e);
      }
    };
    checkPortesOuvertes();
  }, []);

  // Auto-login via impersonate_token (admin se connecte en tant qu'un client depuis le CMS)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const impersonateToken = urlParams.get('impersonate_token');
    if (impersonateToken) {
      // Stocker le token dans une clef dédiée pour ne pas écraser l'admin token
      localStorage.setItem('client_portal_token', impersonateToken);
      localStorage.setItem('client_portal_impersonating', '1');
      // Nettoyer l'URL et relancer la page proprement
      window.history.replaceState({}, '', window.location.pathname);
      // Recharger pour que le composant utilise le nouveau token
      window.location.reload();
    }
  }, []);

  // Charger l'email sauvegardé si "Se souvenir de moi" était coché
  useEffect(() => {
    const savedEmail = localStorage.getItem('client_portal_remembered_email');
    if (savedEmail) {
      setLoginForm(prev => ({ ...prev, email: savedEmail }));
      setRememberMe(true);
    }
  }, []);

  // État pour le modal PWA
  const [showPwaModal, setShowPwaModal] = useState(false);
  const [showPOPopup, setShowPOPopup] = useState(false);

  // Afficher le modal d'aide PWA dès le chargement de la page (avant login)
  useEffect(() => {
    const neverShowAgain = localStorage.getItem('client_portal_pwa_never_show');
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    
    // Afficher seulement sur mobile, si pas "ne plus afficher" et pas déjà en mode PWA
    const isMobile = /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobile && !neverShowAgain && !isStandalone) {
      // Délai court pour laisser la page se charger
      const timer = setTimeout(() => {
        setShowPwaModal(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  // Popup Portes Ouvertes (une fois par session)
  useEffect(() => {
    if (portalSettings?.po_popup_enabled && !sessionStorage.getItem('po_popup_shown')) {
      const t = setTimeout(() => { setShowPOPopup(true); sessionStorage.setItem('po_popup_shown', '1'); }, 2000);
      return () => clearTimeout(t);
    }
  }, [portalSettings]);

  // État pour le message d'incitation aux notifications
  const [showNotifPrompt, setShowNotifPrompt] = useState(false);
  const [clientNotifs, setClientNotifs] = useState([]);
  const [clientUnread, setClientUnread] = useState(0);
  const [notifPanelOpen, setNotifPanelOpen] = useState(false);
  const notifPanelRef = React.useRef(null);
  const mobilePortalPanelRef = React.useRef(null);
  const desktopPortalPanelRef = React.useRef(null);

  // Charger les notifications client
  // iter318 fix perf — Charger seulement le COMPTEUR non lu au boot (léger).
  // La liste complète ne se charge qu'au clic sur la cloche (panel ouvert).
  useEffect(() => {
    if (!client?.id) return;
    const fetchUnread = async () => {
      try {
        const { notifInbox } = await import('../services/api');
        const countRes = await notifInbox.getUnreadCount(client.id, 'client');
        setClientUnread(countRes.data?.count || 0);
      } catch (e) { /* ignore */ }
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [client?.id]);

  // iter318 fix perf — Charger la LISTE des notifs seulement à l'ouverture du panel
  useEffect(() => {
    if (!notifPanelOpen || !client?.id) return;
    (async () => {
      try {
        const { notifInbox } = await import('../services/api');
        const listRes = await notifInbox.getNotifications(client.id, 'client');
        setClientNotifs(listRes.data?.notifications || []);
      } catch (e) { /* ignore */ }
    })();
  }, [notifPanelOpen, client?.id]);

  // Fermer le panel au clic extérieur
  const bellBtnRef = React.useRef(null);
  useEffect(() => {
    if (!notifPanelOpen) return;
    const handler = (e) => {
      // Vérifier si le clic est dans le bouton cloche ou dans l'un des panneaux portail
      const inBell = bellBtnRef.current && bellBtnRef.current.contains(e.target);
      const inMobilePanel = mobilePortalPanelRef.current && mobilePortalPanelRef.current.contains(e.target);
      const inDesktopPanel = desktopPortalPanelRef.current && desktopPortalPanelRef.current.contains(e.target);
      const inDesktopBell = notifPanelRef.current && notifPanelRef.current.contains(e.target);
      if (!inBell && !inMobilePanel && !inDesktopPanel && !inDesktopBell) setNotifPanelOpen(false);
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler, { passive: true });
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [notifPanelOpen]);

  const handleNotifBellClick = async () => {
    setNotifPanelOpen(prev => {
      const opening = !prev;
      if (opening && client?.id) {
        (async () => {
          try {
            const { notifInbox } = await import('../services/api');
            const listRes = await notifInbox.getNotifications(client.id, 'client');
            setClientNotifs(listRes.data?.notifications || []);
            if (clientUnread > 0) {
              setClientUnread(0);
              await notifInbox.markAllRead(client.id, 'client');
            }
          } catch (e) { /* ignore */ }
        })();
      }
      return opening;
    });
  };

  // Afficher le message d'incitation aux notifications après connexion
  useEffect(() => {
    if (isAuthenticated && client) {
      const hasSeenNotifPrompt = sessionStorage.getItem('client_portal_notif_prompt_shown');
      
      // Afficher seulement si pas encore vu cette session, pas déjà abonné, et push supporté
      if (!hasSeenNotifPrompt && !pushSubscribed && pushSupported) {
        const timer = setTimeout(() => {
          setShowNotifPrompt(true);
          sessionStorage.setItem('client_portal_notif_prompt_shown', 'true');
        }, 2000);
        return () => clearTimeout(timer);
      }
    }
  }, [isAuthenticated, client, pushSubscribed, pushSupported]);

  // Charger les paramètres du portail publiquement (pour afficher le logo même sur la page de login)
  useEffect(() => {
    const loadPublicSettings = async () => {
      try {
        const settings = await clientPortalApi.getPublicSettings();
        if (settings) {
          // Utiliser la forme fonctionnelle pour ne PAS écraser les settings authentifiés
          // si checkAuth les a déjà chargés entre temps
          setPortalSettings(prev => prev ? prev : settings);
        }
      } catch (e) {
        console.log('Public settings load failed:', e);
      } finally {
        setSettingsLoading(false);
      }
    };
    // Charger les settings même si non authentifié (pour le logo)
    if (!portalSettings) {
      loadPublicSettings();
    } else {
      setSettingsLoading(false);
    }
  }, [portalSettings]);

  // Vérifier l'authentification au chargement
  useEffect(() => {
    const checkAuth = async () => {
      // Ne pas rediriger vers /modules si on est en train d'être impersonate
      // (le useEffect impersonate_token va poser le client_portal_token puis reload)
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('impersonate_token')) {
        return;
      }
      // Après un reload d'impersonation, le token client est présent :
      // ne PAS rediriger vers /modules dans ce cas.
      const clientPortalTokenInStorage = localStorage.getItem('client_portal_token');
      const isImpersonating = localStorage.getItem('client_portal_impersonating') === '1';
      // Si un token admin existe MAIS pas de token client portal, rediriger vers /modules
      // Sauf si on est en cours d'impersonation (token client posé, reload en cours ou terminé).
      const adminToken = localStorage.getItem('access_token');
      if (adminToken && !token && !clientPortalTokenInStorage && !isImpersonating) {
        window.location.href = clubPath('/modules');
        return;
      }
      
      // Ne pas re-vérifier si déjà authentifié (ex: après login/select profile)
      if (isAuthenticated) {
        setLoading(false);
        return;
      }
      if (token) {
        try {
          const profile = await clientPortalApi.getProfile(token);
          setClient(profile);
          setIsAuthenticated(true);
          
          // Charger les profils liés si email partagé
          try {
            const checkRes = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-portal/check-email`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email: profile.email })
            });
            const checkData = await checkRes.json();
            if (checkData.found && checkData.profiles?.length > 1) {
              setLinkedProfiles(checkData.profiles);
            }
          } catch (e) { /* silently ignore */ }
          
          // Toujours charger les settings (y compris lors du retour de paiement)
          // handlePaymentReturn mettra à jour le solde du carnet ensuite si nécessaire
          try {
            const settings = await clientPortalApi.getPortalSettings(token);
            setPortalSettings(settings);
          } catch (e) {
            console.log('Settings load failed:', e);
          }
        } catch (e) {
          // Seulement déconnecter si c'est une erreur 401 (token invalide/expiré)
          if (e.response?.status === 401) {
            // Essayer de rafraîchir le token
            const refreshToken = localStorage.getItem('client_portal_refresh_token');
            if (refreshToken) {
              try {
                const refreshResponse = await fetch(`${API_URL}/api/client-portal/auth/refresh`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ refresh_token: refreshToken })
                });
                if (refreshResponse.ok) {
                  const data = await refreshResponse.json();
                  localStorage.setItem('client_portal_token', data.access_token);
                  if (data.refresh_token) {
                    localStorage.setItem('client_portal_refresh_token', data.refresh_token);
                  }
                  setToken(data.access_token);
                  return; // Relancer le useEffect avec le nouveau token
                }
              } catch (refreshError) {
                console.log('Refresh failed:', refreshError);
              }
            }
            // NE PAS déconnecter même si le refresh échoue
            // Garder la session et laisser l'utilisateur décider
            console.warn('Token invalide mais session conservée');
          } else {
            // Erreur réseau ou autre - garder la session
            console.warn('Erreur réseau, conservation de la session client');
          }
        }
      }
      setLoading(false);
    };
    checkAuth();
  }, [token]);

  // Lien « Payer ma cotisation » des appels de cotisation (PDF / email) : ouvre directement Mon compte
  // (le pop-up promo est masqué pour ne pas gêner le règlement)
  const [arrivedForCotisation, setArrivedForCotisation] = useState(() => new URLSearchParams(window.location.search).get('pay') === 'cotisation');
  useEffect(() => {
    if (isAuthenticated && token && searchParams.get('pay') === 'cotisation') {
      searchParams.delete('pay');
      setSearchParams(searchParams, { replace: true });
      setActiveTab('account');
      setArrivedForCotisation(true);
      toast.info('Votre appel de cotisation est dans la carte « Ma cotisation » ci-dessous.', { duration: 6000 });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, token]);

  // Gérer le retour de Stripe après paiement
  const handlePaymentReturn = useCallback(async () => {
    const paymentStatus = searchParams.get('payment');
    const stripeSessionId = searchParams.get('session_id');
    const orderId = searchParams.get('order');
    const subscriptionId = searchParams.get('subscription');
    const competitionId = searchParams.get('competition');
    const paymentType = searchParams.get('type');
    const purchaseId = searchParams.get('purchase_id');
    const cotisationCallId = searchParams.get('cotisation_call');

    if (paymentStatus && token) {
      const serverVerified = searchParams.get('server_verified') === 'true';
      
      // Nettoyer les paramètres URL
      searchParams.delete('cotisation_call');
      searchParams.delete('payment');
      searchParams.delete('session_id');
      searchParams.delete('order');
      searchParams.delete('subscription');
      searchParams.delete('competition');
      searchParams.delete('type');
      searchParams.delete('purchase_id');
      searchParams.delete('server_verified');
      searchParams.delete('stage_id');
      searchParams.delete('booking_id');
      setSearchParams(searchParams);

      // ========== APPEL DE COTISATION (CB en ligne) ==========
      if (paymentType === 'cotisation_call' || cotisationCallId) {
        if (paymentStatus === 'success') {
          toast.success('Paiement reçu, merci !', {
            description: serverVerified
              ? 'Votre règlement est transmis à l\'accueil qui finalise l\'enregistrement ; votre facture suivra par email.'
              : 'Votre paiement est en cours de confirmation. Actualisez la page dans quelques instants.',
            duration: 7000,
          });
        } else if (paymentStatus === 'cancelled') {
          toast.info('Paiement annulé', { description: 'Vous pouvez réessayer à tout moment depuis « Ma cotisation ».', duration: 4000 });
        }
        setContractsRefreshKey(k => k + 1);
        setActiveTab('account');
        return;
      }

      // ========== PACK PRACTICE (jetons) ==========
      if (paymentType === 'practice_pack') {
        setActiveTab('boutique');
        if (paymentStatus === 'success' && stripeSessionId) {
          let r = null;
          try {
            r = await fetch(`${API_URL}/api/client-portal/practice/webhook-finalize/${stripeSessionId}`, { method: 'POST' }).then((x) => x.json());
          } catch { r = null; }
          if (serverVerified || r?.ok) {
            toast.success('Jetons Practice crédités', {
              description: r?.credited ? `${r.credited} jetons ajoutés à votre solde. Un email de confirmation vous a été envoyé.` : 'Votre solde est à jour.',
              duration: 6000,
            });
          } else {
            toast.info('Paiement en cours de traitement', { description: 'Vos jetons apparaîtront dans quelques instants.', duration: 5000 });
          }
        } else if (paymentStatus === 'cancelled') {
          toast.info('Paiement annulé', { description: 'Aucun montant n\u2019a été débité.', duration: 4000 });
        }
        loadPractice();
        loadPaymentHistory();
        return;
      }

      // ========== PAIEMENT COMPÉTITION ==========
      if (competitionId) {
        if (paymentStatus === 'success' && stripeSessionId) {
          try {
            // Vérifier le statut du paiement via Stripe
            const status = await clientPortalApi.getPaymentStatus(token, stripeSessionId);
            
            if (status.payment_status === 'paid') {
              toast.success('Inscription confirmée !', {
                description: 'Votre paiement a été accepté. Vous êtes inscrit à la compétition.',
                duration: 6000
              });
              // Recharger les compétitions
              loadCompetitions();
              setActiveTab('competitions');
            } else if (status.payment_status === 'pending') {
              toast.info('Paiement en cours de traitement', {
                description: 'Votre inscription sera confirmée dès réception du paiement.',
                duration: 5000
              });
              loadCompetitions();
            } else {
              toast.error('Paiement non confirmé', {
                description: 'Le paiement n\'a pas abouti. Veuillez réessayer.',
                duration: 5000
              });
            }
          } catch (error) {
            console.error('Erreur vérification paiement compétition:', error);
            toast.info('Paiement en cours de vérification', {
              description: 'Veuillez actualiser la page dans quelques instants.',
              duration: 5000
            });
            loadCompetitions();
          }
        } else if (paymentStatus === 'cancelled') {
          // Supprimer l'inscription en attente quand le paiement est annulé
          try {
            await clientPortalApi.cancelCompetitionRegistration(token, competitionId);
          } catch (e) {
            console.log('Inscription déjà annulée ou inexistante');
          }
          toast.info('Paiement annulé', {
            description: 'Votre inscription n\'a pas été validée. Vous pouvez réessayer.',
            duration: 4000
          });
          loadCompetitions();
          setActiveTab('competitions');
        }
        return;
      }

      // ========== PAIEMENT COTISATION ==========
      if (subscriptionId) {
        if (paymentStatus === 'success') {
          try {
            let statusOk = serverVerified;
            let status = null;
            
            if (!serverVerified) {
              // Vérifier côté API seulement si le serveur n'a pas déjà traité
              for (let attempt = 1; attempt <= 5; attempt++) {
                status = await clientPortalApi.getSubscriptionPaymentStatus(token, subscriptionId, stripeSessionId);
                if (status.payment_status === 'paid' || status.status === 'paid') { statusOk = true; break; }
                await new Promise(r => setTimeout(r, attempt * 1000));
              }
            }
            
            if (statusOk) {
              toast.success('Cotisation payée !', {
                description: 'Votre cotisation a été renouvelée pour un an.',
                duration: 6000
              });
            } else {
              toast.info('Paiement en cours de traitement', {
                description: 'Votre cotisation sera mise à jour sous peu. Actualisez la page dans quelques instants.',
                duration: 5000
              });
            }
            // Toujours rafraîchir les données
            try {
              const [updatedProfile, updatedSettings] = await Promise.all([
                clientPortalApi.getProfile(token),
                clientPortalApi.getPortalSettings(token)
              ]);
              setClient(updatedProfile);
              setPortalSettings(updatedSettings);
            } catch (e) {
              console.error('Erreur rechargement profil:', e);
            }
            loadData();
            setActiveTab('account');
          } catch (error) {
            console.error('Erreur vérification paiement cotisation:', error);
            // Si server_verified, on sait que c'est bon côté serveur
            if (serverVerified) {
              toast.success('Cotisation payée !', { description: 'Votre cotisation a été renouvelée.', duration: 6000 });
            } else {
              toast.info('Paiement en cours de vérification', { description: 'Veuillez actualiser la page.', duration: 5000 });
            }
            loadData();
            setActiveTab('account');
          }
        } else if (paymentStatus === 'cancelled') {
          toast.info('Paiement annulé', {
            description: 'Vous pouvez réessayer à tout moment.',
            duration: 4000
          });
        }
        return;
      }

      // ========== PAIEMENT PACK BOUTIQUE ==========
      if (paymentType === 'pack' && purchaseId) {
        if (paymentStatus === 'success') {
          try {
            let statusOk = serverVerified;
            let status = null;
            
            if (!serverVerified) {
              for (let attempt = 1; attempt <= 5; attempt++) {
                try {
                  let url = `${API_URL}/api/portal/pack-purchase/${purchaseId}/status`;
                  if (stripeSessionId) url += `?session_id=${encodeURIComponent(stripeSessionId)}`;
                  const res = await fetch(url, {
                    headers: { 'Authorization': `Bearer ${token}` }
                  });
                  if (res.ok) {
                    status = await res.json();
                    if (status.payment_status === 'paid' || status.status === 'paid') { statusOk = true; break; }
                  }
                } catch (e) { console.log(`Pack status check attempt ${attempt} failed:`, e); }
                await new Promise(r => setTimeout(r, attempt * 1000));
              }
              
              // Fallback: verify-stripe-session
              if (!statusOk && stripeSessionId) {
                try {
                  const verifyRes = await fetch(`${API_URL}/api/payments/verify-stripe-session`, {
                    method: 'POST',
                    headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                    body: JSON.stringify({ session_id: stripeSessionId })
                  });
                  if (verifyRes.ok) {
                    const verifyData = await verifyRes.json();
                    if (verifyData.status === 'paid' || verifyData.payment_status === 'paid') {
                      statusOk = true;
                      status = { payment_status: 'paid', hours_credited: verifyData.hours_credited || 0, message: verifyData.message };
                    }
                  }
                } catch (e) { console.log('Verify-stripe-session fallback failed:', e); }
              }
            }
            
            if (statusOk) {
              toast.success('Achat confirmé !', {
                description: status?.message || 'Heures ajoutées à votre carnet.',
                duration: 6000
              });
            } else {
              toast.info('Paiement en cours de traitement', {
                description: 'Vos heures seront créditées sous peu. Actualisez la page.',
                duration: 5000
              });
            }
            // Toujours rafraîchir le profil et les settings
            try {
              const [profileData, settings] = await Promise.all([
                clientPortalApi.getProfile(token),
                clientPortalApi.getPortalSettings(token)
              ]);
              setClient(profileData);
              setPortalSettings(settings);
            } catch (e) { console.log('Refresh after pack payment:', e); }
            setActiveTab('boutique');
          } catch (error) {
            console.error('Erreur vérification achat pack:', error);
            if (serverVerified) {
              toast.success('Achat confirmé !', { description: 'Heures créditées sur votre carnet.', duration: 6000 });
            } else {
              toast.info('Paiement en cours de vérification', { description: 'Veuillez actualiser la page.', duration: 5000 });
            }
            setActiveTab('boutique');
          }
        } else if (paymentStatus === 'cancelled') {
          toast.info('Achat annulé', { description: 'Vous pouvez réessayer à tout moment.', duration: 4000 });
          setActiveTab('boutique');
        }
        return;
      }

      // ========== PAIEMENT COMMANDE TAYLOR MADE ==========
      if (orderId) {
        if (paymentStatus === 'success') {
          try {
            const status = await clientPortalApi.getFittingOrderPaymentStatus(token, orderId);
            
            if (status.payment_status === 'paid' || status.status === 'paid') {
              toast.success('Paiement reçu !', {
                description: 'Votre commande TaylorMade est réglée. Nous vous prévenons dès que votre matériel arrive au club ; la facture vous sera remise au retrait.',
                duration: 7000
              });
              // Recharger les commandes fitting
              loadFittingOrders();
              setActiveTab('boutique');
            } else if (status.payment_status === 'pending') {
              toast.info('Paiement en cours de traitement', {
                description: 'Vous recevrez une confirmation par email.',
                duration: 5000
              });
              loadFittingOrders();
            } else {
              toast.error('Erreur de paiement', {
                description: 'Le paiement n\'a pas abouti. Veuillez réessayer.',
                duration: 5000
              });
            }
          } catch (error) {
            console.error('Erreur vérification paiement commande:', error);
            loadFittingOrders();
            toast.info('Paiement en cours de vérification', {
              description: 'Veuillez actualiser la page dans quelques instants.',
              duration: 5000
            });
          }
        } else if (paymentStatus === 'cancelled') {
          toast.info('Paiement annulé', {
            description: 'Vous pouvez réessayer à tout moment.',
            duration: 4000
          });
          setActiveTab('boutique');
        }
        return;
      }

      // ========== FALLBACK: PAIEMENT GÉNÉRIQUE via verify-stripe-session ==========
      if (paymentStatus === 'success' && stripeSessionId) {
        try {
          // Appeler verify-stripe-session comme fallback pour traiter le paiement
          let verifyResult = null;
          for (let attempt = 1; attempt <= 3; attempt++) {
            const res = await fetch(`${API_URL}/api/payments/verify-stripe-session`, {
              method: 'POST',
              headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
              body: JSON.stringify({ session_id: stripeSessionId })
            });
            verifyResult = await res.json();
            if (verifyResult.status === 'paid' || verifyResult.payment_status === 'paid') break;
            await new Promise(r => setTimeout(r, attempt * 2000));
          }
          
          if (verifyResult && (verifyResult.status === 'paid' || verifyResult.payment_status === 'paid')) {
            toast.success('Paiement confirmé !', {
              description: verifyResult.message || 'Votre paiement a été enregistré.',
              duration: 6000
            });
          } else {
            toast.info('Paiement en cours de traitement', {
              description: 'Vous recevrez une confirmation sous peu.',
              duration: 5000
            });
          }
          // Rafraîchir toutes les données
          try {
            const [profileData, settings] = await Promise.all([
              clientPortalApi.getProfile(token),
              clientPortalApi.getPortalSettings(token)
            ]);
            setClient(profileData);
            setPortalSettings(settings);
          } catch (e) { console.log('Refresh after payment:', e); }
          loadData();
          loadPaymentHistory();
        } catch (error) {
          console.error('Erreur vérification paiement fallback:', error);
          toast.info('Paiement en cours de vérification', {
            description: 'Veuillez actualiser la page dans quelques instants.'
          });
        }
      } else if (paymentStatus === 'cancelled') {
        // Annulation de paiement - nettoyer les inscriptions en attente si nécessaire
        const stageId = searchParams.get('stage_id');
        if (paymentType === 'stage' && stageId) {
          try {
            await fetch(`${API_URL}/api/client-portal/stages/${stageId}/cancel-pending`, {
              method: 'DELETE',
              headers: { 'Authorization': `Bearer ${token}` }
            });
          } catch (e) {}
        }
        toast.info('Paiement annulé', {
          description: 'Vous pouvez réessayer à tout moment.',
          duration: 4000
        });
      }
    }
  }, [searchParams, setSearchParams, token]);

  useEffect(() => {
    if (token) {
      handlePaymentReturn();
    }
  }, [token, handlePaymentReturn]);

  // Charger les données quand authentifié
  useEffect(() => {
    if (isAuthenticated && token) {
      loadData();
      // Toujours (re)charger les settings authentifiés : les public-settings chargés avant login
      // ne contiennent ni le carnet, ni le statut membre du client (token change à chaque login/switch)
      clientPortalApi.getPortalSettings(token)
        .then(settings => { if (settings) setPortalSettings(settings); })
        .catch(e => console.log('Settings load failed:', e));
    }
  }, [isAuthenticated, token]);

  // Statut tarif membre (Départs/Boutique) dérivé des portal settings chargés au boot
  useEffect(() => {
    if (portalSettings && typeof portalSettings.client_is_member === 'boolean') {
      setClientIsMember(portalSettings.client_is_member);
    }
  }, [portalSettings]);

  // Statuts légers nécessaires dès l'Accueil / le menu (onglet Départs, École, carte Jouer,
  // réservation restaurant). Chargés une seule fois au login — payloads < 3 KB chacun.
  useEffect(() => {
    if (!isAuthenticated || !token) return;
    loadTeeTimeSettings();
    loadRestaurantReservation();
    loadAccountBalance();
  }, [isAuthenticated, token]);

  // Charger le dashboard
  useEffect(() => {
    if (isAuthenticated && token && activeTab === 'dashboard') {
      setDashboardLoading(true);
      authenticatedFetch(`${API_URL}/api/client-portal/dashboard`)
        .then(res => res.json())
        .then(data => setDashboardData(data))
        .catch(() => {})
        .finally(() => setDashboardLoading(false));
      // Récap « Mes soldes » à jour à chaque retour sur l'accueil
      loadAccountBalance();
      loadPractice();
      clientPortalApi.getPortalSettings(token).then(s => { if (s) setPortalSettings(s); }).catch(() => {});
    }
  }, [isAuthenticated, token, activeTab]);

  // Vérifier l'appartenance à l'académie (École de Golf)
  const checkAcademyStatus = useCallback(() => {
    if (!isAuthenticated || !token) return;
    Promise.all([
      fetch(`${API_URL}/api/golf-school/is-academy-member`, { headers: { 'Authorization': `Bearer ${token}` } }),
      fetch(`${API_URL}/api/golf-school/portal-status`, { headers: { 'Authorization': `Bearer ${token}` } }),
    ]).then(async ([memberRes, statusRes]) => {
      const memberData = memberRes.ok ? await memberRes.json() : null;
      const statusData = statusRes.ok ? await statusRes.json() : null;
      const isMember = memberData?.is_member === true;
      const isEnabled = statusData?.enabled === true;
      setIsAcademyMember(isMember && isEnabled);
    }).catch(() => {});
  }, [isAuthenticated, token]);

  // Status académie : nécessaire au boot pour afficher l'onglet "École" dans le menu
  useEffect(() => {
    if (!isAuthenticated || !token) return;
    checkAcademyStatus();
  }, [checkAcademyStatus, isAuthenticated, token]);

  // iter316.58 — Vérifier si le module Scorecard est activé côté admin
  // Nécessaire au boot : la carte "Jouer une partie" est affichée sur l'Accueil (payload ~2 KB)
  useEffect(() => {
    if (!isAuthenticated || !token) return;
    fetch(`${API_URL}/api/portal/course-config`, { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(d => setScorecardModuleEnabled(!!d?.module_enabled))
      .catch(() => setScorecardModuleEnabled(false));
  }, [isAuthenticated, token]);

  // Re-vérifier quand la page regagne le focus (ex: admin bascule entre onglets)
  useEffect(() => {
    const onFocus = () => checkAcademyStatus();
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [checkAcademyStatus]);


  // Charger les documents automatiquement quand l'onglet "Mon compte" est affiché
  useEffect(() => {
    // Charger les documents si on est sur l'onglet account et que les documents ne sont pas désactivés
    // (par défaut on les charge, sauf si explicitement désactivés)
    if (isAuthenticated && token && activeTab === 'account') {
      // Ne pas charger si explicitement désactivé
      if (portalSettings && portalSettings.show_documents === false) {
        return;
      }
      loadDocuments();
      loadPaymentHistory();
      
      // Re-fetch linked profiles to catch admin-added profiles
      (async () => {
        try {
          const res = await authenticatedFetch(`${API_URL}/api/client-portal/linked-profiles`);
          if (res.ok) {
            const data = await res.json();
            setLinkedProfiles(data.profiles && data.profiles.length > 1 ? data.profiles : null);
          }
        } catch (e) { /* silent */ }
      })();
      
      // Rafraîchissement automatique de l'historique des paiements toutes les 30 secondes
      const interval = setInterval(() => {
        loadPaymentHistory();
      }, 30000);
      
      return () => clearInterval(interval);
    }
  }, [isAuthenticated, token, activeTab, portalSettings]);
  
  // Détecter le retour d'un paiement Stripe - cleanup localStorage uniquement
  useEffect(() => {
    localStorage.removeItem('pending_stripe_payment');
  }, []);


  // Onglet Cours : créneaux de cours individuels à jour pour la vue jour
  const refreshDashboardData = () => authenticatedFetch(`${API_URL}/api/client-portal/dashboard`)
    .then(res => res.json())
    .then(data => setDashboardData(data))
    .catch(() => {});
  useEffect(() => {
    if (!isAuthenticated || !token || activeTab !== 'cours') return;
    refreshDashboardData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, token, activeTab]);

  // Charger les packs quand on affiche l'onglet boutique
  useEffect(() => {
    if (isAuthenticated && token && activeTab === 'boutique') {
      loadCoursePacks();
      loadFittingOrders();
      loadPractice(); // iter313.3 — Charge balance + QR + packs Practice
    }
  }, [isAuthenticated, token, activeTab]);

  // Les stages sont maintenant chargés dans loadData

  // ========== RESTAURANT ==========
  const loadRestaurantReservation = async () => {
    try {
      const res = await authenticatedFetch(`${API_URL}/api/client-portal/restaurant/my-reservations`);
      if (res.ok) {
        const d = await res.json();
        setRestaurantReservation(d.reservations?.[0] || null);
      }
    } catch (e) { /* silent */ }
  };

  const loadRestaurantSlots = async (date) => {
    if (!date) return;
    setRestaurantLoading(true);
    try {
      const res = await authenticatedFetch(`${API_URL}/api/client-portal/restaurant/slots?date=${date}`);
      if (res.ok) {
        const d = await res.json();
        if (d.day_closed) { setRestaurantSlots([]); toast.info('Le restaurant est fermé ce jour'); }
        else if (!d.enabled) { setRestaurantSlots([]); toast.info('La réservation en ligne n\'est pas disponible'); }
        else setRestaurantSlots(d.slots || []);
      }
    } catch (e) { setRestaurantSlots([]); }
    setRestaurantLoading(false);
  };

  const loadRestaurantMenu = async () => {
    try {
      const res = await authenticatedFetch(`${API_URL}/api/client-portal/restaurant/menu`);
      if (res.ok) setRestaurantMenuData(await res.json());
    } catch (e) { /* silent */ }
  };

  const handleRestaurantReserve = async () => {
    if (!restaurantForm.date || !restaurantForm.time) { toast.error('Veuillez choisir une date et un créneau'); return; }
    setRestaurantLoading(true);
    try {
      const res = await authenticatedFetch(`${API_URL}/api/client-portal/restaurant/reserve`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(restaurantForm)
      });
      const resClone = res.clone();
      try {
        const d = await res.json();
        if (!res.ok) throw new Error(d.detail || 'Erreur');
        toast.success('Table réservée !');
        setShowRestaurantReserve(false);
        setRestaurantForm({ date: '', time: '', covers: 2, note: '' });
        setRestaurantReservation(d.reservation);
      } catch (e) {
        if (e.message && !e.message.includes('JSON')) throw e;
        await resClone.text();
        throw new Error('Erreur lors de la réservation');
      }
    } catch (e) { toast.error(e.message); }
    setRestaurantLoading(false);
  };

  const handleCancelRestaurantReservation = async (id) => {
    if (!window.confirm('Voulez-vous vraiment annuler votre réservation ?')) return;
    try {
      const res = await authenticatedFetch(`${API_URL}/api/client-portal/restaurant/my-reservations/${id}`, { method: 'DELETE' });
      if (res.ok) { toast.success('Réservation annulée'); setRestaurantReservation(null); }
      else { const d = await res.json(); toast.error(d.detail || 'Erreur'); }
    } catch (e) { toast.error('Erreur'); }
  };

  const loadData = async () => {
    setDataLoading(true);
    try {
      let startDate, endDate;
      
      if (viewMode === 'day') {
        startDate = format(currentDate, 'yyyy-MM-dd');
        endDate = format(addDays(currentDate, 1), 'yyyy-MM-dd');
      } else {
        startDate = format(startOfWeek(currentDate, { weekStartsOn: 1 }), 'yyyy-MM-dd');
        endDate = format(endOfWeek(currentDate, { weekStartsOn: 1 }), 'yyyy-MM-dd');
      }

      // iter318 fix perf — Charger seulement ce qui est visible sur l'accueil
      // au boot. Les onglets Cours (sessions/registrations/history/stages) chargent
      // leurs données au clic. Avant : 6 appels parallèles au boot (3-4s de blocage).
      // iter319 fix perf — getCompetitions() retourne 600+ KB (toutes les comps +
      // registrations), inutile pour l'Accueil (dashboard.upcoming_competitions
      // suffit pour les preview). Déplacé vers l'onglet Événements à la demande.
      const newsData = await clientPortalApi.getNews(token).catch(() => []);
      setNews(Array.isArray(newsData) ? newsData : []);
    } catch (error) {
      console.error('Erreur:', error);
      toast.error('Erreur lors du chargement des données');
    } finally {
      setDataLoading(false);
    }
  };

  // iter318 fix perf — Charger sessions/registrations/history/stages seulement
  // à l'ouverture des onglets qui les affichent (Cours, Stages).
  const loadCoursesData = useCallback(async () => {
    if (!token) return;
    let startDate, endDate;
    if (viewMode === 'day') {
      startDate = format(currentDate, 'yyyy-MM-dd');
      endDate = format(addDays(currentDate, 1), 'yyyy-MM-dd');
    } else {
      // Vue semaine : fin exclusive = lundi suivant 00:00 pour inclure tout le dimanche
      startDate = format(startOfWeek(currentDate, { weekStartsOn: 1 }), 'yyyy-MM-dd');
      endDate = format(addDays(endOfWeek(currentDate, { weekStartsOn: 1 }), 1), 'yyyy-MM-dd');
    }
    try {
      setDataLoading(true);
      const [sessionsData, registrationsData, historyData, stagesData] = await Promise.all([
        clientPortalApi.getSessions(token, startDate, endDate).catch(() => []),
        clientPortalApi.getMyRegistrations(token).catch(() => []),
        clientPortalApi.getRegistrationsHistory(token).catch(() => ({ upcoming: [], past: [] })),
        clientPortalApi.getStages(token).catch(() => ({ stages: [], client_is_member: false })),
      ]);
      setSessions(Array.isArray(sessionsData) ? sessionsData.filter(s => !s.is_stage && s.event_type !== 'stage') : []);
      setMyRegistrations(Array.isArray(registrationsData) ? registrationsData : []);
      setRegistrationsHistory(historyData || { upcoming: [], past: [] });
      setStages(stagesData?.stages || []);
      if (stagesData?.client_is_member) setClientIsMember(true);
    } catch (e) {
      console.error('loadCoursesData:', e);
    } finally {
      setDataLoading(false);
    }
  }, [token, viewMode, currentDate]);

  useEffect(() => {
    if (!isAuthenticated || !token) return;
    if (activeTab === 'cours' || activeTab === 'stages' || activeTab === 'events' || activeTab === 'reservations') {
      loadCoursesData();
    }
    // iter319 fix perf — Charger les compétitions UNIQUEMENT à l'ouverture
    // de l'onglet Événements (payload 600+ KB) au lieu de systématiquement
    // au boot sur l'Accueil.
    if (activeTab === 'competitions') {
      loadCompetitions();
    }
  }, [isAuthenticated, token, activeTab, loadCoursesData]);
  
  // Fonction pour recharger les données famille
  // ========== PAIEMENT COTISATION ==========
  const handlePaySubscription = async () => {
    if (subscriptionPaymentLoading) return;
    
    setSubscriptionPaymentLoading(true);
    try {
      // Récupérer d'abord les tarifs pour vérifier que le type est valide
      const priceInfo = await clientPortalApi.getSubscriptionPrices(token);
      
      if (!priceInfo.current_price) {
        toast.error('Tarif non disponible', {
          description: `Le tarif pour "${priceInfo.client_cotisation}" n'est pas configuré. Contactez l'accueil.`
        });
        return;
      }
      
      setSubscriptionPriceInfo(priceInfo);
      
      // Créer la session de paiement
      const result = await clientPortalApi.createSubscriptionPayment(token);
      
      if (result.checkout_url) {
        toast.info('Redirection vers Stripe...', {
          description: priceInfo.reverse_charge
            ? `Montant : ${priceInfo.current_price} € HT — autoliquidation art. 196 (TVA due par le preneur)`
            : `Montant: ${priceInfo.current_price}€`
        });
        // Redirection vers Stripe - le paiement sera confirmé via URL callback
        window.location.href = result.checkout_url;
      } else {
        toast.error('Erreur lors de la création du paiement');
      }
    } catch (error) {
      console.error('Erreur paiement cotisation:', error);
      toast.error('Erreur', {
        description: error.message || 'Impossible de créer le paiement'
      });
    } finally {
      setSubscriptionPaymentLoading(false);
    }
  };
  
  // Charger les compétitions

  // === Tee Times Functions ===
  const loadTeeTimeSettings = async () => {
    try {
      const res = await fetch(`${API_URL}/api/tee-times/portal/settings`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setTeeTimeSettings(data);
        if (data.account_balance !== undefined) setAccountBalance(Number(data.account_balance) || 0);
        setTeeTimeEnabled(true);
      } else {
        setTeeTimeEnabled(false);
      }
    } catch { setTeeTimeEnabled(false); }
  };

  // Créneaux par jour gardés en mémoire : un jour déjà vu (ou préparé à l'avance) s'affiche tout de suite, puis se met à jour discrètement
  const teeDayCacheRef = useRef(new Map());
  const teeReqDateRef = useRef(null);
  const teeShownDateRef = useRef(null);
  // Mobile : balayer vers la gauche = jour suivant, vers la droite = jour précédent (jamais avant aujourd'hui)
  const ttSwipe = useSwipe(
    useCallback(() => setTeeTimeDate(d => addDays(d, 1)), []),
    useCallback(() => setTeeTimeDate(d => { const prev = addDays(d, -1); const today = new Date(); today.setHours(0, 0, 0, 0); return prev < today ? d : prev; }), []),
    { threshold: 60 },
  );
  // Changement de profil / connexion : les créneaux (prix membre…) d'un autre profil ne sont jamais réaffichés
  useEffect(() => {
    teeDayCacheRef.current.clear();
    teeShownDateRef.current = null;
  }, [token]);

  const fetchTeeDay = async (dateStr) => {
    const res = await fetch(`${API_URL}/api/tee-times/portal/slots/${dateStr}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) return null;
    const data = await res.json();
    const day = { slots: data.slots || [], dayLimit: data.day_limit_message || '' };
    const cache = teeDayCacheRef.current;
    cache.delete(dateStr);
    cache.set(dateStr, day);
    if (cache.size > 30) cache.delete(cache.keys().next().value);
    return day;
  };

  const prefetchTeeDays = (dateStr) => {
    const base = parseISO(dateStr);
    const today = format(new Date(), 'yyyy-MM-dd');
    [1, -1, 2, -2].forEach((n) => {
      const d = format(addDays(base, n), 'yyyy-MM-dd');
      if (d >= today && !teeDayCacheRef.current.has(d)) fetchTeeDay(d).catch(() => {});
    });
  };

  const loadTeeTimeSlots = async (dateStr) => {
    teeReqDateRef.current = dateStr;
    const apply = (day) => {
      setTeeTimeSlots(day.slots);
      setTeeTimeDayLimit(day.dayLimit);
      teeShownDateRef.current = dateStr;
    };
    const cached = teeDayCacheRef.current.get(dateStr);
    if (cached) apply(cached);
    else if (teeShownDateRef.current !== dateStr) setTeeTimeLoading(true);
    try {
      const day = await fetchTeeDay(dateStr);
      if (day && teeReqDateRef.current === dateStr) apply(day);
    } catch (e) { console.error(e); }
    if (teeReqDateRef.current === dateStr) {
      setTeeTimeLoading(false);
      prefetchTeeDays(dateStr);
    }
  };

  const loadTeeTimeMyBookings = async () => {
    try {
      const res = await fetch(`${API_URL}/api/tee-times/portal/my-bookings`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setTeeTimeMyBookings(data.bookings || []);
      }
    } catch (e) { console.error(e); }
  };

  // Handler post-Stripe : si l'URL contient booking_modified=1 + booking_id + success/cancelled
  useEffect(() => {
    if (!token) return;
    const params = new URLSearchParams(window.location.search);
    const isBookingModified = params.get('booking_modified') === '1';
    if (!isBookingModified) return;
    const bookingModifId = params.get('booking_id');
    const modSuccess = params.get('success');
    const modCancelled = params.get('cancelled');
    const sessionId = params.get('session_id') || params.get('checkout_session_id');
    if (bookingModifId && (modSuccess || modCancelled)) {
      if (modSuccess === '1') {
        // Confirmer côté backend
        fetch(`${API_URL}/api/tee-times/portal/bookings/${bookingModifId}/modification-confirm?session_id=${sessionId || ''}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
          .then(r => r.ok ? r.json() : null)
          .then(d => {
            if (d?.status === 'confirmed') toast.success('Paiement confirmé — réservation mise à jour');
            else if (d?.status === 'pending') toast.info('Paiement en cours de traitement...');
            else if (d?.status === 'not_found') { /* déjà consommée — silencieux */ }
            else toast.error('Modification non confirmée');
            loadTeeTimeMyBookings();
            // Nettoyer l'URL
            window.history.replaceState({}, '', window.location.pathname);
          })
          .catch(() => {
            window.history.replaceState({}, '', window.location.pathname);
          });
      } else if (modCancelled === '1') {
        toast.info('Modification annulée');
        window.history.replaceState({}, '', window.location.pathname);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);


  const rebookGuest = (guest) => {
    // Pré-charge l'invité — sera appliqué au prochain clic de créneau
    setPendingGuestRebook({
      id: guest.id || '',
      first_name: guest.first_name || '',
      last_name: guest.last_name || '',
      email: guest.email || '',
      phone: guest.phone || '',
    });
    setTeeTimeSubTab('planning');
    toast.info(`Choisissez un créneau pour ${guest.first_name} ${guest.last_name}`);
  };

  const openModifyBookingModal = (booking) => {
    setModifyBooking(booking);
    setModifyForm({ mode: null, memberSearch: '', memberResults: [], guest: { first_name: '', last_name: '', email: '', phone: '' }, cartsToAdd: 0 });
  };

  const searchMembersForAdd = async (query) => {
    if (!query || query.length < 2) { setModifyForm(p => ({ ...p, memberResults: [] })); return; }
    try {
      const res = await fetch(`${API_URL}/api/tee-times/portal/search-clients?q=${encodeURIComponent(query)}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        const memberGroups = (teeTimeSettings?.member_groups || ['Membres', 'Joueurs Aio', 'Abonnés']).map(g => g.toLowerCase());
        const members = (data.clients || data || []).filter(c => memberGroups.includes((c.group || '').toLowerCase()));
        setModifyForm(p => ({ ...p, memberResults: members.slice(0, 8) }));
      }
    } catch (e) { /* silent */ }
  };

  const submitModify = async (payload) => {
    if (!modifyBooking) return;
    setModifyLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/tee-times/portal/bookings/${modifyBooking.id}`, {
        method: 'PATCH',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Erreur');
      if (data.checkout_url) {
        window.location.href = data.checkout_url;
        return;
      }
      toast.success(data.message || 'Modifié');
      setModifyBooking(null);
      await loadTeeTimeMyBookings();
    } catch (e) {
      toast.error(e.message);
    }
    setModifyLoading(false);
  };


  const loadFrequentPartners = () => {
    fetch(`${API_URL}/api/tee-times/portal/frequent-partners`, { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : { partners: [] }).then(d => setFrequentPartners(d.partners || [])).catch(() => {});
  };

  const toggleFavoritePartner = async (partner) => {
    const isFav = frequentPartners.some(p => p.id === partner.id && p.favorite);
    try {
      const res = isFav
        ? await fetch(`${API_URL}/api/tee-times/portal/partners/favorites/${partner.id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } })
        : await fetch(`${API_URL}/api/tee-times/portal/partners/favorites`, { method: 'POST', headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify({ client_id: partner.id }) });
      if (!res.ok) throw new Error((await res.json()).detail || 'Erreur');
      toast.success(isFav ? `${partner.first_name} retiré de vos favoris` : `${partner.first_name} épinglé : proposé à chaque réservation`);
      loadFrequentPartners();
    } catch (e) { toast.error(e.message); }
  };

  const openTeeTimeBooking = (slotTime) => {
    setSelectedTeeTimeSlot(slotTime);
    // Membre société : « payer pour l'accompagnant » coché par défaut (l'accompagnant n'est pas un invité offert)
    setTeeTimeBookingForm({ players_count: 1, notes: '', use_carnet: false, player_names: [], companions: [], pay_for_others: !!client?.societe });
    setTtQuote(null);
    // Si un rebook est en attente, active le mode invité avec les données pré-remplies
    if (pendingGuestRebook) {
      setSocieteGuestMode(true);
      setSocieteGuests(pendingGuestRebook.first_name || pendingGuestRebook.last_name ? [pendingGuestRebook] : []);
      setPendingGuestRebook(null);
    } else {
      setSocieteGuestMode(false);
      setSocieteGuests([]);
    }
    setSocieteGuestPreview(null);
    setRepAlsoPlays(false);
    setShowTeeTimeBookingModal(true);
    loadFrequentPartners();
    // Charger la liste des invités mémorisés si le client a une société
    if (client?.societe && !societeGuestsLoaded) {
      fetch(`${API_URL}/api/tee-times/portal/societe/guests`, {
        headers: { 'Authorization': `Bearer ${token}` }
      })
        .then(r => r.ok ? r.json() : null)
        .then(d => {
          if (d) {
            setSocieteGuestsList(d.guests || []);
            setSocieteGuestsLoaded(true);
          }
        })
        .catch(() => {});
    }
  };

  // Tarif détaillé (backend, même calcul que la réservation) : votre GF + celui de chaque accompagnant selon sa fiche
  const ttCompanionKey = (teeTimeBookingForm.companions || []).filter(c => c).map(c => c.id || `${c.first_name}-${c.last_name}`).join('|');
  useEffect(() => {
    if (!showTeeTimeBookingModal || !selectedTeeTimeSlot || !token || (societeGuestMode && teeTimeBookingForm.players_count < 2)) { setTtQuoteLoading(false); return undefined; }
    const comps = (teeTimeBookingForm.companions || []).filter(c => c);
    const ctrl = new AbortController();
    setTtQuoteLoading(true);
    const t = setTimeout(async () => {
      try {
        const r = await fetch(`${API_URL}/api/tee-times/portal/book-quote`, {
          method: 'POST', signal: ctrl.signal,
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({ slot_date: format(teeTimeDate, 'yyyy-MM-dd'), slot_time: selectedTeeTimeSlot, players_count: teeTimeBookingForm.players_count,
            guest_mode: societeGuestMode, rep_plays: repAlsoPlays,
            companion_ids: comps.map(c => c.id), player_names: comps.map(c => `${c.first_name} ${c.last_name}`) })
        });
        if (r.ok) setTtQuote(await r.json()); else setTtQuote({ error: true });
        setTtQuoteLoading(false);
      } catch (e) { if (e?.name !== 'AbortError') { setTtQuote({ error: true }); setTtQuoteLoading(false); } }
    }, 200);
    return () => { clearTimeout(t); ctrl.abort(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showTeeTimeBookingModal, selectedTeeTimeSlot, teeTimeDate, societeGuestMode, repAlsoPlays, teeTimeBookingForm.players_count, ttCompanionKey, token]);

  const computeTtTotals = () => {
    const cartCount = teeTimeBookingForm.cart_count || 0;
    const cartPrice = cartUnitPrice(teeTimeSettings, client?.group);
    const nGuests = Math.max(1, societeGuests.filter(g => g.first_name || g.last_name).length);
    const slotForCarnet = teeTimeSlots.find(sl => sl.time === selectedTeeTimeSlot);
    // Carnet refusé par le backend sur un créneau « GF payant » (hors droits de jeu de la cotisation)
    const carnet = !societeGuestMode && !!teeTimeBookingForm.use_carnet && !(ttQuote?.booker?.override || slotForCarnet?.cotisation_paid_gf);
    // Carnet : couvre votre GF payant puis ceux des accompagnants que vous payez (même règle que le serveur)
    let carnetLeft = carnet ? Number(portalSettings?.green_fee_carnet_remaining || 0) : 0;
    const q = ttQuote && !ttQuote.error ? ttQuote : null;
    const hasCompanions = teeTimeBookingForm.players_count > 1;
    const payOthers = !!teeTimeBookingForm.pay_for_others && hasCompanions;
    let bookerGF; let bookerLabel = ''; let bookerCarnet = false;
    if (societeGuestMode) {
      const paidGuests = Math.max(0, nGuests - offeredGuestsFor(societeGuestPreview, repAlsoPlays));
      const repGF = repAlsoPlays && societeGuestPreview?.rep && !societeGuestPreview.rep.free ? (societeGuestPreview.rep.price || 0) : 0;
      bookerGF = paidGuests * (societeGuestPreview?.guest_price ?? 0) + repGF;
    } else {
      const slot = teeTimeSlots.find(sl => sl.time === selectedTeeTimeSlot);
      const localBooker = slot?.cotisation_paid_gf ? Number(slot.cotisation_paid_gf_price || 0) : 0;
      const rawBooker = q ? Number(q.booker?.price || 0) : localBooker;
      bookerCarnet = carnet && rawBooker > 0 && carnetLeft > 0;
      if (bookerCarnet) carnetLeft -= 1;
      bookerGF = bookerCarnet ? 0 : rawBooker;
      bookerLabel = q?.booker?.label || '';
    }
    const companions = (hasCompanions ? (q?.companions || []) : []).map(c => {
      const covered = carnet && payOthers && Number(c.price) > 0 && carnetLeft > 0;
      if (covered) carnetLeft -= 1;
      return { ...c, carnet: covered };
    });
    const companionsTotal = companions.reduce((s, c) => s + (c.carnet ? 0 : Number(c.price || 0)), 0);
    const carnetUsed = (bookerCarnet ? 1 : 0) + companions.filter(c => c.carnet).length;
    const companionGF = payOthers ? companionsTotal : 0;
    const companionsOnsite = payOthers ? 0 : companionsTotal;
    const cartOnsite = !!teeTimeBookingForm.cart_onsite && !!teeTimeSettings?.cart_on_site_allowed && cartPrice > 0 && cartCount > 0;
    const totalCart = cartOnsite ? 0 : cartPrice * cartCount;
    const total = Math.round((bookerGF + companionGF + totalCart) * 100) / 100;
    const quoteReady = societeGuestMode ? (!hasCompanions || !!ttQuote) : !!ttQuote;
    return { carnet, bookerCarnet, carnetUsed, cartCount, cartPrice, nGuests, bookerGF, bookerLabel, companions, companionsTotal, payOthers, companionGF, companionsOnsite, cartOnsite, totalCart, total, quoteReady };
  };
  const eur = (v) => `${Number.isInteger(Number(v)) ? Number(v) : Number(v).toFixed(2)}€`;

  const handleBookTeeTime = async () => {
    if (!selectedTeeTimeSlot) return;
    // Validation invités
    const guestsClean = societeGuestMode ? societeGuests.map(g => ({ ...g, first_name: (g.first_name || '').trim(), last_name: (g.last_name || '').trim(), email: (g.email || '').trim(), phone: (g.phone || '').trim() })).filter(g => g.first_name || g.last_name || g.email) : [];
    if (societeGuestMode) {
      if (!guestsClean.length || guestsClean.some(g => !g.first_name || !g.last_name)) {
        toast.error('Nom et prénom de chaque invité obligatoires');
        return;
      }
    }
    setTeeTimeBookingLoading(true);
    try {
      const dateStr = format(teeTimeDate, 'yyyy-MM-dd');
      const body = {
        slot_date: dateStr,
        slot_time: selectedTeeTimeSlot,
        players_count: teeTimeBookingForm.players_count,
        notes: teeTimeBookingForm.notes,
        use_carnet: teeTimeBookingForm.use_carnet,
        cart_reserved: teeTimeBookingForm.cart_count || 0,
        cart_payment_mode: teeTimeBookingForm.cart_onsite && teeTimeSettings?.cart_on_site_allowed ? 'onsite' : 'online',
        use_account: !!useAccountPay,
        pay_for_others: teeTimeBookingForm.pay_for_others || false,
        player_names: (teeTimeBookingForm.companions || []).filter(c => c).map(c => `${c.first_name} ${c.last_name}`),
        companion_ids: (teeTimeBookingForm.companions || []).filter(c => c).map(c => c.id)
      };
      let repCheckoutUrl = null;
      if (societeGuestMode) {
        body.guests = guestsClean.map(g => ({ first_name: g.first_name, last_name: g.last_name, email: g.email, phone: g.phone, client_id: g.id || null }));
        // Accompagnants payants (hors invitation société) : conservés dans le même flight, même si vous ne jouez pas
        const extras = Math.max(0, teeTimeBookingForm.players_count - 1);
        const filled = (teeTimeBookingForm.companions || []).slice(0, extras).filter(c => c);
        body.companion_ids = filled.map(c => c.id);
        body.player_names = [...filled.map(c => `${c.first_name} ${c.last_name}`), ...Array.from({ length: extras - filled.length }, (_, i) => `Accompagnant ${filled.length + i + 1}`)];
        body.players_count = body.guests.length + extras;
        body.pay_for_others = extras > 0 && !!teeTimeBookingForm.pay_for_others;
        if (repAlsoPlays) {
          // « Je joue aussi » : le représentant est réservé en premier dans le même flight (règle société : il compte 1 joueur)
          const repRes = await fetch(`${API_URL}/api/tee-times/portal/book`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify({ slot_date: dateStr, slot_time: selectedTeeTimeSlot, players_count: 1, notes: teeTimeBookingForm.notes, use_carnet: false, cart_reserved: 0, player_names: [], companion_ids: [] })
          });
          const repData = await repRes.json();
          if (!repRes.ok) throw new Error(`Votre propre départ n'a pas pu être réservé : ${repData.detail}`);
          if (repData.checkout_url) repCheckoutUrl = repData.checkout_url;
        }
      }
      const res = await fetch(`${API_URL}/api/tee-times/portal/book`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail);
      
      if (data.free || data.paid_by_account) {
        toast.success(societeGuestMode && repAlsoPlays && !repCheckoutUrl ? 'Invité(s) et votre départ réservés dans le même flight' : (data.message || 'Départ réservé !'));
        if (data.paid_by_account) loadAccountBalance();
        if (data.carnet_remaining != null) setPortalSettings(prev => (prev ? { ...prev, green_fee_carnet_remaining: data.carnet_remaining } : prev));
        setShowTeeTimeBookingModal(false);
        // Recharger la liste des invités pour la prochaine résa
        setSocieteGuestsLoaded(false);
        if (repCheckoutUrl) {
          toast.info('Invités réservés — paiement de votre propre green fee…');
          window.location.href = repCheckoutUrl;
          return;
        }
        await loadTeeTimeSlots(dateStr);
        await loadTeeTimeMyBookings();
      } else if (data.checkout_url) {
        toast.success(data.account_amount > 0 ? `${Number(data.account_amount).toFixed(2)}€ sur votre compte · redirection vers le paiement du reste (${Number(data.stripe_amount ?? data.price).toFixed(2)}€)…` : `Redirection vers le paiement (${data.price}€)...`);
        // Redirection vers Stripe
        window.location.href = data.checkout_url;
      }
    } catch (e) {
      toast.error(e.message);
    }
    setTeeTimeBookingLoading(false);
  };

  const handleCancelTeeTime = (bookingId) => {
    const b = teeTimeMyBookings.find(x => x.id === bookingId);
    if (b) setCancelTeeTimeBooking(b);
  };

  // Réservations à venir uniquement (les départs passés ne sont plus gérables)
  const upcomingTeeTimeBookings = useMemo(() => {
    const now = Date.now();
    return teeTimeMyBookings.filter(b => b.status !== 'cancelled' && b.slot_date && new Date(`${b.slot_date}T${b.slot_time || '23:59'}:00`).getTime() >= now);
  }, [teeTimeMyBookings]);

  // Délai client (annulation / changement d'horaire) — même règle que le backend (cancellation_hours_before)
  const teeTimeCanManage = (b) => {
    const hours = Number(teeTimeSettings?.cancellation_hours_before ?? 24);
    const slotTs = new Date(`${b.slot_date}T${b.slot_time || '00:00'}:00`).getTime();
    return slotTs - Date.now() >= hours * 3600 * 1000;
  };

  // Mes réservations de départs : lazy sur l'onglet Départs (les settings sont chargés au boot)
  useEffect(() => {
    if (!isAuthenticated || !token) return;
    if (activeTab !== 'departs') return;
    loadTeeTimeMyBookings();
  }, [isAuthenticated, token, activeTab]);

  // Compteur de contrats en attente : nécessaire au boot pour le badge du menu "Mon Compte"
  useEffect(() => {
    if (!isAuthenticated || !token) { setPendingContractsCount(0); return; }
    (async () => {
      try {
        const r = await fetch(`${API_URL}/api/client-portal/contracts`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!r.ok) return;
        const data = await r.json();
        const pending = (data.contracts || []).filter((c) => c.status !== 'signed').length;
        setPendingContractsCount(pending);
      } catch { /* silencieux */ }
    })();
  }, [isAuthenticated, token]);

  // Charger les créneaux quand on change de date ou de tab
  useEffect(() => {
    if (isAuthenticated && token && activeTab === 'departs' && teeTimeEnabled) {
      loadTeeTimeSlots(format(teeTimeDate, 'yyyy-MM-dd'));
    }
  }, [isAuthenticated, token, activeTab, teeTimeDate, teeTimeEnabled]);

  const loadCompetitions = async () => {
    if (!token) return;
    try {
      const data = await clientPortalApi.getCompetitions(token);
      setCompetitions(data.competitions || []);
      setClientIsMember(data.client_is_member || false);
    } catch (error) {
      console.error('Erreur chargement compétitions:', error);
    }
  };
  
  // Inscription à une compétition
  // Recherche d'accompagnants pour afterwork gratuit
  useEffect(() => {
    if (!showCompetitionModal || !selectedCompetition) return;
    if (selectedCompetition.event_type !== 'afterwork') return;
    const term = afterworkGuestSearch.trim();
    if (term.length < 2) { setAfterworkGuestResults([]); return; }
    const t = setTimeout(async () => {
      setAfterworkGuestSearching(true);
      try {
        const list = await clientPortalApi.searchGuestsForCompetition(token, selectedCompetition.id, term);
        const selectedIds = new Set(selectedAfterworkGuests.map((c) => c.id));
        setAfterworkGuestResults((list || []).filter((c) => !selectedIds.has(c.id)));
      } catch (_e) {
        setAfterworkGuestResults([]);
      } finally {
        setAfterworkGuestSearching(false);
      }
    }, 250);
    return () => clearTimeout(t);
  }, [afterworkGuestSearch, showCompetitionModal, selectedCompetition, selectedAfterworkGuests, token]);

  const handleRegisterCompetition = async (competitionId) => {
    // Vérifier que les options obligatoires sont sélectionnées
    const comp = selectedCompetition;
    if (comp?.custom_options?.length > 0 && comp.custom_options_required) {
      if (!selectedCustomOptions || selectedCustomOptions.length === 0) {
        toast.error(comp.custom_options_label || 'Veuillez faire un choix');
        return;
      }
    }
    
    setCompetitionRegistrationLoading(true);
    try {
      // Afterwork gratuit → endpoint direct (supporte accompagnants)
      const memberPrice = parseFloat(comp?.member_price ?? comp?.price ?? 0);
      const nonMemberPrice = parseFloat(comp?.non_member_price ?? memberPrice);
      const isFreeAfterwork = comp?.event_type === 'afterwork' && memberPrice === 0 && nonMemberPrice === 0;

      if (isFreeAfterwork) {
        const result = await clientPortalApi.registerCompetition(token, competitionId, {
          notes: competitionNotes,
          guests_count: afterworkGuestsCount || 0,
          guest_client_ids: (selectedAfterworkGuests || []).map((g) => g.id),
          custom_options_selected: selectedCustomOptions || [],
        });
        toast.success('Inscription confirmée !');
        setShowCompetitionModal(false);
        setCompetitionNotes('');
        setSelectedCustomOptions([]);
        setAfterworkGuestsCount(0);
        setSelectedAfterworkGuests([]);
        setAfterworkGuestSearch('');
        setAfterworkGuestResults([]);
        await loadCompetitions();
        return;
      }

      const opts = {
        partnerId: selectedPartner?.id || '',
        payForPartner: payForPartner && !!selectedPartner,
        notes: competitionNotes,
        custom_options_selected: selectedCustomOptions || [],
        useAccount: useAccountPay,
      };
      
      // Si partenaire externe, ajouter les données du nouveau client
      if (externalPartnerMode && externalPartnerData.first_name && externalPartnerData.last_name) {
        opts.newClient = {
          first_name: externalPartnerData.first_name,
          last_name: externalPartnerData.last_name,
          email: externalPartnerData.email,
          phone: externalPartnerData.phone
        };
        opts.payForPartner = payForPartner;
      }
      
      const result = await clientPortalApi.createCompetitionPaymentSession(
        token, 
        competitionId, 
        { ...opts, custom_options_selected: selectedCustomOptions }
      );
      
      if (result.free || result.paid_by_account) {
        toast.success(result.paid_by_account ? (result.message || 'Inscription réglée avec votre compte client') : 'Inscription confirmée !');
        if (result.paid_by_account) loadAccountBalance();
        setShowCompetitionModal(false);
        setCompetitionPartnerName('');
        setCompetitionNotes('');
        setSelectedPartner(null);
        setPartnerSearchQuery('');
        setPartnerSearchResults([]);
        setPayForPartner(true);
        setExternalPartnerMode(false);
        setExternalPartnerData({ first_name: '', last_name: '', email: '', phone: '' });
        setSelectedCustomOptions([]);
        await loadCompetitions();
      } else if (result.checkout_url) {
        toast.success(result.account_amount > 0 ? `${Number(result.account_amount).toFixed(2)}€ sur votre compte · paiement du reste (${Number(result.stripe_amount).toFixed(2)}€)…` : `Redirection vers le paiement (${result.price}€)...`);
        window.location.href = result.checkout_url;
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setCompetitionRegistrationLoading(false);
    }
  };
  
  // Payer sa propre inscription (partenaire inscrit mais à payer)
  const handlePayMyRegistration = async (competitionId) => {
    setCompetitionRegistrationLoading(true);
    try {
      const result = await clientPortalApi.payMyRegistration(token, competitionId, useAccountPay);
      if (result.free || result.paid_by_account) {
        toast.success(result.paid_by_account ? (result.message || 'Paiement réglé avec votre compte client') : 'Paiement confirmé !');
        if (result.paid_by_account) loadAccountBalance();
        setShowCompetitionModal(false);
        await loadCompetitions();
      } else if (result.checkout_url) {
        toast.success(result.account_amount > 0 ? `${Number(result.account_amount).toFixed(2)}€ sur votre compte · paiement du reste (${Number(result.stripe_amount).toFixed(2)}€)…` : `Redirection vers le paiement (${result.price}€)...`);
        window.location.href = result.checkout_url;
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setCompetitionRegistrationLoading(false);
    }
  };
  
  // Rechercher un partenaire
  const handlePartnerSearch = async (query) => {
    setPartnerSearchQuery(query);
    if (query.length < 2 || !selectedCompetition) {
      setPartnerSearchResults([]);
      return;
    }
    setPartnerSearchLoading(true);
    try {
      const data = await clientPortalApi.searchPartner(token, selectedCompetition.id, query);
      setPartnerSearchResults(data.results || []);
    } catch (error) {
      console.error('Erreur recherche partenaire:', error);
    } finally {
      setPartnerSearchLoading(false);
    }
  };

  // Annuler inscription à une compétition
  const handleCancelCompetitionRegistration = async (competitionId) => {
    if (!window.confirm('Voulez-vous annuler votre inscription ?')) return;
    try {
      await clientPortalApi.cancelCompetitionRegistration(token, competitionId);
      toast.success('Inscription annulée');
      setShowCompetitionModal(false);
      await loadCompetitions();
    } catch (error) {
      toast.error(error.message);
    }
  };
  
  // Charger les commandes fitting (Taylor Made)
  const loadFittingOrders = async () => {
    try {
      const data = await clientPortalApi.getFittingOrders(token);
      setFittingOrders(data);
    } catch (error) {
      console.error('Erreur chargement commandes fitting:', error);
    }
  };
  
  // Charger les commandes au démarrage
  // iter318 fix perf — Lazy uniquement sur l'onglet Boutique (c'est le seul affichage)
  useEffect(() => {
    if (!isAuthenticated || !token) return;
    if (activeTab !== 'boutique') return;
    loadFittingOrders();
  }, [isAuthenticated, token, activeTab]);
  
  // Charger les participants d'une compétition quand on ouvre le modal
  useEffect(() => {
    if (showCompetitionParticipantsModal && selectedCompetition) {
      const loadParticipants = async () => {
        setLoadingParticipants(true);
        try {
          const data = await clientPortalApi.getCompetitionParticipants(token, selectedCompetition.id);
          setCompetitionParticipants(data.participants || []);
          setIsDoubleParticipantsView(data.is_double || false);
          setParticipantsTotalSeats(data.total_seats ?? (data.participants || []).length);
        } catch (error) {
          console.error('Erreur chargement participants:', error);
          setCompetitionParticipants([]);
        } finally {
          setLoadingParticipants(false);
        }
      };
      loadParticipants();
    }
  }, [showCompetitionParticipantsModal, selectedCompetition, token]);
  
  // Réinitialiser quand on ouvre un nouveau modal
  const handleOpenSessionModal = (session) => {
    setSelectedSession(session);
    setShowSessionModal(true);
  };

  // Ouvrir le modal d'inscription en chargeant les détails complets de la session
  const handleBookFromDashboard = async (sessionId) => {
    if (!sessionId) return;
    try {
      const sessionData = await clientPortalApi.getSessionDetail(token, sessionId);
      handleOpenSessionModal(sessionData);
    } catch (error) {
      console.error('Erreur chargement session:', error);
      toast.error('Impossible de charger les détails du cours');
    }
  };

  // iter321 — Navigation commune bonnes affaires (carrousel + pop-up promo)
  const handleDealNavigate = (deal) => {
    if (deal.type === 'yield_auto' && deal.yield_rule_id) {
      setIndivYieldFilter(deal.yield_rule_id);
      setIndivProFilter('');
      setActiveTab('indiv');
      return;
    }
    if (deal.auto_target_id) {
      handleBookFromDashboard(deal.auto_target_id);
      return;
    }
    const url = deal.popup_url || deal.cta_url;
    if (!url) return;
    if (url.startsWith('portal://book/indiv/')) {
      handleBookFromDashboard(url.split('/').pop());
      return;
    }
    if (url.startsWith('/portail')) {
      try {
        const u = new URL(url, window.location.origin);
        const tab = u.searchParams.get('tab');
        const yieldRule = u.searchParams.get('yield');
        if (tab === 'indiv' && yieldRule) {
          setIndivYieldFilter(yieldRule);
          setIndivProFilter('');
          setActiveTab('indiv');
          return;
        }
        if (tab) { setActiveTab(tab); return; }
      } catch (_e) { /* URL malformée : redirection classique ci-dessous */ }
    }
    if (url.startsWith('vitrine://')) {
      const page = url.replace('vitrine://', '');
      window.location.href = page === 'home' ? '/' : `/${page}`;
      return;
    }
    if (url.startsWith('http')) {
      window.open(url, '_blank', 'noopener');
    } else if (url.startsWith('/')) {
      window.location.href = url;
    }
  };

  
  // Charger les documents du client
  const loadDocuments = async () => {
    if (!token) return;
    setDocumentsLoading(true);
    try {
      const data = await clientPortalApi.getDocuments(token);
      setDocuments(data.documents || []);
    } catch (error) {
      console.error('Erreur chargement documents:', error);
    } finally {
      setDocumentsLoading(false);
    }
  };
  
  // Charger l'historique des paiements
  const loadPaymentHistory = async () => {
    if (!token) return;
    setPaymentHistoryLoading(true);
    try {
      const [payData, sponsorRes] = await Promise.all([
        clientPortalApi.getPaymentHistory(token),
        fetch(`${API_URL}/api/client-portal/sponsor-rewards`, {
          headers: { Authorization: `Bearer ${token}` },
        }).then((r) => (r.ok ? r.json() : { rewards: [] })).catch(() => ({ rewards: [] })),
      ]);
      const payments = payData.data || [];
      // Fusion : les récompenses parrainage apparaissent dans le même flux
      // avec un type dédié "sponsor_credit" pour un rendu différencié.
      const sponsorItems = (sponsorRes.rewards || []).map((r) => ({
        id: `sponsor-${r.id}`,
        type: 'sponsor_credit',
        product: r.reward_type === 'subscription_extension'
          ? `Vous avez été crédité de +${Math.round(r.reward_value)} mois de cotisation suite au parrainage de ${r.referred_client_name || 'un membre'}`
          : `Vous avez été crédité de ${Number(r.reward_value || 0).toFixed(2)} € suite au parrainage de ${r.referred_client_name || 'un membre'}`,
        amount: r.reward_type === 'subscription_extension' ? null : Number(r.reward_value || 0),
        months: r.reward_type === 'subscription_extension' ? Math.round(r.reward_value) : null,
        date: r.applied_at,
        _sortKey: r.applied_at || 0,
      }));
      // Trier tout par date décroissante
      const merged = [
        ...payments.map((p) => ({ ...p, _sortKey: p.date || 0 })),
        ...sponsorItems,
      ].sort((a, b) => new Date(b._sortKey || 0) - new Date(a._sortKey || 0));
      setPaymentHistory(merged);
    } catch (error) {
      console.error('Erreur chargement historique paiements:', error);
    } finally {
      setPaymentHistoryLoading(false);
    }
  };
  
  // Charger les packs de cours disponibles
  const loadCoursePacks = async () => {
    if (!token) return;
    setPacksLoading(true);
    try {
      const response = await authenticatedFetch(`${API_URL}/api/portal/course-packs`);
      if (response.ok) {
        const data = await response.json();
        setCoursePacks(data.data || []);
      }
    } catch (error) {
      console.error('Erreur chargement packs:', error);
    } finally {
      setPacksLoading(false);
    }
  };

  // iter313.3 — Charger le résumé Practice (balance + QR + packs achetables)
  const loadPractice = async () => {
    if (!token) return;
    try {
      const response = await authenticatedFetch(`${API_URL}/api/portal/practice/summary`);
      if (response.ok) {
        const data = await response.json();
        setPracticeData(data);
      }
    } catch (error) {
      console.warn('[practice] load error', error);
    }
  };

  // iter313.3 — Acheter un pack Practice (Stripe checkout)
  const handlePurchasePracticePack = async (pack) => {
    setPurchasingPracticePack(pack.id);
    trackPortalItem('product', `practice-${pack.id}`, `Practice · ${pack.name || 'Pack'}`);
    try {
      const response = await fetch(`${API_URL}/api/client-portal/practice/checkout`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ pack_id: pack.id }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || 'Erreur checkout');
      if (data.checkout_url) {
        window.location.href = data.checkout_url;
      } else {
        toast.error('URL de paiement introuvable');
      }
    } catch (e) {
      toast.error(e.message || 'Erreur achat');
    } finally {
      setPurchasingPracticePack(null);
    }
  };
  
  // Acheter un pack de cours
  const handlePurchasePack = async (pack) => {
    setPurchasingPack(pack.id);
    trackPortalItem('product', `pack-${pack.id}`, `Forfait cours · ${pack.name || 'Pack'}`);
    try {
      console.log('[PackPurchase] Starting purchase for pack:', pack.id);
      const response = await fetch(`${API_URL}/api/portal/course-packs/${pack.id}/purchase`, {
        method: 'POST',
        headers: { 
          'Authorization': `Bearer ${token}`
        }
      });
      console.log('[PackPurchase] Response status:', response.status);
      
      const responseClone = response.clone();
      try {
        const data = await response.json();
        console.log('[PackPurchase] Parsed data:', data);
        
        if (response.ok) {
          if (data.free) {
            // Pack gratuit - déjà crédité
            toast.success(`${data.hours_credited}h créditées sur votre carnet !`);
            try { const p = await clientPortalApi.getProfile(token); setClient(p); } catch(e) {}
          } else if (data.checkout_url) {
            window.location.href = data.checkout_url;
          }
        } else {
          toast.error(data.detail || 'Erreur lors de l\'achat');
        }
      } catch (parseError) {
        console.error('[PackPurchase] Parse error:', parseError);
        const text = await responseClone.text();
        console.error('[PackPurchase] Response text:', text);
        toast.error('Erreur lors du traitement de la réponse');
      }
    } catch (error) {
      console.error('Erreur achat pack:', error);
      toast.error('Erreur lors de l\'achat');
    } finally {
      setPurchasingPack(null);
    }
  };
  
  // Charger les stages disponibles
  const loadStages = async () => {
    try {
      const data = await clientPortalApi.getStages(token);
      setStages(data.stages || []);
    } catch (error) {
      console.error('Erreur chargement stages:', error);
    }
  };
  
  // Inscription à un stage (avec paiement Stripe si payant)
  const handleRegisterStage = async (stageId) => {
    try {
      // Utiliser l'endpoint de paiement qui gère automatiquement gratuit vs payant
      const result = await clientPortalApi.createStagePaymentSession(token, stageId, useAccountPay);
      
      if (result.free || result.paid_by_account) {
        // Inscription gratuite ou réglée par le compte client - déjà confirmée
        toast.success(result.paid_by_account ? (result.message || 'Inscription réglée avec votre compte client') : 'Inscription confirmée !');
        if (result.paid_by_account) loadAccountBalance();
        setShowStageModal(false);
        await loadStages();
      } else if (result.checkout_url) {
        // Rediriger vers Stripe
        toast.success(result.account_amount > 0 ? `${Number(result.account_amount).toFixed(2)}€ sur votre compte · paiement du reste (${Number(result.stripe_amount).toFixed(2)}€)…` : `Redirection vers le paiement (${result.price}€)...`);
        window.location.href = result.checkout_url;
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  // Annuler inscription à un stage
  const handleCancelStageRegistration = async (stageId) => {
    if (!window.confirm('Voulez-vous annuler votre inscription ?')) return;
    try {
      await clientPortalApi.cancelStageRegistration(token, stageId);
      toast.success('Inscription annulée');
      setShowStageModal(false);
      await loadStages();
    } catch (error) {
      toast.error(error.message);
    }
  };
  
  // Télécharger un document
  const handleDownloadDocument = async (doc) => {
    try {
      // Ouvrir directement l'URL de téléchargement (supporte la redirection R2)
      window.open(`${API_URL}/api/client-portal/documents/${doc.id}/download?token=${token}`, '_blank');
    } catch (error) {
      toast.error('Erreur lors du téléchargement');
    }
  };

  const handleLoginCheckEmail = async (e) => {
    e.preventDefault();
    const email = loginForm.email.trim().toLowerCase();
    if (!email) return;
    
    setLoginLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-portal/check-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (data.found && data.profiles?.length > 0) {
        setLoginProfiles(data.profiles);
      } else {
        setLoginProfiles([]);
      }
      setLoginStep('password');
    } catch {
      toast.error('Erreur de connexion');
    } finally {
      setLoginLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginLoading(true);
    try {
      const result = await clientPortalApi.login(loginForm.email, loginForm.password);
      
      // Si admin ou employé → sauvegarder le token admin et rediriger vers /modules
      if (result.user_type === 'admin' || result.user_type === 'employee') {
        localStorage.setItem('access_token', result.access_token);
        if (result.refresh_token) {
          localStorage.setItem('refresh_token', result.refresh_token);
        }
        if (rememberMe) {
          localStorage.setItem('client_portal_remembered_email', loginForm.email);
        }
        toast.success('Connexion réussie !');
        window.location.href = result.redirect || '/modules';
        return;
      }
      
      // Si le backend demande une sélection de profil
      if (result.requires_profile_selection) {
        setLoginProfiles(result.profiles);
        setLoginStep('select-profile');
        return;
      }
      
      // Connexion client directe (1 seul profil)
      localStorage.setItem('client_portal_token', result.access_token);
      if (result.refresh_token) {
        localStorage.setItem('client_portal_refresh_token', result.refresh_token);
      }
      if (rememberMe) {
        localStorage.setItem('client_portal_remembered_email', loginForm.email);
      } else {
        localStorage.removeItem('client_portal_remembered_email');
      }
      setToken(result.access_token);
      setClient(result.client);
      setLinkedProfiles(result.linked_profiles || null);
      setIsAuthenticated(true);
      setActiveTab('dashboard');
      toast.success('Connexion réussie !');
    } catch (error) {
      if (error.message === 'email_not_verified') {
        setVerificationEmail(loginForm.email.toLowerCase().trim());
        setShowVerification(true);
        toast.info('Votre email n\'est pas encore vérifié. Saisissez le code reçu par email.');
      } else {
        toast.error(error.message);
      }
    } finally {
      setLoginLoading(false);
    }
  };

  const handleSelectProfile = async (profileId) => {
    setLoginLoading(true);
    try {
      const result = await clientPortalApi.login(loginForm.email, loginForm.password, profileId);
      localStorage.setItem('client_portal_token', result.access_token);
      if (result.refresh_token) {
        localStorage.setItem('client_portal_refresh_token', result.refresh_token);
      }
      if (rememberMe) {
        localStorage.setItem('client_portal_remembered_email', loginForm.email);
      } else {
        localStorage.removeItem('client_portal_remembered_email');
      }
      setToken(result.access_token);
      setClient(result.client);
      setLinkedProfiles(result.linked_profiles || null);
      setIsAuthenticated(true);
      setActiveTab('dashboard');
      setLoginStep('email');
      toast.success('Connexion réussie !');
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoginLoading(false);
    }
  };

  const handleSwitchProfile = async (profileId) => {
    try {
      const res = await authenticatedFetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-portal/switch-profile`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ client_id: profileId })
      });
      if (!res.ok) throw new Error('Erreur lors du changement de profil');
      const result = await res.json();
      localStorage.setItem('client_portal_token', result.access_token);
      if (result.refresh_token) {
        localStorage.setItem('client_portal_refresh_token', result.refresh_token);
      }
      setToken(result.access_token);
      setClient(result.client);
      setLinkedProfiles(result.linked_profiles || null);
      toast.success(`Profil changé : ${result.client.first_name} ${result.client.last_name}`);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleCheckEmail = async (e) => {
    e.preventDefault();
    const email = signupEmail.trim().toLowerCase();
    if (!email) { toast.error('Veuillez saisir un email'); return; }
    
    setCheckingEmail(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-portal/check-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      
      if (data.found && data.profiles?.length > 0) {
        const available = data.profiles.filter(p => !p.already_active);
        if (available.length === 0) {
          toast.error('Tous les profils liés à cet email ont déjà un compte. Connectez-vous directement.');
          return;
        }
        setEmailProfiles(data.profiles);
        setSelectedProfileId(available[0].id);
        setSignupStep('select-profile');
      } else {
        setSignupForm(prev => ({ ...prev, email }));
        setSignupStep('full-form');
      }
    } catch (error) {
      toast.error('Erreur de connexion');
    } finally {
      setCheckingEmail(false);
    }
  };

  const handleProfileSignup = async (e) => {
    e.preventDefault();
    if (!selectedProfileId) { toast.error('Sélectionnez un profil'); return; }
    if (signupForm.password.length < 6) { toast.error('Le mot de passe doit contenir au moins 6 caractères'); return; }
    if (signupForm.password !== signupForm.confirmPassword) { toast.error('Les mots de passe ne correspondent pas'); return; }
    
    setSignupLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-portal/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: signupEmail.trim().toLowerCase(),
          password: signupForm.password,
          client_id: selectedProfileId
        })
      });
      const result = await res.json();
      if (!res.ok) throw new Error(result.detail || 'Erreur');
      
      if (result.access_token) {
        localStorage.setItem('client_portal_token', result.access_token);
        if (result.refresh_token) {
          localStorage.setItem('client_portal_refresh_token', result.refresh_token);
        }
        setToken(result.access_token);
        setClient(result.client);
        setIsAuthenticated(true);
        setShowSignup(false);
        setActiveTab('dashboard');
        setSignupStep('email');
        toast.success('Compte créé ! Bienvenue.');
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSignupLoading(false);
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    
    // Validation des noms
    const nameRegex = /^[a-zA-ZÀ-ÿ\s'-]+$/;
    const firstName = signupForm.first_name.trim();
    const lastName = signupForm.last_name.trim();
    
    if (firstName.length < 2) {
      toast.error('Le prénom doit contenir au moins 2 caractères');
      return;
    }
    if (lastName.length < 2) {
      toast.error('Le nom doit contenir au moins 2 caractères');
      return;
    }
    if (!nameRegex.test(firstName)) {
      toast.error('Le prénom ne doit pas contenir de caractères spéciaux');
      return;
    }
    if (!nameRegex.test(lastName)) {
      toast.error('Le nom ne doit pas contenir de caractères spéciaux');
      return;
    }
    
    if (signupForm.password !== signupForm.confirmPassword) {
      toast.error('Les mots de passe ne correspondent pas');
      return;
    }
    if (signupForm.password.length < 6) {
      toast.error('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }
    
    setSignupLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-portal/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          first_name: firstName.charAt(0).toUpperCase() + firstName.slice(1),
          last_name: lastName.charAt(0).toUpperCase() + lastName.slice(1),
          email: signupForm.email,
          phone: signupForm.phone,
          password: signupForm.password
        })
      });
      
      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.detail || 'Erreur lors de l\'inscription');
      }
      
      if (result.requires_verification) {
        setVerificationEmail(signupForm.email.toLowerCase().trim());
        setShowVerification(true);
        setShowSignup(false);
        setSignupStep('email');
        toast.success('Code envoyé !', {
          description: 'Vérifiez votre boîte de réception (et les indésirables).'
        });
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSignupLoading(false);
    }
  };

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    if (verificationCode.length !== 6) {
      toast.error('Veuillez saisir un code à 6 chiffres');
      return;
    }
    
    setVerifyLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-portal/verify-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: verificationEmail, code: verificationCode })
      });
      
      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.detail || 'Code incorrect');
      }
      
      localStorage.setItem('client_portal_token', result.access_token);
      if (result.refresh_token) {
        localStorage.setItem('client_portal_refresh_token', result.refresh_token);
      }
      setToken(result.access_token);
      setClient(result.client);
      setIsAuthenticated(true);
      setShowVerification(false);
      setActiveTab('dashboard');
      toast.success('Email vérifié ! Bienvenue sur le portail.');
    } catch (error) {
      toast.error(error.message);
    } finally {
      setVerifyLoading(false);
    }
  };

  const handleResendCode = async () => {
    if (resendCooldown > 0) return;
    
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-portal/resend-code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: verificationEmail })
      });
      
      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.detail || 'Erreur');
      }
      
      toast.success('Nouveau code envoyé !');
      setResendCooldown(30);
      const interval = setInterval(() => {
        setResendCooldown(prev => {
          if (prev <= 1) { clearInterval(interval); return 0; }
          return prev - 1;
        });
      }, 1000);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('client_portal_token');
    localStorage.removeItem('client_portal_refresh_token');
    setToken(null);
    setClient(null);
    setIsAuthenticated(false);
    setMobileMenuOpen(false);
  };
  
  const handleChangePassword = async () => {
    if (passwordForm.newPassword !== passwordForm.confirm) {
      toast.error('Les mots de passe ne correspondent pas');
      return;
    }
    
    if (passwordForm.newPassword.length < 6) {
      toast.error('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }
    
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-portal/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          current_password: passwordForm.current,
          new_password: passwordForm.newPassword
        })
      });
      
      if (response.ok) {
        toast.success('Mot de passe modifié avec succès');
        setShowPasswordChange(false);
        setPasswordForm({ current: '', newPassword: '', confirm: '' });
      } else {
        const error = await response.json();
        toast.error(error.detail || 'Erreur lors du changement de mot de passe');
      }
    } catch (error) {
      toast.error('Erreur de connexion au serveur');
    }
  };

  const handleUpdateProfile = async () => {
    if (!profileForm.first_name.trim() || !profileForm.last_name.trim()) {
      toast.error('Le nom et le prénom sont requis');
      return;
    }
    setSavingProfile(true);
    try {
      const payload = {
        first_name: profileForm.first_name.trim(),
        last_name: profileForm.last_name.trim(),
        birth_date: profileForm.birth_date ? profileForm.birth_date : null,
      };
      const updated = await clientPortalApi.updateProfile(token, payload);
      setClient(prev => ({
        ...prev,
        first_name: updated.first_name || profileForm.first_name.trim(),
        last_name: updated.last_name || profileForm.last_name.trim(),
        birth_date: updated.birth_date !== undefined ? updated.birth_date : payload.birth_date,
      }));
      setEditingProfile(false);
      toast.success('Profil mis à jour');
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSavingProfile(false);
    }
  };

  const handleRegister = async (session, useCarnet = false) => {
    // Toujours réserver pour soi-même (pas de famille)
    const bookingForId = null;
    const bookingForName = null;
    
    // Vérifier si le cours est payant pour ce client
    const isPaid = !session.is_free_for_client && session.client_price && session.client_price > 0;
    
    // Vérifier si le client a un carnet disponible
    const hasCarnetAvailable = (portalSettings?.carnet_remaining || 0) > 0;
    
    setRegisterLoading(true);
    
    try {
      if (isPaid && !useCarnet) {
        // Cours payant sans carnet -> Redirection vers Stripe
        const checkout = await clientPortalApi.createPaymentCheckout(token, session.id);
        
        if (checkout.checkout_url) {
          toast.info('Redirection vers le paiement...', {
            description: `Montant: ${session.client_price}€`,
            duration: 3000
          });
          window.location.href = checkout.checkout_url;
        } else {
          throw new Error('URL de paiement non reçue');
        }
      } else {
        // Cours gratuit OU utilisation du carnet -> Inscription directe
        console.log('Registering for session:', { sessionId: session.id, clientId: client.id, forClientId: bookingForId, useCarnet });
        const result = await clientPortalApi.register(token, session.id, client.id, bookingForId, useCarnet);
        console.log('Registration result:', result);
        
        let successMessage = bookingForName 
          ? `Inscription confirmée pour ${bookingForName} !`
          : 'Inscription confirmée !';
        
        // Si carnet utilisé, afficher le solde restant et recharger les settings
        if (useCarnet && result.carnet_remaining !== undefined) {
          successMessage = `${successMessage} (Carnet: ${result.carnet_remaining}h restantes)`;
          // Mettre à jour immédiatement avec la réponse du serveur
          setPortalSettings(prev => ({
            ...prev,
            carnet_remaining: result.carnet_remaining,
            carnet_total: result.carnet_total
          }));
          // Recharger les settings depuis l'API pour garantir la cohérence
          clientPortalApi.getPortalSettings(token).then(settings => {
            setPortalSettings(settings);
          }).catch(() => {});
        }
        
        toast.success(successMessage, {
          description: useCarnet ? 'Cours débité de votre carnet.' : 'Un rappel sera envoyé avant le cours.',
          duration: 4000
        });
        
        // Réinitialiser (sessions + inscriptions rechargées pour refléter l'inscription)
        loadData();
        loadCoursesData();
        refreshDashboardData();
        setShowSessionModal(false);
      }
    } catch (error) {
      console.error('Erreur inscription:', error);
      toast.error(error.message || 'Erreur lors de l\'inscription');
    } finally {
      setRegisterLoading(false);
    }
  };

  const handleCancelRegistration = async (registrationId) => {
    try {
      const result = await clientPortalApi.cancelRegistration(token, registrationId);
      
      // Si le carnet a été re-crédité, afficher un message spécial et recharger les paramètres
      if (result.carnet_refunded) {
        toast.success('Réservation annulée - Votre carnet a été re-crédité', {
          duration: 5000
        });
        // Recharger les paramètres du portail pour mettre à jour le solde du carnet
        try {
          const settings = await clientPortalApi.getPortalSettings(token);
          setPortalSettings(settings);
        } catch (e) {
          console.log('Settings reload failed:', e);
        }
      } else {
        toast.success('Réservation annulée');
      }
      
      loadData();
      loadCoursesData();
      refreshDashboardData();
    } catch (error) {
      toast.error(error.message);
    }
  };

  // Jours de la semaine pour la vue semaine
  const weekDays = useMemo(() => {
    const start = startOfWeek(currentDate, { weekStartsOn: 1 });
    return Array.from({ length: 7 }, (_, i) => addDays(start, i));
  }, [currentDate]);

  // Jours pour le scroll mobile (14 jours à partir d'aujourd'hui)
  const scrollDays = useMemo(() => {
    const today = new Date();
    return Array.from({ length: 14 }, (_, i) => addDays(today, i));
  }, []);

  // Grouper les sessions par jour pour la vue semaine
  const sessionsByDay = useMemo(() => {
    const days = {};
    weekDays.forEach(day => {
      const dateKey = format(day, 'yyyy-MM-dd');
      days[dateKey] = {
        date: day,
        sessions: sessions.filter(s => {
          const sessionDate = parseISO(s.datetime);
          return isSameDay(sessionDate, day);
        }).sort((a, b) => new Date(a.datetime) - new Date(b.datetime))
      };
    });
    return days;
  }, [sessions, weekDays]);

  // Grouper les cours individuels par jour (vue semaine)
  const indivByDay = useMemo(() => {
    const days = {};
    const allIndivs = dashboardData?.available_indivs || [];
    // iter314 — Filtre optionnel par règle Yield (déclenché depuis le CTA d'une Bonne Affaire virtuelle)
    let filteredIndivs = allIndivs;
    if (indivYieldFilter) {
      filteredIndivs = filteredIndivs.filter(c => c.yield_rule_id === indivYieldFilter);
    }
    if (indivProFilter) {
      filteredIndivs = filteredIndivs.filter(c => c.employee_name === indivProFilter);
    }
    weekDays.forEach(day => {
      const dateKey = format(day, 'yyyy-MM-dd');
      days[dateKey] = {
        date: day,
        sessions: filteredIndivs.filter(c => {
          if (!c.datetime) return false;
          return isSameDay(parseISO(c.datetime), day);
        }).sort((a, b) => new Date(a.datetime) - new Date(b.datetime)),
      };
    });
    return days;
  }, [dashboardData?.available_indivs, indivProFilter, indivYieldFilter, weekDays]);

  // Navigation
  const goToPrev = () => {
    if (viewMode === 'day') {
      setCurrentDate(addDays(currentDate, -1));
    } else {
      setCurrentDate(subWeeks(currentDate, 1));
    }
  };

  const goToNext = () => {
    if (viewMode === 'day') {
      setCurrentDate(addDays(currentDate, 1));
    } else {
      setCurrentDate(addWeeks(currentDate, 1));
    }
  };

  const goToToday = () => setCurrentDate(new Date());

  // Page de chargement
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#E8F6F2] to-[#E9F3FB] flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
            <Calendar className="w-8 h-8 text-primary animate-pulse" />
          </div>
          <p className="text-neutral-500">Chargement...</p>
        </div>
      </div>
    );
  }

  // Page de connexion / inscription
  if (!isAuthenticated) {
    // Déterminer le fond à afficher
    const hasBackgroundImage = portalSettings?.login_background_image?.data;
    const vimeoUrl = portalSettings?.login_vimeo_url;
    const hasCustomBackground = hasBackgroundImage || vimeoUrl;
    
    // Extraire l'ID Vimeo de l'URL
    const getVimeoId = (url) => {
      if (!url) return null;
      const match = url.match(/vimeo\.com\/(\d+)/);
      return match ? match[1] : null;
    };
    const vimeoId = getVimeoId(vimeoUrl);
    
    return (
      <div className="relative min-h-[100dvh] w-full overflow-y-auto flex flex-col items-center justify-between" style={{ fontFamily: "'Manrope', sans-serif" }}>
        {/* Modal PWA - Instructions pour ajouter à l'écran d'accueil */}
        {showPwaModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-3xl shadow-2xl max-w-sm w-full mx-4 overflow-hidden animate-in fade-in zoom-in duration-300">
              {/* Header avec logo du golf */}
              <div className="p-6 text-center border-b border-neutral-100">
                {portalSettings?.portal_logo?.data ? (
                  <img 
                    src={`data:${portalSettings.portal_logo.content_type};base64,${portalSettings.portal_logo.data}`}
                    alt="Logo"
                    className="h-16 w-auto max-w-[140px] object-contain mx-auto mb-4"
                  />
                ) : (
                  <div className="w-16 h-16 bg-emerald-50 rounded-2xl mx-auto mb-4 flex items-center justify-center">
                    <Calendar className="w-8 h-8 text-emerald-600" />
                  </div>
                )}
                <h2 className="text-xl font-bold text-neutral-900">Installer l'application</h2>
                <p className="text-neutral-500 text-sm mt-1">Accès rapide depuis votre écran d'accueil</p>
              </div>
              
              {/* Contenu avec instructions */}
              <div className="p-5 space-y-3">
                {/iPad|iPhone|iPod/.test(navigator.userAgent) && /CriOS|FxiOS|OPiOS|EdgiOS/.test(navigator.userAgent) ? (
                  /* Chrome, Firefox, Opera ou Edge sur iOS → doit ouvrir Safari */
                  <>
                    <div className="bg-amber-50 border border-amber-300 rounded-xl p-4 text-center">
                      <Globe className="w-8 h-8 text-amber-600 mx-auto mb-2" />
                      <p className="text-amber-900 font-bold text-sm">Vous n'êtes pas sur Safari</p>
                      <p className="text-amber-700 text-xs mt-1">L'installation n'est possible que depuis <strong>Safari</strong> sur iPhone/iPad.</p>
                    </div>
                    <div className="flex items-start gap-3 p-3 bg-neutral-50 rounded-xl">
                      <div className="w-9 h-9 bg-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
                        <span className="text-white text-sm font-bold">1</span>
                      </div>
                      <div>
                        <p className="font-semibold text-neutral-800 text-sm">Copiez l'adresse du site</p>
                        <p className="text-sm text-neutral-600">Copiez l'URL depuis la barre d'adresse</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3 p-3 bg-neutral-50 rounded-xl">
                      <div className="w-9 h-9 bg-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
                        <span className="text-white text-sm font-bold">2</span>
                      </div>
                      <div>
                        <p className="font-semibold text-neutral-800 text-sm">Ouvrez Safari</p>
                        <p className="text-sm text-neutral-600">Collez l'adresse dans Safari, puis suivez les étapes ci-dessous</p>
                      </div>
                    </div>
                  </>
                ) : /iPad|iPhone|iPod/.test(navigator.userAgent) ? (
                  /* Safari sur iOS → instructions normales */
                  <>
                    <div className="flex items-start gap-3 p-3 bg-neutral-50 rounded-xl">
                      <div className="w-9 h-9 bg-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
                        <Share className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="font-semibold text-neutral-800 text-sm">Étape 1</p>
                        <p className="text-sm text-neutral-600">Appuyez sur <strong>Partager</strong> <Share className="inline w-3 h-3" /> en bas de l'écran</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3 p-3 bg-neutral-50 rounded-xl">
                      <div className="w-9 h-9 bg-neutral-800 rounded-lg flex items-center justify-center flex-shrink-0">
                        <Plus className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="font-semibold text-neutral-800 text-sm">Étape 2</p>
                        <p className="text-sm text-neutral-600">Sélectionnez <strong>"Sur l'écran d'accueil"</strong></p>
                      </div>
                    </div>
                  </>
                ) : /Android/.test(navigator.userAgent) ? (
                  <>
                    <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 text-center">
                      <p className="text-blue-800 font-semibold text-sm">Ouvrez ce site sur Chrome</p>
                    </div>
                    <div className="flex items-start gap-3 p-3 bg-neutral-50 rounded-xl">
                      <div className="w-9 h-9 bg-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
                        <MoreVertical className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="font-semibold text-neutral-800 text-sm">Étape 1</p>
                        <p className="text-sm text-neutral-600">Appuyez sur <strong>⋮</strong> en haut à droite</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3 p-3 bg-neutral-50 rounded-xl">
                      <div className="w-9 h-9 bg-neutral-800 rounded-lg flex items-center justify-center flex-shrink-0">
                        <Plus className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="font-semibold text-neutral-800 text-sm">Étape 2</p>
                        <p className="text-sm text-neutral-600">Sélectionnez <strong>"Ajouter à l'écran d'accueil"</strong></p>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="flex items-start gap-3 p-3 bg-neutral-50 rounded-xl">
                    <div className="w-9 h-9 bg-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Download className="w-4 h-4 text-white" />
                    </div>
                    <div>
                      <p className="font-semibold text-neutral-800 text-sm">Installation</p>
                      <p className="text-sm text-neutral-600">Utilisez le menu de votre navigateur pour installer</p>
                    </div>
                  </div>
                )}
                
                <div className="flex items-center gap-2 p-3 bg-amber-50/70 rounded-xl text-sm border border-amber-100">
                  <Bell className="w-4 h-4 text-amber-600 flex-shrink-0" />
                  <p className="text-amber-800 text-xs">Recevez les <strong>notifications</strong> des compétitions et actualités</p>
                </div>
              </div>
              
              {/* Boutons */}
              <div className="px-5 pb-5 pt-2">
                <Button 
                  className="w-full h-11 text-sm font-semibold bg-neutral-900 hover:bg-neutral-800 rounded-xl"
                  onClick={() => {
                    setShowPwaModal(false);
                    // Ne pas sauvegarder - réapparaîtra à la prochaine visite
                  }}
                >
                  J'ai compris
                </Button>
                <button 
                  className="w-full mt-2 text-xs text-neutral-400 hover:text-neutral-600"
                  onClick={() => {
                    setShowPwaModal(false);
                    localStorage.setItem('client_portal_pwa_never_show', 'true');
                  }}
                >
                  Ne plus afficher
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Popup Portes Ouvertes */}
        {showPOPopup && portalSettings?.po_popup_enabled && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-5" onClick={() => setShowPOPopup(false)}>
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
            <div
              className="relative w-full max-w-sm rounded-3xl overflow-hidden shadow-2xl animate-in fade-in zoom-in-95 duration-300"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Image de fond */}
              <div className="relative h-44 bg-cover bg-center" style={{ backgroundImage: 'url(/hero-golf.jpg)' }}>
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a3a2a] via-[#1a3a2a]/40 to-transparent" />
                <button
                  onClick={() => setShowPOPopup(false)}
                  className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/30 backdrop-blur-sm flex items-center justify-center text-white/80 hover:text-white hover:bg-black/50 transition-all"
                >
                  <X size={16} />
                </button>
                <div className="absolute bottom-4 left-5 right-5">
                  <p className="text-white/60 text-[11px] font-medium uppercase tracking-widest mb-1">Événement</p>
                  <h2 className="text-white text-xl font-bold leading-tight">{portalSettings?.po_popup_title || 'Et si vous découvriez le golf ?'}</h2>
                </div>
              </div>
              {/* Contenu */}
              <div className="bg-[#1a3a2a] px-5 pb-5 pt-4">
                <p className="text-white/70 text-sm leading-relaxed mb-4">
                  {portalSettings?.po_popup_subtitle || 'Profitez de nos Journées Portes Ouvertes pour vous initier gratuitement au golf dans un cadre exceptionnel.'}
                </p>
                <div className="flex items-center gap-3 bg-white/10 rounded-xl px-3 py-2.5 mb-4">
                  <div className="w-9 h-9 rounded-full bg-emerald-500/20 flex items-center justify-center flex-shrink-0">
                    <CheckCircle2 size={18} className="text-emerald-400" />
                  </div>
                  <div>
                    <p className="text-white text-xs font-semibold">Initiation gratuite</p>
                    <p className="text-white/50 text-[10px]">Matériel prêté · Encadrement pro</p>
                  </div>
                </div>
                <a
                  href={clubPath('/portes-ouvertes')}
                  className="flex items-center justify-center w-full h-11 bg-white text-[#1a3a2a] font-bold text-sm rounded-full hover:bg-white/90 active:scale-[0.98] transition-all shadow-lg"
                  data-testid="po-popup-cta"
                >
                  {portalSettings?.po_popup_cta || "S'inscrire gratuitement"}
                </a>
                <button
                  onClick={() => setShowPOPopup(false)}
                  className="w-full mt-3 text-white/40 hover:text-white/60 text-xs text-center transition-colors"
                >
                  {portalSettings?.po_popup_dismiss || 'Non merci, je suis déjà golfeur'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* BACKGROUND LAYER */}
        <div className="absolute inset-0 bg-neutral-900" />
        
        {hasBackgroundImage && !vimeoId ? (
          <div className="absolute inset-0 transition-opacity duration-1000">
            <img src={`data:${portalSettings.login_background_image.content_type};base64,${portalSettings.login_background_image.data}`} alt="" className="absolute inset-0 w-full h-[60%] object-cover object-center" />
            <div className="absolute inset-0 bg-black/35" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
          </div>
        ) : vimeoId ? (
          <div className="absolute inset-0 overflow-hidden">
            <iframe src={`https://player.vimeo.com/video/${vimeoId}?background=1&autoplay=1&loop=1&muted=1&quality=1080p`} className="absolute w-[177.78vh] min-w-full h-[56.25vw] min-h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" frameBorder="0" allow="autoplay; fullscreen" title="Background video" />
            <div className="absolute inset-0 bg-black/30" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/15 to-transparent" />
          </div>
        ) : (
          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(/hero-golf.jpg)` }}>
            <div className="absolute inset-0 bg-black/35" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/15 to-transparent" />
          </div>
        )}
        
        {/* TOP BRANDING */}
        <div className="relative z-10 w-full flex flex-col items-center pt-16 md:pt-24 px-6">
          {settingsLoading ? (
            <div className="w-20 h-20 bg-white/10 backdrop-blur rounded-2xl animate-pulse mb-5" />
          ) : portalSettings?.portal_logo?.data ? (
            <img src={`data:${portalSettings.portal_logo.content_type};base64,${portalSettings.portal_logo.data}`} alt="Logo" className="h-16 md:h-24 w-auto object-contain mb-3 drop-shadow-2xl" data-testid="login-portal-logo" />
          ) : (
            <div className="w-20 h-20 bg-white/10 backdrop-blur border border-white/20 rounded-2xl flex items-center justify-center mb-5 shadow-xl">
              <Calendar className="w-10 h-10 text-white" />
            </div>
          )}
          <h1 className="text-2xl md:text-5xl text-white text-center tracking-tight drop-shadow-md" style={{ fontFamily: "'Manrope', serif", fontWeight: 600 }}>
            {portalSettings?.app_name || 'Portail Client'}
          </h1>
          <p className="text-white/70 text-[10px] md:text-sm mt-1 font-light tracking-[0.15em] uppercase">
            {portalSettings?.welcome_message || 'Connectez-vous pour accéder à votre espace'}
          </p>
        </div>

        {/* Bouton flottant Portes Ouvertes — au-dessus du formulaire */}
        {portalSettings?.po_floating_enabled && !showPOPopup && (
          <div className="relative z-10 w-full max-w-md mx-auto px-4 mb-3">
            <a
              href={clubPath('/portes-ouvertes')}
              className="flex items-center gap-3 pl-1.5 pr-4 py-1.5 rounded-full border border-white/20 backdrop-blur-xl shadow-2xl hover:scale-[1.02] active:scale-[0.98] transition-all duration-200"
              style={{ background: 'linear-gradient(135deg, rgba(46,106,76,0.92) 0%, rgba(22,50,36,0.95) 100%)' }}
              data-testid="po-floating-banner"
            >
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-md">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="9" stroke="#2E6A4C" strokeWidth="2"/>
                  <path d="M9 9.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" fill="#2E6A4C"/>
                  <path d="M13 8.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" fill="#2E6A4C"/>
                  <path d="M15.5 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" fill="#2E6A4C"/>
                  <path d="M11 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" fill="#2E6A4C"/>
                  <path d="M14 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" fill="#2E6A4C"/>
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-white text-[13px] font-bold leading-tight">{portalSettings?.po_floating_title || 'Portes Ouvertes'}</p>
                <p className="text-emerald-200/70 text-[10px]">{portalSettings?.po_floating_subtitle || 'Initiation gratuite — Venez essayer !'}</p>
              </div>
              <div className="w-6 h-6 rounded-full bg-white/15 flex items-center justify-center flex-shrink-0">
                <ChevronRight size={14} className="text-white" />
              </div>
            </a>
          </div>
        )}

        {/* BOTTOM FORM */}
        <div className="relative z-10 w-full max-w-md mx-auto px-4 pb-4 md:pb-8 -mt-4">
          <div className="bg-black/30 backdrop-blur-xl border border-white/10 shadow-2xl rounded-3xl p-5 md:p-7 overflow-hidden relative">
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-white/5 rounded-full blur-3xl pointer-events-none" />

            {showVerification ? (
              /* VERIFICATION */
              <div className="space-y-4 relative z-10">
                <div className="text-center mb-4">
                  <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-3"><Mail className="w-6 h-6 text-white" /></div>
                  <h3 className="text-lg font-medium text-white">Vérification</h3>
                  <p className="text-sm text-white/50 mt-1">Code envoyé à {verificationEmail}</p>
                  <p className="text-xs text-white/40 mt-1.5">Pensez à vérifier vos indésirables (spam)</p>
                </div>
                <form onSubmit={handleVerifyCode} className="space-y-4" data-testid="verify-email-form">
                  <Input value={verificationCode} onChange={(e) => setVerificationCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    className="h-14 text-center text-3xl tracking-[0.5em] font-mono bg-black/30 border-white/15 text-white rounded-xl focus:border-white/40 focus:ring-0"
                    placeholder="000000" maxLength={6} autoFocus data-testid="verification-code-input" inputMode="numeric" />
                  <Button type="submit" disabled={verifyLoading || verificationCode.length !== 6}
                    className="w-full h-12 bg-[#2E6A4C] hover:bg-[#245839] text-white font-semibold rounded-full shadow-lg" data-testid="verify-code-btn">
                    {verifyLoading ? <Loader2 className="animate-spin mr-2" size={16} /> : null} Valider
                  </Button>
                  <div className="flex justify-between items-center px-1">
                    <button type="button" onClick={() => { setShowVerification(false); setVerificationCode(''); }} className="text-xs text-white/40 hover:text-white">Retour</button>
                    <button type="button" onClick={handleResendCode} disabled={resendCooldown > 0} className="text-xs text-white/60 hover:text-white disabled:opacity-40" data-testid="resend-code-btn">
                      {resendCooldown > 0 ? `Renvoyer (${resendCooldown}s)` : 'Renvoyer le code'}
                    </button>
                  </div>
                </form>
              </div>
            ) : !showSignup ? (
              /* LOGIN - Email + Mot de passe sur le même écran */
              <div className="space-y-3 relative z-10">
                {loginStep !== 'select-profile' ? (
                  <form onSubmit={handleLogin} className="space-y-3" autoComplete="off">
                    <div className="space-y-1.5">
                      <Label htmlFor="email" className="text-xs font-medium text-white/70 uppercase tracking-wider ml-1">Email</Label>
                      <div className="relative group">
                        <Mail className="absolute left-3 top-3.5 h-4 w-4 text-white/40 group-focus-within:text-white/70 transition-colors" />
                        <Input id="email" type="email" name="client-email" value={loginForm.email} onChange={(e) => setLoginForm({ ...loginForm, email: e.target.value })}
                          className="h-11 pl-10 bg-black/20 border-white/10 text-white placeholder:text-white/30 rounded-xl focus:bg-black/40 focus:border-white/30 focus:ring-0 transition-all"
                          placeholder="membre@golf.com" required autoComplete="off" data-testid="login-email-input" />
                      </div>
                    </div>
                    <div className="space-y-1.5">
                      <Label htmlFor="password" className="text-xs font-medium text-white/70 uppercase tracking-wider ml-1">Mot de passe</Label>
                      <div className="relative group">
                        <Lock className="absolute left-3 top-3.5 h-4 w-4 text-white/40 group-focus-within:text-white/70 transition-colors" />
                        <Input id="password" type="password" name="client-password" value={loginForm.password} onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
                          className="h-11 pl-10 bg-black/20 border-white/10 text-white placeholder:text-white/30 rounded-xl focus:bg-black/40 focus:border-white/30 focus:ring-0 transition-all"
                          placeholder="Votre mot de passe" required autoComplete="off" data-testid="login-password-input" />
                      </div>
                    </div>
                    <div className="flex items-center justify-between ml-1">
                      <div className="flex items-center space-x-2">
                        <input type="checkbox" id="remember-me" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)}
                          className="h-4 w-4 rounded border-white/30 bg-white/10 text-[#2E6A4C] focus:ring-[#2E6A4C] focus:ring-offset-0" data-testid="remember-me-checkbox" />
                        <Label htmlFor="remember-me" className="text-xs text-white/60 cursor-pointer hover:text-white/80 transition-colors">Se souvenir de moi</Label>
                      </div>
                      <a href={clubPath('/forgot-password')} className="text-xs text-white/60 hover:text-white underline underline-offset-2" data-testid="forgot-password-link">
                        Mot de passe oublié ?
                      </a>
                    </div>
                    <Button type="submit" disabled={loginLoading}
                      className="w-full h-11 bg-[#2E6A4C] hover:bg-[#245839] text-white font-semibold rounded-full shadow-lg hover:shadow-xl hover:scale-[1.01] active:scale-[0.99] transition-all duration-200"
                      data-testid="login-submit-button">
                      {loginLoading ? <><Loader2 className="animate-spin mr-2" size={16} /> Connexion...</> : 'Se connecter'}
                    </Button>
                    <div className="pt-1 text-center">
                      <p className="text-[11px] text-white/40 mb-1.5">Ne ratez rien de l'actualité du club</p>
                      <button type="button" onClick={() => setShowSignup(true)} className="text-sm text-white/80 hover:text-white transition-colors font-medium underline underline-offset-2">Créer mon compte</button>
                    </div>
                    {(portalSettings?.guest_booking_enabled) && (
                      <div className="pt-3 mt-2 border-t border-white/10 space-y-2">
                        <Button type="button" variant="outline" onClick={() => window.location.href = clubPath('/invites')}
                          className="w-full h-10 bg-transparent border-white/20 text-white hover:bg-white/10 hover:text-white rounded-full text-sm" data-testid="guest-booking-btn">
                          <UserPlus className="mr-2 h-4 w-4" /> Réserver en tant qu'invité
                        </Button>
                      </div>
                    )}
                  </form>
                ) : (
                  <div className="space-y-3">
                    <h2 className="text-lg font-medium text-white">Choisissez votre profil</h2>
                    <p className="text-xs text-white/50">Vous pourrez changer de profil à tout moment dans l'espace Mon Compte, sans vous déconnecter.</p>
                    <div className="space-y-2">
                      {loginProfiles.map((p) => (
                        <button key={p.id} onClick={() => handleSelectProfile(p.id)} disabled={loginLoading}
                          className="w-full text-left px-4 py-3 rounded-xl border border-white/10 bg-black/20 hover:bg-[#2E6A4C]/20 hover:border-[#2E6A4C] transition-all"
                          data-testid={`login-profile-${p.id}`}>
                          <span className="text-sm text-white font-medium">{p.first_name} {p.last_name}</span>
                          {p.group && <span className="text-[10px] text-white/40 ml-2">{p.group}</span>}
                        </button>
                      ))}
                    </div>
                    {loginLoading && <div className="flex justify-center"><Loader2 className="animate-spin text-white/50" size={20} /></div>}
                  </div>
                )}
              </div>
            ) : (
              /* SIGNUP MULTI-STEP */
              <div className="space-y-4 relative z-10">
                <div className="flex items-center mb-2">
                  <button onClick={() => { 
                    if (signupStep === 'select-profile' || signupStep === 'full-form') { setSignupStep('email'); }
                    else { setShowSignup(false); setSignupStep('email'); setSignupEmail(''); setEmailProfiles([]); }
                  }} className="text-white/60 hover:text-white mr-3"><ChevronLeft className="w-5 h-5" /></button>
                  <h2 className="text-lg font-medium text-white">Créer un compte</h2>
                </div>

                {signupStep === 'email' && (
                  <form onSubmit={handleCheckEmail} className="space-y-3" autoComplete="off">
                    <div className="space-y-1">
                      <Label className="text-xs text-white/60 ml-1">Votre adresse email</Label>
                      <Input type="email" value={signupEmail} onChange={(e) => setSignupEmail(e.target.value)}
                        className="h-11 bg-black/20 border-white/10 text-white placeholder:text-white/30 rounded-xl focus:bg-black/40 focus:border-white/30 focus:ring-0" 
                        placeholder="votre@email.com" required autoComplete="off" data-testid="signup-email-input" />
                      <p className="text-[10px] text-white/40 leading-tight ml-1">Nous vérifierons si votre email est déjà enregistré au club.</p>
                    </div>
                    <Button type="submit" disabled={checkingEmail}
                      className="w-full h-11 bg-[#2E6A4C] hover:bg-[#245839] text-white font-semibold rounded-full shadow-lg" data-testid="signup-check-email-btn">
                      {checkingEmail ? <><Loader2 className="animate-spin mr-2" size={16} /> Vérification...</> : 'Continuer'}
                    </Button>
                  </form>
                )}

                {signupStep === 'select-profile' && (
                  <form onSubmit={handleProfileSignup} className="space-y-3" autoComplete="off">
                    <p className="text-xs text-white/60 ml-1">Profils trouvés pour <strong className="text-white/80">{signupEmail}</strong></p>
                    <div className="space-y-2 max-h-40 overflow-y-auto">
                      {emailProfiles.map((p) => (
                        <button key={p.id} type="button" disabled={p.already_active}
                          onClick={() => !p.already_active && setSelectedProfileId(p.id)}
                          className={`w-full text-left px-3 py-2.5 rounded-xl border transition-all ${
                            p.already_active 
                              ? 'border-white/5 bg-white/5 opacity-40 cursor-not-allowed' 
                              : selectedProfileId === p.id 
                                ? 'border-[#2E6A4C] bg-[#2E6A4C]/20' 
                                : 'border-white/10 bg-black/20 hover:bg-black/30'
                          }`} data-testid={`profile-option-${p.id}`}>
                          <div className="flex items-center justify-between">
                            <div>
                              <span className="text-sm text-white font-medium">{p.first_name} {p.last_name}</span>
                              {p.group && <span className="text-[10px] text-white/40 ml-2">{p.group}</span>}
                            </div>
                            {p.already_active && <span className="text-[10px] text-white/30">Déjà actif</span>}
                            {!p.already_active && selectedProfileId === p.id && <Check size={16} className="text-[#2E6A4C]" />}
                          </div>
                        </button>
                      ))}
                    </div>
                    <div className="space-y-1">
                      <Label className="text-xs text-white/60 ml-1">Choisissez un mot de passe</Label>
                      <Input type="password" value={signupForm.password} onChange={(e) => setSignupForm({...signupForm, password: e.target.value})}
                        className="h-10 bg-black/20 border-white/10 text-white placeholder:text-white/30 rounded-xl focus:bg-black/40 focus:border-white/30 focus:ring-0" 
                        placeholder="Min. 6 caractères" required minLength={6} autoComplete="new-password" data-testid="signup-profile-password" />
                    </div>
                    <div className="space-y-1">
                      <Label className="text-xs text-white/60 ml-1">Confirmation</Label>
                      <Input type="password" value={signupForm.confirmPassword} onChange={(e) => setSignupForm({...signupForm, confirmPassword: e.target.value})}
                        className="h-10 bg-black/20 border-white/10 text-white placeholder:text-white/30 rounded-xl focus:bg-black/40 focus:border-white/30 focus:ring-0" 
                        placeholder="Confirmez le mot de passe" required minLength={6} autoComplete="new-password" data-testid="signup-profile-confirm" />
                    </div>
                    <Button type="submit" disabled={signupLoading || !selectedProfileId}
                      className="w-full h-11 bg-[#2E6A4C] hover:bg-[#245839] text-white font-semibold rounded-full shadow-lg mt-1" data-testid="signup-profile-submit">
                      {signupLoading ? <><Loader2 className="animate-spin mr-2" size={16} /> Création...</> : 'Créer mon compte'}
                    </Button>
                  </form>
                )}

                {signupStep === 'full-form' && (
                  <form onSubmit={handleSignup} className="space-y-3" autoComplete="off">
                    <p className="text-[10px] text-white/40 ml-1">Aucun profil trouvé pour <strong>{signupEmail}</strong>. Complétez votre inscription.</p>
                    <div className="grid grid-cols-2 gap-3">
                      <div className="space-y-1">
                        <Label className="text-xs text-white/60 ml-1">Prénom</Label>
                        <Input value={signupForm.first_name} onChange={(e) => {
                            let v = e.target.value.replace(/[^a-zA-ZÀ-ÿ\s'-]/g, '');
                            if (v.length > 0) v = v.charAt(0).toUpperCase() + v.slice(1);
                            setSignupForm({...signupForm, first_name: v});
                          }}
                          className="h-10 bg-black/20 border-white/10 text-white placeholder:text-white/30 rounded-xl focus:bg-black/40 focus:border-white/30 focus:ring-0" placeholder="Jean" required minLength={2} autoComplete="off" />
                      </div>
                      <div className="space-y-1">
                        <Label className="text-xs text-white/60 ml-1">Nom</Label>
                        <Input value={signupForm.last_name} onChange={(e) => {
                            let v = e.target.value.replace(/[^a-zA-ZÀ-ÿ\s'-]/g, '');
                            if (v.length > 0) v = v.charAt(0).toUpperCase() + v.slice(1);
                            setSignupForm({...signupForm, last_name: v});
                          }}
                          className="h-10 bg-black/20 border-white/10 text-white placeholder:text-white/30 rounded-xl focus:bg-black/40 focus:border-white/30 focus:ring-0" placeholder="Dupont" required minLength={2} autoComplete="off" />
                      </div>
                    </div>
                    <div className="space-y-1">
                      <Label className="text-xs text-white/60 ml-1">Téléphone</Label>
                      <Input type="tel" value={signupForm.phone} onChange={(e) => setSignupForm({...signupForm, phone: e.target.value})}
                        className="h-10 bg-black/20 border-white/10 text-white placeholder:text-white/30 rounded-xl focus:bg-black/40 focus:border-white/30 focus:ring-0" placeholder="06 12 34 56 78" autoComplete="off" />
                    </div>
                    <div className="space-y-1">
                      <Label className="text-xs text-white/60 ml-1">Mot de passe</Label>
                      <Input type="password" value={signupForm.password} onChange={(e) => setSignupForm({...signupForm, password: e.target.value})}
                        className="h-10 bg-black/20 border-white/10 text-white placeholder:text-white/30 rounded-xl focus:bg-black/40 focus:border-white/30 focus:ring-0" placeholder="Min. 6 caractères" required minLength={6} autoComplete="new-password" />
                    </div>
                    <div className="space-y-1">
                      <Label className="text-xs text-white/60 ml-1">Confirmation</Label>
                      <Input type="password" value={signupForm.confirmPassword} onChange={(e) => setSignupForm({...signupForm, confirmPassword: e.target.value})}
                        className="h-10 bg-black/20 border-white/10 text-white placeholder:text-white/30 rounded-xl focus:bg-black/40 focus:border-white/30 focus:ring-0" placeholder="Confirmez le mot de passe" required minLength={6} autoComplete="new-password" />
                    </div>
                    <Button type="submit" disabled={signupLoading}
                      className="w-full h-11 bg-[#2E6A4C] hover:bg-[#245839] text-white font-semibold rounded-full shadow-lg mt-1">
                      {signupLoading ? 'Inscription...' : "S'inscrire"}
                    </Button>
                  </form>
                )}
              </div>
            )}
          </div>
        </div>

      </div>
    );
  }

  // Portail connecté
  return (
    <div className="fixed inset-0 flex flex-col overflow-hidden pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] portal-premium" style={{ backgroundColor: '#F5F2EB' }} data-testid="client-portal">
      {/* Header Mobile avec Logo */}
      <header className={`flex-shrink-0 z-40 md:hidden overflow-visible ${activeTab === 'dashboard' ? 'hidden' : ''}`} style={{ backgroundColor: '#F5F2EB', borderBottom: '1px solid #e8e4de' }}>
        <div className="px-3 py-2 flex items-center justify-between overflow-visible">
          <div className="flex items-center gap-2">
            {/* Logo du portail sur mobile avec skeleton */}
            {settingsLoading ? (
              <div className="w-8 h-8 bg-neutral-200 rounded-lg animate-pulse" />
            ) : portalSettings?.portal_logo?.data ? (
              <img 
                src={`data:${portalSettings.portal_logo.content_type};base64,${portalSettings.portal_logo.data}`}
                alt="Logo"
                className="h-8 w-auto max-w-[100px] object-contain"
                data-testid="mobile-portal-logo"
              />
            ) : (
              <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                <Calendar className="w-4 h-4 text-primary" />
              </div>
            )}
            <div>
              <h1 className="font-semibold text-neutral-900 text-sm">Portail Client</h1>
              <p className="text-[10px] text-neutral-500">Bonjour, {client?.first_name}</p>
            </div>
            {/* Sélecteur de profil rapide - Mobile */}
            {linkedProfiles && linkedProfiles.length > 1 && (
              <Popover>
                <PopoverTrigger asChild>
                  <button
                    className="flex items-center gap-1 px-2 py-1 rounded-full border border-neutral-200 hover:bg-neutral-50 transition-colors"
                    data-testid="profile-switcher-mobile"
                  >
                    <ArrowLeftRight size={12} className="text-neutral-500" />
                    <span className="text-[10px] font-medium text-neutral-600">{client?.first_name?.[0]}{client?.last_name?.[0]}</span>
                  </button>
                </PopoverTrigger>
                <PopoverContent className="w-52 p-1.5" align="start" sideOffset={8}>
                  <p className="text-[10px] font-semibold text-neutral-400 uppercase tracking-wide px-2 py-1">Changer de profil</p>
                  {linkedProfiles.map((p) => {
                    const isActive = p.id === client?.id;
                    return (
                      <button
                        key={p.id}
                        onClick={() => { if (!isActive) handleSwitchProfile(p.id); }}
                        className={`w-full flex items-center gap-2 px-2 py-2 rounded-lg text-left transition-colors ${isActive ? 'bg-emerald-50' : 'hover:bg-neutral-50'}`}
                        data-testid={`profile-option-mobile-${p.id}`}
                      >
                        <div className={`w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold text-white flex-shrink-0`} style={{ backgroundColor: isActive ? '#2E6A4C' : '#9ca3af' }}>
                          {(p.first_name || '?')[0].toUpperCase()}
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className={`text-[11px] font-medium truncate ${isActive ? 'text-emerald-700' : 'text-neutral-700'}`}>{p.first_name} {p.last_name}</p>
                          {p.group && <p className="text-[9px] text-neutral-400 truncate">{p.group}</p>}
                        </div>
                        {isActive && <Check size={12} className="text-emerald-600 flex-shrink-0" />}
                      </button>
                    );
                  })}
                </PopoverContent>
              </Popover>
            )}
          </div>
          <div className="flex items-center gap-1">
            {/* Cloche unifiée - notifications + activation push */}
            <div className="relative">
              <Button
                ref={bellBtnRef}
                variant="ghost"
                size="sm"
                onClick={handleNotifBellClick}
                className="h-8 px-2 relative text-neutral-600"
                data-testid="client-notification-bell-mobile"
              >
                <Bell size={14} />
                {/* Badge nombre non-lu */}
                {clientUnread > 0 && (
                  <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] flex items-center justify-center bg-red-500 text-white text-[9px] font-bold rounded-full px-0.5">
                    {clientUnread > 99 ? '99+' : clientUnread}
                  </span>
                )}
                {/* Point rouge si push pas activé ET pas de badge nombre */}
                {!pushSubscribed && !pushLoading && clientUnread === 0 && (
                  <span className="absolute -top-1 -right-1 flex h-3 w-3">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                  </span>
                )}
              </Button>

              {/* Panel de notifications - via Portal pour positionnement correct sur toutes les pages */}
              {notifPanelOpen && createPortal(
                <div ref={mobilePortalPanelRef} className="fixed right-1 w-[calc(100vw-0.5rem)] max-w-80 bg-white rounded-xl shadow-2xl border border-neutral-200 z-[9999] overflow-hidden md:hidden" style={{ top: 'calc(env(safe-area-inset-top, 0px) + 2.75rem)' }} data-testid="client-notif-panel">
                  {/* Bannière d'activation push si pas activé */}
                  {!pushSubscribed && (
                    <div className="px-3 py-2.5 bg-amber-50 border-b border-amber-200">
                      {(() => {
                        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
                        const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
                        const isIOSBrowser = isIOS && !isStandalone;
                        const isIOSNonSafari = isIOS && /CriOS|FxiOS|OPiOS|EdgiOS/.test(navigator.userAgent);
                        const isAndroid = /Android/.test(navigator.userAgent);

                        if (isIOSNonSafari) {
                          return (
                            <div className="space-y-2" data-testid="pwa-guide-mobile">
                              <p className="text-xs font-bold text-amber-900">Pour recevoir les notifications :</p>
                              <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                                <div className="w-6 h-6 bg-amber-500 rounded flex items-center justify-center flex-shrink-0"><Globe size={12} className="text-white" /></div>
                                <p className="text-[11px] text-neutral-700"><strong>1.</strong> Ouvrez ce site dans <strong>Safari</strong></p>
                              </div>
                              <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                                <div className="w-6 h-6 bg-blue-500 rounded flex items-center justify-center flex-shrink-0"><Share size={12} className="text-white" /></div>
                                <p className="text-[11px] text-neutral-700"><strong>2.</strong> Appuyez sur <strong>Partager</strong> <Share className="inline w-3 h-3" /></p>
                              </div>
                              <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                                <div className="w-6 h-6 bg-neutral-800 rounded flex items-center justify-center flex-shrink-0"><Plus size={12} className="text-white" /></div>
                                <p className="text-[11px] text-neutral-700"><strong>3.</strong> <strong>"Sur l'écran d'accueil"</strong></p>
                              </div>
                            </div>
                          );
                        }
                        if (isIOSBrowser) {
                          return (
                            <div className="space-y-2" data-testid="pwa-guide-mobile">
                              <p className="text-xs font-bold text-amber-900">Pour recevoir les notifications :</p>
                              <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                                <div className="w-6 h-6 bg-blue-500 rounded flex items-center justify-center flex-shrink-0"><Share size={12} className="text-white" /></div>
                                <p className="text-[11px] text-neutral-700"><strong>1.</strong> Appuyez sur <strong>Partager</strong> <Share className="inline w-3 h-3" /> en bas de l'écran</p>
                              </div>
                              <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                                <div className="w-6 h-6 bg-neutral-800 rounded flex items-center justify-center flex-shrink-0"><Plus size={12} className="text-white" /></div>
                                <p className="text-[11px] text-neutral-700"><strong>2.</strong> Sélectionnez <strong>"Sur l'écran d'accueil"</strong></p>
                              </div>
                              <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                                <div className="w-6 h-6 bg-emerald-500 rounded flex items-center justify-center flex-shrink-0"><Bell size={12} className="text-white" /></div>
                                <p className="text-[11px] text-neutral-700"><strong>3.</strong> Ouvrez l'app puis activez les notifications</p>
                              </div>
                            </div>
                          );
                        }
                        if (isAndroid) {
                          return (
                            <div className="space-y-2" data-testid="pwa-guide-mobile">
                              <p className="text-xs font-bold text-amber-900">Pour recevoir les notifications :</p>
                              <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                                <div className="w-6 h-6 bg-blue-500 rounded flex items-center justify-center flex-shrink-0"><MoreVertical size={12} className="text-white" /></div>
                                <p className="text-[11px] text-neutral-700"><strong>1.</strong> Appuyez sur <strong>&#8942;</strong> en haut à droite</p>
                              </div>
                              <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                                <div className="w-6 h-6 bg-neutral-800 rounded flex items-center justify-center flex-shrink-0"><Plus size={12} className="text-white" /></div>
                                <p className="text-[11px] text-neutral-700"><strong>2.</strong> <strong>"Ajouter à l'écran d'accueil"</strong></p>
                              </div>
                            </div>
                          );
                        }
                        // Desktop ou PWA : bouton Activer direct
                        return (
                          <>
                            <div className="flex items-center gap-2">
                              <div className="relative flex h-3 w-3 flex-shrink-0">
                                <span className="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-red-400 opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                              </div>
                              <p className="text-xs text-amber-800 font-medium flex-1">Activez les notifications push</p>
                            </div>
                            <button
                              className="mt-1.5 bg-emerald-500 hover:bg-emerald-600 text-white text-xs px-3 py-1.5 rounded-lg w-full font-medium transition-colors"
                              data-testid="activate-push-btn-mobile"
                              onMouseDown={(e) => e.stopPropagation()}
                              onTouchStart={(e) => e.stopPropagation()}
                              onClick={async (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                if (typeof Notification === 'undefined') {
                                  toast.error('Votre appareil ne supporte pas les notifications push. Mettez à jour votre navigateur ou utilisez un appareil plus récent.', { duration: 8000 });
                                  return;
                                }
                                try {
                                  // Appel direct pour conserver le user gesture context (iOS)
                                  const perm = await Notification.requestPermission();
                                  if (perm === 'granted') {
                                    // Permission accordée, lancer la souscription complète
                                    const ok = await pushSubscribe();
                                    if (ok) {
                                      toast.success('Notifications activées !');
                                      setShowNotifPrompt(false);
                                    } else {
                                      toast.error('Erreur lors de l\'activation. Réessayez.', { duration: 5000 });
                                    }
                                  } else if (perm === 'denied') {
                                    toast.error('Notifications bloquées. Allez dans Réglages > Notifications pour les activer.', { duration: 8000 });
                                  } else {
                                    toast.info('Appuyez à nouveau sur Activer pour autoriser les notifications.', { duration: 5000 });
                                  }
                                } catch (err) {
                                  console.error('[Push] Permission error:', err);
                                  toast.error('Votre appareil ne supporte pas les notifications push. Mettez à jour votre navigateur ou utilisez un appareil plus récent.', { duration: 8000 });
                                }
                              }}
                            >
                              Activer
                            </button>
                          </>
                        );
                      })()}
                    </div>
                  )}
                  {/* Header avec logo */}
                  <div className="px-4 py-3 border-b border-neutral-100 bg-gradient-to-r from-emerald-50 to-white flex items-center gap-2.5">
                    {portalSettings?.portal_logo?.data ? (
                      <img src={`data:${portalSettings.portal_logo.content_type};base64,${portalSettings.portal_logo.data}`} alt="" className="h-6 w-6 object-contain rounded" />
                    ) : (
                      <div className="w-6 h-6 bg-emerald-600 rounded-full flex items-center justify-center">
                        <Bell size={12} className="text-white" />
                      </div>
                    )}
                    <span className="font-semibold text-sm text-neutral-900">Notifications</span>
                    {clientNotifs.length > 0 && (
                      <span className="ml-auto text-[10px] bg-emerald-600 text-white px-1.5 py-0.5 rounded-full font-medium">{clientNotifs.length}</span>
                    )}
                  </div>
                  {/* Liste */}
                  <div className="max-h-80 overflow-y-auto divide-y divide-neutral-100">
                    {clientNotifs.length === 0 ? (
                      <div className="py-8 text-center text-neutral-400">
                        <Bell size={28} className="mx-auto mb-2 opacity-20" />
                        <p className="text-xs">Aucune notification</p>
                      </div>
                    ) : (
                      clientNotifs.map((n) => {
                        const iconConfig = {
                          booking_confirmed: { icon: Calendar, color: 'bg-blue-500' },
                          booking_cancelled_by_admin: { icon: X, color: 'bg-red-500' },
                          new_competition_available: { icon: Trophy, color: 'bg-amber-500' },
                          competition_reminder: { icon: Trophy, color: 'bg-amber-500' },
                          new_stage_available: { icon: BookOpen, color: 'bg-purple-500' },
                          stage_reminder: { icon: BookOpen, color: 'bg-purple-500' },
                          new_news: { icon: Newspaper, color: 'bg-emerald-500' },
                          new_devis: { icon: CreditCard, color: 'bg-indigo-500' },
                          cotisation_expiry: { icon: CreditCard, color: 'bg-orange-500' },
                        };
                        const cfg = iconConfig[n.type] || { icon: Bell, color: 'bg-neutral-400' };
                        const IconComp = cfg.icon;
                        return (
                          <a key={n.id} href={n.url || '#'} className="flex items-start gap-3 px-4 py-3 hover:bg-neutral-50 transition-colors" data-testid={`client-notif-${n.id}`}>
                            <div className={`w-8 h-8 ${cfg.color} rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm`}>
                              <IconComp size={14} className="text-white" />
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-semibold text-neutral-900 line-clamp-1">{n.title}</p>
                              <p className="text-xs text-neutral-500 mt-0.5 line-clamp-2 leading-relaxed">{n.body}</p>
                            </div>
                          </a>
                        );
                      })
                    )}
                  </div>
                </div>
              , document.body)}

              {/* Message d'incitation aux notifications - mobile */}
              {!pushSubscribed && showNotifPrompt && !notifPanelOpen && createPortal(
                <div className="fixed right-3 top-[52px] bg-neutral-900 text-white text-xs px-3 py-2.5 rounded-lg shadow-lg w-56 z-[9999] md:hidden animate-in fade-in slide-in-from-top-2" data-testid="notif-prompt-mobile">
                  <div className="absolute -top-2 right-4 w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-b-8 border-b-neutral-900"></div>
                  <button 
                    className="absolute top-1 right-1 bg-neutral-700 hover:bg-neutral-600 rounded-full w-5 h-5 flex items-center justify-center text-xs"
                    onClick={() => setShowNotifPrompt(false)}
                  >
                    x
                  </button>
                  <p className="mb-2 pr-4">
                    <Bell className="inline w-3 h-3 mr-1" />
                    Activez les notifications pour ne rien manquer !
                  </p>
                  <button 
                    className="bg-emerald-500 hover:bg-emerald-600 text-white text-xs px-2 py-1.5 rounded w-full font-medium"
                    data-testid="activate-push-bubble-mobile"
                    onMouseDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                    onClick={async (e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      if (typeof Notification === 'undefined') {
                        toast.error('Votre appareil ne supporte pas les notifications push. Mettez à jour votre navigateur ou utilisez un appareil plus récent.', { duration: 8000 });
                        return;
                      }
                      try {
                        const perm = await Notification.requestPermission();
                        if (perm === 'granted') {
                          const ok = await pushSubscribe();
                          if (ok) { toast.success('Notifications activées !'); setShowNotifPrompt(false); }
                          else toast.error("Erreur lors de l'activation. Réessayez.", { duration: 5000 });
                        } else if (perm === 'denied') {
                          toast.error('Notifications bloquées. Allez dans Réglages > Notifications.', { duration: 8000 });
                        } else {
                          toast.info('Appuyez à nouveau pour autoriser.', { duration: 5000 });
                        }
                      } catch (err) {
                        toast.error('Votre appareil ne supporte pas les notifications push. Mettez à jour votre navigateur ou utilisez un appareil plus récent.', { duration: 8000 });
                      }
                    }}
                  >
                    Activer
                  </button>
                </div>,
                document.body
              )}
            </div>
            <Button 
              variant="ghost" 
              size="sm"
              onClick={handleLogout}
              className="h-8 px-2 text-xs text-neutral-500"
            >
              <LogOut size={14} />
            </Button>
          </div>
        </div>
      </header>

      {/* Navigation Mobile en bas */}
      <div className="fixed bottom-0 left-0 right-0 md:hidden z-50 pb-[env(safe-area-inset-bottom)]" style={{ backgroundColor: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(12px)', borderTop: '1px solid #e8e4de' }}>
        <div className="flex justify-around py-1.5">
          {[
            { id: 'dashboard', label: 'Accueil', icon: Home },
            { id: 'cours', label: 'Cours', icon: CalendarDays },
            ...(teeTimeEnabled ? [{ id: 'departs', label: 'Départs', icon: Flag }] : []),
            { id: 'stages', label: 'Stages', icon: BookOpen },
            { id: 'competitions', label: 'Événem.', icon: Trophy },
            ...(isAcademyMember ? [{ id: 'ecole', label: 'École', icon: Shield }] : []),
            { id: 'boutique', label: 'Boutique', icon: ShoppingBag },
            { id: 'news', label: 'Actus', icon: Newspaper },
            { id: 'account', label: 'Compte', icon: User },
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className="flex flex-col items-center gap-0.5 px-1.5 py-1 transition-colors relative"
              data-testid={`bottom-nav-${tab.id}`}
            >
              {activeTab === tab.id && (
                <div className="absolute -top-1.5 left-1/2 -translate-x-1/2 w-5 h-0.5 rounded-full" style={{ backgroundColor: '#2E6A4C' }} />
              )}
              <div className="relative">
                <tab.icon size={21} style={{ color: activeTab === tab.id ? '#2E6A4C' : '#aaa' }} />
                {tab.id === 'account' && pendingContractsCount > 0 && (
                  <span
                    className="absolute -top-1 -right-1.5 flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full bg-red-600 text-white text-[10px] font-bold shadow-sm ring-2 ring-white"
                    data-testid="nav-account-badge-mobile"
                  >
                    {pendingContractsCount}
                  </span>
                )}
              </div>
              <span className="font-semibold" style={{ fontSize: '9px', color: activeTab === tab.id ? '#2E6A4C' : '#aaa' }}>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Desktop Header only */}
      <header className="flex-shrink-0 bg-white border-b border-neutral-200 z-50 shadow-sm hidden md:block overflow-visible">
        <div className="w-full mx-auto px-4 py-2 flex items-center justify-between gap-2">
          <div className="flex items-center gap-3 flex-shrink-0">
            {/* Logo du portail ou icône par défaut */}
            {portalSettings?.portal_logo?.data ? (
              <img 
                src={`data:${portalSettings.portal_logo.content_type};base64,${portalSettings.portal_logo.data}`}
                alt="Logo"
                className="h-9 w-auto max-w-[100px] object-contain"
                data-testid="portal-logo"
              />
            ) : (
              <div className="w-8 h-8 bg-primary/10 rounded-xl flex items-center justify-center">
                <Calendar className="w-4 h-4 text-primary" />
              </div>
            )}
            <div className="hidden lg:block">
              <h1 className="font-semibold text-neutral-900 text-sm leading-tight">{portalSettings?.app_name || 'Portail Client'}</h1>
              <p className="text-[11px] text-neutral-500 truncate max-w-[140px]">Bienvenue, {client?.first_name}</p>
            </div>
            {/* Sélecteur de profil rapide - Desktop */}
            {linkedProfiles && linkedProfiles.length > 1 && (
              <Popover>
                <PopoverTrigger asChild>
                  <button
                    className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-full border border-neutral-200 hover:bg-neutral-50 transition-colors text-xs"
                    data-testid="profile-switcher-desktop"
                  >
                    <div className="w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold text-white flex-shrink-0" style={{ backgroundColor: '#2E6A4C' }}>
                      {(client?.first_name || '?')[0].toUpperCase()}
                    </div>
                    <span className="font-medium text-neutral-700 max-w-[100px] truncate">{client?.first_name} {(client?.last_name || '')[0]}.</span>
                    <ChevronDown size={12} className="text-neutral-400" />
                  </button>
                </PopoverTrigger>
                <PopoverContent className="w-56 p-1.5" align="start" sideOffset={8}>
                  <p className="text-[10px] font-semibold text-neutral-400 uppercase tracking-wide px-2 py-1">Changer de profil</p>
                  {linkedProfiles.map((p) => {
                    const isActive = p.id === client?.id;
                    return (
                      <button
                        key={p.id}
                        onClick={() => { if (!isActive) handleSwitchProfile(p.id); }}
                        className={`w-full flex items-center gap-2.5 px-2 py-2 rounded-lg text-left transition-colors ${isActive ? 'bg-emerald-50' : 'hover:bg-neutral-50'}`}
                        data-testid={`profile-option-${p.id}`}
                      >
                        <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold text-white flex-shrink-0 ${isActive ? '' : 'opacity-60'}`} style={{ backgroundColor: isActive ? '#2E6A4C' : '#9ca3af' }}>
                          {(p.first_name || '?')[0].toUpperCase()}
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className={`text-xs font-medium truncate ${isActive ? 'text-emerald-700' : 'text-neutral-700'}`}>{p.first_name} {p.last_name}</p>
                          {p.group && <p className="text-[10px] text-neutral-400 truncate">{p.group}</p>}
                        </div>
                        {isActive && <Check size={14} className="text-emerald-600 flex-shrink-0" />}
                      </button>
                    );
                  })}
                </PopoverContent>
              </Popover>
            )}
          </div>
          
          {/* Desktop nav */}
          <nav className="flex items-center gap-0.5 flex-wrap justify-center">
          {[
              { id: 'dashboard', label: 'Accueil', icon: Home },
              { id: 'cours', label: 'Cours', icon: CalendarDays },
              ...(teeTimeEnabled ? [{ id: 'departs', label: 'Départs', icon: Flag }] : []),
              { id: 'stages', label: 'Stages', icon: BookOpen },
              { id: 'competitions', label: 'Événements', icon: Trophy },
              ...(isAcademyMember ? [{ id: 'ecole', label: 'École de Golf', icon: Shield }] : []),
              { id: 'boutique', label: 'Boutique', icon: ShoppingBag },
              { id: 'news', label: 'Actualités', icon: Newspaper },
              { id: 'account', label: 'Compte', icon: User },
            ].map(tab => (
              <Button
                key={tab.id}
                variant={activeTab === tab.id ? 'default' : 'ghost'}
                size="sm"
                onClick={() => setActiveTab(tab.id)}
                className="h-8 px-2.5 text-xs relative"
                style={activeTab === tab.id ? { backgroundColor: '#2E6A4C', color: '#fff', borderRadius: '20px' } : { borderRadius: '20px' }}
                data-testid={`nav-${tab.id}`}
              >
                <tab.icon size={14} className="mr-1.5" />
                {tab.label}
                {tab.id === 'account' && pendingContractsCount > 0 && (
                  <span
                    className="absolute -top-1 -right-1 flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full bg-red-600 text-white text-[10px] font-bold shadow-sm ring-2 ring-white"
                    data-testid="nav-account-badge-desktop"
                  >
                    {pendingContractsCount}
                  </span>
                )}
              </Button>
            ))}
          </nav>

          {/* Cloche unifiée + Retour admin - desktop */}
          <div className="flex items-center gap-1">
            {isAdminViewing && (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => { localStorage.removeItem('client_portal_token'); window.location.href = clubPath('/modules'); }}
                className="h-8 px-2.5 text-xs flex-shrink-0 text-emerald-700 hover:bg-emerald-50"
                title="Retour Administration"
                data-testid="back-to-admin-btn-desktop"
              >
                <Shield size={14} className="mr-1" />
                Admin
              </Button>
            )}
          <div className="relative" ref={notifPanelRef}>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleNotifBellClick}
              className="h-8 w-8 p-0 flex-shrink-0 relative text-neutral-600"
              title="Notifications"
              data-testid="client-notification-bell-desktop"
            >
              <Bell size={14} />
              {clientUnread > 0 && (
                <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] flex items-center justify-center bg-red-500 text-white text-[9px] font-bold rounded-full px-0.5">
                  {clientUnread > 99 ? '99+' : clientUnread}
                </span>
              )}
              {!pushSubscribed && !pushLoading && clientUnread === 0 && (
                <span className="absolute -top-0.5 -right-0.5 flex h-2.5 w-2.5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
                </span>
              )}
            </Button>

            {/* Panel de notifications - desktop via Portal */}
            {notifPanelOpen && createPortal(
              <div ref={desktopPortalPanelRef} className="fixed right-4 top-12 w-96 bg-white rounded-xl shadow-2xl border border-neutral-200 z-[9999] overflow-hidden hidden md:block" data-testid="client-notif-panel-desktop">
                {!pushSubscribed && (
                  <div className="px-3 py-2.5 bg-amber-50 border-b border-amber-200">
                    {(() => {
                      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
                      const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
                      const isIOSBrowser = isIOS && !isStandalone;
                      const isIOSNonSafari = isIOS && /CriOS|FxiOS|OPiOS|EdgiOS/.test(navigator.userAgent);
                      const isAndroid = /Android/.test(navigator.userAgent);

                      if (isIOSNonSafari) {
                        return (
                          <div className="space-y-2" data-testid="pwa-guide-desktop">
                            <p className="text-xs font-bold text-amber-900">Pour recevoir les notifications :</p>
                            <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                              <div className="w-6 h-6 bg-amber-500 rounded flex items-center justify-center flex-shrink-0"><Globe size={12} className="text-white" /></div>
                              <p className="text-[11px] text-neutral-700"><strong>1.</strong> Ouvrez ce site dans <strong>Safari</strong></p>
                            </div>
                            <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                              <div className="w-6 h-6 bg-blue-500 rounded flex items-center justify-center flex-shrink-0"><Share size={12} className="text-white" /></div>
                              <p className="text-[11px] text-neutral-700"><strong>2.</strong> Appuyez sur <strong>Partager</strong> <Share className="inline w-3 h-3" /></p>
                            </div>
                            <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                              <div className="w-6 h-6 bg-neutral-800 rounded flex items-center justify-center flex-shrink-0"><Plus size={12} className="text-white" /></div>
                              <p className="text-[11px] text-neutral-700"><strong>3.</strong> <strong>"Sur l'écran d'accueil"</strong></p>
                            </div>
                          </div>
                        );
                      }
                      if (isIOSBrowser) {
                        return (
                          <div className="space-y-2" data-testid="pwa-guide-desktop">
                            <p className="text-xs font-bold text-amber-900">Pour recevoir les notifications :</p>
                            <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                              <div className="w-6 h-6 bg-blue-500 rounded flex items-center justify-center flex-shrink-0"><Share size={12} className="text-white" /></div>
                              <p className="text-[11px] text-neutral-700"><strong>1.</strong> Appuyez sur <strong>Partager</strong> <Share className="inline w-3 h-3" /> en bas de l'écran</p>
                            </div>
                            <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                              <div className="w-6 h-6 bg-neutral-800 rounded flex items-center justify-center flex-shrink-0"><Plus size={12} className="text-white" /></div>
                              <p className="text-[11px] text-neutral-700"><strong>2.</strong> Sélectionnez <strong>"Sur l'écran d'accueil"</strong></p>
                            </div>
                            <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                              <div className="w-6 h-6 bg-emerald-500 rounded flex items-center justify-center flex-shrink-0"><Bell size={12} className="text-white" /></div>
                              <p className="text-[11px] text-neutral-700"><strong>3.</strong> Ouvrez l'app puis activez les notifications</p>
                            </div>
                          </div>
                        );
                      }
                      if (isAndroid) {
                        return (
                          <div className="space-y-2" data-testid="pwa-guide-desktop">
                            <p className="text-xs font-bold text-amber-900">Pour recevoir les notifications :</p>
                            <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                              <div className="w-6 h-6 bg-blue-500 rounded flex items-center justify-center flex-shrink-0"><MoreVertical size={12} className="text-white" /></div>
                              <p className="text-[11px] text-neutral-700"><strong>1.</strong> Appuyez sur <strong>&#8942;</strong> en haut à droite</p>
                            </div>
                            <div className="bg-white rounded-lg p-2 flex items-center gap-2">
                              <div className="w-6 h-6 bg-neutral-800 rounded flex items-center justify-center flex-shrink-0"><Plus size={12} className="text-white" /></div>
                              <p className="text-[11px] text-neutral-700"><strong>2.</strong> <strong>"Ajouter à l'écran d'accueil"</strong></p>
                            </div>
                          </div>
                        );
                      }
                      // Desktop : bouton Activer direct
                      return (
                        <div className="flex items-center gap-2">
                          <div className="relative flex h-3 w-3 flex-shrink-0">
                            <span className="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-red-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                          </div>
                          <p className="text-xs text-amber-800 font-medium flex-1">Activez les notifications pour ne rien manquer</p>
                          <button
                            className="bg-emerald-500 hover:bg-emerald-600 text-white text-xs px-3 py-1 rounded-lg font-medium transition-colors flex-shrink-0"
                            data-testid="activate-push-btn-desktop"
                            onMouseDown={(e) => e.stopPropagation()}
                            onTouchStart={(e) => e.stopPropagation()}
                            onClick={async (e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              try {
                                const perm = await Notification.requestPermission();
                                if (perm === 'granted') {
                                  const ok = await pushSubscribe();
                                  if (ok) {
                                    toast.success('Notifications activées !');
                                    setShowNotifPrompt(false);
                                  } else {
                                    toast.error('Erreur lors de l\'activation. Réessayez.', { duration: 5000 });
                                  }
                                } else if (perm === 'denied') {
                                  toast.error('Notifications bloquées. Allez dans Réglages > Notifications pour les activer.', { duration: 8000 });
                                } else {
                                  toast.info('Appuyez à nouveau sur Activer pour autoriser les notifications.', { duration: 5000 });
                                }
                              } catch (err) {
                                console.error('[Push] Permission error:', err);
                                toast.error('Erreur : ' + (err.message || 'Impossible d\'activer'), { duration: 5000 });
                              }
                            }}
                          >
                            Activer
                          </button>
                        </div>
                      );
                    })()}
                  </div>
                )}
                <div className="px-4 py-3 border-b border-neutral-100 bg-gradient-to-r from-emerald-50 to-white flex items-center gap-2.5">
                  {portalSettings?.portal_logo?.data ? (
                    <img src={`data:${portalSettings.portal_logo.content_type};base64,${portalSettings.portal_logo.data}`} alt="" className="h-6 w-6 object-contain rounded" />
                  ) : (
                    <div className="w-6 h-6 bg-emerald-600 rounded-full flex items-center justify-center">
                      <Bell size={12} className="text-white" />
                    </div>
                  )}
                  <span className="font-semibold text-sm text-neutral-900">Notifications</span>
                  {clientNotifs.length > 0 && (
                    <span className="ml-auto text-[10px] bg-emerald-600 text-white px-1.5 py-0.5 rounded-full font-medium">{clientNotifs.length}</span>
                  )}
                </div>
                <div className="max-h-80 overflow-y-auto divide-y divide-neutral-100">
                  {clientNotifs.length === 0 ? (
                    <div className="py-8 text-center text-neutral-400">
                      <Bell size={28} className="mx-auto mb-2 opacity-20" />
                      <p className="text-xs">Aucune notification</p>
                    </div>
                  ) : (
                    clientNotifs.map((n) => {
                      const iconConfig = {
                        booking_confirmed: { icon: Calendar, color: 'bg-blue-500' },
                        booking_cancelled_by_admin: { icon: X, color: 'bg-red-500' },
                        new_competition_available: { icon: Trophy, color: 'bg-amber-500' },
                        competition_reminder: { icon: Trophy, color: 'bg-amber-500' },
                        new_stage_available: { icon: BookOpen, color: 'bg-purple-500' },
                        stage_reminder: { icon: BookOpen, color: 'bg-purple-500' },
                        new_news: { icon: Newspaper, color: 'bg-emerald-500' },
                        new_devis: { icon: CreditCard, color: 'bg-indigo-500' },
                        cotisation_expiry: { icon: CreditCard, color: 'bg-orange-500' },
                      };
                      const cfg = iconConfig[n.type] || { icon: Bell, color: 'bg-neutral-400' };
                      const IconComp = cfg.icon;
                      return (
                        <a key={n.id} href={n.url || '#'} className="flex items-start gap-3 px-4 py-3 hover:bg-neutral-50 transition-colors">
                          <div className={`w-8 h-8 ${cfg.color} rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm`}>
                            <IconComp size={14} className="text-white" />
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="text-sm font-semibold text-neutral-900 line-clamp-1">{n.title}</p>
                            <p className="text-xs text-neutral-500 mt-0.5 line-clamp-2 leading-relaxed">{n.body}</p>
                          </div>
                        </a>
                      );
                    })
                  )}
                </div>
              </div>
            , document.body)}

            {/* Tooltip d'incitation - desktop */}
            {!pushSubscribed && showNotifPrompt && !notifPanelOpen && createPortal(
              <div className="fixed right-20 top-[52px] bg-neutral-900 text-white text-xs px-3 py-2.5 rounded-lg shadow-lg w-52 z-[9999] hidden md:block animate-in fade-in slide-in-from-top-2" data-testid="notif-prompt-desktop">
                <div className="absolute -top-2 right-3 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-b-[8px] border-b-neutral-900"></div>
                <button 
                  className="absolute top-1 right-1 bg-neutral-700 hover:bg-neutral-600 rounded-full w-4 h-4 flex items-center justify-center text-[10px]"
                  onClick={() => setShowNotifPrompt(false)}
                >
                  x
                </button>
                <p className="mb-2 pr-3">
                  <Bell className="inline w-3 h-3 mr-1" />
                  Activez les notifications !
                </p>
                <button 
                  className="bg-emerald-500 hover:bg-emerald-600 text-white text-xs px-2 py-1 rounded w-full font-medium"
                  data-testid="activate-push-bubble-desktop"
                  onClick={async (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    try {
                      const perm = await Notification.requestPermission();
                      if (perm === 'granted') {
                        const ok = await pushSubscribe();
                        if (ok) { toast.success('Notifications activées !'); setShowNotifPrompt(false); }
                        else toast.error("Erreur. Réessayez.", { duration: 5000 });
                      } else if (perm === 'denied') {
                        toast.error('Notifications bloquées. Allez dans Réglages > Notifications.', { duration: 8000 });
                      }
                    } catch (err) {
                      toast.error('Erreur : ' + (err.message || "Impossible d'activer"), { duration: 5000 });
                    }
                  }}
                >
                  Activer
                </button>
              </div>,
              document.body
            )}
          </div>
          </div>
          <Button 
            variant="outline" 
            size="sm"
            onClick={handleLogout}
            className="h-8 w-8 p-0 flex-shrink-0"
            data-testid="logout-button"
            title="Déconnexion"
          >
            <LogOut size={14} />
          </Button>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex flex-col min-h-0 overflow-hidden max-w-6xl mx-auto w-full pb-16 md:pb-0">
        {/* Dialogue d'annulation d'un départ (délai + choix avoir / remboursement) — accessible depuis l'accueil et l'onglet Départs */}
        {cancelTeeTimeBooking && (
          <CancelTeeTimeDialog
            booking={cancelTeeTimeBooking}
            token={token}
            onClose={() => setCancelTeeTimeBooking(null)}
            onCancelled={async () => {
              setUpcomingRefresh((k) => k + 1);
              loadAccountBalance();
              clientPortalApi.getPortalSettings(token).then(s => { if (s) setPortalSettings(s); }).catch(() => {});
              await loadTeeTimeMyBookings();
              await loadTeeTimeSlots(format(teeTimeDate, 'yyyy-MM-dd'));
            }}
          />
        )}
        {/* Dashboard Tab */}
        {activeTab === 'dashboard' && (
          <div className="flex-1 overflow-y-auto" data-testid="dashboard-tab">
            {showIndivList ? (
              <div className="px-4 py-4" data-testid="indiv-list-view">
                <div className="flex items-center gap-3 mb-4">
                  <button
                    onClick={() => setShowIndivList(false)}
                    className="w-8 h-8 flex items-center justify-center rounded-lg bg-neutral-100 hover:bg-neutral-200 active:scale-95 transition-all"
                    data-testid="indiv-list-back-btn"
                  >
                    <ChevronLeft size={18} className="text-neutral-700" />
                  </button>
                  <h2 className="text-base font-bold text-neutral-900">Cours indiv. disponibles</h2>
                </div>
                {dashboardData?.available_indivs?.length > 0 ? (
                  <div className="space-y-2.5">
                    {dashboardData.available_indivs.map((c, i) => {
                      const empColor = c.employee_color || '#1B8066';
                      const durationLabel = c.duration_minutes ? (c.duration_minutes >= 60 ? `${c.duration_minutes / 60}h` : `${c.duration_minutes}min`) : '';
                      // iter316.11 — Utiliser client_price (aligné popup) si dispo, sinon fallback member/price
                      const effectivePrice = c.client_price ?? c.member_price ?? c.price;
                      const originalPrice = c.client_original_price ?? c.original_member_price ?? c.original_price;
                      const hasYield = c.yield_applied && c.yield_label;
                      return (
                        <div
                          key={i}
                          className="rounded-lg overflow-hidden"
                          style={{ backgroundColor: empColor + '15', borderLeft: `4px solid ${empColor}` }}
                          data-testid={`indiv-list-item-${i}`}
                        >
                          <div className="px-3 py-2.5 flex items-center gap-3">
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-semibold text-neutral-900">
                                {c.course_name?.toLowerCase().startsWith('cours') ? '' : 'Cours '}{c.course_name}{c.employee_name ? <span className="font-normal text-neutral-500"> avec </span> : ''}{c.employee_name && <span className="text-neutral-900">{c.employee_name}</span>}
                              </p>
                              <div className="flex items-center gap-2 mt-0.5 flex-wrap">
                                <p className="text-xs text-neutral-500">
                                  {c.datetime ? format(parseISO(c.datetime), "EEEE d MMMM 'à' HH:mm", { locale: fr }) : ''}
                                  {durationLabel && <span className="text-neutral-300 mx-1.5">·</span>}
                                  {durationLabel && <span className="text-neutral-400">{durationLabel}</span>}
                                </p>
                                {hasYield && (
                                  <span
                                    className="text-[9px] uppercase tracking-[0.15em] font-medium px-1.5 py-0.5 rounded-sm"
                                    style={{ color: '#B8860B', backgroundColor: 'rgba(212, 175, 55, 0.14)', border: '1px solid rgba(212, 175, 55, 0.4)' }}
                                  >
                                    {c.yield_label}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="flex flex-col items-end gap-1 flex-shrink-0">
                              {(effectivePrice > 0 || originalPrice > 0) && (
                                <div className="flex items-baseline gap-1.5">
                                  {hasYield && originalPrice > 0 && originalPrice !== effectivePrice && (
                                    <span className="text-[10px] text-neutral-400 line-through">{originalPrice}€</span>
                                  )}
                                  {effectivePrice > 0 && (
                                    <span className="text-xs font-bold text-neutral-800">{effectivePrice}€</span>
                                  )}
                                </div>
                              )}
                              <button
                                onClick={() => handleBookFromDashboard(c.id)}
                                className="text-[11px] bg-emerald-600 text-white font-semibold px-3 py-1.5 rounded-lg hover:bg-emerald-700 active:scale-95 transition-all"
                                data-testid={`indiv-list-book-${i}`}
                              >
                                Réserver
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center py-10">
                    <User size={32} className="mx-auto text-neutral-300 mb-2" />
                    <p className="text-sm text-neutral-400">Aucun cours individuel disponible pour le moment</p>
                  </div>
                )}
              </div>
            ) : dashboardLoading ? (
              <div className="flex items-center justify-center py-20">
                <Loader2 className="animate-spin" size={28} style={{ color: '#2E6A4C' }} />
              </div>
            ) : dashboardData ? (() => {
              const GOLF_GREEN = '#2E6A4C';
              const CREAM_BG = '#F5F2EB';
              const CARD_SHADOW = '0 2px 12px rgba(0,0,0,0.06)';
              
              const weatherLabels = {
                0: { label: 'Ciel dégagé', icon: 'sun' }, 1: { label: 'Dégagé', icon: 'sun' }, 2: { label: 'Partiellement nuageux', icon: 'cloud-sun' }, 3: { label: 'Nuageux', icon: 'cloud' },
                45: { label: 'Brouillard', icon: 'cloud' }, 48: { label: 'Brouillard givrant', icon: 'cloud' },
                51: { label: 'Bruine légère', icon: 'cloud-rain' }, 53: { label: 'Bruine', icon: 'cloud-rain' }, 55: { label: 'Bruine dense', icon: 'cloud-rain' },
                61: { label: 'Pluie légère', icon: 'cloud-rain' }, 63: { label: 'Pluie', icon: 'cloud-rain' }, 65: { label: 'Forte pluie', icon: 'cloud-rain' },
                71: { label: 'Neige légère', icon: 'snowflake' }, 73: { label: 'Neige', icon: 'snowflake' }, 75: { label: 'Forte neige', icon: 'snowflake' },
                80: { label: 'Averses', icon: 'cloud-rain' }, 81: { label: 'Averses', icon: 'cloud-rain' }, 82: { label: 'Fortes averses', icon: 'cloud-rain' },
                95: { label: 'Orage', icon: 'zap' }, 96: { label: 'Orage grêle', icon: 'zap' }, 99: { label: 'Orage fort', icon: 'zap' }
              };
              const WeatherIcon = ({ code, size = 20, className: cn = '' }) => {
                const info = weatherLabels[code] || { icon: 'cloud' };
                if (info.icon === 'sun') return <Sun size={size} className={cn || "text-yellow-400"} />;
                if (info.icon === 'cloud-sun') return <CloudSun size={size} className={cn || "text-yellow-500"} />;
                if (info.icon === 'cloud-rain') return <CloudRain size={size} className={cn || "text-blue-400"} />;
                if (info.icon === 'snowflake') return <Snowflake size={size} className={cn || "text-blue-300"} />;
                if (info.icon === 'zap') return <Zap size={size} className={cn || "text-yellow-500"} />;
                return <Cloud size={size} className={cn || "text-neutral-300"} />;
              };
              const dayName = (dateStr) => format(parseISO(dateStr), 'EEE', { locale: fr });
              
              const getVimeoIdFromEmbed = (embed) => {
                if (!embed) return null;
                const m = embed.match(/vimeo\.com\/(?:video\/)?(\d+)/);
                return m ? m[1] : null;
              };
              
              return (
                <div className="pb-24" style={{ fontFamily: "'Manrope', sans-serif", backgroundColor: CREAM_BG }} data-testid="dashboard-home">
                  
                  {/* ===== HERO SECTION ===== */}
                  <div className="relative" style={{ height: '340px' }} data-testid="hero-section">
                    <img src={portalSettings?.login_background_image?.data ? `data:${portalSettings.login_background_image.content_type};base64,${portalSettings.login_background_image.data}` : '/hero-golf.jpg'} alt="Golf" className="w-full h-full object-cover object-top" />
                    <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0.05) 40%, rgba(0,0,0,0.45) 100%)' }} />
                    
                    {/* Logo en haut à gauche */}
                    <div className="absolute top-0 left-0 right-0 px-5 pt-4 flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        {portalSettings?.portal_logo?.data ? (
                          <img 
                            src={`data:${portalSettings.portal_logo.content_type};base64,${portalSettings.portal_logo.data}`}
                            alt="Logo" className="h-10 w-auto max-w-[110px] object-contain drop-shadow-lg"
                            data-testid="hero-logo"
                          />
                        ) : (
                          <span className="text-white font-bold text-lg drop-shadow-lg">{portalSettings?.app_name || 'Golf'}</span>
                        )}
                        <div className="flex flex-col">
                          <span className="text-white font-bold text-2xl drop-shadow-lg" style={{ fontFamily: "'Manrope', sans-serif" }}>{client?.first_name} {client?.last_name}</span>
                          {client?.group && (
                            <span className="text-white/60 font-medium text-xs drop-shadow-lg" style={{ fontFamily: "'Manrope', sans-serif" }}>{client.group === 'Membres' ? 'Membre' : client.group}</span>
                          )}
                        </div>
                      </div>
                      {/* Profile switcher mobile - hero */}
                      <div className="flex items-center gap-2">
                        {isAdminViewing && (
                          <button
                            onClick={() => { localStorage.removeItem('client_portal_token'); window.location.href = clubPath('/modules'); }}
                            className="w-9 h-9 flex items-center justify-center rounded-full"
                            style={{ backgroundColor: 'rgba(255,255,255,0.18)', backdropFilter: 'blur(8px)' }}
                            title="Retour Administration"
                            data-testid="back-to-admin-btn"
                          >
                            <Shield size={15} className="text-white" />
                          </button>
                        )}
                        {linkedProfiles && linkedProfiles.length > 1 && (
                          <Popover>
                            <PopoverTrigger asChild>
                              <button
                                className="w-9 h-9 flex items-center justify-center rounded-full"
                                style={{ backgroundColor: 'rgba(255,255,255,0.18)', backdropFilter: 'blur(8px)' }}
                                data-testid="profile-switcher-hero"
                              >
                                <ArrowLeftRight size={15} className="text-white" />
                              </button>
                            </PopoverTrigger>
                            <PopoverContent className="w-52 p-1.5" align="end" sideOffset={8}>
                              <p className="text-[10px] font-semibold text-neutral-400 uppercase tracking-wide px-2 py-1">Changer de profil</p>
                              {linkedProfiles.map((p) => {
                                const isActive = p.id === client?.id;
                                return (
                                  <button
                                    key={p.id}
                                    onClick={() => { if (!isActive) handleSwitchProfile(p.id); }}
                                    className={`w-full flex items-center gap-2 px-2 py-2 rounded-lg text-left transition-colors ${isActive ? 'bg-emerald-50' : 'hover:bg-neutral-50'}`}
                                    data-testid={`profile-option-hero-${p.id}`}
                                  >
                                    <div className="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold text-white flex-shrink-0" style={{ backgroundColor: isActive ? '#2E6A4C' : '#9ca3af' }}>
                                      {(p.first_name || '?')[0].toUpperCase()}
                                    </div>
                                    <div className="flex-1 min-w-0">
                                      <p className={`text-[11px] font-medium truncate ${isActive ? 'text-emerald-700' : 'text-neutral-700'}`}>{p.first_name} {p.last_name}</p>
                                      {p.group && <p className="text-[9px] text-neutral-400 truncate">{p.group}</p>}
                                    </div>
                                    {isActive && <Check size={12} className="text-emerald-600 flex-shrink-0" />}
                                  </button>
                                );
                              })}
                            </PopoverContent>
                          </Popover>
                        )}
                        <button
                          ref={bellBtnRef}
                          onClick={handleNotifBellClick}
                          className="relative w-9 h-9 flex items-center justify-center rounded-full"
                          style={{ backgroundColor: 'rgba(255,255,255,0.18)', backdropFilter: 'blur(8px)' }}
                          data-testid="hero-notif-bell"
                      >
                        <Bell size={17} className="text-white" />
                        {clientUnread > 0 && (
                          <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 flex items-center justify-center rounded-full text-white font-bold" style={{ fontSize: '9px', backgroundColor: '#EF4444', padding: '0 4px' }}>{clientUnread}</span>
                        )}
                        {!pushSubscribed && !pushLoading && clientUnread === 0 && (
                          <span className="absolute -top-0.5 -right-0.5 flex h-3 w-3">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                          </span>
                        )}
                      </button>
                      </div>
                    </div>
                    
                    {/* Météo en bas du hero */}
                    <div className="absolute bottom-0 left-0 right-0 px-5 pb-5 flex items-end justify-between">
                      <div>
                        {dashboardData.weather && (
                          <p className="text-white/80 font-medium" style={{ fontSize: '12px', fontFamily: "'Manrope', sans-serif" }}>
                            Plobsheim, {Math.round(dashboardData.weather.current_temp)}° · {(weatherLabels[dashboardData.weather.current_code] || {}).label || ''}
                          </p>
                        )}
                      </div>
                      <div className="text-right space-y-0.5" style={{ textShadow: '0 1px 4px rgba(0,0,0,0.5)' }}>
                        {client?.cotisation && (
                          <p className="text-white/85 font-medium" style={{ fontSize: '11px', fontFamily: "'Manrope', sans-serif" }}>
                            {client?.is_subscription_valid === false
                              ? 'Cotisation : à renouveler'
                              : `Cotisation : ${client.displayed_cotisation || client.cotisation}`}
                          </p>
                        )}
                        {client?.cotisation && client?.subscription_expiry && client?.is_subscription_valid !== false && (
                          <p className="text-white/70" style={{ fontSize: '10px', fontFamily: "'Manrope', sans-serif" }}>
                            Actif jusqu'au : {format(parseISO(client.subscription_expiry), 'dd/MM/yyyy')}
                          </p>
                        )}
                        {client?.cours_collectif && (
                          <p className="text-white/70" style={{ fontSize: '10px', fontFamily: "'Manrope', sans-serif" }}>
                            Cours collectif : {client.cours_collectif}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* ===== CONTENU ===== */}
                  <div className="px-4 -mt-3 relative z-10 space-y-3">
                    
                    {/* Prévisions météo */}
                    {dashboardData.weather?.days && (
                      <div className="rounded-2xl px-4 py-3" style={{ backgroundColor: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(12px)', boxShadow: CARD_SHADOW }} data-testid="weather-forecast">
                        <div className="flex items-center justify-between">
                          {dashboardData.weather.days.slice(0, 5).map((d, i) => (
                            <div key={i} className="text-center flex-1">
                              <p className="font-bold uppercase" style={{ fontSize: '9px', color: '#999', letterSpacing: '0.05em' }}>{i === 0 ? "Auj." : dayName(d.date)}</p>
                              <div className="my-1 flex justify-center"><WeatherIcon code={d.weathercode} size={18} /></div>
                              <p style={{ fontSize: '11px' }}><span className="font-bold" style={{ color: '#1a1a1a' }}>{Math.round(d.temp_max)}°</span><span style={{ color: '#bbb' }}>/{Math.round(d.temp_min)}°</span></p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* 🎉 Bonnes affaires — carrousel configurable via CMS (placé en tête après la météo) */}
                    <FeaturedDealsCarousel
                      endpoint="/api/client-portal/featured-deals"
                      authToken={localStorage.getItem('client_portal_token')}
                      onDealClick={handleDealNavigate}
                    />

                    {/* Infos importantes (alertes admin) */}
                    {dashboardData.important_infos?.length > 0 && (
                      <div className="space-y-2" data-testid="important-infos-section">
                        {dashboardData.important_infos.map((info, i) => (
                          <div key={i} className="flex items-center gap-3 rounded-2xl px-4 py-3.5" style={{ backgroundColor: 'rgba(255,255,255,0.9)', boxShadow: CARD_SHADOW }} data-testid={`important-info-${i}`}>
                            <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: i === 0 ? '#FEF3C7' : i === 1 ? '#E8F5E9' : '#F3F4F6' }}>
                              {i === 0 ? <AlertCircle size={16} style={{ color: '#D97706' }} /> : i === 1 ? <Flag size={16} style={{ color: '#2E6A4C' }} /> : <Truck size={16} style={{ color: '#6B7280' }} />}
                            </div>
                            <p className="flex-1 font-medium" style={{ fontSize: '13px', color: '#1a1a1a' }}>{info}</p>
                          </div>
                        ))}
                      </div>
                    )}
                    
                    {/* Alerte commande Fitting */}
                    {dashboardData.has_pending_fitting && (
                      <div className="flex items-center gap-3 rounded-2xl px-4 py-3.5" style={{ backgroundColor: 'rgba(255,255,255,0.9)', boxShadow: CARD_SHADOW }} data-testid="fitting-alert">
                        <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#EBF5FF' }}>
                          <Package size={16} style={{ color: '#2563EB' }} />
                        </div>
                        <p className="flex-1 font-medium" style={{ fontSize: '13px', color: '#1a1a1a' }}>Une commande est dans votre espace boutique</p>
                        <button onClick={() => setActiveTab('boutique')} className="font-semibold text-white px-4 py-1.5" style={{ fontSize: '12px', backgroundColor: GOLF_GREEN, borderRadius: '20px' }} data-testid="fitting-alert-voir">
                          Voir
                        </button>
                      </div>
                    )}

                    {/* Bandeau Portes Ouvertes */}
                    {portesOuvertesEnabled && (
                      <a 
                        href={clubPath('/portes-ouvertes')} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="block rounded-2xl overflow-hidden"
                        style={{ backgroundColor: GOLF_GREEN, boxShadow: CARD_SHADOW }}
                        data-testid="portes-ouvertes-banner"
                      >
                        <div className="flex items-center gap-3 px-4 py-3.5">
                          <div className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                            <UserPlus size={18} style={{ color: '#fff' }} />
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="font-bold text-white" style={{ fontSize: '13px', lineHeight: '1.3' }}>Faites découvrir le golf à un proche</p>
                            <p className="text-white/80" style={{ fontSize: '11px', marginTop: '2px' }}>Inscrivez-le aux Portes Ouvertes</p>
                          </div>
                          <ChevronRight size={18} style={{ color: 'rgba(255,255,255,0.7)', flexShrink: 0 }} />
                        </div>
                      </a>
                    )}

                    {/* Carrousel actualités */}
                    {dashboardData.latest_news_list?.length > 0 && (
                      <div data-testid="news-carousel">
                        <div className="flex items-center justify-between mb-2.5 px-1">
                          <p className="font-bold uppercase" style={{ fontSize: '11px', color: '#999', letterSpacing: '0.08em' }}>Actualités</p>
                          <button onClick={() => setActiveTab('news')} className="font-semibold" style={{ fontSize: '12px', color: GOLF_GREEN }} data-testid="voir-toutes-actus">Voir tout</button>
                        </div>
                        <div className="flex gap-3 overflow-x-auto pb-1 -mx-4 px-4 snap-x snap-mandatory" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none', WebkitOverflowScrolling: 'touch' }}>
                          {dashboardData.latest_news_list.map((n, idx) => {
                            const vimeoId = n.video_embed ? getVimeoIdFromEmbed(n.video_embed) : null;
                            const isVideo = n.media_type === 'video' && vimeoId;
                            const thumbUrl = n.video_thumbnail_url || (vimeoId ? `https://vumbnail.com/${vimeoId}.jpg` : null);
                            const photoUrl = n.image_url || (n.images?.length > 0 ? n.images[0].url : null);
                            // Photo d'étiquette dédiée = priorité absolue (paysage optimisé pour miniature)
                            const displayThumb = n.thumbnail_url || (isVideo ? thumbUrl : photoUrl);
                            const useContain = !n.thumbnail_url; // Si étiquette dédiée : object-cover (déjà optimisée). Sinon object-contain (préserve les vidéos verticales).
                            
                            return (
                              <button key={n.id} className="flex-shrink-0 snap-start overflow-hidden text-left relative" style={{ width: '70vw', maxWidth: '280px', height: '180px', borderRadius: '16px', boxShadow: CARD_SHADOW, backgroundColor: '#1a1a1a' }} onClick={() => openNewsDetail(n.id)} data-track={n.title || undefined} data-testid={`news-carousel-${idx}`}>
                                {displayThumb ? (
                                  <img src={displayThumb} alt="" className={`w-full h-full ${useContain ? 'object-contain' : 'object-cover'}`} />
                                ) : (
                                  <div className="w-full h-full flex items-center justify-center" style={{ backgroundColor: '#e8e4de' }}>
                                    <Newspaper size={28} style={{ color: '#ccc' }} />
                                  </div>
                                )}
                                {isVideo && (
                                  <div className="absolute inset-0 flex items-center justify-center">
                                    <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(255,255,255,0.9)' }}>
                                      <svg className="w-4 h-4 ml-0.5" style={{ color: '#1a1a1a' }} fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                                    </div>
                                  </div>
                                )}
                                <div className="absolute bottom-0 left-0 right-0 px-4 pb-3 pt-12" style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 60%, transparent 100%)' }}>
                                  <span className="inline-block font-bold uppercase text-white px-2 py-0.5 rounded" style={{ fontSize: '9px', backgroundColor: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(4px)', letterSpacing: '0.05em' }}>
                                    {n.publish_date ? format(parseISO(n.publish_date), 'dd MMM', { locale: fr }).toUpperCase() : ''}
                                  </span>
                                  <p className="text-white font-bold mt-1 line-clamp-2" style={{ fontSize: '15px', lineHeight: '1.3', textShadow: '0 1px 3px rgba(0,0,0,0.3)' }}>{n.title}</p>
                                </div>
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    )}

                    {/* Carnet de cours */}
                    {dashboardData.carnet?.has_carnet && (() => {
                      const remaining = dashboardData.carnet.remaining || 0;
                      const total = dashboardData.carnet.total || 1;
                      const pct = Math.min(100, Math.round((remaining / total) * 100));
                      return (
                        <div className="rounded-2xl px-4 py-3.5" style={{ backgroundColor: 'rgba(255,255,255,0.9)', boxShadow: CARD_SHADOW }} data-testid="carnet-widget">
                          <div className="flex items-center justify-between mb-2">
                            <div className="flex items-center gap-2">
                              <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#E8F5E9' }}>
                                <BookOpen size={14} style={{ color: GOLF_GREEN }} />
                              </div>
                              <span className="font-bold" style={{ fontSize: '14px', color: '#1a1a1a' }}>Carnet de cours</span>
                            </div>
                            <button onClick={() => setActiveTab('boutique')} className="font-semibold text-white px-4 py-1.5" style={{ fontSize: '11px', backgroundColor: GOLF_GREEN, borderRadius: '20px' }} data-testid="recharger-carnet-btn">
                              Recharger
                            </button>
                          </div>
                          <div className="flex items-end gap-1 mb-1.5">
                            <span className="font-extrabold" style={{ fontSize: '26px', color: '#1a1a1a', lineHeight: 1 }}>{remaining}</span>
                            <span className="font-medium pb-0.5" style={{ fontSize: '13px', color: '#999' }}>h restantes</span>
                          </div>
                          <div className="h-2 rounded-full overflow-hidden" style={{ backgroundColor: '#e8e4de' }}>
                            <div className="h-full rounded-full transition-all duration-700" style={{ width: `${pct}%`, backgroundColor: GOLF_GREEN }} />
                          </div>
                        </div>
                      );
                    })()}
                    
                    {/* Prochain cours réservé */}
                    {dashboardData.next_booking && (
                      <div className="rounded-2xl px-4 py-3.5 flex items-center gap-3" style={{ backgroundColor: 'rgba(255,255,255,0.9)', boxShadow: CARD_SHADOW }} data-testid="next-booking">
                        <div className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#E8F5E9' }}>
                          <CalendarDays size={16} style={{ color: GOLF_GREEN }} />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="font-bold truncate" style={{ fontSize: '14px', color: '#1a1a1a' }}>{dashboardData.next_booking.course_name}{dashboardData.next_booking.employee_name ? ` avec ${dashboardData.next_booking.employee_name}` : ''}</p>
                          <p className="font-medium" style={{ fontSize: '12px', color: '#999' }}>
                            {dashboardData.next_booking.datetime ? format(parseISO(dashboardData.next_booking.datetime), "EEE d MMM · HH:mm", { locale: fr }) : ''}
                            {dashboardData.next_booking.duration_minutes ? ` · ${dashboardData.next_booking.duration_minutes >= 60 ? `${dashboardData.next_booking.duration_minutes / 60}h` : `${dashboardData.next_booking.duration_minutes}min`}` : ''}
                          </p>
                        </div>
                        <button className="font-semibold text-white px-4 py-1.5 flex-shrink-0" style={{ fontSize: '11px', backgroundColor: GOLF_GREEN, borderRadius: '20px' }}>
                          Réserver
                        </button>
                      </div>
                    )}

                    {/* Liens rapides */}
                    <div className="flex gap-2.5">
                      <button onClick={() => setActiveTab('cours')} className="flex-1 flex items-center justify-center gap-2 rounded-2xl px-3 py-3.5 font-semibold" style={{ fontSize: '12px', backgroundColor: 'rgba(255,255,255,0.9)', color: '#1a1a1a', boxShadow: CARD_SHADOW }} data-testid="quick-book-cours">
                        <CalendarDays size={15} style={{ color: GOLF_GREEN }} />
                        Réserver cours
                      </button>
                      {teeTimeEnabled ? (
                        <button onClick={() => setActiveTab('departs')} className="flex-1 flex items-center justify-center gap-2 rounded-2xl px-3 py-3.5 font-semibold text-center" style={{ fontSize: '12px', backgroundColor: 'rgba(255,255,255,0.9)', color: '#1a1a1a', boxShadow: CARD_SHADOW }} data-testid="quick-book-departs">
                          <Flag size={15} style={{ color: GOLF_GREEN }} />
                          Réserver départ
                        </button>
                      ) : (
                        <>
                          {dashboardData.booking_link_member && (
                            <a href={dashboardData.booking_link_member} target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-center gap-2 rounded-2xl px-3 py-3.5 font-semibold text-center" style={{ fontSize: '12px', backgroundColor: 'rgba(255,255,255,0.9)', color: '#1a1a1a', boxShadow: CARD_SHADOW }} data-testid="booking-link-member">
                              <Globe size={15} style={{ color: GOLF_GREEN }} />
                              Départ membre
                            </a>
                          )}
                          {dashboardData.booking_link_non_member && (
                            <a href={dashboardData.booking_link_non_member} target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-center gap-2 rounded-2xl px-3 py-3.5 font-semibold text-center" style={{ fontSize: '12px', backgroundColor: 'rgba(255,255,255,0.9)', color: '#1a1a1a', boxShadow: CARD_SHADOW }} data-testid="booking-link-non-member">
                              <Globe size={15} style={{ color: '#999' }} />
                              Départ visiteur
                            </a>
                          )}
                        </>
                      )}
                    </div>

                    {/* Bouton Jouer (Scorecard) - carte proéminente */}
                    {scorecardModuleEnabled && (
                    <button
                      onClick={() => setActiveTab('jouer')}
                      className="w-full flex items-center gap-3 rounded-2xl px-4 py-3.5 font-semibold active:scale-[0.99] transition-transform"
                      style={{
                        background: `linear-gradient(135deg, ${GOLF_GREEN} 0%, #245239 100%)`,
                        color: '#fff',
                        boxShadow: '0 4px 16px rgba(46,106,76,0.28)'
                      }}
                      data-testid="dashboard-jouer-card"
                    >
                      <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(255,255,255,0.18)' }}>
                        <Play size={20} className="text-white" style={{ marginLeft: '2px' }} />
                      </div>
                      <div className="flex-1 text-left">
                        <p className="font-bold text-white" style={{ fontSize: '14px' }}>Jouer une partie</p>
                        <p className="font-medium" style={{ fontSize: '11px', color: 'rgba(255,255,255,0.75)' }}>Saisir mon score · Classement · Handicap</p>
                      </div>
                      <ChevronRight size={18} className="text-white/70 flex-shrink-0" />
                    </button>
                    )}
                    
                    {/* Restaurant buttons */}
                    <div className="flex gap-2">
                      <button onClick={() => setShowRestaurantReserve(true)} className="flex-1 flex items-center justify-center gap-2 rounded-2xl px-3 py-3.5 font-semibold" style={{ fontSize: '12px', backgroundColor: 'rgba(255,255,255,0.9)', color: '#1a1a1a', boxShadow: CARD_SHADOW }} data-testid="reserve-table-btn">
                        <UtensilsCrossed size={15} style={{ color: '#d97706' }} />
                        Réserver une table
                      </button>
                      <button onClick={async () => { await loadRestaurantMenu(); setShowRestaurantMenu(true); }} className="flex-1 flex items-center justify-center gap-2 rounded-2xl px-3 py-3.5 font-semibold" style={{ fontSize: '12px', backgroundColor: 'rgba(255,255,255,0.9)', color: '#1a1a1a', boxShadow: CARD_SHADOW }} data-testid="view-menu-btn">
                        <BookOpen size={15} style={{ color: '#d97706' }} />
                        Voir la carte
                      </button>
                    </div>
                    
                    {/* Restaurant reservation active */}
                    {restaurantReservation && (
                      <div className="rounded-2xl overflow-hidden" style={{ backgroundColor: 'rgba(255,255,255,0.9)', boxShadow: CARD_SHADOW }}>
                        <div className="flex">
                          <div className="w-1.5 flex-shrink-0 bg-amber-500" />
                          <div className="flex-1 px-3.5 py-3">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="font-bold uppercase" style={{ fontSize: '10px', color: '#d97706', letterSpacing: '0.08em' }}>Réservation restaurant</p>
                                <p className="text-sm font-semibold mt-1">{restaurantReservation.date ? format(parseISO(restaurantReservation.date), 'EEE d MMM', { locale: fr }) : ''} à {restaurantReservation.time}</p>
                                <p className="text-xs text-neutral-500">{restaurantReservation.covers} couvert{restaurantReservation.covers > 1 ? 's' : ''}</p>
                              </div>
                              {restaurantReservation.status === 'active' && (
                                <div className="flex flex-col items-end gap-1">
                                  {restaurantReservation.manage_token && (
                                    <button
                                      onClick={() => window.open(clubPath(`/reservation/gerer/${restaurantReservation.manage_token}`), '_blank', 'noopener')}
                                      className="text-xs text-emerald-600 hover:text-emerald-700 font-medium"
                                      data-testid="portal-resto-manage-btn"
                                    >Modifier</button>
                                  )}
                                  <button onClick={() => handleCancelRestaurantReservation(restaurantReservation.id)}
                                    className="text-xs text-red-400 hover:text-red-600 font-medium">Annuler</button>
                                </div>
                              )}
                              {restaurantReservation.status === 'cancelled_by_admin' && (
                                <div className="text-right">
                                  <Badge variant="outline" className="text-[10px] bg-red-50 text-red-600 border-red-200">Annulée</Badge>
                                  {restaurantReservation.cancel_reason && <p className="text-[10px] text-red-400 mt-1">{restaurantReservation.cancel_reason}</p>}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    
                    {/* Cours individuels disponibles */}
                    <div className="rounded-2xl px-4 py-3.5" style={{ backgroundColor: 'rgba(255,255,255,0.9)', boxShadow: CARD_SHADOW }} data-testid="available-indivs">
                      <div className="flex items-center justify-between mb-3">
                        <p className="font-bold uppercase" style={{ fontSize: '11px', color: '#999', letterSpacing: '0.08em' }}>Cours indiv. disponibles</p>
                        <div className="flex items-center gap-3">
                          <button onClick={() => setActiveTab('reservations')} className="font-medium px-2.5 py-0.5 rounded-full" style={{ fontSize: '10px', backgroundColor: '#F0EDE8', color: '#666' }} data-testid="indiv-mes-reservations">Mes réservations</button>
                          <button onClick={() => setActiveTab('indiv')} className="font-semibold" style={{ fontSize: '11px', color: GOLF_GREEN }} data-testid="voir-tout-indivs">Voir tout</button>
                        </div>
                      </div>
                      {dashboardData.available_indivs?.length > 0 ? (
                        <div className="space-y-2.5">
                          {dashboardData.available_indivs.slice(0, 3).map((c, i) => (
                            <button key={i} className="flex items-center gap-3 w-full text-left" onClick={() => handleBookFromDashboard(c.id)} data-testid={`dashboard-indiv-${i}`}>
                              <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#E8F5E9' }}>
                                <User size={14} style={{ color: GOLF_GREEN }} />
                              </div>
                              <div className="flex-1 min-w-0">
                                <p className="font-semibold truncate" style={{ fontSize: '13px', color: '#1a1a1a' }}>{c.course_name}{c.employee_name ? ` avec ${c.employee_name}` : ''}</p>
                                <p className="font-medium" style={{ fontSize: '11px', color: '#999' }}>
                                  {c.datetime ? format(parseISO(c.datetime), "EEE d MMM · HH:mm", { locale: fr }) : ''}
                                  {c.duration_minutes ? ` · ${c.duration_minutes >= 60 ? `${c.duration_minutes / 60}h` : `${c.duration_minutes}min`}` : ''}
                                </p>
                              </div>
                              <span className="font-semibold text-white px-3.5 py-1.5 flex-shrink-0" style={{ fontSize: '11px', backgroundColor: GOLF_GREEN, borderRadius: '20px' }}>Réserver</span>
                            </button>
                          ))}
                        </div>
                      ) : (
                        <p className="text-center py-4 font-medium" style={{ fontSize: '12px', color: '#bbb' }}>Aucun cours individuel à venir</p>
                      )}
                    </div>
                    
                    {/* Mes cours collectifs */}
                    {(client?.cours_collectif || dashboardData?.my_upcoming_collectifs?.length > 0) && (
                    <div className="rounded-2xl px-4 py-3.5" style={{ backgroundColor: 'rgba(255,255,255,0.9)', boxShadow: CARD_SHADOW }} data-testid="my-collectifs">
                      <div className="flex items-center justify-between mb-3">
                        <div>
                          <p className="font-bold uppercase" style={{ fontSize: '11px', color: '#999', letterSpacing: '0.08em' }}>Cours collectifs</p>
                          <p className="font-medium italic" style={{ fontSize: '10px', color: '#bbb' }}>Groupe {(client.cours_collectif || '').toString().toLowerCase()}</p>
                        </div>
                        <div className="flex items-center gap-3">
                          <button onClick={() => setActiveTab('reservations')} className="font-medium px-2.5 py-0.5 rounded-full" style={{ fontSize: '10px', backgroundColor: '#F0EDE8', color: '#666' }} data-testid="collectif-mes-reservations">Mes réservations</button>
                          <button onClick={() => setActiveTab('cours')} className="font-semibold" style={{ fontSize: '11px', color: GOLF_GREEN }} data-testid="voir-tout-collectifs">Voir tout</button>
                        </div>
                      </div>
                      {dashboardData.my_upcoming_collectifs?.length > 0 ? (
                        <div className="space-y-2.5">
                          {dashboardData.my_upcoming_collectifs.map((c, i) => (
                            <button key={i} className="flex items-center gap-3 w-full text-left" onClick={() => handleBookFromDashboard(c.id)} data-testid={`dashboard-collectif-${i}`}>
                              <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#EBF5FF' }}>
                                <CalendarDays size={14} style={{ color: '#2563EB' }} />
                              </div>
                              <div className="flex-1 min-w-0">
                                <p className="font-semibold truncate" style={{ fontSize: '13px', color: '#1a1a1a' }}>{c.course_name}</p>
                                <p className="font-medium" style={{ fontSize: '11px', color: '#999' }}>
                                  {c.datetime ? format(parseISO(c.datetime), "EEE d MMM · HH:mm", { locale: fr }) : ''}
                                  {c.employee_name ? ` · ${c.employee_name}` : ''}
                                </p>
                              </div>
                              {c.is_registered ? (
                                <span className="font-semibold flex-shrink-0" style={{ fontSize: '11px', color: GOLF_GREEN }}>Inscrit</span>
                              ) : (
                                <span className="font-semibold text-white px-3.5 py-1.5 flex-shrink-0" style={{ fontSize: '11px', backgroundColor: GOLF_GREEN, borderRadius: '20px' }}>S'inscrire</span>
                              )}
                            </button>
                          ))}
                        </div>
                      ) : (
                        <p className="text-center py-4 font-medium" style={{ fontSize: '12px', color: '#bbb' }}>Aucun cours collectif à venir</p>
                      )}
                    </div>
                    )}
                    
                    {/* Compétitions */}
                    {dashboardData.upcoming_competitions?.length > 0 && (
                      <div className="rounded-2xl px-4 py-3.5" style={{ backgroundColor: 'rgba(255,255,255,0.9)', boxShadow: CARD_SHADOW }} data-testid="upcoming-competitions">
                        <div className="flex items-center justify-between mb-3">
                          <p className="font-bold uppercase" style={{ fontSize: '11px', color: '#999', letterSpacing: '0.08em' }}>Compétitions à venir</p>
                          <p className="text-[10px] text-neutral-400 mt-0.5">Cliquez sur une compétition pour vous inscrire</p>
                          <div className="flex items-center gap-3">
                            <button onClick={() => { setActiveTab('competitions'); setShowMyCompRegistrations(true); }} className="font-medium px-2.5 py-0.5 rounded-full" style={{ fontSize: '10px', backgroundColor: '#F0EDE8', color: '#666' }} data-testid="comp-mes-reservations-dash">Mes inscriptions</button>
                            <button onClick={() => setActiveTab('competitions')} className="font-semibold" style={{ fontSize: '11px', color: GOLF_GREEN }} data-testid="voir-tout-competitions">Voir tout</button>
                          </div>
                        </div>
                        <div className="space-y-2.5">
                          {dashboardData.upcoming_competitions.map((comp, i) => (
                            <button key={i} className="flex items-center gap-3 w-full text-left" onClick={() => { setSelectedCompetition(comp); setShowCompetitionModal(true); setSelectedPartner(null); setPartnerSearchQuery(''); setPartnerSearchResults([]); setPayForPartner(true); }} data-testid={`dashboard-comp-${i}`}>
                              <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#FEF3C7' }}>
                                <Trophy size={14} style={{ color: '#D97706' }} />
                              </div>
                              <div className="flex-1 min-w-0">
                                <p className="font-semibold truncate" style={{ fontSize: '13px', color: '#1a1a1a' }}>{comp.name}</p>
                                <p className="font-medium" style={{ fontSize: '11px', color: '#999' }}>{comp.start_date ? format(parseISO(comp.start_date), 'd MMM yyyy', { locale: fr }) : ''}{comp.nombre_trous ? ` · ${comp.nombre_trous} trous` : ''}</p>
                              </div>
                              {comp.is_registered ? (
                                <span className="font-semibold flex-shrink-0" style={{ fontSize: '11px', color: GOLF_GREEN }}>Inscrit</span>
                              ) : (
                                <span className="font-semibold text-white px-3.5 py-1.5 flex-shrink-0" style={{ fontSize: '11px', backgroundColor: GOLF_GREEN, borderRadius: '20px' }}>S'inscrire</span>
                              )}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    {/* Stages */}
                    {dashboardData.upcoming_stages?.length > 0 && (
                      <div className="rounded-2xl px-4 py-3.5" style={{ backgroundColor: 'rgba(255,255,255,0.9)', boxShadow: CARD_SHADOW }} data-testid="upcoming-stages">
                        <div className="flex items-center justify-between mb-3">
                          <p className="font-bold uppercase" style={{ fontSize: '11px', color: '#999', letterSpacing: '0.08em' }}>Stages à venir</p>
                          <p className="text-[10px] text-neutral-400 mt-0.5">Cliquez sur un stage pour vous inscrire</p>
                          <div className="flex items-center gap-3">
                            <button onClick={() => { setActiveTab('stages'); setShowMyStageRegistrations(true); }} className="font-medium px-2.5 py-0.5 rounded-full" style={{ fontSize: '10px', backgroundColor: '#F0EDE8', color: '#666' }} data-testid="stage-mes-reservations-dash">Mes inscriptions</button>
                            <button onClick={() => setActiveTab('stages')} className="font-semibold" style={{ fontSize: '11px', color: GOLF_GREEN }} data-testid="voir-tout-stages">Voir tout</button>
                          </div>
                        </div>
                        <div className="space-y-2.5">
                          {dashboardData.upcoming_stages.map((stage, i) => (
                            <button key={i} className="flex items-center gap-3 w-full text-left" onClick={() => { setSelectedStage(stage); setShowStageModal(true); }} data-testid={`dashboard-stage-${i}`}>
                              <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#F3E8FF' }}>
                                <BookOpen size={14} style={{ color: '#7C3AED' }} />
                              </div>
                              <div className="flex-1 min-w-0">
                                <p className="font-semibold truncate" style={{ fontSize: '13px', color: '#1a1a1a' }}>{stage.name}</p>
                                <p className="font-medium" style={{ fontSize: '11px', color: '#999' }}>
                                  {stage.start_date ? format(parseISO(stage.start_date), 'd MMM', { locale: fr }) : ''}
                                  {stage.end_date ? ` - ${format(parseISO(stage.end_date), 'd MMM yyyy', { locale: fr })}` : ''}
                                  {stage.coach_name ? ` · ${stage.coach_name}` : ''}
                                </p>
                              </div>
                              {stage.is_registered ? (
                                <span className="font-semibold flex-shrink-0" style={{ fontSize: '11px', color: GOLF_GREEN }}>Inscrit</span>
                              ) : stage.is_full ? (
                                <span className="font-semibold flex-shrink-0" style={{ fontSize: '11px', color: '#EF4444' }}>Complet</span>
                              ) : (
                                <span className="font-semibold text-white px-3.5 py-1.5 flex-shrink-0" style={{ fontSize: '11px', backgroundColor: GOLF_GREEN, borderRadius: '20px' }}>S'inscrire</span>
                              )}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* 📅 Mes prochains rendez-vous — départs, cours, stages, compétitions, restaurant, échéances */}
                    <UpcomingCard
                      token={token}
                      refreshKey={`${teeTimeMyBookings.length}-${activeTab}-${upcomingRefresh}`}
                      onCancelled={(it) => {
                        if (it.kind !== 'depart') return;
                        loadTeeTimeMyBookings();
                        loadAccountBalance();
                        clientPortalApi.getPortalSettings(token).then(s => { if (s) setPortalSettings(s); }).catch(() => {});
                      }}
                      onCancelRequest={(it) => setCancelTeeTimeBooking({ id: it.id, slot_date: it.date, slot_time: it.time, players_count: it.players_count || 1 })}
                      onReschedule={async (it) => {
                        // Ouvre directement le choix du nouveau créneau (modal « Modifier » en mode horaire)
                        let b = teeTimeMyBookings.find(x => x.id === it.id);
                        if (!b) {
                          try {
                            const r = await fetch(`${API_URL}/api/tee-times/portal/my-bookings`, { headers: { Authorization: `Bearer ${token}` } });
                            const d = r.ok ? await r.json() : {};
                            setTeeTimeMyBookings(d.bookings || []);
                            b = (d.bookings || []).find(x => x.id === it.id);
                          } catch (e) { /* silent */ }
                        }
                        if (!b) { toast.error('Réservation introuvable'); return; }
                        setActiveTab('departs'); setTeeTimeSubTab('reservations');
                        openModifyBookingModal(b);
                        setModifyForm(p => ({ ...p, mode: 'reschedule' }));
                      }}
                      onNavigate={(it) => {
                        if (it.kind === 'depart') { setActiveTab('departs'); setTeeTimeSubTab('reservations'); }
                        else if (it.kind === 'cours') { setActiveTab('reservations'); }
                        else if (it.kind === 'stage') { setActiveTab('stages'); setShowMyStageRegistrations(true); }
                        else if (it.kind === 'competition') { setActiveTab('competitions'); }
                        else if (it.kind === 'restaurant') { setShowRestaurantReserve(true); }
                        else { setActiveTab('account'); }
                      }}
                    />

                    {/* Mes soldes : carnets, jetons practice (QR en un clic), compte */}
                    <BalancesRecapCard
                      shadow={CARD_SHADOW}
                      coursHours={portalSettings?.show_carnet_cours !== false ? Number(portalSettings?.carnet_remaining || 0) : 0}
                      gfCount={portalSettings?.show_carnet_gf !== false && teeTimeSettings?.carnet_green_fee_enabled ? Number(portalSettings?.green_fee_carnet_remaining || 0) : 0}
                      practiceTokens={portalSettings?.show_practice_portal ? Number(practiceData?.balance?.remaining || 0) : 0}
                      onShowQr={practiceData?.qr_value ? () => setShowPracticeQrFullscreen(true) : null}
                      accountBalance={accountBalance}
                      showAccount={portalSettings?.show_wallet === true}
                      onSeeAll={() => setActiveTab('boutique')}
                    />

                  </div>
                </div>
              );
            })() : null}
          </div>
        )}


        {/* Départs Tab */}
        {activeTab === 'departs' && teeTimeEnabled && (
          <div data-testid="departs-tab" className="flex-1 overflow-y-auto pb-24" style={{ fontFamily: "'Manrope', sans-serif", backgroundColor: '#F5F2EB' }}>
            <div className="max-w-lg mx-auto px-3 py-4 space-y-4">
              {/* Header */}
              <div className="text-center">
                <h2 className="text-lg font-bold" style={{ color: '#1a3c2a' }}>Réserver un départ</h2>
                <p className="text-xs text-neutral-500 mt-0.5">{teeTimeSettings?.course_name || 'Parcours 18 trous'}</p>
                {teeTimeSettings?.booking_message && (
                  <p className="text-xs text-amber-700 mt-1 bg-amber-50 rounded-lg px-3 py-1.5">{teeTimeSettings.booking_message}</p>
                )}
              </div>

              {/* Onglets Planning / Mes réservations */}
              <div className="flex gap-2 bg-white rounded-xl p-1 border">
                <button
                  onClick={() => setTeeTimeSubTab('planning')}
                  className="flex-1 py-2 rounded-lg text-xs font-semibold transition-all"
                  style={teeTimeSubTab === 'planning' ? { backgroundColor: '#2E6A4C', color: '#fff' } : { color: '#666' }}
                  data-testid="tt-tab-planning"
                >
                  Planning
                </button>
                <button
                  onClick={() => setTeeTimeSubTab('reservations')}
                  className="flex-1 py-2 rounded-lg text-xs font-semibold transition-all"
                  style={teeTimeSubTab === 'reservations' ? { backgroundColor: '#2E6A4C', color: '#fff' } : { color: '#666' }}
                  data-testid="tt-tab-reservations"
                >
                  Mes réservations ({upcomingTeeTimeBookings.length})
                </button>
                {client?.societe && (
                  <button
                    onClick={() => setTeeTimeSubTab('my-guests')}
                    className="flex-1 py-2 rounded-lg text-xs font-semibold transition-all"
                    style={teeTimeSubTab === 'my-guests' ? { backgroundColor: '#2E6A4C', color: '#fff' } : { color: '#666' }}
                    data-testid="tt-tab-my-guests"
                  >
                    Ma société
                  </button>
                )}
              </div>

              {/* GF restants en haut */}
              {(portalSettings?.green_fee_carnet_remaining || 0) > 0 && (
                <div className="flex items-center gap-2 p-2.5 rounded-xl bg-white border" style={{ borderColor: '#c6e9d3' }}>
                  <Wallet size={16} style={{ color: '#2E6A4C' }} />
                  <span className="text-xs font-semibold" style={{ color: '#2E6A4C' }}>
                    {portalSettings.green_fee_carnet_remaining} Green Fee{portalSettings.green_fee_carnet_remaining > 1 ? 's' : ''} restant{portalSettings.green_fee_carnet_remaining > 1 ? 's' : ''}
                  </span>
                </div>
              )}

              {/* Sous-onglet Planning */}
              {teeTimeSubTab === 'planning' && (
                <>
                  {/* Bannière rebook invité en attente */}
                  {pendingGuestRebook && (
                    <div className="mb-2 bg-indigo-50 border border-indigo-200 rounded-xl p-2.5 flex items-center gap-2" data-testid="pending-guest-banner">
                      <Building2 size={14} className="text-indigo-600 flex-shrink-0" />
                      <div className="flex-1 min-w-0">
                        <p className="text-xs font-semibold text-indigo-800">
                          Réservation invité en cours : {pendingGuestRebook.first_name || pendingGuestRebook.last_name ? `${pendingGuestRebook.first_name} ${pendingGuestRebook.last_name}` : 'nouvel invité'}
                        </p>
                        <p className="text-[10px] text-indigo-600">Sélectionnez un créneau ci-dessous</p>
                      </div>
                      <button
                        onClick={() => setPendingGuestRebook(null)}
                        className="text-[10px] text-indigo-600 hover:text-indigo-800 underline flex-shrink-0"
                        data-testid="cancel-pending-guest"
                      >
                        Annuler
                      </button>
                    </div>
                  )}
                  {/* Sélecteur de date */}
              <div className="flex items-center justify-between bg-white rounded-xl p-2.5 border">
                <button onClick={() => setTeeTimeDate(d => { const prev = addDays(d, -1); const today = new Date(); today.setHours(0,0,0,0); return prev < today ? d : prev; })} className="p-1.5 hover:bg-neutral-100 rounded-lg" disabled={isSameDay(teeTimeDate, new Date())} data-testid="tt-date-prev">
                  <ChevronLeft size={16} className={isSameDay(teeTimeDate, new Date()) ? 'text-neutral-300' : ''} />
                </button>
                <Popover open={ttCalOpen} onOpenChange={setTtCalOpen}>
                  <PopoverTrigger asChild>
                    <button type="button" className="text-sm font-semibold flex items-center gap-1.5 cursor-pointer px-2 py-1 rounded-lg hover:bg-emerald-50 transition-colors" style={{ color: '#2E6A4C' }} title="Choisir une date dans le calendrier" data-testid="tt-date-picker-label">
                      <Calendar size={14} />
                      <span className="capitalize">{format(teeTimeDate, 'EEEE d MMMM', { locale: fr })}</span>
                    </button>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0 bg-white" align="center" data-testid="tt-date-picker">
                    <CalendarPicker
                      mode="single"
                      selected={teeTimeDate}
                      defaultMonth={teeTimeDate}
                      onSelect={(d) => { if (d) { setTeeTimeDate(d); setTtCalOpen(false); } }}
                      disabled={[{ before: (() => { const t = new Date(); t.setHours(0, 0, 0, 0); return t; })() }, { after: addDays(new Date(), Number(teeTimeSettings?.booking_open_days_ahead || 14)) }]}
                      locale={fr}
                      className="rounded-md border"
                      initialFocus
                    />
                  </PopoverContent>
                </Popover>
                <button onClick={() => setTeeTimeDate(d => addDays(d, 1))} className="p-1.5 hover:bg-neutral-100 rounded-lg" data-testid="tt-date-next">
                  <ChevronRight size={16} />
                </button>
              </div>

              {/* Quota du groupe atteint ce jour (Cotisations & droits) */}
              {!teeTimeLoading && teeTimeDayLimit && (
                <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 flex items-start gap-2" data-testid="portal-group-day-limit-banner">
                  <AlertCircle size={16} className="text-amber-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-xs font-semibold text-amber-900" data-testid="portal-group-day-limit-message">{teeTimeDayLimit}</p>
                    <p className="text-[11px] text-amber-700 mt-0.5">Choisissez une autre date ou contactez l’accueil.</p>
                  </div>
                </div>
              )}

              {/* Créneaux : grand chargement seulement s'il n'y a encore rien à montrer ; sinon liste atténuée le temps de la mise à jour */}
              {teeTimeLoading && !teeShownDateRef.current ? (
                <div className="flex justify-center py-8">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2" style={{ borderColor: '#2E6A4C' }}></div>
                </div>
              ) : (
                <div className={`bg-white rounded-xl border overflow-hidden relative transition-opacity ${teeTimeLoading ? 'opacity-40 pointer-events-none' : ''}`} data-testid="tt-slots-list" aria-busy={teeTimeLoading}
                  style={{ touchAction: 'pan-y' }} ref={ttSwipe.ref} onTouchStart={ttSwipe.onTouchStart} onTouchMove={ttSwipe.onTouchMove} onTouchEnd={ttSwipe.onTouchEnd}>
                  {teeTimeLoading && <div className="absolute top-0 left-0 right-0 h-0.5 overflow-hidden" data-testid="tt-day-loading"><div className="h-full w-1/3 animate-pulse" style={{ backgroundColor: '#2E6A4C' }} /></div>}
                  <div className="divide-y">
                    {(() => {
                      // Créneaux passés du jour J masqués : seuls les horaires à venir sont proposés
                      const now = new Date();
                      const isToday_ = isSameDay(teeTimeDate, now);
                      const upcoming = teeTimeSlots.filter(slot => {
                        const [sh, sm] = slot.time.split(':').map(Number);
                        return !(isToday_ && (sh < now.getHours() || (sh === now.getHours() && sm <= now.getMinutes())));
                      });
                      if (upcoming.length === 0) return <p className="text-center text-xs text-neutral-400 py-6" data-testid="portal-no-slots">Aucun créneau à venir ce jour</p>;
                      return upcoming.map(slot => {
                      const isPastSlot = false;
                      const players = slot.players || [];
                      const isExpanded = expandedSlotTime === slot.time;
                      return (
                      <div
                        key={slot.time}
                        className={`px-3.5 py-2.5 ${
                          isPastSlot ? 'bg-neutral-50 opacity-40' :
                          slot.is_blocked ? 'bg-neutral-50 opacity-50' :
                          slot.member_only && !slot.can_book ? 'bg-blue-50/40 opacity-60' :
                          slot.available_spots === 0 ? 'bg-red-50/50' :
                          slot.available_spots <= 2 ? 'bg-amber-50/50' : ''
                        }`}
                        data-testid={`portal-slot-${slot.time}`}
                      >
                      <div className="flex items-center justify-between gap-2">
                        <div className="flex items-center gap-3 min-w-0 flex-1">
                          <span className={`text-sm font-bold w-12 ${isPastSlot ? 'text-neutral-400' : 'text-neutral-800'}`}>{slot.time}</span>
                          {isPastSlot ? (
                            <span className="text-[10px] text-neutral-400 italic">Passé</span>
                          ) : slot.is_blocked ? (
                            <span className="text-[10px] text-neutral-400 italic">{slot.block_reason || 'Indisponible'}</span>
                          ) : slot.member_only && !slot.can_book && slot.block_kind !== 'group_limit' ? (
                            <span className="text-[10px] font-medium text-blue-500 flex items-center gap-1">
                              <Lock size={10} /> Réservé membres
                            </span>
                          ) : slot.cotisation_blocked ? (
                            <span className="text-[10px] font-medium text-red-500 flex items-center gap-1" title={slot.cotisation_reason || ''} data-testid={`portal-slot-blocked-${slot.time}`}>
                              <Lock size={10} /> {slot.block_kind === 'group_limit' ? 'Quota du jour atteint' : slot.block_kind === 'no_grid' ? 'Réservation à l’accueil' : 'Non autorisé (cotisation)'}
                            </span>
                          ) : (
                            <span className={`text-[10px] font-medium ${
                              slot.available_spots === 0 ? 'text-red-500' :
                              slot.available_spots <= 2 ? 'text-amber-600' : 'text-emerald-600'
                            }`}>
                              {slot.available_spots === 0 ? 'Complet' : `${slot.available_spots} place${slot.available_spots > 1 ? 's' : ''}`}
                              {slot.member_only && <span className="text-blue-400 ml-1">(membres)</span>}
                              {slot.cotisation_paid_gf && slot.cotisation_paid_gf_price > 0 && (
                                <span
                                  className="ml-2 inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded bg-amber-100 text-amber-700 text-[10px] font-semibold"
                                  title={`Ce créneau nécessite un Green Fee payant (${slot.cotisation_reason})`}
                                  data-testid={`paid-gf-badge-${slot.time}`}
                                >
                                  <DollarSign size={9} />
                                  GF {slot.cotisation_paid_gf_price}€
                                </span>
                              )}
                              {slot.promo && slot.available_spots > 0 && (
                                <span className="ml-2"><SlotPromoBadge promo={slot.promo} testId={`portal-slot-promo-${slot.time}`} /></span>
                              )}
                            </span>
                          )}
                          {players.length > 0 && !isPastSlot && (
                            <button
                              type="button"
                              onClick={() => setExpandedSlotTime(isExpanded ? null : slot.time)}
                              className="min-w-0 flex-1 text-left text-[11px] text-neutral-600 truncate flex items-center gap-1"
                              title="Voir les inscrits"
                              data-testid={`slot-players-${slot.time}`}
                            >
                              <Users size={10} className="flex-shrink-0 text-neutral-400" />
                              <span className="truncate">{players.map(p => p.is_me ? `${p.label} (vous)` : p.label).join(' · ')}</span>
                            </button>
                          )}
                        </div>
                        {!isPastSlot && slot.can_book && slot.available_spots >= teeTimeBookingForm.players_count && (
                          <button
                            onClick={() => openTeeTimeBooking(slot.time)}
                            className="px-3 py-1.5 rounded-full text-[11px] font-semibold text-white flex-shrink-0"
                            style={{ backgroundColor: '#2E6A4C' }}
                            data-testid={`book-slot-${slot.time}`}
                          >
                            Réserver
                          </button>
                        )}
                      </div>
                      {isExpanded && players.length > 0 && (
                        <div className="mt-1.5 ml-[60px] flex flex-wrap gap-1" data-testid={`slot-players-expanded-${slot.time}`}>
                          {players.map((p, i) => (
                            <span key={i} className={`text-[11px] px-2 py-0.5 rounded-full ${p.is_me ? 'bg-emerald-100 text-emerald-800 font-semibold' : p.anonymous ? 'bg-neutral-100 text-neutral-500 italic' : 'bg-neutral-100 text-neutral-700'}`}>
                              {p.label}{p.is_me ? ' (vous)' : ''}
                            </span>
                          ))}
                        </div>
                      )}
                      </div>
                    );
                      });
                    })()}
                  </div>
                </div>
              )}

              </>
              )}

              {/* Sous-onglet Ma société (représentant) : droit de jeu du jour, invitations du mois, mes invités */}
              {teeTimeSubTab === 'my-guests' && client?.societe && (
                <SocietePortalPanel
                  apiUrl={API_URL}
                  token={token}
                  client={client}
                  date={format(teeTimeDate, 'yyyy-MM-dd')}
                  onRebookGuest={rebookGuest}
                  onNewGuest={() => { setPendingGuestRebook({ first_name: '', last_name: '', email: '', phone: '' }); setTeeTimeSubTab('planning'); toast.info('Choisissez un créneau pour votre invité'); }}
                />
              )}

              {/* Sous-onglet Mes réservations */}
              {teeTimeSubTab === 'reservations' && (
                <>
                  {upcomingTeeTimeBookings.length > 0 ? (
                    <div className="space-y-2">
                      {upcomingTeeTimeBookings.map(b => { const canManage = teeTimeCanManage(b); return (
                        <div key={b.id} className="bg-white rounded-xl border p-3 flex items-center justify-between gap-2" data-testid={`reservation-card-${b.id}`}>
                          <div className="min-w-0 flex-1">
                            <p className="text-sm font-semibold text-neutral-800">
                              {b.slot_date && format(parseISO(b.slot_date), 'EEEE d MMMM', { locale: fr })}
                            </p>
                            <p className="text-xs font-medium" style={{ color: '#2E6A4C' }}>{b.slot_time}{b.booked_for_guest && <span className="ml-1.5 inline-flex items-center gap-0.5 text-[10px] bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded font-medium" data-testid={`reservation-guest-badge-${b.id}`}><Building2 size={9} /> invité {b.client_name}</span>}</p>
                            <p className="text-[10px] text-neutral-500 mt-0.5">
                              {b.players_count} joueur{b.players_count > 1 ? 's' : ''} · {b.cart_reserved || 0} voit. · {b.societe_invitation ? 'Invitation société' : b.payment_status === 'paid' ? (['account', 'account+carnet'].includes(b.payment_method) ? `Payé avec mon compte${Number(b.carnet_used) > 0 ? ' + carnet' : ''}` : b.payment_method === 'mixed' ? 'Payé : compte + carte' : b.stripe_session_id || ['stripe', 'stripe_public'].includes(b.payment_method) ? 'Réglé en ligne' : 'Réglé à l\u2019accueil') : b.payment_status === 'free' ? 'Gratuit' : b.payment_status === 'carnet' ? 'Payé avec mon carnet' : 'Sur place'}
                              {b.payment_status === 'paid' && <span className="ml-1.5 inline-flex items-center text-[9px] font-bold uppercase bg-emerald-100 text-emerald-700 px-1.5 py-0.5 rounded" data-testid={`reservation-paid-badge-${b.id}`}>Payé</span>}
                            </p>
                            {teeTimeSettings?.cancellation_hours_before != null && (
                              <p className={`text-[9px] mt-0.5 ${canManage ? 'text-neutral-400' : 'text-amber-600 font-medium'}`} data-testid={`reservation-deadline-${b.id}`}>
                                {canManage ? `Annulation / changement d'horaire jusqu'à ${teeTimeSettings.cancellation_hours_before}h avant` : `Délai de ${teeTimeSettings.cancellation_hours_before}h dépassé — contactez l'accueil pour modifier ou annuler`}
                              </p>
                            )}
                          </div>
                          <div className="flex items-center gap-1 flex-shrink-0">
                            <button
                              onClick={() => openModifyBookingModal(b)}
                              disabled={!canManage}
                              title={canManage ? '' : 'Délai dépassé — contactez l\u2019accueil'}
                              className="text-[10px] text-emerald-600 hover:text-emerald-800 font-medium px-2 py-1 rounded-lg hover:bg-emerald-50 border border-emerald-200 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent"
                              data-testid={`modify-booking-${b.id}`}
                            >
                              Modifier
                            </button>
                            <button
                              onClick={() => handleCancelTeeTime(b.id)}
                              disabled={!canManage}
                              title={canManage ? '' : 'Délai dépassé — contactez l\u2019accueil'}
                              className="text-[10px] text-red-500 hover:text-red-700 font-medium px-2 py-1 rounded-lg hover:bg-red-50 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent"
                              data-testid={`cancel-booking-${b.id}`}
                            >
                              Annuler
                            </button>
                          </div>
                        </div>
                      ); })}
                    </div>
                  ) : (
                    <div className="text-center py-10">
                      <Flag size={32} className="mx-auto text-neutral-300 mb-2" />
                      <p className="text-sm text-neutral-500">Aucune réservation</p>
                      <p className="text-xs text-neutral-400 mt-1">Vos réservations de départ apparaîtront ici</p>
                      <button
                        onClick={() => setTeeTimeSubTab('planning')}
                        className="mt-3 px-4 py-2 rounded-full text-xs font-semibold text-white"
                        style={{ backgroundColor: '#2E6A4C' }}
                        data-testid="tt-go-to-planning"
                      >
                        Réserver un départ
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>


            {/* Modal Modifier réservation */}
            {modifyBooking && (
              <div className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center bg-black/40" onClick={() => setModifyBooking(null)}>
                <div className="bg-white w-full sm:max-w-md sm:rounded-2xl rounded-t-2xl shadow-xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-testid="modify-booking-modal">
                  <div className="sticky top-0 bg-white border-b p-4 flex items-center justify-between rounded-t-2xl z-10">
                    <div>
                      <h3 className="font-bold text-base" style={{ color: '#1a3c2a' }}>Modifier la réservation</h3>
                      <p className="text-xs text-neutral-500 mt-0.5">
                        {modifyBooking.slot_date && format(parseISO(modifyBooking.slot_date), 'EEEE d MMMM', { locale: fr })} à {modifyBooking.slot_time}
                      </p>
                    </div>
                    <button onClick={() => setModifyBooking(null)} className="p-1.5 hover:bg-neutral-100 rounded-lg">
                      <X size={18} />
                    </button>
                  </div>

                  <div className="p-4 space-y-4">
                    {/* Récap actuel */}
                    <div className="bg-neutral-50 rounded-lg p-3 text-xs">
                      <p className="font-semibold text-neutral-800 mb-1">Réservation actuelle</p>
                      <p className="text-neutral-600">{modifyBooking.players_count} joueur(s) · {modifyBooking.cart_reserved || 0} voiturette(s)</p>
                      {(modifyBooking.added_players || []).length > 0 && (
                        <div className="mt-2 space-y-1">
                          <p className="text-[10px] text-neutral-500">Joueurs ajoutés :</p>
                          {(modifyBooking.added_players || []).map((p, idx) => (
                            <div key={idx} className="flex items-center justify-between bg-white px-2 py-1 rounded border">
                              <span className="text-[11px]">
                                {p.name}
                                <span className={`ml-1 text-[9px] px-1 rounded ${p.type === 'member' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`}>
                                  {p.type === 'member' ? 'Membre' : `Invité ${p.paid ? '✓ Payé' : '⏳ Non payé'}`}
                                </span>
                              </span>
                              <button
                                onClick={() => {
                                  const label = p.type === 'member' ? `Retirer ${p.name} ?` : `Retirer ${p.name} et rembourser ${p.gf_amount || 0}€ ?`;
                                  if (window.confirm(label)) submitModify({ remove_player_index: idx });
                                }}
                                className="text-[10px] text-red-500 hover:text-red-700 font-semibold"
                                data-testid={`remove-added-player-${idx}`}
                              >Retirer</button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Actions : choix */}
                    {!modifyForm.mode && (
                      <div className="grid grid-cols-2 gap-2">
                        <button onClick={() => setModifyForm(p => ({ ...p, mode: 'reschedule' }))} className="col-span-2 p-3 rounded-lg border-2 border-sky-200 hover:bg-sky-50 text-xs font-semibold text-sky-800 flex items-center justify-center gap-1.5" data-testid="modify-reschedule-btn">
                          <Clock size={14} /> Changer l'horaire du départ
                        </button>
                        <button onClick={() => setModifyForm(p => ({ ...p, mode: 'add_member' }))} className="p-3 rounded-lg border-2 border-emerald-200 hover:bg-emerald-50 text-xs font-semibold text-emerald-800" data-testid="modify-add-member-btn">
                          + Ajouter membre
                        </button>
                        <button onClick={() => setModifyForm(p => ({ ...p, mode: 'add_guest' }))} className="p-3 rounded-lg border-2 border-amber-200 hover:bg-amber-50 text-xs font-semibold text-amber-800" data-testid="modify-add-guest-btn">
                          + Ajouter invité
                        </button>
                        <button onClick={() => setModifyForm(p => ({ ...p, mode: 'add_cart' }))} className="p-3 rounded-lg border-2 border-indigo-200 hover:bg-indigo-50 text-xs font-semibold text-indigo-800" data-testid="modify-add-cart-btn">
                          + Voiturette
                        </button>
                        {(modifyBooking.cart_reserved || 0) > 0 && (
                          <button onClick={() => submitModify({ remove_cart: true })} className="p-3 rounded-lg border-2 border-red-200 hover:bg-red-50 text-xs font-semibold text-red-700" data-testid="modify-remove-cart-btn">
                            − Retirer voiturette
                          </button>
                        )}
                      </div>
                    )}

                    {/* Mode changer l'horaire */}
                    {modifyForm.mode === 'reschedule' && (
                      <RescheduleTeeTime
                        booking={modifyBooking}
                        token={token}
                        settings={teeTimeSettings}
                        onBack={() => setModifyForm(p => ({ ...p, mode: null }))}
                        onDone={async () => { setModifyBooking(null); await loadTeeTimeMyBookings(); await loadTeeTimeSlots(format(teeTimeDate, 'yyyy-MM-dd')); }}
                      />
                    )}

                    {/* Mode ajouter membre */}
                    {modifyForm.mode === 'add_member' && (
                      <div className="space-y-2">
                        <label className="text-xs font-semibold text-neutral-700">Chercher un membre</label>
                        <input
                          type="text"
                          value={modifyForm.memberSearch}
                          onChange={(e) => { setModifyForm(p => ({ ...p, memberSearch: e.target.value })); searchMembersForAdd(e.target.value); }}
                          placeholder="Nom, prénom..."
                          className="w-full h-9 text-sm border rounded px-2"
                          data-testid="modify-member-search"
                        />
                        {modifyForm.memberResults.length > 0 && (
                          <div className="border rounded max-h-52 overflow-y-auto">
                            {modifyForm.memberResults.map(m => (
                              <button
                                key={m.id}
                                onClick={() => submitModify({ add_member_client_id: m.id })}
                                className="w-full text-left p-2 hover:bg-emerald-50 text-xs border-b last:border-b-0"
                                data-testid={`modify-member-result-${m.id}`}
                              >
                                <span className="font-medium">{m.first_name} {m.last_name}</span>
                                <span className="text-[10px] text-neutral-500 ml-2">{m.email || '—'}</span>
                              </button>
                            ))}
                          </div>
                        )}
                        <button onClick={() => setModifyForm(p => ({ ...p, mode: null }))} className="text-xs text-neutral-500 underline">Retour</button>
                      </div>
                    )}

                    {/* Mode ajouter invité */}
                    {modifyForm.mode === 'add_guest' && (
                      <div className="space-y-2">
                        <div className="bg-amber-50 border border-amber-200 rounded p-2 text-[11px] text-amber-800">
                          <strong>Green Fee visiteur</strong> — le paiement se fait via Stripe. Le joueur sera confirmé après paiement.
                        </div>
                        <div className="grid grid-cols-2 gap-2">
                          <input placeholder="Prénom *" value={modifyForm.guest.first_name} onChange={(e) => setModifyForm(p => ({ ...p, guest: { ...p.guest, first_name: e.target.value } }))} className="h-9 text-sm border rounded px-2" data-testid="modify-guest-first-name" />
                          <input placeholder="Nom *" value={modifyForm.guest.last_name} onChange={(e) => setModifyForm(p => ({ ...p, guest: { ...p.guest, last_name: e.target.value } }))} className="h-9 text-sm border rounded px-2" data-testid="modify-guest-last-name" />
                        </div>
                        <input placeholder="Email" type="email" value={modifyForm.guest.email} onChange={(e) => setModifyForm(p => ({ ...p, guest: { ...p.guest, email: e.target.value } }))} className="w-full h-9 text-sm border rounded px-2" data-testid="modify-guest-email" />
                        <input placeholder="Téléphone" type="tel" value={modifyForm.guest.phone} onChange={(e) => setModifyForm(p => ({ ...p, guest: { ...p.guest, phone: e.target.value } }))} className="w-full h-9 text-sm border rounded px-2" data-testid="modify-guest-phone" />
                        <div className="flex gap-2">
                          <button onClick={() => submitModify({ add_guest: modifyForm.guest })} disabled={!modifyForm.guest.first_name || !modifyForm.guest.last_name || modifyLoading} className="flex-1 h-9 rounded text-xs font-semibold text-white disabled:opacity-50" style={{ backgroundColor: '#2E6A4C' }} data-testid="modify-submit-guest">
                            {modifyLoading ? 'Chargement...' : 'Continuer vers paiement'}
                          </button>
                          <button onClick={() => setModifyForm(p => ({ ...p, mode: null }))} className="px-3 text-xs text-neutral-500 underline">Retour</button>
                        </div>
                      </div>
                    )}

                    {/* Mode ajouter voiturette */}
                    {modifyForm.mode === 'add_cart' && (() => {
                      const isMember = cartIsMemberRate(teeTimeSettings, client?.group);
                      const cartUnit = cartUnitPrice(teeTimeSettings, client?.group);
                      const totalToPay = cartUnit * modifyForm.cartsToAdd;
                      const showOnsiteOption = isMember && cartUnit > 0;
                      return (
                        <div className="space-y-2">
                          {cartUnit === 0 ? (
                            <div className="bg-emerald-50 border border-emerald-200 rounded p-2 text-[11px] text-emerald-800">
                              Voiturette gratuite pour votre statut.
                            </div>
                          ) : (
                            <div className="bg-indigo-50 border border-indigo-200 rounded p-2 text-[11px] text-indigo-800">
                              Tarif voiturette : <strong>{cartUnit}€</strong> l'unité
                              {isMember && ' — vous pouvez régler en ligne ou à l\u2019accueil'}
                              {!isMember && ' — paiement en ligne obligatoire'}
                            </div>
                          )}
                          <div className="flex items-center gap-2 justify-center">
                            <button onClick={() => setModifyForm(p => ({ ...p, cartsToAdd: Math.max(0, p.cartsToAdd - 1) }))} className="w-10 h-10 rounded-full border text-lg font-bold">−</button>
                            <span className="text-2xl font-bold w-12 text-center" data-testid="modify-carts-count">{modifyForm.cartsToAdd}</span>
                            <button onClick={() => setModifyForm(p => ({ ...p, cartsToAdd: p.cartsToAdd + 1 }))} className="w-10 h-10 rounded-full border text-lg font-bold">+</button>
                          </div>
                          {showOnsiteOption ? (
                            <div className="flex flex-col gap-2">
                              <button
                                onClick={() => submitModify({ add_carts: modifyForm.cartsToAdd, cart_payment_mode: 'online' })}
                                disabled={modifyForm.cartsToAdd < 1 || modifyLoading}
                                className="h-10 rounded text-xs font-semibold text-white disabled:opacity-50 flex items-center justify-center gap-2"
                                style={{ backgroundColor: '#2E6A4C' }}
                                data-testid="modify-submit-cart-online"
                              >
                                💳 Payer en ligne — {totalToPay.toFixed(2)}€
                              </button>
                              <button
                                onClick={() => submitModify({ add_carts: modifyForm.cartsToAdd, cart_payment_mode: 'onsite' })}
                                disabled={modifyForm.cartsToAdd < 1 || modifyLoading}
                                className="h-10 rounded text-xs font-semibold text-neutral-700 border-2 border-neutral-300 hover:bg-neutral-50 disabled:opacity-50 flex items-center justify-center gap-2"
                                data-testid="modify-submit-cart-onsite"
                              >
                                🏢 Payer à l'accueil ({totalToPay.toFixed(2)}€)
                              </button>
                              <button onClick={() => setModifyForm(p => ({ ...p, mode: null, cartsToAdd: 0 }))} className="text-xs text-neutral-500 underline">Retour</button>
                            </div>
                          ) : (
                            <div className="flex gap-2">
                              <button
                                onClick={() => submitModify({ add_carts: modifyForm.cartsToAdd, cart_payment_mode: 'online' })}
                                disabled={modifyForm.cartsToAdd < 1 || modifyLoading}
                                className="flex-1 h-9 rounded text-xs font-semibold text-white disabled:opacity-50"
                                style={{ backgroundColor: '#2E6A4C' }}
                                data-testid="modify-submit-cart"
                              >
                                {modifyLoading ? 'Chargement...' : (cartUnit > 0 ? `Payer en ligne — ${totalToPay.toFixed(2)}€` : `Ajouter ${modifyForm.cartsToAdd} voiturette(s)`)}
                              </button>
                              <button onClick={() => setModifyForm(p => ({ ...p, mode: null, cartsToAdd: 0 }))} className="px-3 text-xs text-neutral-500 underline">Retour</button>
                            </div>
                          )}
                        </div>
                      );
                    })()}

                    <p className="text-[10px] text-neutral-400 text-center italic">
                      Changement d&apos;horaire et annulation possibles jusqu&apos;à {teeTimeSettings?.cancellation_hours_before ?? 24}h avant le départ (avoir sur votre compte ou remboursement). Après ce délai : contactez l&apos;accueil.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Modal de réservation */}

            {showTeeTimeBookingModal && selectedTeeTimeSlot && (
              <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-black/40" onClick={() => setShowTeeTimeBookingModal(false)}>
                <div className="bg-white w-full sm:max-w-md sm:rounded-2xl rounded-t-2xl shadow-xl max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-testid="tee-time-booking-modal">
                  {/* Header */}
                  <div className="sticky top-0 bg-white border-b p-4 flex items-center justify-between rounded-t-2xl z-10">
                    <div>
                      <h3 className="font-bold text-base" style={{ color: '#1a3c2a' }}>Confirmer le départ</h3>
                      <p className="text-xs text-neutral-500 mt-0.5">
                        {format(teeTimeDate, 'EEEE d MMMM', { locale: fr })} à {selectedTeeTimeSlot}
                      </p>
                    </div>
                    <button onClick={() => setShowTeeTimeBookingModal(false)} className="p-1.5 hover:bg-neutral-100 rounded-lg">
                      <X size={18} />
                    </button>
                  </div>

                  <div className="p-4 space-y-4">
                    {/* Phase 2 Sociétés — Toggle "Réserver pour un invité" */}
                    {client?.societe && (
                      <div className="border rounded-lg overflow-hidden">
                        <div className="bg-indigo-50 px-3 py-2 border-b flex items-center gap-2">
                          <Building2 size={14} className="text-indigo-600" />
                          <span className="text-xs font-semibold text-indigo-800 flex-1">
                            Réservation société : <span className="font-normal">{client.societe}</span>
                          </span>
                        </div>
                        <div className="p-3">
                          <label className="flex items-center gap-2 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={societeGuestMode}
                              onChange={(e) => setSocieteGuestMode(e.target.checked)}
                              className="w-4 h-4 rounded"
                              data-testid="societe-guest-mode-toggle"
                            />
                            <span className="text-sm font-medium text-neutral-800">Je réserve pour un invité</span>
                          </label>
                          {societeGuestMode && (
                            <div className="mt-3 space-y-2" data-testid="societe-guest-section">
                              <SocieteGuestHint apiUrl={API_URL} token={token} date={format(teeTimeDate, 'yyyy-MM-dd')} time={selectedTeeTimeSlot} onPreview={setSocieteGuestPreview} />
                              <SocieteGuestsForm
                                key={`${selectedTeeTimeSlot}-${societeGuestPreview ? offeredGuestsFor(societeGuestPreview, repAlsoPlays) : 'x'}-${repAlsoPlays ? 'r' : 'n'}`}
                                searchClients={async (q) => {
                                  const r = await fetch(`${API_URL}/api/tee-times/portal/search-clients?q=${encodeURIComponent(q)}`, { headers: { Authorization: `Bearer ${token}` } });
                                  return r.ok ? r.json() : [];
                                }}
                                initial={societeGuests}
                                maxGuests={Math.max(1, Math.min(offeredGuestsFor(societeGuestPreview, repAlsoPlays), (teeTimeSlots.find(sl => sl.time === selectedTeeTimeSlot)?.available_spots ?? 4) - (repAlsoPlays ? 1 : 0) - Math.max(0, teeTimeBookingForm.players_count - 1)))}
                                remainingGuests={offeredGuestsFor(societeGuestPreview, repAlsoPlays)}
                                suggestions={societeGuestsList}
                                onChange={setSocieteGuests}
                                ready={!!societeGuestPreview}
                              />
                              {(() => {
                                const slot = teeTimeSlots.find(sl => sl.time === selectedTeeTimeSlot);
                                const spots = slot?.available_spots ?? 4;
                                const nG = Math.max(1, societeGuests.filter(g => g.first_name || g.last_name).length);
                                const noRoom = spots < nG + 1 + Math.max(0, teeTimeBookingForm.players_count - 1);
                                const alreadyPlays = (societeGuestPreview?.rep_slot_times || []).length > 0;
                                return (
                                  <label className={`flex items-center justify-between gap-2 rounded-lg border px-3 py-2 ${repAlsoPlays ? 'border-emerald-300 bg-emerald-50/60' : 'border-neutral-200 bg-white'} ${noRoom ? 'opacity-50' : ''}`} data-testid="rep-also-plays-row">
                                    <div>
                                      <p className="text-xs font-semibold text-neutral-800">Je joue aussi dans ce flight</p>
                                      <p className="text-[10px] text-neutral-500" data-testid="rep-also-plays-info">{noRoom ? 'Plus assez de places sur ce créneau' : alreadyPlays ? `Vous jouez déjà ce jour (${societeGuestPreview.rep_slot_times.join(', ')})` : societeGuestPreview?.rep ? (societeGuestPreview.rep.member ? 'Votre départ : gratuit (membre)' : societeGuestPreview.rep.offered_by_societe ? 'Votre départ : offert par la société (droit de jeu)' : `Votre départ : Green Fee payant ${societeGuestPreview.rep.price} €`) : 'Votre départ est réservé avec vos invités, en une fois'}</p>
                                    </div>
                                    <input type="checkbox" checked={repAlsoPlays} disabled={noRoom} onChange={e => setRepAlsoPlays(e.target.checked)} className="w-4 h-4 rounded" data-testid="rep-also-plays-toggle" />
                                  </label>
                                );
                              })()}
                              {(() => {
                                const slot = teeTimeSlots.find(sl => sl.time === selectedTeeTimeSlot);
                                const nG = Math.max(1, societeGuests.filter(g => g.first_name || g.last_name).length);
                                const maxExtras = Math.max(0, (slot?.available_spots ?? 4) - nG - (repAlsoPlays ? 1 : 0));
                                const extras = Math.max(0, teeTimeBookingForm.players_count - 1);
                                return (
                                  <div className="flex items-center justify-between gap-2 rounded-lg border border-neutral-200 bg-white px-3 py-2" data-testid="societe-extra-row">
                                    <div>
                                      <p className="text-xs font-semibold text-neutral-800">Accompagnant hors invitation</p>
                                      <p className="text-[10px] text-neutral-500">Joue dans le même flight et règle son green fee, même si vous ne jouez pas</p>
                                    </div>
                                    <div className="flex items-center gap-2 flex-shrink-0">
                                      <button type="button" disabled={extras === 0} onClick={() => setTeeTimeBookingForm(prev => ({ ...prev, players_count: Math.max(1, prev.players_count - 1), companions: (prev.companions || []).slice(0, Math.max(0, prev.players_count - 2)) }))}
                                        className="w-7 h-7 rounded-full border text-sm font-bold disabled:opacity-40" style={{ borderColor: '#2E6A4C', color: '#2E6A4C' }} data-testid="societe-extra-minus">-</button>
                                      <span className="text-sm font-bold w-4 text-center" data-testid="societe-extra-count">{extras}</span>
                                      <button type="button" disabled={extras >= maxExtras} onClick={() => setTeeTimeBookingForm(prev => ({ ...prev, players_count: prev.players_count + 1 }))}
                                        className="w-7 h-7 rounded-full border text-sm font-bold disabled:opacity-40" style={{ borderColor: '#2E6A4C', color: '#2E6A4C' }} data-testid="societe-extra-plus">+</button>
                                    </div>
                                  </div>
                                );
                              })()}
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Nombre de joueurs (masqué en mode invité : 1 joueur par invité) */}
                    {!societeGuestMode && <div>
                      <label className="text-xs font-semibold text-neutral-700 mb-2 block">Nombre de joueurs</label>
                      <div className="flex items-center gap-3">
                        <button
                          onClick={() => {
                            setTeeTimeBookingForm(prev => {
                              const newCount = Math.max(1, prev.players_count - 1);
                              return { ...prev, players_count: newCount, companions: prev.companions.slice(0, Math.max(0, newCount - 1)) };
                            });
                          }}
                          className="w-9 h-9 rounded-full flex items-center justify-center text-base font-bold border-2 transition-colors"
                          style={{ borderColor: '#2E6A4C', color: '#2E6A4C' }}
                          data-testid="tt-modal-minus"
                        >-</button>
                        <span className="text-lg font-bold w-6 text-center" style={{ color: '#2E6A4C' }}>{teeTimeBookingForm.players_count}</span>
                        <button
                          onClick={() => {
                            const slot = teeTimeSlots.find(s => s.time === selectedTeeTimeSlot);
                            const max = slot ? slot.available_spots : 4;
                            setTeeTimeBookingForm(prev => ({ ...prev, players_count: Math.min(max, prev.players_count + 1) }));
                          }}
                          className="w-9 h-9 rounded-full flex items-center justify-center text-base font-bold border-2 transition-colors"
                          style={{ borderColor: '#2E6A4C', color: '#2E6A4C' }}
                          data-testid="tt-modal-plus"
                        >+</button>
                      </div>
                    </div>}

                    {/* Partenaires habituels : ajout en un clic */}
                    {!societeGuestMode && (
                      <PartnerChips
                        partners={frequentPartners}
                        onToggleFavorite={toggleFavoritePartner}
                        selectedIds={(teeTimeBookingForm.companions || []).filter(c => c).map(c => c.id)}
                        onPick={(p) => {
                          const slot = teeTimeSlots.find(sl => sl.time === selectedTeeTimeSlot);
                          const max = slot ? slot.available_spots : 4;
                          setTeeTimeBookingForm(prev => {
                            const comps = [...(prev.companions || [])];
                            const free = comps.findIndex((c, i) => !c && i < prev.players_count - 1);
                            if (free >= 0) { comps[free] = p; return { ...prev, companions: comps }; }
                            if (prev.players_count >= max) { toast.info('Plus de place sur ce créneau'); return prev; }
                            comps[prev.players_count - 1] = p;
                            return { ...prev, players_count: prev.players_count + 1, companions: comps };
                          });
                        }}
                      />
                    )}

                    {/* Accompagnants avec recherche */}
                    {teeTimeBookingForm.players_count > 1 && (
                      <div>
                        <label className="text-xs font-semibold text-neutral-700 mb-2 block">{societeGuestMode ? 'Accompagnants (hors invitation société)' : 'Accompagnants'}</label>
                        <div className="space-y-2">
                          {Array.from({ length: teeTimeBookingForm.players_count - 1 }).map((_, idx) => {
                            const companion = (teeTimeBookingForm.companions || [])[idx];
                            return (
                              <div key={idx}>
                                {companion ? (
                                  <div className="flex items-center justify-between border rounded-lg px-3 py-2 bg-neutral-50">
                                    <div>
                                      <p className="text-sm font-medium">{companion.first_name} {companion.last_name}</p>
                                      <p className="text-[10px] text-neutral-500">{companion.group || 'Client extérieur'}</p>
                                    </div>
                                    <FavoriteStar active={frequentPartners.some(p => p.id === companion.id && p.favorite)} onClick={() => toggleFavoritePartner(companion)} testId={`companion-fav-${idx}`} />
                                    <button onClick={() => {
                                      setTeeTimeBookingForm(prev => {
                                        const comps = [...(prev.companions || [])];
                                        comps[idx] = null;
                                        return { ...prev, companions: comps };
                                      });
                                    }} className="p-1 hover:bg-neutral-200 rounded">
                                      <X size={14} className="text-neutral-400" />
                                    </button>
                                  </div>
                                ) : (
                                  <CompanionSearchField
                                    idx={idx}
                                    token={token}
                                    onSelect={(client) => {
                                      setTeeTimeBookingForm(prev => {
                                        const comps = [...(prev.companions || [])];
                                        comps[idx] = client;
                                        return { ...prev, companions: comps };
                                      });
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}

                    {/* Option carnet */}
                    {!societeGuestMode && teeTimeSettings?.carnet_green_fee_enabled && (portalSettings?.green_fee_carnet_remaining || 0) > 0 && (
                      <div className="flex items-center justify-between p-3 rounded-xl border" style={{ backgroundColor: teeTimeBookingForm.use_carnet ? '#f0fdf4' : '#fff', borderColor: teeTimeBookingForm.use_carnet ? '#86efac' : '#e5e7eb' }}>
                        <div>
                          <p className="text-xs font-semibold text-neutral-700">Utiliser mon carnet Green Fee</p>
                          <p className="text-[10px] text-neutral-500">{portalSettings.green_fee_carnet_remaining} green fee{portalSettings.green_fee_carnet_remaining > 1 ? 's' : ''} restant{portalSettings.green_fee_carnet_remaining > 1 ? 's' : ''}</p>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input type="checkbox" checked={teeTimeBookingForm.use_carnet} onChange={(e) => setTeeTimeBookingForm(prev => ({ ...prev, use_carnet: e.target.checked }))} className="sr-only peer" data-testid="tt-use-carnet" />
                          <div className="w-10 h-5 bg-[#e5e7eb] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-emerald-500"></div>
                        </label>
                      </div>
                    )}

                    {/* Payer pour les accompagnants */}
                    {teeTimeBookingForm.players_count > 1 && (() => {
                      const T = computeTtTotals();
                      const payingComps = T.companions.filter(c => Number(c.price) > 0);
                      return (
                        <>
                          <div className="flex items-center justify-between p-3 rounded-xl border" style={{ backgroundColor: teeTimeBookingForm.pay_for_others ? '#f0fdf4' : '#fff', borderColor: teeTimeBookingForm.pay_for_others ? '#86efac' : '#e5e7eb' }}>
                            <div>
                              <p className="text-xs font-semibold text-neutral-700">Payer pour les accompagnants</p>
                              <p className="text-[10px] text-neutral-500" data-testid="tt-pay-for-others-info">
                                {T.companionsTotal > 0 ? (teeTimeBookingForm.pay_for_others ? `Leur green fee (${eur(T.companionsTotal)}) est ajouté à votre paiement` : `Décoché : leur green fee (${eur(T.companionsTotal)}) sera réglé à l'accueil`) : 'Green fee + voiturettes de tout le groupe'}
                              </p>
                            </div>
                            <label className="relative inline-flex items-center cursor-pointer">
                              <input type="checkbox" checked={teeTimeBookingForm.pay_for_others || false} onChange={(e) => setTeeTimeBookingForm(prev => ({ ...prev, pay_for_others: e.target.checked }))} className="sr-only peer" data-testid="tt-pay-for-others" />
                              <div className="w-10 h-5 bg-[#e5e7eb] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-emerald-500"></div>
                            </label>
                          </div>
                          {client?.societe && payingComps.length > 0 && (
                            <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-[11px] text-amber-800" data-testid="tt-societe-companion-note">
                              {payingComps.length > 1 ? 'Vos accompagnants ne sont pas comptés' : 'Votre accompagnant n\'est pas compté'} comme invité{payingComps.length > 1 ? 's' : ''} de la société : {payingComps.length > 1 ? 'ils règlent' : 'il règle'} donc {payingComps.length > 1 ? 'leur' : 'son'} green fee.{!societeGuestMode && <> Pour l&apos;inviter avec le droit de jeu, cochez « Je réserve pour un invité ».</>}
                            </div>
                          )}
                        </>
                      );
                    })()}

                    {/* Notes */}
                    <div>
                      <label className="text-xs font-semibold text-neutral-700 mb-1 block">Notes (optionnel)</label>
                      <input type="text" placeholder="Handicap, remarques..." className="w-full border rounded-lg px-3 py-2 text-sm" value={teeTimeBookingForm.notes} onChange={(e) => setTeeTimeBookingForm(prev => ({ ...prev, notes: e.target.value }))} data-testid="tt-notes" />
                    </div>

                    {/* Option voiturette - sélecteur quantité */}
                    {(teeTimeSettings?.cart_count > 0) && (() => {
                      const cartCount = teeTimeBookingForm.cart_count || 0;
                      const cartPrice = cartUnitPrice(teeTimeSettings, client?.group);
                      const slot = teeTimeSlots.find(sl => sl.time === selectedTeeTimeSlot);
                      // Règle : jamais plus de 2 voiturettes sur un même départ (toutes réservations confondues)
                      const cartMax = Math.max(0, Math.min(2, slot?.cart_available ?? 2));
                      const onSiteOk = !!teeTimeSettings?.cart_on_site_allowed && cartPrice > 0;
                      return (
                        <div className="p-3 rounded-xl border space-y-2" style={{ backgroundColor: cartCount > 0 ? '#fffbeb' : '#fff', borderColor: cartCount > 0 ? '#fcd34d' : '#e5e7eb' }} data-testid="tt-cart-block">
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2.5">
                              <span className="text-lg">🚗</span>
                              <div>
                                <p className="text-xs font-semibold text-neutral-700">Voiturettes</p>
                                <p className="text-[10px] text-neutral-500" data-testid="tt-cart-price">
                                  {cartPrice > 0 ? `${cartPrice}€ / voiturette` : 'Gratuit'}{teeTimeSettings?.my_cart_special_rate ? ` · ${teeTimeSettings.my_cart_special_rate}` : ''}
                                  {cartMax === 0 ? ' · plus de voiturette sur ce départ' : ` · ${cartMax} max sur ce départ`}
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center gap-2">
                              <button onClick={() => setTeeTimeBookingForm(prev => ({ ...prev, cart_count: Math.max(0, (prev.cart_count || 0) - 1) }))} className="w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold border border-amber-300 text-amber-600 hover:bg-amber-50 disabled:opacity-40" disabled={cartCount === 0} data-testid="tt-cart-minus">-</button>
                              <span className="text-sm font-bold w-4 text-center" data-testid="tt-cart-count">{cartCount}</span>
                              <button onClick={() => setTeeTimeBookingForm(prev => ({ ...prev, cart_count: Math.min(cartMax, (prev.cart_count || 0) + 1) }))} className="w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold border border-amber-300 text-amber-600 hover:bg-amber-50 disabled:opacity-40" disabled={cartCount >= cartMax} data-testid="tt-cart-plus">+</button>
                            </div>
                          </div>
                          {cartCount > 0 && onSiteOk && (
                            <label className="flex items-center justify-between gap-2 rounded-lg border bg-white px-2.5 py-1.5 cursor-pointer" data-testid="tt-cart-onsite-row">
                              <div>
                                <p className="text-[11px] font-semibold text-neutral-800">Je règle la voiturette à l'accueil</p>
                                <p className="text-[10px] text-neutral-500">Espèces ou carte sur place · {cartCount * cartPrice}€ à régler le jour J</p>
                              </div>
                              <input type="checkbox" checked={!!teeTimeBookingForm.cart_onsite} onChange={(e) => setTeeTimeBookingForm(prev => ({ ...prev, cart_onsite: e.target.checked }))} className="w-4 h-4 rounded accent-amber-600" data-testid="tt-cart-onsite" />
                            </label>
                          )}
                        </div>
                      );
                    })()}

                    {/* Récapitulatif prix */}
                    {(() => {
                      const T = computeTtTotals();
                      const { cartCount, cartPrice, nGuests, bookerGF, cartOnsite, totalCart, total } = T;
                      const split = splitAccount(total, accountBalance, useAccountPay);
                      const slotPromo = teeTimeSlots.find(sl => sl.time === selectedTeeTimeSlot)?.promo;
                      const showPromo = !!slotPromo && !societeGuestMode && !T.bookerCarnet && bookerGF > 0 && Math.abs(bookerGF - Number(slotPromo.final_price)) < 0.01;
                      return (
                        <div className="rounded-xl p-3 space-y-1.5" style={{ backgroundColor: '#f8f6f1' }} data-testid="tt-price-recap">
                          <div className="flex justify-between text-xs">
                            <span className="text-neutral-600">{societeGuestMode ? `Green fee invité${nGuests > 1 ? `s ×${nGuests}` : ''}` : 'Votre green fee'}</span>
                            <span className="font-semibold flex items-center gap-1.5" style={{ color: '#2E6A4C' }}>
                              {showPromo && <SlotPromoBadge promo={slotPromo} testId="tt-booker-promo" withPrice={false} />}
                              <span data-testid="tt-booker-gf">{societeGuestMode && bookerGF === 0 ? 'Offert (société)' : T.bookerCarnet ? 'Carnet' : (bookerGF === 0 ? 'Gratuit' : eur(bookerGF))}</span>
                            </span>
                          </div>
                          {!societeGuestMode && bookerGF > 0 && T.bookerLabel && T.bookerLabel !== 'Tarif visiteur' && (
                            <p className="text-[10px] text-amber-700 -mt-1" data-testid="tt-booker-gf-label">{T.bookerLabel}</p>
                          )}
                          {T.companions.map((c, i) => (
                            <div key={`${c.client_id || c.name}-${i}`} className="flex justify-between gap-2 text-xs" data-testid={`tt-companion-gf-${i}`}>
                              <span className="text-neutral-600 truncate">{c.name}<span className="text-[10px] text-neutral-400"> · {c.label}</span></span>
                              <span className={`font-semibold shrink-0 ${Number(c.price) > 0 && !T.payOthers ? 'text-amber-700' : ''}`} style={Number(c.price) > 0 && !T.payOthers ? undefined : { color: '#2E6A4C' }}>
                                {c.carnet ? 'Carnet' : Number(c.price) === 0 ? 'Gratuit' : T.payOthers ? eur(c.price) : `${eur(c.price)} à l'accueil`}
                              </span>
                            </div>
                          ))}
                          {cartCount > 0 && (
                            <div className="flex justify-between text-xs">
                              <span className="text-neutral-600">Voiturette x{cartCount}</span>
                              <span className="font-semibold text-amber-600" data-testid="tt-recap-cart">{cartPrice === 0 ? 'Gratuit' : cartOnsite ? `${cartPrice * cartCount}€ à l'accueil` : `${totalCart}€`}</span>
                            </div>
                          )}
                          {total > 0 && (
                            <div className="flex justify-between text-xs font-bold border-t pt-1.5 mt-1.5" style={{ borderColor: '#e5e0d5' }}>
                              <span>Total à payer</span>
                              <span style={{ color: '#2E6A4C' }} data-testid="tt-recap-total">{eur(total)}</span>
                            </div>
                          )}
                          {T.companionsOnsite > 0 && (
                            <div className="flex justify-between text-[11px]" data-testid="tt-recap-companions-onsite">
                              <span className="text-neutral-600">À régler à l&apos;accueil (accompagnants)</span>
                              <span className="font-semibold text-amber-700">{eur(T.companionsOnsite)}</span>
                            </div>
                          )}
                          {total > 0 && split.account > 0 && (
                            <>
                              <div className="flex justify-between text-[11px]"><span className="text-neutral-600">Pris sur mon compte client</span><span className="font-semibold text-blue-700">− {split.account.toFixed(2)}€</span></div>
                              <div className="flex justify-between text-[11px]"><span className="text-neutral-600">Reste à payer en ligne</span><span className="font-semibold" style={{ color: '#2E6A4C' }} data-testid="tt-recap-stripe">{split.stripe > 0 ? `${split.stripe.toFixed(2)}€` : 'Rien'}</span></div>
                            </>
                          )}
                        </div>
                      );
                    })()}

                    {/* Compte client : solde utilisé en premier, reste par Stripe (aussi pour une résa d'invités) */}
                    <AccountPayChoice total={computeTtTotals().total} balance={accountBalance} useAccount={useAccountPay} onChange={setUseAccountPay} testId="tt-account-pay" />

                    {/* Bouton confirmer */}
                    {(() => {
                      const T = computeTtTotals();
                      const { total, cartOnsite } = T;
                      const isFree = total === 0;
                      const accountLabel = total > 0 ? payLabel(total, accountBalance, useAccountPay) : null;
                      const onsiteBits = `${cartOnsite ? ' · voiturette à l\'accueil' : ''}${T.companionsOnsite > 0 ? ` · GF accompagnant${T.companions.filter(c => Number(c.price) > 0).length > 1 ? 's' : ''} à l'accueil` : ''}`;
                      return (
                        <button
                          onClick={handleBookTeeTime}
                          disabled={teeTimeBookingLoading || (societeGuestMode && !societeGuestPreview) || !T.quoteReady || ttQuoteLoading}
                          className="w-full py-3 rounded-xl text-white text-sm font-semibold transition-opacity disabled:opacity-50 whitespace-normal"
                          style={{ backgroundColor: '#2E6A4C' }}
                          data-testid="tt-confirm-booking"
                        >
                          {teeTimeBookingLoading ? (
                            <span className="flex items-center justify-center gap-2">
                              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                              Réservation en cours...
                            </span>
                          ) : (
                            societeGuestMode && !societeGuestPreview ? 'Vérification du droit de jeu…' : !T.quoteReady ? 'Calcul du tarif…' : isFree ? `Confirmer (${societeGuestMode ? 'invitation offerte' : T.carnetUsed ? 'carnet' : 'gratuit'})${onsiteBits}` : `${accountLabel || `Payer ${eur(total)} et réserver`}${onsiteBits}`
                          )}
                        </button>
                      );
                    })()}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Cours Tab */}
        {activeTab === 'jouer' && scorecardModuleEnabled && (
          <div data-testid="jouer-tab" className="flex-1 min-h-0 overflow-auto">
            <PortalScorecardTab token={token} onNavigateToLessons={() => setActiveTab('indiv')} />
          </div>
        )}

        {activeTab === 'cours' && (
          <div data-testid="cours-tab" className="flex-1 flex flex-col min-h-0 overflow-hidden">
            {/* Date Navigation - FIXE en haut */}
            <div className="flex-shrink-0 z-40" style={{ backgroundColor: '#F5F2EB', borderBottom: '1px solid #e8e4de' }}>
              
              {/* Week day selector with Month button - mobile */}
              {viewMode === 'day' && isMobile && (
                <div className="py-2 overflow-x-auto">
                  <div className="flex items-center gap-2 px-3" style={{ width: 'max-content' }}>
                    {scrollDays.map(day => {
                      const isSelected = isSameDay(day, currentDate);
                      const hasSessions = sessions.some(s => isSameDay(parseISO(s.datetime), day));
                      
                      return (
                        <button
                          key={day.toISOString()}
                          onClick={() => setCurrentDate(day)}
                          className={`flex-shrink-0 w-14 py-1.5 rounded-xl text-center transition-all ${
                            isSelected 
                              ? 'bg-primary text-white shadow-md' 
                              : 'bg-neutral-100 hover:bg-neutral-200'
                          }`}
                        >
                          <div className="text-[10px] uppercase opacity-70">
                            {format(day, 'EEE', { locale: fr })}
                          </div>
                          <div className="text-base font-semibold">{format(day, 'd')}</div>
                          <div className="text-[9px] uppercase opacity-60">
                            {format(day, 'MMM', { locale: fr })}
                          </div>
                          {hasSessions && !isSelected && (
                            <div className="w-1 h-1 mx-auto mt-0.5 rounded-full bg-primary" />
                          )}
                        </button>
                      );
                    })}
                    
                    {/* Bouton Mois */}
                    <Popover open={showDatePicker} onOpenChange={setShowDatePicker}>
                      <PopoverTrigger asChild>
                        <button 
                          className="flex-shrink-0 w-12 py-1.5 rounded-xl text-center bg-neutral-100 hover:bg-neutral-200 transition-all"
                          data-testid="month-picker-button"
                        >
                          <div className="text-[10px] uppercase opacity-70">
                            Mois
                          </div>
                          <div className="text-base font-semibold">📅</div>
                        </button>
                      </PopoverTrigger>
                      <PopoverContent className="w-auto p-0 bg-white" align="end">
                        <CalendarPicker
                          mode="single"
                          selected={currentDate}
                          onSelect={(date) => {
                            if (date) {
                              setCurrentDate(date);
                              setShowDatePicker(false);
                            }
                          }}
                          locale={fr}
                          className="rounded-md border"
                        />
                      </PopoverContent>
                    </Popover>
                  </div>
                </div>
              )}
              
              {/* Desktop navigation header */}
              {!isMobile && (
                <div className="px-4 py-3 flex items-center justify-between">
                  <Button variant="ghost" size="icon" onClick={goToPrev} data-testid="nav-prev">
                    <ChevronLeft size={20} />
                  </Button>
                  
                  <Popover open={showDatePicker} onOpenChange={setShowDatePicker}>
                    <PopoverTrigger asChild>
                      <button 
                        className="text-center"
                        data-testid="current-date-display"
                      >
                        <h2 className="font-semibold text-neutral-900">
                          {viewMode === 'day' 
                            ? format(currentDate, 'EEEE d MMMM', { locale: fr })
                            : `Semaine du ${format(weekDays[0], 'd MMM', { locale: fr })}`
                          }
                        </h2>
                        {isToday(currentDate) && viewMode === 'day' && (
                          <Badge variant="outline" className="text-xs mt-1">Aujourd&apos;hui</Badge>
                        )}
                      </button>
                    </PopoverTrigger>
                    <PopoverContent className="w-auto p-0 bg-white" align="center">
                      <CalendarPicker
                        mode="single"
                        selected={currentDate}
                        onSelect={(date) => {
                          if (date) {
                            setCurrentDate(date);
                            setShowDatePicker(false);
                          }
                        }}
                        locale={fr}
                        className="rounded-md border"
                      />
                    </PopoverContent>
                  </Popover>
                  
                  <Button variant="ghost" size="icon" onClick={goToNext} data-testid="nav-next">
                    <ChevronRight size={20} />
                  </Button>
                </div>
              )}
              
              {/* Onglets Mes réservations / Cours indiv. */}
              <div className="flex justify-center gap-2 px-1 pb-2">
                <button
                  onClick={() => setActiveTab('reservations')}
                  className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg border border-neutral-200 bg-white hover:bg-neutral-50 text-neutral-700 active:scale-95 transition-all"
                  data-testid="cours-goto-reservations"
                >
                  <History size={14} className="text-emerald-600" />
                  Mes réservations ({myRegistrations.filter(r => r.status !== 'cancelled' && r.session?.datetime && new Date(r.session.datetime) > new Date()).length})
                </button>
                <button
                  onClick={() => setActiveTab('indiv')}
                  className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg border border-violet-200 bg-violet-50 hover:bg-violet-100 text-violet-700 active:scale-95 transition-all"
                  data-testid="cours-goto-indiv"
                >
                  <User size={14} />
                  Cours indiv. ({dashboardData?.available_indivs?.length || 0})
                </button>
              </div>

              {/* View mode toggle (visible only on tablet+) */}
              {(
              <div className="hidden sm:flex justify-center pb-3">
                <div className="inline-flex bg-neutral-100 p-1 rounded-lg">
                  <Button 
                    variant={viewMode === 'day' ? 'default' : 'ghost'}
                    size="sm"
                    onClick={() => setViewMode('day')}
                    className={viewMode === 'day' ? 'bg-white shadow-sm text-neutral-900' : 'text-neutral-700 hover:text-neutral-900'}
                  >
                    Jour
                  </Button>
                  <Button 
                    variant={viewMode === 'week' ? 'default' : 'ghost'}
                    size="sm"
                    onClick={() => setViewMode('week')}
                    className={viewMode === 'week' ? 'bg-white shadow-sm text-neutral-900' : 'text-neutral-700 hover:text-neutral-900'}
                  >
                    Semaine
                  </Button>
                </div>
              </div>
              )}
            </div>

            {/* Contenu calendrier */}
            {(
            <div className="flex-1 overflow-y-auto">
              {viewMode === 'day' ? (
                <DayView 
                  date={currentDate} 
                  sessions={sessions} 
                  onSessionClick={(s) => handleOpenSessionModal(s)}
                  isLoading={dataLoading}
                  indivs={dashboardData?.available_indivs || []}
                  onIndivClick={(c) => handleBookFromDashboard(c.id)}
                />
              ) : (
                /* Week View */
                <div className="grid grid-cols-7 gap-2 p-4" data-testid="week-view">
                  {Object.entries(sessionsByDay).map(([dateKey, dayData]) => {
                    const isCurrentDay = isToday(dayData.date);
                    return (
                      <div 
                        key={dateKey} 
                        className={`min-h-[300px] rounded-xl border ${
                          isCurrentDay ? 'border-primary bg-primary/5' : 'border-neutral-200 bg-white'
                        }`}
                      >
                        <div className={`p-2 text-center border-b ${
                          isCurrentDay ? 'border-primary/20' : 'border-neutral-100'
                        }`}>
                          <div className="text-xs text-neutral-500 uppercase">
                            {format(dayData.date, 'EEE', { locale: fr })}
                          </div>
                          <div className={`text-lg font-bold ${isCurrentDay ? 'text-primary' : ''}`}>
                            {format(dayData.date, 'd')}
                          </div>
                        </div>
                        <div className="p-2 space-y-2">
                          {(() => {
                            // Cours individuels disponibles du jour, mêlés par heure aux collectifs
                            const ids = new Set(dayData.sessions.map(s => s.id));
                            const dayIndivs = (dashboardData?.available_indivs || []).filter(c => c.datetime && !ids.has(c.id) && isSameDay(parseISO(c.datetime), dayData.date));
                            const entries = [
                              ...dayData.sessions.map(s => ({ kind: 'session', dt: s.datetime, data: s })),
                              ...dayIndivs.map(c => ({ kind: 'indiv', dt: c.datetime, data: c })),
                            ].sort((a, b) => new Date(a.dt) - new Date(b.dt));
                            if (entries.length === 0) return <p className="text-xs text-neutral-400 text-center py-4">-</p>;
                            const hasRegisteredToday = dayData.sessions.some(s => s.is_registered);
                            return entries.map(({ kind, data: session }) => {
                                if (kind === 'indiv') return <IndivWeekChip key={`indiv-${session.id}`} slot={session} onClick={() => handleBookFromDashboard(session.id)} />;
                                const blockedByDayLimit = hasRegisteredToday && !session.is_registered;
                                return (
                                  <button
                                    key={session.id}
                                    onClick={() => !blockedByDayLimit && handleOpenSessionModal(session)}
                                    className={`w-full p-2 rounded-lg text-left text-xs transition-all ${
                                      session.is_registered 
                                        ? 'bg-primary/10 border border-primary/30' 
                                        : blockedByDayLimit
                                          ? 'bg-neutral-50 opacity-40 cursor-not-allowed'
                                          : 'bg-neutral-50 hover:bg-neutral-100 hover:scale-[1.02]'
                                    }`}
                                    style={{ borderLeftColor: session.employee_color, borderLeftWidth: '3px' }}
                                    disabled={blockedByDayLimit}
                                  >
                                    <div className="font-medium truncate">{session.course_name}</div>
                                    <div className="text-neutral-500 mt-0.5">
                                      {format(parseISO(session.datetime), 'HH:mm')}
                                    </div>
                                    {session.is_registered && (
                                      <Badge className="mt-1 bg-primary text-white text-[10px]">Inscrit</Badge>
                                    )}
                                    {blockedByDayLimit && (
                                      <span className="mt-1 block text-[10px] text-amber-600">Déjà un cours ce jour</span>
                                    )}
                                  </button>
                                );
                              });
                          })()}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            )}

          </div>
        )}

        {/* Page plein écran : Mes réservations */}
        {activeTab === 'reservations' && (
          <div className="flex-1 overflow-y-auto p-3 space-y-2" data-testid="reservations-page" style={{ backgroundColor: '#F5F2EB' }}>
            <div className="flex items-center gap-1 mb-2">
              <button onClick={() => setActiveTab('cours')} className="p-1 rounded-lg" style={{ color: '#2E6A4C' }}><ChevronLeft size={18} /></button>
              <h4 className="font-bold uppercase" style={{ fontSize: '11px', color: '#999', letterSpacing: '0.08em' }}>Réservations à venir</h4>
            </div>
                {(() => {
                  const now = new Date();
                  const futureRegistrations = myRegistrations
                    .filter(r => {
                      if (r.status === 'cancelled') return false;
                      const sessionDate = r.session?.datetime ? new Date(r.session.datetime) : null;
                      return sessionDate && sessionDate > now;
                    })
                    .sort((a, b) => new Date(a.session?.datetime) - new Date(b.session?.datetime));
                  
                  return futureRegistrations.length === 0 ? (
                  <Card className="border-dashed">
                    <CardContent className="py-8 text-center">
                      <CalendarDays size={40} className="mx-auto text-neutral-300 mb-3" />
                      <p className="text-neutral-500 text-sm mb-3">Aucune réservation à venir</p>
                      <Button variant="outline" size="sm" onClick={() => setActiveTab('cours')}>
                        Voir les cours
                      </Button>
                    </CardContent>
                  </Card>
                ) : (
                  <div className="space-y-3">
                    {futureRegistrations
                      .map(reg => {
                        const session = reg.session;
                        const sessionDate = session?.datetime ? parseISO(session.datetime) : null;
                        const endTime = sessionDate ? new Date(sessionDate.getTime() + (session?.duration_minutes || 60) * 60000) : null;
                        const cancelHours = portalSettings?.cancellation_hours_before ?? 12;
                        const canCancel = cancelHours > 0 && sessionDate && (sessionDate - new Date()) > cancelHours * 60 * 60 * 1000;
                        const sessionColor = session?.employee_color || '#1B8066';
                        const bookedFor = reg.booked_for;
                        const beneficiaryName = bookedFor?.is_self 
                          ? 'Moi' 
                          : `${bookedFor?.first_name || ''} ${bookedFor?.last_name || ''}`.trim() || 'Inconnu';
                        const isForOther = bookedFor && !bookedFor.is_self;
                        
                        return (
                          <div 
                            key={reg.id} 
                            className="rounded-xl overflow-hidden bg-white shadow-sm border border-neutral-100"
                          >
                            <div className="flex">
                              <div className="w-1.5 flex-shrink-0" style={{ backgroundColor: sessionColor }} />
                              <div className="flex-1 px-3.5 py-3">
                                <div className="flex items-start justify-between gap-2">
                                  <div className="flex-1 min-w-0">
                                    <h3 className="font-semibold text-neutral-900 text-sm leading-tight">
                                      {session?.course_name || 'Cours'}
                                    </h3>
                                    <div className="flex items-center gap-1.5 text-xs text-neutral-500 mt-1.5">
                                      <Calendar size={12} className="text-neutral-400 flex-shrink-0" />
                                      <span className="font-medium" style={{ color: sessionColor }}>
                                        {sessionDate ? format(sessionDate, 'EEE d MMM', { locale: fr }) : ''}
                                      </span>
                                      <span className="text-neutral-300">|</span>
                                      <Clock size={12} className="text-neutral-400 flex-shrink-0" />
                                      <span>{sessionDate ? `${format(sessionDate, 'HH:mm')}–${endTime ? format(endTime, 'HH:mm') : ''}` : ''}</span>
                                    </div>
                                    <div className="flex items-center gap-1.5 text-xs text-neutral-500 mt-1">
                                      {session?.employee_name && (
                                        <span className="flex items-center gap-1">
                                          <User size={11} className="text-neutral-400" />
                                          <span>{session.employee_name}</span>
                                        </span>
                                      )}
                                      <span className={`${isForOther ? 'text-blue-600 font-medium' : 'text-neutral-400'}`}>
                                        {isForOther ? `Pour ${beneficiaryName}` : ''}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="flex flex-col items-end gap-1.5 flex-shrink-0">
                                    <Badge variant="outline" className={`text-[10px] px-2.5 py-0.5 h-5 rounded-full font-medium ${
                                      reg.payment_status === 'paid'
                                        ? 'bg-emerald-50 text-emerald-700 border-emerald-200' 
                                        : reg.status === 'confirmed'
                                        ? 'bg-blue-50 text-blue-700 border-blue-200'
                                        : reg.payment_status === 'free'
                                        ? 'bg-neutral-50 text-neutral-600 border-neutral-200'
                                        : 'bg-amber-50 text-amber-700 border-amber-200'
                                    }`}>
                                      {reg.payment_status === 'paid' ? 'Payé' : 
                                       reg.status === 'confirmed' ? 'Confirmé' : 
                                       reg.payment_status === 'free' ? 'Gratuit' : 
                                       'En attente'}
                                    </Badge>
                                    {canCancel && (
                                      <button 
                                        className="text-[10px] text-red-400 hover:text-red-600 font-medium transition-colors"
                                        onClick={() => {
                                          if (window.confirm('Voulez-vous vraiment annuler cette réservation ?')) {
                                            handleCancelRegistration(reg.id);
                                          }
                                        }}
                                      >
                                        Annuler
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                )
                })()}

                {/* Historique */}
                {registrationsHistory.past.length > 0 && (
                  <div className="mt-4">
                    <h4 className="text-xs font-medium text-neutral-500 uppercase mb-2 px-1">Historique</h4>
                    <div className="space-y-1.5">
                      {registrationsHistory.past.slice(0, 10).map(reg => {
                        const session = reg.session;
                        const sessionDate = session?.datetime ? parseISO(session.datetime) : null;
                        const isCancelled = reg.status === 'cancelled';
                        const isCourseDeleted = reg.status === 'course_deleted';
                        const isInactive = isCancelled || isCourseDeleted;
                        return (
                          <div key={reg.id} className={`rounded-lg px-3.5 py-2.5 ${isInactive ? 'bg-neutral-50' : 'bg-neutral-100'}`}>
                            <div className="flex items-center justify-between">
                              <div className="min-w-0 flex-1">
                                <p className={`text-sm font-medium truncate ${isInactive ? 'text-neutral-400 line-through' : 'text-neutral-700'}`}>
                                  {session?.course_name || 'Cours'}
                                </p>
                                <p className="text-xs text-neutral-400">
                                  {sessionDate ? format(sessionDate, 'EEE d MMM yyyy', { locale: fr }) : 'Date inconnue'}
                                </p>
                              </div>
                              <Badge variant="outline" className={`text-[10px] flex-shrink-0 ${
                                isCourseDeleted ? 'text-amber-500 border-amber-200 bg-amber-50' : isCancelled ? 'text-red-400 border-red-200' : 'text-neutral-400'
                              }`}>
                                {isCourseDeleted ? 'Cours supprimé' : isCancelled ? 'Annulé' : 'Terminé'}
                              </Badge>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

          </div>
        )}

        {/* Page plein écran : Cours individuels — vue Liste/Calendrier identique au site vitrine */}
        {activeTab === 'indiv' && (
          <div className="flex-1 overflow-y-auto" data-testid="indiv-page" style={{ backgroundColor: '#F5F5F3' }}>
            {/* En-tête minimal : bouton retour + label */}
            <div className="bg-white border-b border-stone-200 sticky top-0 z-10">
              <div className="px-3 sm:px-4 py-3 flex items-center gap-2">
                <button
                  onClick={() => setActiveTab('cours')}
                  className="p-1.5 rounded-lg text-emerald-950 hover:bg-neutral-100 transition-colors flex-shrink-0"
                  data-testid="indiv-back-btn"
                >
                  <ChevronLeft size={18} />
                </button>
                <p className="font-bold uppercase" style={{ fontSize: '10px', color: '#999', letterSpacing: '0.12em' }}>Cours individuels</p>
              </div>
            </div>

            {/* Contenu : hero + Liste/Calendrier partagé avec la vitrine */}
            <div className="px-4 sm:px-8 lg:px-12 py-8 lg:py-12 max-w-5xl mx-auto w-full">
              <h1 className="font-['Playfair_Display'] text-3xl lg:text-4xl text-[#0B0B0B] font-light">Cours individuels</h1>
              <div className="w-12 h-px bg-[#D4AF37] mt-6 mb-6" />

              <div className="mt-12">
                {/* iter314 — Bannière filtre Yield actif */}
                {indivYieldFilter && (() => {
                  const allIndivs = dashboardData?.available_indivs || [];
                  const matched = allIndivs.filter(c => c.yield_rule_id === indivYieldFilter);
                  const label = matched[0]?.yield_label || 'Promo';
                  const price = matched[0]?.member_price ?? matched[0]?.price;
                  return (
                    <div
                      className="mb-6 rounded-2xl px-4 py-3 flex items-center justify-between"
                      style={{ background: 'linear-gradient(135deg, #FDF6E3 0%, #FBE9B7 100%)', border: '1px solid rgba(184, 134, 11, 0.35)' }}
                      data-testid="indiv-yield-filter-banner"
                    >
                      <div className="min-w-0">
                        <p className="font-bold text-sm text-[#3D2E00]">
                          Promo <span className="italic">{label}</span> — {matched.length} créneau{matched.length > 1 ? 'x' : ''} dispo{price ? ` à ${price}€` : ''}
                        </p>
                        <p className="text-[11px] text-[#8B6914] mt-0.5">Seuls les créneaux impactés par cette promo sont affichés.</p>
                      </div>
                      <button
                        onClick={() => setIndivYieldFilter('')}
                        className="ml-3 px-3 py-1.5 text-xs font-semibold rounded-full bg-white/70 hover:bg-white text-[#8B6914] border border-[#8B6914]/30"
                        data-testid="indiv-yield-filter-clear"
                      >
                        Retirer le filtre
                      </button>
                    </div>
                  );
                })()}
                <CoursListCalendar
                  courses={
                    indivYieldFilter
                      ? (dashboardData?.available_indivs || []).filter(c => c.yield_rule_id === indivYieldFilter)
                      : (dashboardData?.available_indivs || [])
                  }
                  loading={dataLoading}
                  lang="fr"
                  onBook={(course) => handleBookFromDashboard(course.id)}
                  storageKey="portal-cours-view"
                />
              </div>
            </div>
          </div>
        )}

        {/* Stages Tab — Design aligné sur la page publique (site vitrine) */}
        {activeTab === 'stages' && (
          <div className="flex-1 overflow-y-auto px-3 sm:px-4 py-4 space-y-6" data-testid="stages-tab" style={{ backgroundColor: '#F5F2EB' }}>
            {/* En-tête avec titre serif + toggle Mes inscriptions */}
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="font-bold uppercase" style={{ fontSize: '10px', color: '#999', letterSpacing: '0.12em' }}>Stages</p>
                <h1 className="font-serif text-2xl sm:text-3xl text-emerald-950 leading-tight mt-1">
                  Stages à venir
                </h1>
              </div>
              <Button
                variant={showMyStageRegistrations ? "default" : "outline"}
                size="sm"
                onClick={() => setShowMyStageRegistrations(!showMyStageRegistrations)}
                className="h-8 text-[11px] gap-1.5 rounded-full shrink-0"
                data-testid="stages-reservations-btn"
              >
                <History size={13} />
                Mes inscriptions ({stages.filter(s => s.is_registered).length})
              </Button>
            </div>

            {dataLoading ? (
              <div className="flex items-center justify-center py-16">
                <Loader2 className="animate-spin text-emerald-950" size={28} />
              </div>
            ) : stages.length === 0 ? (
              <div className="text-center py-16">
                <CalendarDays size={32} className="mx-auto text-stone-300 mb-3" />
                <p className="text-stone-500 text-xs">Aucun stage disponible</p>
              </div>
            ) : (() => {
              const DAY_SHORT = ['DIM.', 'LUN.', 'MAR.', 'MER.', 'JEU.', 'VEN.', 'SAM.'];

              // Filtrer si toggle actif
              const filteredStages = showMyStageRegistrations ? stages.filter(s => s.is_registered) : stages;
              if (filteredStages.length === 0) {
                return (
                  <div className="text-center py-16">
                    <CalendarDays size={32} className="mx-auto text-stone-300 mb-3" />
                    <p className="text-stone-500 text-xs">Aucune inscription en cours</p>
                  </div>
                );
              }
              // Grouper par mois
              const grouped = {};
              const sortedStages = [...filteredStages].sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
              sortedStages.forEach(stage => {
                const date = stage.start_date ? parseISO(stage.start_date) : new Date();
                const key = format(date, 'yyyy-MM');
                const label = format(date, 'MMMM yyyy', { locale: fr }).toUpperCase();
                if (!grouped[key]) grouped[key] = { label, items: [] };
                grouped[key].items.push(stage);
              });
              const sortedKeys = Object.keys(grouped).sort();

              return (
                <div className="space-y-10">
                  {sortedKeys.map(key => {
                    const group = grouped[key];
                    return (
                      <section key={key} id={`stage-month-${key}`} data-month-key={key}>
                        {/* En-tête de mois — style vitrine */}
                        <div className="flex items-end justify-between gap-4 mb-4">
                          <div className="flex items-center gap-2.5">
                            <Calendar size={13} className="text-stone-400" strokeWidth={1.5} />
                            <h2 className="text-[11px] font-semibold tracking-[0.2em] text-stone-500">
                              {group.label}
                            </h2>
                          </div>
                          <div className="flex-1 border-b border-stone-200 mb-1.5"></div>
                          <span className="text-[10px] text-stone-400">
                            {group.items.length} {group.items.length > 1 ? 'stages' : 'stage'}
                          </span>
                        </div>

                        {/* Card blanc englobant tous les stages du mois */}
                        <div className="bg-white border border-stone-200 rounded-xl overflow-hidden">
                          {group.items.map((stage, idx) => {
                            const isFull = stage.max_participants && stage.registered_count >= stage.max_participants;
                            const registered = stage.is_registered;
                            const d = stage.start_date ? parseISO(stage.start_date) : null;
                            const dEnd = stage.end_date ? parseISO(stage.end_date) : null;
                            const dayShort = d ? DAY_SHORT[d.getDay()] : '';
                            const dayNum = d ? d.getDate() : '—';
                            const isPast = d && d < new Date() && (!dEnd || dEnd < new Date());
                            let daysCount = 1;
                            if (stage.start_date && stage.end_date && stage.start_date !== stage.end_date) {
                              daysCount = Math.ceil((parseISO(stage.end_date) - parseISO(stage.start_date)) / (1000 * 60 * 60 * 24)) + 1;
                            }

                            return (
                              <div
                                key={stage.id}
                                onClick={() => { setSelectedStage(stage); setShowStageModal(true); }}
                                className={`flex items-center gap-3 sm:gap-5 p-3 sm:p-4 transition-colors cursor-pointer ${
                                  idx > 0 ? 'border-t border-stone-100' : ''
                                } ${isPast ? 'opacity-60' : 'hover:bg-stone-50/50'}`}
                                data-testid={`stage-card-${stage.id}`}
                              >
                                {/* Date à gauche : jour court + numéro serif */}
                                <div className="flex flex-col items-center justify-center w-11 sm:w-14 flex-shrink-0">
                                  <span className="text-[9px] sm:text-[10px] italic tracking-wider text-stone-400 uppercase">
                                    {dayShort}
                                  </span>
                                  <span className="font-serif text-2xl sm:text-3xl text-emerald-950 leading-none mt-0.5">
                                    {dayNum}
                                  </span>
                                  {dEnd && stage.end_date !== stage.start_date && (
                                    <span className="text-[8px] sm:text-[9px] tracking-wider text-stone-400 uppercase mt-0.5">
                                      → {dEnd.getDate()}
                                    </span>
                                  )}
                                </div>

                                {/* Séparateur vertical fin */}
                                <div className="h-12 w-px bg-stone-200 flex-shrink-0 hidden sm:block"></div>

                                {/* Infos stage */}
                                <div className="flex-1 min-w-0">
                                  <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5 mb-1">
                                    <h3 className="text-sm sm:text-[15px] font-semibold text-emerald-950 leading-tight">
                                      {stage.name}
                                    </h3>
                                    {isPast && (
                                      <span className="text-[9px] uppercase tracking-wider font-semibold text-stone-400">Terminé</span>
                                    )}
                                    {isFull && !registered && !isPast && (
                                      <span className="text-[9px] uppercase tracking-wider font-semibold text-red-500">Complet</span>
                                    )}
                                    {registered && (
                                      <span className="text-[9px] uppercase tracking-wider font-semibold text-emerald-600">Inscrit</span>
                                    )}
                                  </div>

                                  {/* Coach en accent (comme le type d'événement) */}
                                  {stage.coach_name && (
                                    <div className="text-[10px] uppercase tracking-[0.15em] font-semibold text-emerald-700 mb-1.5">
                                      AVEC {stage.coach_name}
                                    </div>
                                  )}

                                  {/* Ligne infos : durée • participants • prix */}
                                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-stone-500">
                                    {daysCount > 1 && (
                                      <span className="flex items-center gap-1">
                                        <CalendarDays size={10} strokeWidth={1.5} />
                                        {daysCount} jours
                                      </span>
                                    )}
                                    {stage.start_time && (
                                      <span className="flex items-center gap-1">
                                        <Clock size={10} strokeWidth={1.5} />
                                        {stage.start_time}
                                      </span>
                                    )}
                                    {stage.max_participants > 0 && (
                                      <span className="flex items-center gap-1">
                                        <Users size={10} strokeWidth={1.5} />
                                        {stage.registered_count || 0}/{stage.max_participants}
                                      </span>
                                    )}
                                    <span className={`font-medium ${stage.client_price === 0 ? 'text-emerald-600' : 'text-stone-700'}`}>
                                      {stage.client_price === 0 ? 'Gratuit' : `${stage.client_price}€`}
                                    </span>
                                  </div>
                                </div>

                                {/* Bouton S'INSCRIRE outline (masqué si passé/complet/déjà inscrit) */}
                                {!isPast && !registered && !isFull && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedStage(stage);
                                      setShowStageModal(true);
                                    }}
                                    className="hidden sm:inline-flex flex-shrink-0 items-center gap-1.5 px-3 sm:px-4 py-1.5 sm:py-2 border border-emerald-950 text-[10px] sm:text-[11px] uppercase tracking-wider font-semibold text-emerald-950 hover:bg-emerald-950 hover:text-stone-50 transition-colors"
                                    data-testid={`stage-register-btn-${stage.id}`}
                                  >
                                    S&apos;inscrire
                                  </button>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </section>
                    );
                  })}
                </div>
              );
            })()}
          </div>
        )}

        {/* Stage Modal - IDENTIQUE au Competition Modal */}
        <Dialog open={showStageModal} onOpenChange={setShowStageModal}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <CalendarDays size={20} style={{ color: getStageMonthColor(selectedStage?.start_date).accent }} />
                {selectedStage?.name}
              </DialogTitle>
            </DialogHeader>
            
            {selectedStage && (
              <div className="space-y-4">
                {/* Date */}
                <div className="flex items-center gap-2 text-sm">
                  <Calendar size={16} className="text-neutral-400" />
                  <span>
                    {selectedStage.start_date && format(parseISO(selectedStage.start_date), 'EEEE d MMMM yyyy', { locale: fr })}
                    {selectedStage.end_date && selectedStage.end_date !== selectedStage.start_date && (
                      <> au {format(parseISO(selectedStage.end_date), 'd MMMM', { locale: fr })}</>
                    )}
                  </span>
                </div>
                
                {/* Coach */}
                {selectedStage.coach_name && (
                  <div className="flex items-center gap-2 text-sm" data-testid="stage-modal-coach">
                    <User size={16} className="text-neutral-400" />
                    <span>Coach : <span className="font-medium text-neutral-800">{selectedStage.coach_name}</span></span>
                  </div>
                )}

                {/* Horaires */}
                {(selectedStage.start_time || selectedStage.duration_minutes) && (
                  <div className="flex items-center gap-2 text-sm" data-testid="stage-modal-schedule">
                    <Clock size={16} className="text-neutral-400" />
                    <span>
                      {selectedStage.start_time && (() => {
                        const [h, m] = selectedStage.start_time.split(':').map(Number);
                        const endMin = h * 60 + m + (selectedStage.duration_minutes || 0);
                        const endH = Math.floor(endMin / 60);
                        const endM = endMin % 60;
                        return <><span className="font-medium text-neutral-800">{selectedStage.start_time}</span>{selectedStage.duration_minutes && <> à <span className="font-medium text-neutral-800">{String(endH).padStart(2,'0')}:{String(endM).padStart(2,'0')}</span></>}</>;
                      })()}
                      {selectedStage.duration_minutes && (
                        <span className="text-neutral-400 ml-1">({Math.floor(selectedStage.duration_minutes / 60)}h{selectedStage.duration_minutes % 60 > 0 ? `${String(selectedStage.duration_minutes % 60).padStart(2,'0')}` : ''} / jour)</span>
                      )}
                    </span>
                  </div>
                )}
                
                {/* Places */}
                {selectedStage.max_participants && (
                  <div className="flex items-center gap-2 text-sm">
                    <Users size={16} className="text-neutral-400" />
                    <span>{selectedStage.registered_count} / {selectedStage.max_participants} inscrits</span>
                  </div>
                )}
                
                {/* Date limite */}
                {selectedStage.registration_deadline && (
                  <div className="flex items-center gap-2 text-sm">
                    <AlertCircle size={16} className="text-amber-500" />
                    <span>Inscription avant le {format(parseISO(selectedStage.registration_deadline), 'd MMMM', { locale: fr })}</span>
                  </div>
                )}
                
                {/* Description */}
                {selectedStage.description && (
                  <div className="p-3 bg-neutral-50 rounded-lg">
                    <p className="text-sm text-neutral-600 whitespace-pre-line">{selectedStage.description}</p>
                  </div>
                )}
                
                {/* Prix */}
                <div className="p-3 bg-primary/5 rounded-lg">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-neutral-600">Tarif</span>
                    <div className="text-right">
                      <span className="text-xl font-bold text-primary">
                        {selectedStage.client_price === 0 ? 'Gratuit' : `${selectedStage.client_price}€`}
                      </span>
                      {selectedStage.is_member_price !== null && (
                        <Badge className={`ml-2 text-[9px] ${selectedStage.is_member_price ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}`}>
                          {selectedStage.is_member_price ? 'Membre' : 'Non-membre'}
                        </Badge>
                      )}
                    </div>
                  </div>
                  {selectedStage.member_price !== null && selectedStage.non_member_price !== null && (
                    <p className="text-[10px] text-neutral-400 mt-1">
                      Membre: {selectedStage.member_price}€ | Non-membre: {selectedStage.non_member_price}€
                    </p>
                  )}
                </div>
                
                {/* Actions */}
                <div className="pt-2">
                  {selectedStage.is_registered ? (
                    <div className="space-y-2">
                      <div className="text-center p-3 bg-green-50 rounded-lg">
                        <CheckCircle2 className="w-8 h-8 mx-auto text-green-600 mb-1" />
                        <p className="font-medium text-green-700">Vous êtes inscrit !</p>
                      </div>
                      <Button 
                        variant="outline" 
                        className="w-full text-red-600 border-red-200 hover:bg-red-50"
                        onClick={() => handleCancelStageRegistration(selectedStage.id)}
                      >
                        <XCircle size={16} className="mr-2" />
                        Annuler mon inscription
                      </Button>
                    </div>
                  ) : (
                    <>
                      {selectedStage.max_participants && selectedStage.registered_count >= selectedStage.max_participants ? (
                        <div className="text-center p-3 bg-red-50 rounded-lg">
                          <XCircle className="w-8 h-8 mx-auto text-red-400 mb-1" />
                          <p className="font-medium text-red-600">Stage complet</p>
                        </div>
                      ) : selectedStage.registration_deadline && isBefore(parseISO(selectedStage.registration_deadline), new Date()) ? (
                        <div className="text-center p-3 bg-amber-50 rounded-lg">
                          <AlertCircle className="w-8 h-8 mx-auto text-amber-400 mb-1" />
                          <p className="font-medium text-amber-600">Inscriptions closes</p>
                        </div>
                      ) : (
                        <div className="space-y-2">
                          <AccountPayChoice total={selectedStage.client_price || 0} balance={accountBalance} useAccount={useAccountPay} onChange={setUseAccountPay} testId="stage-account-pay" />
                          <Button 
                            className="w-full whitespace-normal h-auto py-2 min-w-0"
                            onClick={() => handleRegisterStage(selectedStage.id)}
                            data-testid="stage-register-btn"
                          >
                            <Check size={16} className="mr-2" />
                            {selectedStage.client_price > 0 
                              ? (payLabel(selectedStage.client_price, accountBalance, useAccountPay, '') || `S'inscrire - ${selectedStage.client_price}€`).replace('Payer', "S'inscrire et payer")
                              : "S'inscrire (gratuit)"
                            }
                          </Button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>

        {/* iter313 — La section Practice (jetons + QR) est désormais intégrée dans l'onglet Boutique */}

        {/* Boutique Tab - Packs de cours + Practice (QR + achat jetons) */}
        {activeTab === 'boutique' && (
          <div className="flex-1 overflow-y-auto p-3 space-y-3" data-testid="boutique-tab" style={{ backgroundColor: '#F5F2EB' }}>
            {/* Widget compte prépayé + bon cadeau (Phase 3.5) — visibilité contrôlée par portal-settings */}
            <PortalWalletWidget
              key={`wallet-${accountBalance}`}
              onNavigateToDetail={() => document.querySelector('[data-testid="boutique-wallet-topup"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' })}
              showWallet={portalSettings?.show_wallet === true}
              showGiftCards={portalSettings?.show_gift_cards === true}
            />
            {/* Solde du compte client + rechargement — masqués si « Solde compte » est désactivé (Paramètres portail) */}
            {portalSettings?.show_wallet === true && (
              <WalletTopupCard key={`topup-${accountBalance}`} token={token} returnTab="boutique" onBalance={setAccountBalance} hideBalance testId="boutique-wallet-topup" />
            )}
            {/* Activer un bon cadeau reçu → crédit du compte — masqué si « Bons cadeaux » est désactivé */}
            {portalSettings?.show_gift_cards === true && (
              <GiftCardActivateCard token={token} onActivated={(b) => setAccountBalance(Number(b) || 0)} />
            )}
            
            <div className="flex items-center justify-between px-1 pt-2">
              <h4 className="font-bold uppercase" style={{ fontSize: '11px', color: '#999', letterSpacing: '0.08em' }}>Packs de cours individuels</h4>
              {clientIsMember ? (
                <Badge className="bg-green-100 text-green-700 text-[10px]">Tarif membre</Badge>
              ) : (
                <Badge className="bg-amber-100 text-amber-700 text-[10px]">Tarif non-membre</Badge>
              )}
            </div>
            
            {/* Solde actuel du carnet */}
            {portalSettings?.show_carnet_cours !== false && (
              <Card className="bg-gradient-to-r from-emerald-50 to-teal-50 border-emerald-200">
                <CardContent className="p-3">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <BookOpen className="text-emerald-600" size={20} />
                      <div>
                        <p className="text-xs text-neutral-600">Votre carnet</p>
                        <p className="font-bold text-emerald-700">
                          {portalSettings?.carnet_remaining ?? 0}h restantes
                        </p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )}
            
            <p className="text-xs text-neutral-500 px-1">
              Rechargez votre carnet de cours individuels en achetant un pack
            </p>
            
            {packsLoading ? (
              <div className="flex items-center justify-center py-8">
                <Loader2 className="animate-spin text-neutral-400" size={24} />
              </div>
            ) : coursePacks.length === 0 ? (
              <Card className="border-dashed">
                <CardContent className="py-8 text-center">
                  <ShoppingBag size={40} className="mx-auto text-neutral-300 mb-3" />
                  <p className="text-neutral-500 text-sm">Aucun pack disponible</p>
                  <p className="text-neutral-400 text-xs mt-1">Contactez l'accueil pour plus d'infos</p>
                </CardContent>
              </Card>
            ) : (
              <div className="grid gap-3">
                {coursePacks.map(pack => (
                  <Card key={pack.id} className="overflow-hidden">
                    <CardContent className="p-0">
                      <div className="flex">
                        <div className="flex-1 p-3">
                          <h3 className="font-medium text-sm">{pack.name}</h3>
                          <p className="text-emerald-600 font-bold mt-1">
                            {pack.hours} heures
                          </p>
                          {pack.description && (
                            <p className="text-xs text-neutral-500 mt-1">{pack.description}</p>
                          )}
                        </div>
                        <div className="bg-emerald-50 p-3 flex flex-col items-center justify-center min-w-[100px]">
                          <span className="font-bold text-lg text-emerald-700">
                            {pack.your_price || (clientIsMember ? pack.price_member : pack.price_non_member)}€
                          </span>
                          <Button
                            size="sm"
                            className="mt-2 bg-emerald-600 hover:bg-emerald-700 h-7 text-xs"
                            onClick={() => handlePurchasePack(pack)}
                            disabled={purchasingPack === pack.id}
                          >
                            {purchasingPack === pack.id ? (
                              <Loader2 className="animate-spin mr-1" size={12} />
                            ) : (
                              <CreditCard size={12} className="mr-1" />
                            )}
                            Acheter
                          </Button>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            )}

            {/* Section Carnets Green Fee — iter313.4 : contrôlé par portalSettings.show_carnet_gf ET tee_time.carnet_green_fee_enabled */}
            {portalSettings?.show_carnet_gf !== false && teeTimeEnabled && teeTimeSettings?.carnet_green_fee_enabled && (
              <>
                <div className="border-t border-neutral-200 my-2" />
                <div className="flex items-center justify-between px-1">
                  <h4 className="font-bold uppercase" style={{ fontSize: '11px', color: '#999', letterSpacing: '0.08em' }}>Carnets Green Fee</h4>
                </div>
                {(portalSettings?.green_fee_carnet_remaining || 0) > 0 && (
                  <Card className="bg-gradient-to-r from-emerald-50 to-teal-50 border-emerald-200">
                    <CardContent className="p-3">
                      <div className="flex items-center gap-2">
                        <Wallet className="text-emerald-600" size={20} />
                        <div>
                          <p className="text-xs text-neutral-600">Votre solde</p>
                          <p className="font-bold text-emerald-700">
                            {portalSettings.green_fee_carnet_remaining} Green Fee{portalSettings.green_fee_carnet_remaining > 1 ? 's' : ''} restant{portalSettings.green_fee_carnet_remaining > 1 ? 's' : ''}
                          </p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                )}
                <p className="text-xs text-neutral-500 px-1">
                  Rechargez votre carnet de Green Fees pour réserver vos départs
                </p>
                <div className="grid grid-cols-2 gap-3">
                  <Card className="overflow-hidden cursor-pointer hover:shadow-md transition-all" data-testid="buy-carnet-10"
                    onClick={async () => {
                      trackPortalItem('product', 'carnet-gf-10', 'Carnet 10 Green Fees');
                      try {
                        const res = await fetch(`${API_URL}/api/tee-times/portal/buy-carnet`, {
                          method: 'POST',
                          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                          body: JSON.stringify({ carnet_type: '10' })
                        });
                        const data = await res.json();
                        if (!res.ok) throw new Error(data.detail);
                        window.location.href = data.checkout_url;
                      } catch (e) { toast.error(e.message); }
                    }}
                  >
                    <CardContent className="p-3 text-center">
                      <p className="font-bold text-sm" style={{ color: '#2E6A4C' }}>10 Green Fees</p>
                      <p className="font-bold text-lg text-emerald-700 mt-1">{teeTimeSettings.carnet_green_fee_price_10 || '—'}€</p>
                      <Button size="sm" className="mt-2 bg-emerald-600 hover:bg-emerald-700 h-7 text-xs w-full">
                        <CreditCard size={12} className="mr-1" /> Acheter
                      </Button>
                    </CardContent>
                  </Card>
                  <Card className="overflow-hidden cursor-pointer hover:shadow-md transition-all" data-testid="buy-carnet-20"
                    onClick={async () => {
                      trackPortalItem('product', 'carnet-gf-20', 'Carnet 20 Green Fees');
                      try {
                        const res = await fetch(`${API_URL}/api/tee-times/portal/buy-carnet`, {
                          method: 'POST',
                          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                          body: JSON.stringify({ carnet_type: '20' })
                        });
                        const data = await res.json();
                        if (!res.ok) throw new Error(data.detail);
                        window.location.href = data.checkout_url;
                      } catch (e) { toast.error(e.message); }
                    }}
                  >
                    <CardContent className="p-3 text-center">
                      <p className="font-bold text-sm" style={{ color: '#2E6A4C' }}>20 Green Fees</p>
                      <p className="font-bold text-lg text-emerald-700 mt-1">{teeTimeSettings.carnet_green_fee_price_20 || '—'}€</p>
                      <Button size="sm" className="mt-2 bg-emerald-600 hover:bg-emerald-700 h-7 text-xs w-full">
                        <CreditCard size={12} className="mr-1" /> Acheter
                      </Button>
                    </CardContent>
                  </Card>
                </div>
              </>
            )}

            {/* iter313.3 — Section Practice (Jetons machine à balles + QR) — même style que Carnets GF */}
            {portalSettings?.show_practice_portal && (
              <>
                <div className="border-t border-neutral-200 my-2" />
                <div className="flex items-center justify-between px-1">
                  <h4 className="font-bold uppercase" style={{ fontSize: '11px', color: '#999', letterSpacing: '0.08em' }}>Jetons Practice</h4>
                </div>
                {/* Solde + QR compact */}
                <Card className="bg-gradient-to-r from-amber-50 to-yellow-50 border-amber-200" data-testid="practice-balance-card">
                  <CardContent className="p-3">
                    <div className="flex items-center justify-between gap-3">
                      <div className="flex items-center gap-2 flex-1">
                        <span className="text-2xl leading-none">⚡</span>
                        <div>
                          <p className="text-xs text-neutral-600">Votre solde</p>
                          <p className="font-bold text-amber-700">
                            {Math.floor(practiceData?.balance?.remaining || 0)} jeton{(practiceData?.balance?.remaining || 0) !== 1 ? 's' : ''} restant{(practiceData?.balance?.remaining || 0) !== 1 ? 's' : ''}
                          </p>
                        </div>
                      </div>
                      {practiceData?.qr_value && (
                        <button
                          onClick={() => setShowPracticeQrFullscreen(true)}
                          className="flex flex-col items-center bg-white p-2 rounded-lg border border-amber-200 hover:border-amber-400 hover:shadow-sm transition"
                          data-testid="practice-qr-button"
                          title="Cliquez pour afficher en grand devant la machine"
                        >
                          <QRCodeSVG value={practiceData.qr_value} size={54} level="M" />
                          <span className="text-[9px] text-amber-700 mt-1 font-semibold">Voir QR</span>
                        </button>
                      )}
                    </div>
                    {/* iter314 — Boutons Apple/Google Wallet */}
                    {practiceData?.qr_value && (
                      <div className="mt-3 pt-3 border-t border-amber-200">
                        <WalletButtonsPractice compact />
                      </div>
                    )}
                  </CardContent>
                </Card>
                <p className="text-xs text-neutral-500 px-1">
                  Rechargez votre solde de jetons pour la machine à balles
                </p>
                {(practiceData?.packs_available?.length || 0) > 0 ? (
                  <div className="grid grid-cols-2 gap-3">
                    {practiceData.packs_available.map(pack => (
                      <Card
                        key={pack.id}
                        className="overflow-hidden cursor-pointer hover:shadow-md transition-all"
                        data-testid={`buy-practice-${pack.id}`}
                        onClick={() => handlePurchasePracticePack(pack)}
                      >
                        <CardContent className="p-3 text-center">
                          <p className="font-bold text-sm" style={{ color: '#2E6A4C' }}>{pack.name}</p>
                          <p className="text-xs text-neutral-500 mt-0.5">{pack.count} jeton{pack.count > 1 ? 's' : ''}</p>
                          <p className="font-bold text-lg text-emerald-700 mt-1">
                            {clientIsMember ? pack.price_member : pack.price_non_member}€
                          </p>
                          <Button size="sm" className="mt-2 bg-emerald-600 hover:bg-emerald-700 h-7 text-xs w-full" disabled={purchasingPracticePack === pack.id}>
                            {purchasingPracticePack === pack.id ? (
                              <Loader2 className="animate-spin mr-1" size={12} />
                            ) : (
                              <CreditCard size={12} className="mr-1" />
                            )}
                            Acheter
                          </Button>
                        </CardContent>
                      </Card>
                    ))}
                  </div>
                ) : (
                  <Card className="border-dashed">
                    <CardContent className="py-6 text-center">
                      <p className="text-neutral-500 text-sm">Aucun pack disponible à l'achat en ligne</p>
                      <p className="text-neutral-400 text-xs mt-1">Achetez vos jetons directement à l'accueil</p>
                    </CardContent>
                  </Card>
                )}
              </>
            )}

            {/* Section Commandes Fitting */}
            {fittingOrders.length > 0 && (
              <>
                <div className="border-t border-neutral-200 my-2" />
                <div className="flex items-center justify-between px-1">
                  <h4 className="text-xs font-medium text-neutral-500 uppercase">Mes commandes Fitting</h4>
                </div>
                <div className="space-y-2">
                  {fittingOrders.map(order => (
                    <Card 
                      key={order.id} 
                      className={`cursor-pointer hover:shadow-md transition-all border-l-4 ${fittingPortalStatus(order).border}`}
                      onClick={() => {
                        setSelectedFittingOrder(order);
                        setShowFittingOrderModal(true);
                      }}
                    >
                      <CardContent className="p-3">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="font-semibold text-sm text-neutral-800">
                              Commande du {order.quote_date || 'N/A'}
                            </p>
                            <p className="text-xs text-neutral-500">
                              Fitting : {order.fitting_date || 'N/A'}
                            </p>
                          </div>
                          <div className="text-right">
                            <p className="font-bold text-emerald-600">
                              {(order.totals?.totalTTC || 0).toLocaleString('fr-FR')}€
                            </p>
                            <Badge variant="outline" className={`text-[10px] ${fittingPortalStatus(order).badge}`} data-testid={`portal-fitting-status-${order.id}`}>
                              {fittingPortalStatus(order).label}
                            </Badge>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              </>
            )}
          </div>
        )}

        {/* Competitions Tab — Design aligné sur la page publique (site vitrine) */}
        {activeTab === 'competitions' && (
          <div className="flex-1 overflow-y-auto px-3 sm:px-4 py-4 space-y-6" data-testid="competitions-tab" style={{ backgroundColor: '#F5F2EB' }}>
            {/* En-tête avec titre serif + toggle Mes inscriptions */}
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="font-bold uppercase" style={{ fontSize: '10px', color: '#999', letterSpacing: '0.12em' }}>Événements</p>
                <h1 className="font-serif text-2xl sm:text-3xl text-emerald-950 leading-tight mt-1">
                  Événements à venir
                </h1>
              </div>
              <Button
                variant={showMyCompRegistrations ? "default" : "outline"}
                size="sm"
                onClick={() => setShowMyCompRegistrations(!showMyCompRegistrations)}
                className="h-8 text-[11px] gap-1.5 rounded-full shrink-0"
                data-testid="comp-reservations-btn"
              >
                <History size={13} />
                Mes inscriptions ({competitions.filter(c => c.is_registered).length})
              </Button>
            </div>

            {/* Filtres pills — style vitrine */}
            <div className="flex flex-wrap gap-2">
              {[
                { id: 'all', label: 'Tous' },
                { id: 'competition', label: 'Compétitions' },
                { id: 'afterwork', label: 'Afterworks' },
                { id: 'atelier', label: 'Ateliers' },
              ].map(tab => (
                <button
                  key={tab.id}
                  onClick={() => setFilterCompType(tab.id)}
                  className={`px-3.5 py-1.5 text-[11px] uppercase tracking-wider font-medium transition-all rounded-full ${
                    filterCompType === tab.id
                      ? 'bg-emerald-950 text-stone-50'
                      : 'text-stone-600 border border-stone-300 hover:border-emerald-950 hover:text-emerald-950 bg-white'
                  }`}
                  data-testid={`portal-event-tab-${tab.id}`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {competitions.length === 0 ? (
              <div className="text-center py-16">
                <Calendar size={32} className="mx-auto text-stone-300 mb-3" />
                <p className="text-stone-500 text-xs">Aucun événement à venir pour le moment.</p>
              </div>
            ) : (() => {
              const DAY_SHORT = ['DIM.', 'LUN.', 'MAR.', 'MER.', 'JEU.', 'VEN.', 'SAM.'];
              const TYPE_ACCENT = {
                competition: 'text-amber-600',
                atelier: 'text-purple-600',
                afterwork: 'text-pink-600',
                initiation: 'text-emerald-600',
              };
              const buildTypeLabel = (c) => {
                if ((c.event_type || 'competition') !== 'competition') {
                  return c.event_type === 'afterwork' ? 'AFTERWORK' : c.event_type === 'atelier' ? 'ATELIER' : (c.event_type || '').toUpperCase();
                }
                return (c.formula || 'STABLEFORD').toUpperCase();
              };

              // Filtrer par type + toggle inscriptions
              let filteredComps = competitions;
              if (filterCompType !== 'all') {
                filteredComps = filteredComps.filter(c => (c.event_type || 'competition') === filterCompType);
              }
              if (showMyCompRegistrations) {
                filteredComps = filteredComps.filter(c => c.is_registered);
              }
              if (filteredComps.length === 0) {
                return (
                  <div className="text-center py-16">
                    <Calendar size={32} className="mx-auto text-stone-300 mb-3" />
                    <p className="text-stone-500 text-xs">{showMyCompRegistrations ? 'Aucune inscription' : 'Aucun événement dans cette catégorie'}</p>
                  </div>
                );
              }
              // Grouper par mois
              const grouped = {};
              const sortedComps = [...filteredComps].sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
              sortedComps.forEach(comp => {
                const date = comp.start_date ? parseISO(comp.start_date) : new Date();
                const key = format(date, 'yyyy-MM');
                const label = format(date, 'MMMM yyyy', { locale: fr }).toUpperCase();
                if (!grouped[key]) grouped[key] = { label, items: [] };
                grouped[key].items.push(comp);
              });
              const sortedKeys = Object.keys(grouped).sort();

              return (
                <div className="space-y-10">
                  {sortedKeys.map(key => {
                    const group = grouped[key];
                    return (
                      <section key={key} id={`comp-month-${key}`} data-month-key={key}>
                        {/* En-tête de mois — style vitrine */}
                        <div className="flex items-end justify-between gap-4 mb-4">
                          <div className="flex items-center gap-2.5">
                            <Calendar size={13} className="text-stone-400" strokeWidth={1.5} />
                            <h2 className="text-[11px] font-semibold tracking-[0.2em] text-stone-500">
                              {group.label}
                            </h2>
                          </div>
                          <div className="flex-1 border-b border-stone-200 mb-1.5"></div>
                          <span className="text-[10px] text-stone-400">
                            {group.items.length} {group.items.length > 1 ? 'événements' : 'événement'}
                          </span>
                        </div>

                        {/* Card blanc englobant tous les événements du mois */}
                        <div className="bg-white border border-stone-200 rounded-xl overflow-hidden">
                          {group.items.map((comp, idx) => {
                            const isFull = comp.max_participants && comp.registered_count >= comp.max_participants;
                            const isPast = comp.is_past;
                            const d = comp.start_date ? parseISO(comp.start_date) : null;
                            const dayShort = d ? DAY_SHORT[d.getDay()] : '';
                            const dayNum = d ? d.getDate() : '—';
                            const typeAccent = TYPE_ACCENT[comp.event_type || 'competition'] || 'text-stone-500';
                            const typeLabel = buildTypeLabel(comp);
                            const clickable = !isPast || comp.departs_pdf_url || comp.resultats_pdf_url;
                            const registered = comp.is_registered;
                            const awaitingPayment = registered && comp.my_registration?.payment_status === 'awaiting_payment';

                            return (
                              <div
                                key={comp.id}
                                onClick={() => {
                                  if (!clickable && !comp.open_to_portal) return;
                                  setSelectedCompetition(comp);
                                  setShowCompetitionModal(true);
                                  setSelectedPartner(null);
                                  setPartnerSearchQuery('');
                                  setPartnerSearchResults([]);
                                  setPayForPartner(true);
                                  setSelectedCustomOptions([]);
                                }}
                                className={`flex items-center gap-3 sm:gap-5 p-3 sm:p-4 transition-colors cursor-pointer ${
                                  idx > 0 ? 'border-t border-stone-100' : ''
                                } ${isPast ? 'opacity-60' : 'hover:bg-stone-50/50'}`}
                                data-testid={`competition-card-${comp.id}`}
                              >
                                {/* Date à gauche : jour court + numéro serif */}
                                <div className="flex flex-col items-center justify-center w-11 sm:w-14 flex-shrink-0">
                                  <span className="text-[9px] sm:text-[10px] italic tracking-wider text-stone-400 uppercase">
                                    {dayShort}
                                  </span>
                                  <span className="font-serif text-2xl sm:text-3xl text-emerald-950 leading-none mt-0.5">
                                    {dayNum}
                                  </span>
                                </div>

                                {/* Séparateur vertical fin */}
                                <div className="h-12 w-px bg-stone-200 flex-shrink-0 hidden sm:block"></div>

                                {/* Infos événement */}
                                <div className="flex-1 min-w-0">
                                  <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5 mb-1">
                                    <h3 className="text-sm sm:text-[15px] font-semibold text-emerald-950 leading-tight">
                                      {comp.name}
                                    </h3>
                                    {isPast && (
                                      <span className="text-[9px] uppercase tracking-wider font-semibold text-stone-400">Terminée</span>
                                    )}
                                    {comp.is_double && !isPast && (
                                      <span className="text-[9px] uppercase tracking-wider font-semibold text-sky-600">Double</span>
                                    )}
                                    {isFull && !registered && !isPast && (
                                      <span className="text-[9px] uppercase tracking-wider font-semibold text-red-500">Complet</span>
                                    )}
                                    {awaitingPayment ? (
                                      <span className="text-[9px] uppercase tracking-wider font-semibold text-orange-500">À payer</span>
                                    ) : registered ? (
                                      <span className="text-[9px] uppercase tracking-wider font-semibold text-emerald-600">Inscrit</span>
                                    ) : null}
                                  </div>

                                  {/* Type label en couleur (STABLEFORD / AFTERWORK / ATELIER) */}
                                  <div className={`text-[10px] uppercase tracking-[0.15em] font-semibold ${typeAccent} mb-1.5`}>
                                    {typeLabel}
                                  </div>

                                  {/* Ligne infos : heure • participants • prix */}
                                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-stone-500">
                                    {comp.start_time && (
                                      <span className="flex items-center gap-1">
                                        <Clock size={10} strokeWidth={1.5} />
                                        {comp.start_time}
                                      </span>
                                    )}
                                    {comp.max_participants > 0 && (
                                      <span className="flex items-center gap-1">
                                        <Users size={10} strokeWidth={1.5} />
                                        {comp.registered_count || 0}/{comp.max_participants}
                                      </span>
                                    )}
                                    {comp.open_to_portal && (
                                      <span className={`font-medium ${comp.client_price === 0 ? 'text-emerald-600' : 'text-stone-700'}`}>
                                        {comp.client_price === 0 ? 'Gratuit' : `${comp.client_price}€`}
                                      </span>
                                    )}
                                  </div>

                                  {/* Badges statut Inscrits/Départs/Résultats (priorité) + Photos (permanent).
                                      L'un remplace l'autre : Inscrits (défaut) → Départs (dispo) → Résultats (final).
                                      Photos reste visible en parallèle si la galerie contient des photos. */}
                                  {(() => {
                                    const hasResults = !!comp.resultats_pdf_url;
                                    const hasDeparts = !!comp.departs_pdf_url;
                                    const hasPhotos = (comp.media_photos || []).length > 0 || (comp.media_videos || []).length > 0;
                                    const showInscrits = !hasResults && !hasDeparts && (comp.event_type || 'competition') === 'competition' && (comp.registered_count || 0) > 0;
                                    if (!hasResults && !hasDeparts && !hasPhotos && !showInscrits) return null;
                                    return (
                                      <div className="flex flex-wrap gap-1.5 mt-2">
                                        {/* 1. Résultats (priorité 1) */}
                                        {hasResults && (
                                          <button
                                            type="button"
                                            onClick={(e) => { e.stopPropagation(); openPdf(comp.resultats_pdf_url, `${comp.name} — Résultats`); }}
                                            className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-semibold bg-emerald-600 text-white hover:bg-emerald-700 transition-colors"
                                            data-testid={`resultats-btn-${comp.id}`}
                                          >
                                            <Trophy size={10} strokeWidth={2} />
                                            Résultats
                                          </button>
                                        )}
                                        {/* 2. Départs (priorité 2, masqué si résultats dispo) */}
                                        {!hasResults && hasDeparts && (
                                          <button
                                            type="button"
                                            onClick={(e) => { e.stopPropagation(); openPdf(comp.departs_pdf_url, `${comp.name} — Départs`); }}
                                            className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-semibold bg-blue-600 text-white hover:bg-blue-700 transition-colors"
                                            data-testid={`departs-btn-${comp.id}`}
                                          >
                                            <FileText size={10} strokeWidth={2} />
                                            Départs
                                          </button>
                                        )}
                                        {/* 3. Inscrits (défaut, tant qu'aucun PDF n'est publié) — ouvre directement la modale participants */}
                                        {showInscrits && (
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setSelectedCompetition(comp);
                                              setShowCompetitionParticipantsModal(true);
                                            }}
                                            className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-semibold bg-emerald-900 text-white hover:bg-emerald-950 transition-colors"
                                            data-testid={`inscrits-btn-${comp.id}`}
                                          >
                                            <Users size={10} strokeWidth={2} />
                                            Inscrits ({comp.registered_count || 0})
                                          </button>
                                        )}
                                        {/* Photos — permanent tant qu'il y a du contenu */}
                                        {hasPhotos && (
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setSelectedCompetition(comp);
                                              setShowCompetitionModal(true);
                                              setSelectedPartner(null);
                                              setPartnerSearchQuery('');
                                              setPartnerSearchResults([]);
                                              setPayForPartner(true);
                                              setSelectedCustomOptions([]);
                                            }}
                                            className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-semibold bg-purple-600 text-white hover:bg-purple-700 transition-colors"
                                            data-testid={`photos-btn-${comp.id}`}
                                            title={`${(comp.media_photos || []).length} photo(s)${(comp.media_videos || []).length > 0 ? `, ${(comp.media_videos || []).length} vidéo(s)` : ''}`}
                                          >
                                            <ImageIcon size={10} strokeWidth={2} />
                                            Photos {(comp.media_photos || []).length > 0 ? `(${(comp.media_photos || []).length})` : ''}
                                          </button>
                                        )}
                                      </div>
                                    );
                                  })()}
                                </div>

                                {/* Bouton S'INSCRIRE outline (masqué si passé/complet/déjà inscrit) */}
                                {!isPast && !registered && comp.open_to_portal && !isFull && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedCompetition(comp);
                                      setShowCompetitionModal(true);
                                      setSelectedPartner(null);
                                      setPartnerSearchQuery('');
                                      setPartnerSearchResults([]);
                                      setPayForPartner(true);
                                      setSelectedCustomOptions([]);
                                    }}
                                    className="hidden sm:inline-flex flex-shrink-0 items-center gap-1.5 px-3 sm:px-4 py-1.5 sm:py-2 border border-emerald-950 text-[10px] sm:text-[11px] uppercase tracking-wider font-semibold text-emerald-950 hover:bg-emerald-950 hover:text-stone-50 transition-colors"
                                    data-testid={`register-btn-${comp.id}`}
                                  >
                                    S&apos;inscrire
                                  </button>
                                )}
                                {!comp.open_to_portal && !isPast && (
                                  <span className="hidden sm:inline text-[10px] bg-blue-50 text-blue-600 font-medium px-2 py-0.5 rounded flex-shrink-0">Programme</span>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </section>
                    );
                  })}
                </div>
              );
            })()}
          </div>
        )}
        
        {/* Competition Modal */}
        <Dialog open={showCompetitionModal} onOpenChange={setShowCompetitionModal}>
          <DialogContent className="max-w-md max-h-[90vh] flex flex-col p-0">
            <DialogHeader className="p-6 pb-0">
              <DialogTitle className="flex items-center gap-2">
                <Trophy size={20} className="text-orange-500" />
                {selectedCompetition?.name}
              </DialogTitle>
            </DialogHeader>
            
            {selectedCompetition && (
              <div className="flex-1 overflow-y-auto p-6 pt-4 pb-32 space-y-4" style={{ WebkitOverflowScrolling: 'touch' }}>
                {/* Photo de couverture cliquable */}
                {selectedCompetition.cover_image && (
                  <img
                    src={resolveCoverSrc(selectedCompetition.cover_image)}
                    alt={selectedCompetition.name}
                    className="w-full h-40 object-cover rounded-lg cursor-pointer hover:opacity-90 transition-opacity"
                    onClick={() => setCoverImageZoom(resolveCoverSrc(selectedCompetition.cover_image))}
                  />
                )}
                {/* Galerie photos & vidéos (visible seulement si contenu disponible) */}
                <EventGallery
                  competitionId={selectedCompetition.id}
                  photos={selectedCompetition.media_photos || []}
                  videos={selectedCompetition.media_videos || []}
                  editable={false}
                />
                {/* Date + Heure */}
                <div className="flex items-center gap-2 text-sm">
                  <Calendar size={16} className="text-neutral-400" />
                  <span>
                    {selectedCompetition.start_date && format(parseISO(selectedCompetition.start_date), 'EEEE d MMMM yyyy', { locale: fr })}
                    {selectedCompetition.end_date && selectedCompetition.end_date !== selectedCompetition.start_date && (
                      <> au {format(parseISO(selectedCompetition.end_date), 'd MMMM', { locale: fr })}</>
                    )}
                    {selectedCompetition.start_time && (
                      <span className="ml-1 text-neutral-600">
                        — {((selectedCompetition.event_type || 'competition') === 'atelier' || (selectedCompetition.event_type || 'competition') === 'afterwork' || selectedCompetition.depart_type === 'shotgun') ? 'Début' : '1er départ'} : {selectedCompetition.start_time}
                      </span>
                    )}
                  </span>
                </div>
                
                {/* Formule + Trous + Type de départ — masqué pour ateliers ; Trous/Départ masqués pour afterworks */}
                {(selectedCompetition.event_type || 'competition') !== 'atelier' && (selectedCompetition.formula || selectedCompetition.nombre_trous || selectedCompetition.depart_type) && (
                  <div className="flex items-center gap-2 text-sm flex-wrap">
                    <Globe size={16} className="text-neutral-400 flex-shrink-0" />
                    {selectedCompetition.formula && (
                      <span className="font-medium text-primary">{selectedCompetition.formula}</span>
                    )}
                    {(selectedCompetition.event_type || 'competition') !== 'afterwork' && selectedCompetition.nombre_trous && (
                      <>
                        <span className="text-neutral-300">•</span>
                        <span className="text-neutral-600">{selectedCompetition.nombre_trous} trous</span>
                      </>
                    )}
                    {(selectedCompetition.event_type || 'competition') !== 'afterwork' && selectedCompetition.depart_type && (
                      <>
                        <span className="text-neutral-300">•</span>
                        <span className="text-neutral-600">{selectedCompetition.depart_type === 'shotgun' ? 'Shotgun' : 'Départ différé'}</span>
                      </>
                    )}
                  </div>
                )}
                
                {/* Places */}
                {selectedCompetition.max_participants && (
                  <div className="flex items-center gap-2 text-sm">
                    <Users size={16} className="text-neutral-400" />
                    <span>{selectedCompetition.registered_count} / {selectedCompetition.max_participants} inscrits</span>
                  </div>
                )}
                
                {/* Date limite */}
                {selectedCompetition.registration_deadline && (
                  <div className="flex items-center gap-2 text-sm">
                    <AlertCircle size={16} className="text-amber-500" />
                    <span>Inscription avant le {format(parseISO(selectedCompetition.registration_deadline), 'd MMMM', { locale: fr })}</span>
                  </div>
                )}
                
                {/* Description */}
                {selectedCompetition.description && (
                  <div className="p-3 bg-neutral-50 rounded-lg">
                    <p className="text-sm text-neutral-600 whitespace-pre-line">{selectedCompetition.description}</p>
                  </div>
                )}
                
                {/* Liens : Inscrits + Départs + Résultats */}
                <div className="flex items-center gap-2 flex-wrap">
                  <button
                    onClick={() => { setShowCompetitionParticipantsModal(true); }}
                    className="flex items-center gap-1.5 px-4 py-2.5 rounded-lg text-sm font-medium border-2 border-amber-400 bg-amber-50 text-amber-700 hover:bg-amber-100 transition-colors"
                    data-testid="modal-list-inscrits-link"
                  >
                    <Users size={14} />
                    Voir liste inscrits
                  </button>
                  {selectedCompetition.departs_pdf_url && (
                    <button
                      onClick={() => openPdf(selectedCompetition.departs_pdf_url, `${selectedCompetition.name} — Départs`)}
                      className="flex items-center gap-1.5 px-4 py-2.5 rounded-lg text-sm font-medium border-2 border-blue-400 bg-blue-50 text-blue-700 hover:bg-blue-100 transition-colors"
                      data-testid="modal-departs-pdf-link"
                    >
                      <FileText size={14} />
                      Voir départs
                    </button>
                  )}
                  {selectedCompetition.resultats_pdf_url && (
                    <button
                      onClick={() => openPdf(selectedCompetition.resultats_pdf_url, `${selectedCompetition.name} — Résultats`)}
                      className="flex items-center gap-1.5 px-4 py-2.5 rounded-lg text-sm font-medium border-2 border-emerald-400 bg-emerald-50 text-emerald-700 hover:bg-emerald-100 transition-colors"
                      data-testid="modal-resultats-pdf-link"
                    >
                      <FileText size={14} />
                      Voir résultats
                    </button>
                  )}
                </div>
                
                {/* Prix */}
                <div className="p-3 bg-primary/5 rounded-lg">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-neutral-600">Tarif</span>
                    <div className="text-right">
                      <span className="text-xl font-bold text-primary">
                        {selectedCompetition.client_price === 0 ? 'À définir' : `${selectedCompetition.client_price}€`}
                      </span>
                      {selectedCompetition.is_member_price !== null && (
                        <Badge className={`ml-2 text-[9px] ${selectedCompetition.is_member_price ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}`}>
                          {selectedCompetition.is_member_price ? 'Membre' : 'Non-membre'}
                        </Badge>
                      )}
                    </div>
                  </div>
                  {selectedCompetition.member_price !== null && selectedCompetition.non_member_price !== null && (
                    <p className="text-[10px] text-neutral-400 mt-1">
                      Membre: {selectedCompetition.member_price}€ | Non-membre: {selectedCompetition.non_member_price}€
                    </p>
                  )}
                </div>
                
                {/* Actions */}
                <div className="pt-2">
                  {selectedCompetition.is_past ? (
                    <div className="text-center p-3 bg-neutral-100 rounded-lg">
                      <Trophy size={24} className="mx-auto text-neutral-400 mb-1" />
                      <p className="font-medium text-neutral-500">Compétition terminée</p>
                      {selectedCompetition.resultats_pdf_url && (
                        <p className="text-xs text-emerald-600 mt-1">Consultez les résultats ci-dessus</p>
                      )}
                    </div>
                  ) : !selectedCompetition.open_to_portal ? (
                    <div className="text-center p-3 bg-blue-50 rounded-lg">
                      <Eye size={24} className="mx-auto text-blue-400 mb-1" />
                      <p className="font-medium text-blue-700">Inscriptions pas encore ouvertes</p>
                      <p className="text-xs text-neutral-500 mt-1">Les inscriptions seront bientôt disponibles</p>
                    </div>
                  ) : selectedCompetition.is_registered ? (
                    <div className="space-y-2">
                      {/* Vérifier si c'est un partenaire inscrit mais à payer */}
                      {selectedCompetition.my_registration?.payment_status === 'awaiting_payment' ? (
                        <>
                          <div className="text-center p-3 bg-orange-50 rounded-lg">
                            <AlertCircle className="w-8 h-8 mx-auto text-orange-500 mb-1" />
                            <p className="font-medium text-orange-700">Inscrit - Paiement en attente</p>
                            {selectedCompetition.my_registration.team_partner_name && (
                              <p className="text-xs text-neutral-500 mt-1">
                                Inscrit par {selectedCompetition.my_registration.team_partner_name}
                              </p>
                            )}
                            {selectedCompetition.my_registration.price > 0 && (
                              <p className="text-sm font-semibold text-orange-600 mt-1">{selectedCompetition.my_registration.price}€</p>
                            )}
                          </div>
                          <AccountPayChoice total={selectedCompetition.my_registration.price || 0} balance={accountBalance} useAccount={useAccountPay} onChange={setUseAccountPay} testId="paymy-account-pay" />
                          <Button 
                            className="w-full"
                            onClick={() => handlePayMyRegistration(selectedCompetition.id)}
                            disabled={competitionRegistrationLoading}
                            data-testid="pay-my-registration-btn"
                          >
                            {competitionRegistrationLoading ? (
                              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
                            ) : (
                              <CreditCard size={16} className="mr-2" />
                            )}
                            Payer mon inscription - {selectedCompetition.my_registration.price}€
                          </Button>
                        </>
                      ) : (
                        <>
                          <div className="text-center p-3 bg-green-50 rounded-lg">
                            <CheckCircle2 className="w-8 h-8 mx-auto text-green-600 mb-1" />
                            <p className="font-medium text-green-700">Vous êtes inscrit !</p>
                            {selectedCompetition.my_registration?.team_partner_name && (
                              <p className="text-xs text-neutral-500 mt-1">
                                Partenaire: {selectedCompetition.my_registration.team_partner_name}
                              </p>
                            )}
                          </div>
                          {/* 🎯 iter228 : lien "Modifier ma réservation" (partenaire, accompagnants, notes) */}
                          {selectedCompetition.my_registration?.manage_token && (
                            <Button
                              variant="outline"
                              className="w-full"
                              data-testid="portal-comp-manage-btn"
                              onClick={() => window.open(clubPath(`/reservation/gerer/${selectedCompetition.my_registration.manage_token}`), '_blank', 'noopener')}
                            >
                              <Edit3 size={16} className="mr-2" />
                              Modifier ma réservation
                            </Button>
                          )}
                          <Button 
                            variant="outline" 
                            className="w-full text-red-600 border-red-200 hover:bg-red-50"
                            onClick={() => handleCancelCompetitionRegistration(selectedCompetition.id)}
                          >
                            <XCircle size={16} className="mr-2" />
                            Annuler mon inscription
                          </Button>
                        </>
                      )}
                    </div>
                  ) : (
                    <>
                      {selectedCompetition.max_participants && selectedCompetition.registered_count >= selectedCompetition.max_participants ? (
                        <div className="text-center p-3 bg-red-50 rounded-lg">
                          <XCircle className="w-8 h-8 mx-auto text-red-400 mb-1" />
                          <p className="font-medium text-red-600">Compétition complète</p>
                        </div>
                      ) : selectedCompetition.registration_deadline && isBefore(parseISO(selectedCompetition.registration_deadline), new Date()) ? (
                        <div className="text-center p-3 bg-amber-50 rounded-lg">
                          <AlertCircle className="w-8 h-8 mx-auto text-amber-400 mb-1" />
                          <p className="font-medium text-amber-600">Inscriptions closes</p>
                        </div>
                      ) : (
                        <div className="space-y-3">
                          {/* Recherche partenaire pour compétition double */}
                          {selectedCompetition.is_double && (
                            <div className="p-3 bg-violet-50 rounded-lg border border-violet-200 space-y-2">
                              <label className="block text-sm font-medium text-violet-700">
                                <Users size={14} className="inline mr-1" />
                                {externalPartnerMode ? 'Partenaire extérieur' : 'Rechercher votre partenaire'}
                              </label>
                              {!externalPartnerMode && (
                              <div className="relative">
                                <input
                                  type="text"
                                  className="w-full px-3 py-2 border rounded-lg text-sm pr-8"
                                  placeholder="Tapez un nom ou prénom..."
                                  value={partnerSearchQuery}
                                  onChange={(e) => handlePartnerSearch(e.target.value)}
                                  data-testid="partner-search-input"
                                />
                                {partnerSearchLoading && (
                                  <div className="absolute right-2 top-2.5 animate-spin rounded-full h-4 w-4 border-b-2 border-violet-500" />
                                )}
                                {selectedPartner && (
                                  <Check size={14} className="absolute right-2 top-2.5 text-green-500" />
                                )}
                              </div>
                              )}
                              
                              {/* Résultats de recherche */}
                              {partnerSearchResults.length > 0 && !selectedPartner && !externalPartnerMode && (
                                <div className="bg-white border rounded-md shadow-lg max-h-36 overflow-y-auto">
                                  {partnerSearchResults.map(p => (
                                    <button
                                      key={p.id}
                                      type="button"
                                      onClick={() => {
                                        setSelectedPartner(p);
                                        setPartnerSearchQuery(`${p.first_name} ${p.last_name}`.trim());
                                        setPartnerSearchResults([]);
                                      }}
                                      disabled={p.already_registered}
                                      className={`w-full text-left px-3 py-2 text-xs border-b last:border-b-0 ${
                                        p.already_registered 
                                          ? 'opacity-50 cursor-not-allowed bg-neutral-50' 
                                          : 'hover:bg-violet-50 cursor-pointer'
                                      }`}
                                      data-testid={`partner-result-${p.id}`}
                                    >
                                      <div className="flex items-center justify-between">
                                        <div>
                                          <span className="font-medium">{p.first_name} {p.last_name}</span>
                                          {p.email && <span className="text-neutral-400 ml-2">{p.email}</span>}
                                        </div>
                                        <div className="flex items-center gap-1.5">
                                          <span className={`text-[10px] px-1.5 py-0.5 rounded ${p.is_member ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}`}>
                                            {p.is_member ? 'Membre' : 'Non-membre'}
                                          </span>
                                          <span className="font-medium text-primary">{p.partner_price}€</span>
                                          {p.already_registered && <span className="text-red-500 text-[10px]">Déjà inscrit</span>}
                                        </div>
                                      </div>
                                    </button>
                                  ))}
                                </div>
                              )}
                              
                              {/* Lien partenaire extérieur */}
                              {!selectedPartner && !externalPartnerMode && (
                                <button
                                  type="button"
                                  onClick={() => { setExternalPartnerMode(true); setPartnerSearchQuery(''); setPartnerSearchResults([]); }}
                                  className="text-xs text-violet-600 hover:text-violet-800 underline mt-1"
                                  data-testid="external-partner-toggle"
                                >
                                  Partenaire extérieur ?
                                </button>
                              )}

                              {/* Formulaire partenaire extérieur */}
                              {externalPartnerMode && (
                                <div className="bg-violet-50 border border-violet-200 rounded-lg p-3 space-y-2">
                                  <div className="flex items-center justify-between">
                                    <p className="text-xs font-medium text-violet-800">Partenaire extérieur (non-membre)</p>
                                    <button
                                      type="button"
                                      onClick={() => { setExternalPartnerMode(false); setExternalPartnerData({ first_name: '', last_name: '', email: '', phone: '' }); }}
                                      className="text-neutral-400 hover:text-red-500"
                                    >
                                      <XCircle size={14} />
                                    </button>
                                  </div>
                                  <div className="grid grid-cols-2 gap-2">
                                    <input
                                      type="text"
                                      className="w-full px-3 py-2 border rounded-lg text-sm"
                                      placeholder="Prénom *"
                                      value={externalPartnerData.first_name}
                                      onChange={(e) => setExternalPartnerData(prev => ({ ...prev, first_name: e.target.value }))}
                                      data-testid="external-partner-firstname"
                                    />
                                    <input
                                      type="text"
                                      className="w-full px-3 py-2 border rounded-lg text-sm"
                                      placeholder="Nom *"
                                      value={externalPartnerData.last_name}
                                      onChange={(e) => setExternalPartnerData(prev => ({ ...prev, last_name: e.target.value }))}
                                      data-testid="external-partner-lastname"
                                    />
                                  </div>
                                  <input
                                    type="email"
                                    className="w-full px-3 py-2 border rounded-lg text-sm"
                                    placeholder="Email"
                                    value={externalPartnerData.email}
                                    onChange={(e) => setExternalPartnerData(prev => ({ ...prev, email: e.target.value }))}
                                    data-testid="external-partner-email"
                                  />
                                  <input
                                    type="tel"
                                    className="w-full px-3 py-2 border rounded-lg text-sm"
                                    placeholder="Téléphone"
                                    value={externalPartnerData.phone}
                                    onChange={(e) => setExternalPartnerData(prev => ({ ...prev, phone: e.target.value }))}
                                    data-testid="external-partner-phone"
                                  />
                                  {selectedCompetition.non_member_price != null && (
                                    <p className="text-[10px] text-amber-600 font-medium">
                                      Tarif non-membre : {selectedCompetition.non_member_price}€
                                    </p>
                                  )}
                                </div>
                              )}
                              
                              {/* Partenaire sélectionné */}
                              {selectedPartner && !externalPartnerMode && (
                                <div className="flex items-center justify-between bg-white p-2 rounded-lg border border-violet-300">
                                  <div className="flex items-center gap-2">
                                    <div className="w-7 h-7 rounded-full bg-violet-100 flex items-center justify-center text-violet-600 text-xs font-medium">
                                      {(selectedPartner.first_name || '?')[0].toUpperCase()}
                                    </div>
                                    <div>
                                      <p className="text-sm font-medium">{selectedPartner.first_name} {selectedPartner.last_name}</p>
                                      <p className="text-[10px] text-neutral-500">
                                        {selectedPartner.is_member ? 'Membre' : 'Non-membre'} - {selectedPartner.partner_price}€
                                      </p>
                                    </div>
                                  </div>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setSelectedPartner(null);
                                      setPartnerSearchQuery('');
                                      setPartnerSearchResults([]);
                                    }}
                                    className="text-neutral-400 hover:text-red-500"
                                  >
                                    <XCircle size={16} />
                                  </button>
                                </div>
                              )}
                              
                              {/* Options de paiement si partenaire sélectionné */}
                              {selectedPartner && (
                                <div className="space-y-1.5 mt-2">
                                  <p className="text-xs font-medium text-violet-700">Qui paie ?</p>
                                  <label className={`flex items-center gap-2 p-2 rounded-lg border-2 cursor-pointer transition-colors ${payForPartner ? 'border-primary bg-primary/5' : 'border-neutral-200'}`}>
                                    <input
                                      type="radio"
                                      name="payment_option"
                                      checked={payForPartner}
                                      onChange={() => setPayForPartner(true)}
                                      className="accent-primary"
                                    />
                                    <div>
                                      <p className="text-xs font-medium">Payer pour les 2</p>
                                      <p className="text-[10px] text-neutral-500">
                                        Total: {(selectedCompetition.client_price || 0) + (selectedPartner.partner_price || 0)}€ ({selectedCompetition.client_price}€ + {selectedPartner.partner_price}€)
                                      </p>
                                    </div>
                                  </label>
                                  <label className={`flex items-center gap-2 p-2 rounded-lg border-2 cursor-pointer transition-colors ${!payForPartner ? 'border-primary bg-primary/5' : 'border-neutral-200'}`}>
                                    <input
                                      type="radio"
                                      name="payment_option"
                                      checked={!payForPartner}
                                      onChange={() => setPayForPartner(false)}
                                      className="accent-primary"
                                    />
                                    <div>
                                      <p className="text-xs font-medium">Payer uniquement pour moi</p>
                                      <p className="text-[10px] text-neutral-500">
                                        {selectedCompetition.client_price}€ - Votre partenaire recevra un email pour payer {selectedPartner.partner_price}€
                                      </p>
                                    </div>
                                  </label>
                                </div>
                              )}
                              
                              {/* Résumé prix partenaire extérieur - options de paiement */}
                              {externalPartnerMode && externalPartnerData.first_name && externalPartnerData.last_name && (
                                <div className="space-y-1.5 mt-2">
                                  <p className="text-xs font-medium text-violet-700">Qui paie ?</p>
                                  <label className={`flex items-center gap-2 p-2 rounded-lg border-2 cursor-pointer transition-colors ${payForPartner ? 'border-primary bg-primary/5' : 'border-neutral-200'}`}>
                                    <input
                                      type="radio"
                                      name="ext_payment_option"
                                      checked={payForPartner}
                                      onChange={() => setPayForPartner(true)}
                                      className="accent-primary"
                                    />
                                    <div>
                                      <p className="text-xs font-medium">Payer pour les 2</p>
                                      <p className="text-[10px] text-neutral-500">
                                        Total: {(selectedCompetition.client_price || 0) + (selectedCompetition.non_member_price || selectedCompetition.client_price || 0)}€ ({selectedCompetition.client_price}€ + {selectedCompetition.non_member_price || selectedCompetition.client_price || 0}€)
                                      </p>
                                    </div>
                                  </label>
                                  <label className={`flex items-center gap-2 p-2 rounded-lg border-2 cursor-pointer transition-colors ${!payForPartner ? 'border-primary bg-primary/5' : 'border-neutral-200'}`}>
                                    <input
                                      type="radio"
                                      name="ext_payment_option"
                                      checked={!payForPartner}
                                      onChange={() => setPayForPartner(false)}
                                      className="accent-primary"
                                    />
                                    <div>
                                      <p className="text-xs font-medium">Payer uniquement pour moi</p>
                                      <p className="text-[10px] text-neutral-500">
                                        {selectedCompetition.client_price}€ - Votre partenaire recevra un email pour payer {selectedCompetition.non_member_price || selectedCompetition.client_price || 0}€
                                      </p>
                                    </div>
                                  </label>
                                </div>
                              )}
                            </div>
                          )}
                          
                          {/* Options personnalisées (ateliers) */}
                          {selectedCompetition.custom_options && selectedCompetition.custom_options.length > 0 && (
                            <div className="p-3 bg-amber-50 rounded-lg border border-amber-200">
                              <label className="block text-sm font-medium text-slate-700 mb-2">
                                {selectedCompetition.custom_options_label || 'Choisissez votre option'}
                                {selectedCompetition.custom_options_required && <span className="text-red-500 ml-1">*</span>}
                              </label>
                              <div className="space-y-1.5">
                                {selectedCompetition.custom_options.map((opt, idx) => (
                                  <label key={idx} className="flex items-center gap-2 cursor-pointer p-1.5 rounded hover:bg-amber-100/50">
                                    <input
                                      type={selectedCompetition.custom_options_mode === 'multiple' ? 'checkbox' : 'radio'}
                                      name="custom-option"
                                      checked={selectedCustomOptions.includes(opt.label)}
                                      onChange={() => {
                                        if (selectedCompetition.custom_options_mode === 'multiple') {
                                          setSelectedCustomOptions(prev =>
                                            prev.includes(opt.label) ? prev.filter(o => o !== opt.label) : [...prev, opt.label]
                                          );
                                        } else {
                                          setSelectedCustomOptions([opt.label]);
                                        }
                                      }}
                                      className="w-4 h-4 text-amber-600"
                                    />
                                    <span className="text-sm text-slate-700">{opt.label}</span>
                                  </label>
                                ))}
                              </div>
                              {selectedCompetition.custom_options_required && selectedCustomOptions.length === 0 && (
                                <p className="text-[10px] text-red-500 mt-1.5">Veuillez faire un choix pour continuer</p>
                              )}
                            </div>
                          )}

                          {/* Remarque / Note */}
                          <div className="p-3 bg-slate-50 rounded-lg border border-slate-200">
                            <label className="block text-sm font-medium text-slate-700 mb-1">Remarque (optionnel)</label>
                            <textarea
                              data-testid="competition-notes-input"
                              value={competitionNotes}
                              onChange={e => setCompetitionNotes(e.target.value)}
                              placeholder="Ex: personne supplementaire pour le repas, allergies alimentaires, regime particulier..."
                              rows={2}
                              className="w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary resize-none"
                            />
                          </div>

                          {/* Accompagnants — afterworks gratuits uniquement */}
                          {selectedCompetition?.event_type === 'afterwork' && parseFloat(selectedCompetition?.member_price ?? selectedCompetition?.price ?? 0) === 0 && parseFloat(selectedCompetition?.non_member_price ?? selectedCompetition?.member_price ?? selectedCompetition?.price ?? 0) === 0 && (
                            <div className="p-3 bg-emerald-50 rounded-lg border border-emerald-200" data-testid="portal-evt-guests-block">
                              <div className="flex items-start gap-2 mb-2">
                                <Users size={14} className="text-emerald-700 flex-shrink-0 mt-0.5" />
                                <div>
                                  <p className="text-sm font-semibold text-emerald-900">Accompagnants (facultatif)</p>
                                  <p className="text-[11px] text-emerald-700/80 leading-snug mt-0.5">Invitez d'autres membres ou des invités. Chacun compte dans le total.</p>
                                </div>
                              </div>

                              {selectedAfterworkGuests.length > 0 && (
                                <div className="flex flex-wrap gap-1.5 mb-2">
                                  {selectedAfterworkGuests.map((c) => (
                                    <span key={c.id} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-white border border-emerald-300 text-xs text-emerald-900">
                                      {c.name}
                                      <button type="button" onClick={() => setSelectedAfterworkGuests((s) => s.filter((x) => x.id !== c.id))} className="ml-0.5 text-emerald-700 hover:text-rose-600" aria-label="Retirer">×</button>
                                    </span>
                                  ))}
                                </div>
                              )}

                              <div className="relative mb-2">
                                <input
                                  value={afterworkGuestSearch}
                                  onChange={(e) => setAfterworkGuestSearch(e.target.value)}
                                  placeholder="Rechercher un membre par nom ou email…"
                                  data-testid="portal-evt-guest-search"
                                  className="w-full px-2 py-1.5 border border-emerald-200 rounded-md text-xs focus:outline-none focus:border-emerald-500"
                                />
                                {afterworkGuestResults.length > 0 && (
                                  <div className="absolute z-20 left-0 right-0 mt-1 bg-white border border-emerald-200 rounded-md shadow-lg max-h-40 overflow-y-auto">
                                    {afterworkGuestResults.map((c) => (
                                      <button
                                        type="button"
                                        key={c.id}
                                        onClick={() => {
                                          setSelectedAfterworkGuests((s) => [...s, { id: c.id, name: `${c.first_name} ${c.last_name}`.trim() }]);
                                          setAfterworkGuestSearch('');
                                          setAfterworkGuestResults([]);
                                        }}
                                        data-testid={`portal-evt-guest-pick-${c.id}`}
                                        className="w-full text-left px-2 py-1.5 text-xs hover:bg-emerald-50 border-b border-stone-100 last:border-b-0"
                                      >
                                        <span className="font-medium text-emerald-900">{c.first_name} {c.last_name}</span>
                                        {c.email && <span className="text-stone-500"> · {c.email}</span>}
                                      </button>
                                    ))}
                                  </div>
                                )}
                                {afterworkGuestSearching && <p className="text-[10px] text-emerald-700/70 mt-1 italic">Recherche…</p>}
                              </div>

                              <div className="flex items-center justify-between p-2 bg-white border border-emerald-200 rounded-md">
                                <div>
                                  <p className="text-xs font-medium text-emerald-900">Invités (anonymes)</p>
                                  <p className="text-[10px] text-stone-500">Sans nom requis — comptent dans le total.</p>
                                </div>
                                <div className="flex items-center gap-1.5">
                                  <button
                                    type="button"
                                    onClick={() => setAfterworkGuestsCount((n) => Math.max(0, n - 1))}
                                    className="w-7 h-7 rounded-full border border-emerald-300 text-emerald-800 leading-none flex items-center justify-center hover:bg-emerald-50"
                                    data-testid="portal-evt-guests-minus"
                                    aria-label="Retirer un invité"
                                  >−</button>
                                  <span className="min-w-[24px] text-center font-semibold text-emerald-900" data-testid="portal-evt-guests-count">{afterworkGuestsCount}</span>
                                  <button
                                    type="button"
                                    onClick={() => setAfterworkGuestsCount((n) => Math.min(20, n + 1))}
                                    className="w-7 h-7 rounded-full border border-emerald-300 text-emerald-800 leading-none flex items-center justify-center hover:bg-emerald-50"
                                    data-testid="portal-evt-guests-plus"
                                    aria-label="Ajouter un invité"
                                  >+</button>
                                </div>
                              </div>

                              {(selectedAfterworkGuests.length + afterworkGuestsCount) > 0 && (
                                <p className="mt-2 text-[11px] text-emerald-900 font-medium">
                                  Total inscrits via vous : <strong>{1 + selectedAfterworkGuests.length + afterworkGuestsCount}</strong> personne{(1 + selectedAfterworkGuests.length + afterworkGuestsCount) > 1 ? 's' : ''}.
                                </p>
                              )}
                            </div>
                          )}

                          <AccountPayChoice
                            total={(selectedCompetition.client_price || 0) + (selectedCompetition.is_double && payForPartner ? (selectedPartner ? (selectedPartner.partner_price || 0) : (externalPartnerMode && externalPartnerData.first_name && externalPartnerData.last_name ? (selectedCompetition.non_member_price || selectedCompetition.client_price || 0) : 0)) : 0)}
                            balance={accountBalance} useAccount={useAccountPay} onChange={setUseAccountPay} testId="competition-account-pay" />
                          <Button 
                            className="w-full whitespace-normal h-auto py-2 min-w-0"
                            onClick={() => handleRegisterCompetition(selectedCompetition.id)}
                            disabled={competitionRegistrationLoading || (selectedCompetition.is_double && !selectedPartner && !(externalPartnerMode && externalPartnerData.first_name.trim() && externalPartnerData.last_name.trim()))}
                            data-testid="competition-register-btn"
                          >
                            {competitionRegistrationLoading ? (
                              <>
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
                                Inscription en cours...
                              </>
                            ) : (
                              <>
                                <Check size={16} className="mr-2" />
                                {(() => {
                                  const compTotal = (selectedCompetition.client_price || 0) + (selectedCompetition.is_double && payForPartner ? (selectedPartner ? (selectedPartner.partner_price || 0) : (externalPartnerMode && externalPartnerData.first_name && externalPartnerData.last_name ? (selectedCompetition.non_member_price || selectedCompetition.client_price || 0) : 0)) : 0);
                                  if (compTotal <= 0) return "S'inscrire (gratuit)";
                                  const lbl = payLabel(compTotal, accountBalance, useAccountPay, '');
                                  return (lbl || `Payer ${compTotal}€`).replace('Payer', "S'inscrire et payer").replace('Confirmer —', "S'inscrire —").trim();
                                })()}
                              </>
                            )}
                          </Button>
                          {selectedCompetition.is_double && !selectedPartner && !externalPartnerMode && (
                            <p className="text-[10px] text-amber-600 text-center">Veuillez sélectionner un partenaire pour vous inscrire</p>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>


        {/* Modal zoom image couverture plein écran — rendu via portail pour passer au-dessus du Dialog */}
        {coverImageZoom && ReactDOM.createPortal(
          <div
            className="fixed inset-0 flex items-center justify-center p-4 cursor-pointer"
            style={{ zIndex: 999999, backgroundColor: 'rgba(0,0,0,0.92)' }}
            onClick={() => setCoverImageZoom(null)}
            data-testid="cover-image-zoom"
          >
            <img
              src={coverImageZoom}
              alt="Photo de couverture"
              className="max-w-full max-h-full object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
            <button
              onClick={() => setCoverImageZoom(null)}
              className="absolute top-4 right-4 text-white bg-black/50 rounded-full w-10 h-10 flex items-center justify-center hover:bg-black/70 text-lg font-bold"
            >
              ✕
            </button>
          </div>,
          document.body
        )}


        {/* Modal liste des participants d'une compétition */}
        <Dialog open={showCompetitionParticipantsModal} onOpenChange={setShowCompetitionParticipantsModal}>
          <DialogContent className="sm:max-w-sm max-h-[85vh] overflow-hidden flex flex-col">
            <DialogHeader className="pb-2">
              <DialogTitle className="flex items-center gap-2 text-base">
                <Users size={16} className="text-amber-500" />
                Inscrits
                {!loadingParticipants && (
                  <Badge variant="outline" className="text-[10px] ml-1">{participantsTotalSeats}</Badge>
                )}
              </DialogTitle>
              {selectedCompetition && (
                <p className="text-xs text-neutral-500">{selectedCompetition.name}</p>
              )}
            </DialogHeader>
            
            <div className="flex-1 overflow-y-auto -mx-6 px-6">
              {loadingParticipants ? (
                <div className="flex items-center justify-center py-8">
                  <Loader2 className="animate-spin text-amber-500" size={20} />
                </div>
              ) : competitionParticipants.length === 0 ? (
                <div className="text-center py-6">
                  <Users size={24} className="mx-auto text-neutral-300 mb-1" />
                  <p className="text-neutral-500 text-xs">Aucun participant inscrit</p>
                </div>
              ) : (
                <div className="space-y-px">
                  {(() => {
                    // Grouper par team_id si compétition double
                    if (isDoubleParticipantsView) {
                      const teams = {};
                      const solos = [];
                      competitionParticipants.forEach(p => {
                        if (p.team_id) {
                          if (!teams[p.team_id]) teams[p.team_id] = [];
                          teams[p.team_id].push(p);
                        } else {
                          solos.push(p);
                        }
                      });
                      
                      let teamIdx = 0;
                      return (
                        <>
                          {Object.entries(teams).map(([teamId, members]) => {
                            teamIdx++;
                            return (
                              <div key={teamId} className="p-1.5 rounded bg-violet-50 border border-violet-100 mb-1">
                                <p className="text-[9px] font-medium text-violet-500 uppercase tracking-wider mb-0.5">Equipe {teamIdx}</p>
                                {members.map((participant) => (
                                  <div key={participant.id} className="flex items-center gap-1.5 py-0.5 pl-1">
                                    <div className="w-5 h-5 rounded-full bg-violet-200 flex items-center justify-center text-violet-700 font-medium text-[10px] flex-shrink-0">
                                      {(participant.first_name || '?')[0]}
                                    </div>
                                    <span className="text-xs text-neutral-800 truncate">{participant.first_name} {participant.last_name}</span>
                                    {participant.payment_status === 'awaiting_payment' && (
                                      <span className="text-[8px] px-1 py-0.5 rounded bg-orange-100 text-orange-600 flex-shrink-0">A payer</span>
                                    )}
                                  </div>
                                ))}
                              </div>
                            );
                          })}
                          {solos.map((participant, index) => (
                            <div key={participant.id || index} className="flex items-center gap-2 py-1 px-1 rounded hover:bg-neutral-50">
                              <div className="w-5 h-5 rounded-full bg-amber-100 flex items-center justify-center text-amber-700 font-medium text-[10px] flex-shrink-0">
                                {(participant.first_name || '?')[0]}
                              </div>
                              <span className="text-xs text-neutral-800 truncate">{participant.first_name} {participant.last_name}</span>
                            </div>
                          ))}
                        </>
                      );
                    }
                    
                    // Affichage compact pour compétitions individuelles
                    return competitionParticipants.map((participant, index) => (
                      <div key={participant.id || index} className={`flex items-center gap-2 py-1 px-1 rounded hover:bg-neutral-50 ${participant.guest_of ? 'pl-5' : ''}`}>
                        <span className={`w-5 h-5 rounded-full flex items-center justify-center font-medium text-[10px] flex-shrink-0 ${participant.guest_of ? 'bg-emerald-50 text-emerald-600' : 'bg-neutral-100 text-neutral-500'}`}>
                          {participant.guest_of ? '↳' : index + 1}
                        </span>
                        <span className="text-xs text-neutral-800 truncate flex-1">
                          {participant.first_name} {participant.last_name}
                          {(participant.anonymous_guests_count || 0) > 0 && (
                            <span className="ml-1.5 inline-flex items-center px-1.5 py-0 rounded-full bg-emerald-100 text-emerald-700 text-[9px] font-bold align-middle" title={`${participant.anonymous_guests_count} invité(s) anonyme(s)`}>+{participant.anonymous_guests_count}</span>
                          )}
                          {participant.guest_of && (
                            <span className="ml-1.5 text-[9px] text-emerald-600 italic">accompagnant</span>
                          )}
                        </span>
                        {participant.registration_date && !participant.guest_of && (
                          <span className="text-[9px] text-neutral-400 flex-shrink-0">{format(parseISO(participant.registration_date), 'd MMM', { locale: fr })}</span>
                        )}
                      </div>
                    ));
                  })()}
                </div>
              )}
            </div>
          </DialogContent>
        </Dialog>

        {/* Orders Tab (Commandes Fitting / Taylor Made) */}
        {activeTab === 'orders' && (
          <div className="flex-1 overflow-y-auto p-3 space-y-3" data-testid="orders-tab">
            <div className="flex items-center justify-between px-1">
              <h4 className="text-xs font-medium text-neutral-500 uppercase">Mes commandes Fitting</h4>
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={async () => {
                  try {
                    const data = await clientPortalApi.getFittingOrders(token);
                    setFittingOrders(data);
                  } catch (err) {
                    toast.error('Erreur lors du rechargement');
                  }
                }}
                className="h-7 text-xs"
              >
                Actualiser
              </Button>
            </div>
            
            {fittingOrders.length === 0 ? (
              <Card className="border-dashed">
                <CardContent className="py-8 text-center">
                  <ShoppingBag size={40} className="mx-auto text-neutral-300 mb-3" />
                  <p className="text-neutral-500 text-sm">Aucune commande en cours</p>
                  <p className="text-neutral-400 text-xs mt-1">
                    Vos bons de commande Fitting apparaîtront ici
                  </p>
                </CardContent>
              </Card>
            ) : (
              <div className="space-y-2">
                {fittingOrders.map(order => (
                  <Card 
                    key={order.id} 
                    className={`cursor-pointer hover:shadow-md transition-all border-l-4 ${fittingPortalStatus(order).border}`}
                    onClick={() => {
                      setSelectedFittingOrder(order);
                      setShowFittingOrderModal(true);
                    }}
                  >
                    <CardContent className="p-3">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="font-semibold text-sm text-neutral-800">
                            Bon de commande du {order.quote_date || 'N/A'}
                          </p>
                          <p className="text-xs text-neutral-500">
                            Fitting : {order.fitting_date || 'N/A'}
                          </p>
                        </div>
                        <div className="text-right">
                          <p className="font-bold text-emerald-600">
                            {(order.totals?.totalTTC || 0).toLocaleString('fr-FR')}€
                          </p>
                          <Badge variant="outline" className={`text-xs ${fittingPortalStatus(order).badge}`} data-testid={`portal-order-status-${order.id}`}>
                            {fittingPortalStatus(order).label}
                          </Badge>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            )}
          </div>
        )}
        
        {/* iter313.3 — Modal QR Practice plein écran (pour scanner à la machine à balles) */}
        <Dialog open={showPracticeQrFullscreen} onOpenChange={setShowPracticeQrFullscreen}>
          <DialogContent className="max-w-md" data-testid="practice-qr-fullscreen-modal">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <span className="text-2xl">⚡</span>
                QR Machine à balles
              </DialogTitle>
            </DialogHeader>
            <div className="flex flex-col items-center gap-4 py-4">
              {practiceData?.qr_value && (
                <div className="bg-white p-4 rounded-lg border-2 border-amber-200">
                  <QRCodeSVG value={practiceData.qr_value} size={280} level="M" />
                </div>
              )}
              <p className="text-center text-sm text-neutral-600 px-4">
                Solde actuel : <b className="text-amber-700">{Math.floor(practiceData?.balance?.remaining || 0)} jeton{(practiceData?.balance?.remaining || 0) !== 1 ? 's' : ''}</b>
              </p>
              <p className="text-center text-xs text-neutral-500 px-4">
                Présentez ce QR devant le lecteur de la machine à balles.<br/>
                Chaque scan décrémente 1 jeton de votre solde.
              </p>
            </div>
          </DialogContent>
        </Dialog>

        {/* Modal détails commande fitting */}
        <Dialog open={showFittingOrderModal} onOpenChange={setShowFittingOrderModal}>
          <DialogContent className="max-w-md max-h-[80vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <ShoppingBag className="text-emerald-500" size={20} />
                Commande Fitting
              </DialogTitle>
            </DialogHeader>
            
            {selectedFittingOrder && (
              <div className="space-y-4">
                {/* Dates */}
                <div className="grid grid-cols-2 gap-3">
                  <div className="p-3 bg-blue-50 rounded-lg">
                    <p className="text-xs text-blue-600 mb-1">Date fitting</p>
                    <p className="font-medium text-blue-800 text-sm">{selectedFittingOrder.fitting_date || '-'}</p>
                  </div>
                  <div className="p-3 bg-purple-50 rounded-lg">
                    <p className="text-xs text-purple-600 mb-1">Date devis</p>
                    <p className="font-medium text-purple-800 text-sm">{selectedFittingOrder.quote_date || '-'}</p>
                  </div>
                </div>
                
                {/* Statut */}
                <div className="flex items-center justify-between p-3 border rounded-lg">
                  <span className="text-neutral-600 text-sm">Statut</span>
                  <Badge variant="outline" className={fittingPortalStatus(selectedFittingOrder).badge} data-testid="portal-fitting-modal-status">
                    {selectedFittingOrder.status === 'validated' ? 'Validé - En attente de paiement' : fittingPortalStatus(selectedFittingOrder).label}
                  </Badge>
                </div>
                
                {/* Articles */}
                <div className="border rounded-lg overflow-hidden">
                  <div className="bg-neutral-50 px-3 py-2 border-b">
                    <p className="font-semibold text-sm text-neutral-700">Articles commandés</p>
                  </div>
                  <div className="divide-y max-h-40 overflow-y-auto">
                    {selectedFittingOrder.lines?.map((line, idx) => (
                      <div key={idx} className="px-3 py-2 flex justify-between items-center text-sm">
                        <div>
                          <p className="font-medium">{line.description}</p>
                          {line.shaft && <p className="text-xs text-neutral-500">Shaft: {line.shaft}</p>}
                          {line.quantity > 1 && <p className="text-xs text-neutral-400">Qté: {line.quantity}</p>}
                        </div>
                        <p className="font-semibold text-emerald-600">{(Number(line.unitPrice ?? line.unit_price ?? 0) * Number(line.quantity || 1) * (1 - Number(line.discount || 0) / 100)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} € TTC</p>
                      </div>
                    ))}
                  </div>
                </div>
                
                {/* Total */}
                <div className="bg-emerald-50 p-3 rounded-lg" data-testid="portal-fitting-totals">
                  <div className="flex justify-between text-sm">
                    <span className="text-neutral-600">Total HT</span>
                    <span className="font-medium">{(Number(selectedFittingOrder.totals?.totalTTC || 0) / 1.2).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-neutral-600">TVA 20%</span>
                    <span className="font-medium">{(Number(selectedFittingOrder.totals?.totalTTC || 0) - Number(selectedFittingOrder.totals?.totalTTC || 0) / 1.2).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</span>
                  </div>
                  <div className="flex justify-between text-lg font-bold border-t pt-2 mt-2">
                    <span className="text-emerald-700">Total TTC</span>
                    <span className="text-emerald-700">{selectedFittingOrder.totals?.totalTTC?.toLocaleString('fr-FR')}€</span>
                  </div>
                </div>
                
                {/* Actions */}
                <div className="space-y-3">
                  {selectedFittingOrder.status === 'pending' && (
                    <>
                      {/* Bouton principal : Valider ET Payer */}
                      <Button 
                        className="w-full bg-emerald-500 hover:bg-emerald-600 h-12 text-base"
                        onClick={async () => {
                          setFittingOrderLoading(true);
                          try {
                            // 1. Valider le devis
                            await clientPortalApi.validateFittingOrder(token, selectedFittingOrder.id);
                            toast.success('Devis validé ! Redirection vers le paiement...');
                            
                            // 2. Créer la session Stripe et rediriger
                            const result = await clientPortalApi.createFittingOrderPayment(token, selectedFittingOrder.id);
                            if (result.checkout_url) {
                              window.location.href = result.checkout_url;
                            } else {
                              const data = await clientPortalApi.getFittingOrders(token);
                              setFittingOrders(data);
                            }
                          } catch (err) {
                            toast.error(err.message);
                            // En cas d'erreur, recharger quand même les données
                            try {
                              const data = await clientPortalApi.getFittingOrders(token);
                              setFittingOrders(data);
                            } catch (e) {}
                          } finally {
                            setFittingOrderLoading(false);
                          }
                        }}
                        disabled={fittingOrderLoading}
                      >
                        {fittingOrderLoading ? (
                          <Loader2 className="animate-spin mr-2" size={18} />
                        ) : (
                          <CreditCard size={18} className="mr-2" />
                        )}
                        Valider et payer - {selectedFittingOrder.totals?.totalTTC?.toLocaleString('fr-FR')}€
                      </Button>
                      
                      {/* Bouton secondaire : Valider seulement */}
                      <Button 
                        variant="outline"
                        className="w-full text-neutral-600 border-neutral-300 hover:bg-neutral-50"
                        onClick={async () => {
                          setFittingOrderLoading(true);
                          try {
                            await clientPortalApi.validateFittingOrder(token, selectedFittingOrder.id);
                            toast.success('Devis validé ! Vous pourrez payer plus tard.');
                            // Recharger les commandes
                            const data = await clientPortalApi.getFittingOrders(token);
                            setFittingOrders(data);
                            setShowFittingOrderModal(false);
                          } catch (err) {
                            toast.error(err.message);
                          } finally {
                            setFittingOrderLoading(false);
                          }
                        }}
                        disabled={fittingOrderLoading}
                      >
                        <Check size={16} className="mr-2" />
                        Valider (payer plus tard)
                      </Button>
                      
                      <p className="text-xs text-center text-neutral-500">
                        En validant, vous confirmez votre accord pour cette commande
                      </p>
                    </>
                  )}
                  
                  {selectedFittingOrder.status === 'validated' && (
                    <>
                      <Button 
                        className="w-full bg-emerald-500 hover:bg-emerald-600"
                        onClick={async () => {
                          setFittingOrderLoading(true);
                          try {
                            const result = await clientPortalApi.createFittingOrderPayment(token, selectedFittingOrder.id);
                            if (result.checkout_url) {
                              window.location.href = result.checkout_url;
                            }
                          } catch (err) {
                            toast.error(err.message);
                          } finally {
                            setFittingOrderLoading(false);
                          }
                        }}
                        disabled={fittingOrderLoading}
                      >
                        {fittingOrderLoading ? <Loader2 className="animate-spin mr-2" size={16} /> : <CreditCard size={16} className="mr-2" />}
                        Payer ma commande - {selectedFittingOrder.totals?.totalTTC?.toLocaleString('fr-FR')}€
                      </Button>
                      <p className="text-xs text-center text-neutral-500">
                        Ou payez directement à l'accueil du golf
                      </p>
                    </>
                  )}
                  
                  {(selectedFittingOrder.status === 'paid' || selectedFittingOrder.status === 'picked_up') && (
                    <div className="text-center p-4 bg-emerald-50 rounded-lg" data-testid="portal-fitting-paid-info">
                      <CheckCircle2 className="mx-auto text-emerald-500 mb-2" size={32} />
                      <p className="font-medium text-emerald-700">
                        {selectedFittingOrder.status === 'picked_up' ? 'Commande récupérée' : selectedFittingOrder.received_at ? 'Votre matériel est arrivé : à récupérer à l\u2019accueil' : 'Commande payée'}
                      </p>
                      <p className="text-sm text-emerald-600">
                        {selectedFittingOrder.status === 'picked_up' ? 'Votre facture est disponible dans vos documents. Merci pour votre achat !' : 'Votre facture vous sera remise lors du retrait de votre matériel.'}
                      </p>
                    </div>
                  )}
                  
                  {selectedFittingOrder.document_id && (
                    <Button 
                      variant="outline"
                      className="w-full"
                      onClick={() => {
                        window.open(`${API_URL}/api/golf/documents/${selectedFittingOrder.document_id}/download?token=${token}`, '_blank');
                      }}
                    >
                      <Download size={16} className="mr-2" />
                      Télécharger le bon de commande
                    </Button>
                  )}
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>

        {/* News Tab */}
        {activeTab === 'news' && (() => {
          const getVimeoId = (embedCode) => {
            if (!embedCode) return null;
            const urlMatch = embedCode.match(/vimeo\.com\/(\d+)/);
            if (urlMatch) return urlMatch[1];
            const embedMatch = embedCode.match(/player\.vimeo\.com\/video\/(\d+)/);
            if (embedMatch) return embedMatch[1];
            if (/^\d+$/.test(embedCode.trim())) return embedCode.trim();
            return null;
          };
          
          const selectedItem = selectedNewsId ? news.find(n => n.id === selectedNewsId) : null;
          
          const playVideoFullscreen = async (videoId) => {
            const overlay = document.createElement('div');
            overlay.id = 'video-fullscreen-overlay';
            overlay.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;background:black;z-index:9999;display:flex;align-items:center;justify-content:center;';
            const closeBtn = document.createElement('button');
            closeBtn.innerHTML = '✕';
            closeBtn.style.cssText = 'position:absolute;top:env(safe-area-inset-top, 48px);right:16px;width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,0.9);border:none;font-size:22px;cursor:pointer;z-index:10000;margin-top:12px;';
            closeBtn.onclick = () => { overlay.remove(); if (screen.orientation?.unlock) screen.orientation.unlock(); };
            const iframe = document.createElement('iframe');
            iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1&badge=0&autopause=0`;
            iframe.style.cssText = 'width:100%;height:100%;';
            iframe.frameBorder = '0';
            iframe.allow = 'autoplay; fullscreen; picture-in-picture';
            iframe.allowFullscreen = true;
            overlay.appendChild(closeBtn);
            overlay.appendChild(iframe);
            document.body.appendChild(overlay);
            try { if (screen.orientation?.lock) await screen.orientation.lock('landscape'); } catch (e) {}
          };

          // Vue détail d'une actualité
          if (selectedItem) {
            const vimeoId = selectedItem.video_embed ? getVimeoId(selectedItem.video_embed) : null;
            const dateStr = selectedItem.publish_date 
              ? format(parseISO(selectedItem.publish_date), 'd MMMM yyyy', { locale: fr })
              : selectedItem.created_at ? format(parseISO(selectedItem.created_at), 'd MMMM yyyy', { locale: fr }) : '';
            
            return (
              <div className="flex-1 overflow-y-auto" data-testid="news-detail">
                {/* Header retour */}
                <div className="sticky top-0 bg-white/95 backdrop-blur-sm border-b border-neutral-100 px-4 py-2.5 flex items-center gap-3 z-10">
                  <button onClick={() => setSelectedNewsId(null)} className="p-1 -ml-1 text-neutral-600" data-testid="news-back-btn">
                    <ChevronLeft size={20} />
                  </button>
                  <span className="text-sm font-semibold text-neutral-800 truncate">{selectedItem.title}</span>
                </div>
                
                <div className="pb-8">
                  {/* Vidéo Vimeo - thumbnail + play plein écran */}
                  {selectedItem.media_type === 'video' && vimeoId && (
                    <button onClick={() => playVideoFullscreen(vimeoId)} className="w-full relative aspect-video bg-neutral-900">
                      <img src={selectedItem.video_thumbnail_url || `https://vumbnail.com/${vimeoId}.jpg`} alt={selectedItem.title} className="w-full h-full object-cover" onError={(e) => { e.target.style.display = 'none'; }} />
                      <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                        <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center shadow-lg">
                          <svg className="w-6 h-6 text-neutral-800 ml-1" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                        </div>
                      </div>
                    </button>
                  )}
                  
                  {/* Photo unique - cliquable pour lightbox */}
                  {((selectedItem.media_type === 'photo' && selectedItem.image_url) || (!selectedItem.media_type && selectedItem.image_url)) && (
                    <button className="w-full" onClick={() => setNewsLightbox({ images: [selectedItem.image_url], index: 0 })}>
                      <img src={selectedItem.image_url} alt={selectedItem.title} className="w-full" />
                    </button>
                  )}
                  
                  {/* Multi-photos carrousel - cliquable pour lightbox */}
                  {selectedItem.media_type === 'photos' && selectedItem.images?.length > 0 && (
                    <div className="relative">
                      <div className="flex overflow-x-auto snap-x snap-mandatory" style={{ scrollbarWidth: 'none' }}>
                        {selectedItem.images.map((img, imgIdx) => (
                          <button key={imgIdx} className="flex-shrink-0 w-full snap-center" onClick={() => setNewsLightbox({ images: selectedItem.images.map(i => i.url), index: imgIdx })}>
                            <img src={img.url} alt={`${selectedItem.title} ${imgIdx + 1}`} className="w-full" />
                          </button>
                        ))}
                      </div>
                      {selectedItem.images.length > 1 && (
                        <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1.5">
                          {selectedItem.images.map((_, dotIdx) => (
                            <span key={dotIdx} className="w-2 h-2 rounded-full bg-white/80 shadow-sm" />
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                  
                  {/* Contenu */}
                  <div className="px-4 pt-4">
                    <span className="text-[10px] text-neutral-400 font-semibold uppercase tracking-wide">{dateStr}</span>
                    <h1 className="text-lg font-bold text-neutral-900 mt-1.5 leading-snug">{selectedItem.title}</h1>
                    {selectedItem.pdf_url && (
                      <a
                        href={selectedItem.pdf_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="portal-news-pdf-btn"
                        className="mt-3 inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-gradient-to-r from-[#D4AF37] via-[#E5C158] to-[#B8912B] text-[#1A1204] text-sm font-semibold shadow-md shadow-[#D4AF37]/25 hover:shadow-lg hover:-translate-y-0.5 transition-all"
                      >
                        <FileText size={16} /> {selectedItem.pdf_label || 'Télécharger le PDF'}
                      </a>
                    )}
                    {selectedItem.content && (
                      <p className="text-sm text-neutral-600 whitespace-pre-wrap mt-3 leading-relaxed">{selectedItem.content}</p>
                    )}

                    {/* CTA — Événement lié : inscription directe */}
                    {selectedItem.linked_competition && (() => {
                      const lc = selectedItem.linked_competition;
                      const startDate = lc.start_date ? parseISO(lc.start_date) : null;
                      const isPast = startDate ? startDate < new Date(new Date().setHours(0,0,0,0)) : false;
                      const isFull = lc.max_participants && (lc.registered_count || 0) >= lc.max_participants;
                      const canRegister = !isPast && lc.open_to_portal && !isFull;
                      const eventLabel = lc.event_type === 'atelier' ? 'à l\u2019atelier' : lc.event_type === 'afterwork' ? 'à l\u2019afterwork' : 'à la compétition';
                      const typeIcon = lc.event_type === 'atelier' || lc.event_type === 'afterwork' ? Calendar : Trophy;
                      const TypeIcon = typeIcon;
                      return (
                        <div className="mt-6 p-4 rounded-2xl border-2 border-emerald-100 bg-emerald-50/60" data-testid="news-linked-event-card">
                          <div className="flex items-start gap-3">
                            <div className="w-10 h-10 rounded-full bg-emerald-600 flex items-center justify-center flex-shrink-0">
                              <TypeIcon size={18} className="text-white" />
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-[10px] uppercase tracking-wider font-semibold text-emerald-700">Événement lié</p>
                              <p className="text-sm font-bold text-neutral-900 mt-0.5 truncate">{lc.name}</p>
                              {startDate && (
                                <p className="text-xs text-neutral-600 mt-0.5">
                                  {format(startDate, 'EEEE d MMMM yyyy', { locale: fr })}
                                  {lc.start_time ? ` — ${lc.start_time}` : ''}
                                </p>
                              )}
                              {lc.max_participants && (
                                <p className="text-[11px] text-neutral-500 mt-1">
                                  {lc.registered_count || 0} / {lc.max_participants} inscrits
                                </p>
                              )}
                            </div>
                          </div>
                          <button
                            onClick={() => {
                              // Ouvre la modale d'inscription à l'événement (utilise le comp complet chargé depuis /competitions si dispo, sinon utilise le résumé)
                              const fullComp = competitions.find(c => c.id === lc.id) || lc;
                              setSelectedCompetition(fullComp);
                              setSelectedPartner(null);
                              setPartnerSearchQuery('');
                              setPartnerSearchResults([]);
                              setPayForPartner(true);
                              setSelectedCustomOptions([]);
                              setShowCompetitionModal(true);
                            }}
                            disabled={!canRegister}
                            className={`w-full mt-3 py-2.5 rounded-lg text-sm font-semibold uppercase tracking-wider transition-colors flex items-center justify-center gap-2 ${
                              canRegister
                                ? 'bg-emerald-950 text-white hover:bg-emerald-900'
                                : 'bg-neutral-200 text-neutral-500 cursor-not-allowed'
                            }`}
                            data-testid="news-register-event-btn"
                          >
                            {isPast ? 'Événement passé' : isFull ? 'Complet' : !lc.open_to_portal ? 'Sur invitation' : `S\u2019inscrire ${eventLabel}`}
                          </button>
                        </div>
                      );
                    })()}

                    {/* CTA — Stage lié : inscription directe au stage */}
                    {selectedItem.linked_stage && (() => {
                      const ls = selectedItem.linked_stage;
                      const startDate = ls.start_date ? parseISO(ls.start_date) : null;
                      const endDate = ls.end_date ? parseISO(ls.end_date) : null;
                      const isPast = startDate ? startDate < new Date(new Date().setHours(0,0,0,0)) : false;
                      const isFull = ls.max_participants && (ls.registered_count || 0) >= ls.max_participants;
                      const canRegister = !isPast && ls.open_to_portal && !isFull;
                      return (
                        <div className="mt-6 p-4 rounded-2xl border-2 border-blue-100 bg-blue-50/60" data-testid="news-linked-stage-card">
                          <div className="flex items-start gap-3">
                            <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center flex-shrink-0">
                              <CalendarDays size={18} className="text-white" />
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-[10px] uppercase tracking-wider font-semibold text-blue-700">Stage lié</p>
                              <p className="text-sm font-bold text-neutral-900 mt-0.5 truncate">{ls.name}</p>
                              {startDate && (
                                <p className="text-xs text-neutral-600 mt-0.5">
                                  {format(startDate, 'EEEE d MMMM yyyy', { locale: fr })}
                                  {endDate && endDate.getTime() !== startDate.getTime() && (
                                    <> — {format(endDate, 'd MMMM', { locale: fr })}</>
                                  )}
                                  {ls.start_time ? ` · ${ls.start_time}` : ''}
                                </p>
                              )}
                              {ls.max_participants && (
                                <p className="text-[11px] text-neutral-500 mt-1">
                                  {ls.registered_count || 0} / {ls.max_participants} inscrits
                                  {ls.member_price ? ` · ${ls.member_price}€` : ''}
                                </p>
                              )}
                            </div>
                          </div>
                          <button
                            onClick={() => {
                              const fullStage = stages.find(s => (s.id || s._id) === ls.id) || ls;
                              setSelectedStage(fullStage);
                              setShowStageModal(true);
                            }}
                            disabled={!canRegister}
                            className={`w-full mt-3 py-2.5 rounded-lg text-sm font-semibold uppercase tracking-wider transition-colors flex items-center justify-center gap-2 ${
                              canRegister
                                ? 'bg-blue-900 text-white hover:bg-blue-800'
                                : 'bg-neutral-200 text-neutral-500 cursor-not-allowed'
                            }`}
                            data-testid="news-register-stage-btn"
                          >
                            {isPast ? 'Stage passé' : isFull ? 'Complet' : !ls.open_to_portal ? 'Sur invitation' : 'S\u2019inscrire au stage'}
                          </button>
                        </div>
                      );
                    })()}
                  </div>
                </div>

                {/* Lightbox plein écran */}
                {newsLightbox && (
                  <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center" onClick={() => setNewsLightbox(null)}>
                    <button className="absolute top-[env(safe-area-inset-top,12px)] right-4 text-white/80 hover:text-white z-10 p-2 mt-3" onClick={() => setNewsLightbox(null)}>
                      <X size={28} />
                    </button>
                    {newsLightbox.images.length > 1 && (
                      <>
                        <button className="absolute left-3 top-1/2 -translate-y-1/2 text-white/70 hover:text-white bg-black/40 rounded-full p-2 z-10" onClick={(e) => { e.stopPropagation(); setNewsLightbox(prev => ({ ...prev, index: (prev.index - 1 + prev.images.length) % prev.images.length })); }}>
                          <ChevronLeft size={24} />
                        </button>
                        <button className="absolute right-3 top-1/2 -translate-y-1/2 text-white/70 hover:text-white bg-black/40 rounded-full p-2 z-10" onClick={(e) => { e.stopPropagation(); setNewsLightbox(prev => ({ ...prev, index: (prev.index + 1) % prev.images.length })); }}>
                          <ChevronRight size={24} />
                        </button>
                      </>
                    )}
                    <img src={newsLightbox.images[newsLightbox.index]} alt="" className="max-h-[90vh] max-w-[95vw] object-contain" onClick={(e) => e.stopPropagation()} />
                    {newsLightbox.images.length > 1 && (
                      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
                        {newsLightbox.images.map((_, i) => (
                          <button key={i} className={`w-2.5 h-2.5 rounded-full transition-colors ${i === newsLightbox.index ? 'bg-white' : 'bg-white/40'}`} onClick={(e) => { e.stopPropagation(); setNewsLightbox(prev => ({ ...prev, index: i })); }} />
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          }
          
          // Vue liste des actualités
          return (
            <div className="flex-1 overflow-y-auto" data-testid="news-tab" style={{ backgroundColor: '#F5F2EB' }}>
              <div className="px-4 pt-4 pb-6">
                <h2 className="font-bold uppercase mb-3" style={{ fontSize: '11px', color: '#999', letterSpacing: '0.08em' }}>Actualités</h2>
                {news.length === 0 ? (
                  <div className="py-16 text-center">
                    <Newspaper size={32} className="mx-auto text-neutral-300 mb-3" />
                    <p className="text-neutral-500 text-sm">Aucune actualité pour le moment</p>
                  </div>
                ) : (
                  <div className="space-y-3">
                    {news.map((item) => {
                      const vimeoId = item.video_embed ? getVimeoId(item.video_embed) : null;
                      const dateStr = item.publish_date 
                        ? format(parseISO(item.publish_date), 'd MMMM yyyy', { locale: fr })
                        : item.created_at ? format(parseISO(item.created_at), 'd MMMM yyyy', { locale: fr }) : '';
                      const photoUrl = item.image_url || (item.images?.length > 0 ? item.images[0].url : null);
                      const thumbUrl = item.video_thumbnail_url || (vimeoId ? `https://vumbnail.com/${vimeoId}.jpg` : null);
                      // Photo d'étiquette dédiée : priorité pour la miniature de la liste
                      const listThumb = item.thumbnail_url || (item.media_type === 'video' ? thumbUrl : photoUrl);
                      const useContain = !item.thumbnail_url && item.media_type === 'video'; // vidéo sans étiquette → contain pour préserver le format
                      
                      return (
                        <article 
                          key={item.id} 
                          data-testid={`news-card-${item.id}`}
                          className="bg-white rounded-xl overflow-hidden border border-neutral-200"
                        >
                          {/* Thumbnail vidéo - clic = lance plein écran (sauf si étiquette dédiée : clic = ouvre article) */}
                          {item.media_type === 'video' && (thumbUrl || vimeoId) && !item.thumbnail_url && (
                            <button onClick={() => playVideoFullscreen(getVimeoId(item.video_embed))} className="w-full relative h-40 bg-neutral-900">
                              <img src={thumbUrl || `https://vumbnail.com/${vimeoId}.jpg`} alt={item.title} className={`w-full h-full ${useContain ? 'object-contain' : 'object-cover'}`} onError={(e) => { e.target.style.display = 'none'; }} />
                              <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                                <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center shadow-lg">
                                  <svg className="w-5 h-5 text-neutral-800 ml-0.5" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                                </div>
                              </div>
                            </button>
                          )}

                          {/* Étiquette dédiée (paysage) — clic = ouvre article */}
                          {item.thumbnail_url && (
                            <button onClick={() => setSelectedNewsId(item.id)} data-track={item.title || undefined} className="w-full relative h-40 bg-neutral-100">
                              <img src={item.thumbnail_url} alt={item.title} className="w-full h-full object-cover" />
                              {item.media_type === 'video' && (
                                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center shadow-lg">
                                    <svg className="w-5 h-5 text-neutral-800 ml-0.5" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                                  </div>
                                </div>
                              )}
                            </button>
                          )}
                          
                          {/* Photo (single ou première du multi) - clic = ouvre article - masqué si étiquette dédiée */}
                          {item.media_type !== 'video' && photoUrl && !item.thumbnail_url && (
                            <button onClick={() => setSelectedNewsId(item.id)} data-track={item.title || undefined} className="w-full relative h-40 bg-neutral-100">
                              <img src={photoUrl} alt={item.title} className="w-full h-full object-cover" />
                              {item.images?.length > 1 && (
                                <span className="absolute top-2 right-2 bg-black/60 text-white text-[10px] px-2 py-0.5 rounded-full font-semibold">
                                  {item.images.length} photos
                                </span>
                              )}
                            </button>
                          )}
                          
                          {/* Texte - clic = ouvre l'article */}
                          <button onClick={() => setSelectedNewsId(item.id)} data-track={item.title || undefined} className="w-full text-left px-3.5 py-3">
                            <span className="text-[10px] text-neutral-400 font-medium uppercase tracking-wide">{dateStr}</span>
                            <h3 className="font-semibold text-neutral-900 text-sm leading-snug mt-1">{item.title}</h3>
                            {item.content && (
                              <p className="text-neutral-500 mt-1.5 text-xs line-clamp-2">{item.content}</p>
                            )}
                          </button>
                        </article>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          );
        })()}

        {/* École de Golf Tab */}
        {activeTab === 'ecole' && isAcademyMember && (
          <div className="flex-1 overflow-y-auto p-3 pb-20" style={{ backgroundColor: '#F5F2EB' }} data-testid="ecole-tab">
            <GolfSchoolPortal 
              token={token} 
              clientId={client?.id} 
              clientName={`${client?.first_name || ''} ${client?.last_name || ''}`.trim()} 
            />
          </div>
        )}

        {/* Account Tab */}
        {activeTab === 'account' && (
          <div className="flex-1 overflow-y-auto p-3 pb-20 space-y-3" data-testid="account-tab" style={{ backgroundColor: '#F5F2EB' }}>
            {/* Profil compact - éditable */}
            <div className="rounded-2xl p-4" style={{ backgroundColor: 'rgba(255,255,255,0.92)', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#E8F5E9' }}>
                  <User className="w-6 h-6" style={{ color: '#2E6A4C' }} />
                </div>
                <div className="min-w-0 flex-1">
                  {editingProfile ? (
                    <div className="space-y-2">
                      <div className="flex gap-2">
                        <input
                          type="text"
                          value={profileForm.first_name}
                          onChange={(e) => setProfileForm({ ...profileForm, first_name: e.target.value })}
                          placeholder="Prénom"
                          className="flex-1 px-2.5 py-1.5 border border-neutral-300 rounded-lg text-sm"
                          data-testid="edit-profile-firstname"
                        />
                        <input
                          type="text"
                          value={profileForm.last_name}
                          onChange={(e) => setProfileForm({ ...profileForm, last_name: e.target.value })}
                          placeholder="Nom"
                          className="flex-1 px-2.5 py-1.5 border border-neutral-300 rounded-lg text-sm"
                          data-testid="edit-profile-lastname"
                        />
                      </div>
                      <div>
                        <label className="block text-[10px] font-semibold uppercase tracking-wide mb-1" style={{ color: '#999', letterSpacing: '0.08em' }}>
                          Date de naissance
                        </label>
                        <input
                          type="date"
                          value={profileForm.birth_date || ''}
                          onChange={(e) => setProfileForm({ ...profileForm, birth_date: e.target.value })}
                          className="w-full px-2.5 py-1.5 border border-neutral-300 rounded-lg text-sm"
                          data-testid="edit-profile-birthdate"
                          max={new Date().toISOString().slice(0, 10)}
                        />
                        <p className="mt-1 text-[10px]" style={{ color: '#B5A788' }}>
                          Un joli message d'anniversaire vous sera envoyé chaque année
                        </p>
                      </div>
                      <div className="flex gap-2">
                        <button
                          onClick={() => setEditingProfile(false)}
                          className="px-3 py-1.5 text-xs border border-neutral-300 rounded-lg hover:bg-neutral-50"
                        >
                          Annuler
                        </button>
                        <button
                          onClick={handleUpdateProfile}
                          disabled={savingProfile}
                          className="px-3 py-1.5 text-xs text-white rounded-lg"
                          style={{ backgroundColor: '#2E6A4C' }}
                          data-testid="save-profile-btn"
                        >
                          {savingProfile ? 'Enregistrement...' : 'Enregistrer'}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="flex items-center gap-2">
                        <h3 className="font-bold text-sm truncate" style={{ color: '#1a1a1a' }}>{client?.first_name} {client?.last_name}</h3>
                        <button
                          onClick={() => {
                            setProfileForm({
                              first_name: client?.first_name || '',
                              last_name: client?.last_name || '',
                              birth_date: (client?.birth_date || '').slice(0, 10),
                            });
                            setEditingProfile(true);
                          }}
                          className="p-1 rounded-lg hover:bg-neutral-100 transition-colors"
                          data-testid="edit-profile-btn"
                        >
                          <Pencil size={13} style={{ color: '#999' }} />
                        </button>
                      </div>
                      <p className="text-xs truncate" style={{ color: '#999' }}>{client?.email}</p>
                      {client?.phone && (
                        <p className="text-xs truncate" style={{ color: '#bbb' }}>{client.phone}</p>
                      )}
                      {client?.birth_date && (
                        <p className="text-xs mt-0.5 flex items-center gap-1" style={{ color: '#C9A44D' }} data-testid="profile-birthdate-display">
                          <span style={{ fontSize: '11px' }}>◆</span>
                          <span>Anniversaire · {formatBirthday(client.birth_date)}</span>
                        </p>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Changer de profil — affiché si plusieurs profils liés */}
            {linkedProfiles && linkedProfiles.length > 1 && (
              <div className="rounded-2xl p-4" style={{ backgroundColor: 'rgba(255,255,255,0.92)', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
                <h4 className="font-bold uppercase mb-2" style={{ fontSize: '11px', color: '#999', letterSpacing: '0.08em' }}>Changer de profil</h4>
                <p className="text-[10px] text-neutral-400 mb-2">Plusieurs profils sont liés à votre email. Changez sans vous déconnecter.</p>
                <div className="space-y-1.5">
                  {linkedProfiles.map((p) => {
                    const currentId = client?.id || client?._id;
                    const isCurrent = p.id === currentId;
                    return (
                      <button key={p.id} onClick={() => !isCurrent && handleSwitchProfile(p.id)} disabled={isCurrent}
                        className={`w-full text-left px-3 py-2 rounded-xl border transition-all flex items-center justify-between ${
                          isCurrent ? 'border-[#2E6A4C]/30 bg-[#2E6A4C]/5' : 'border-neutral-200 hover:border-[#2E6A4C]/30 hover:bg-[#2E6A4C]/5'
                        }`} data-testid={`switch-profile-${p.id}`}>
                        <div>
                          <span className="text-sm font-medium" style={{ color: isCurrent ? '#2E6A4C' : '#333' }}>{p.first_name} {p.last_name}</span>
                          {p.group && <span className="text-[10px] text-neutral-400 ml-2">{p.group}</span>}
                        </div>
                        {isCurrent && <Check size={14} style={{ color: '#2E6A4C' }} />}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Solde du compte client + rechargement — masqués si « Solde compte » est désactivé */}
            {portalSettings?.show_wallet === true && (
              <WalletTopupCard token={token} returnTab="account" onBalance={setAccountBalance} testId="account-wallet-topup" />
            )}

            {/* Ma cotisation — appel de cotisation en cours (CB en ligne / SEPA 10× avec mandat signé en ligne / virement) */}
            <CotisationCallCard
              refreshKey={`${pendingContractsCount}-${contractsRefreshKey}`}
              onMandateRequested={handleMandateRequested}
              onVisibilityChange={setCotisationCallVisible}
            />

            {/* Mes contrats — n'apparaît que s'il y a des contrats à signer, highlight à l'ouverture */}
            <div
              ref={contratsSectionRef}
              className={`rounded-2xl ${pendingContractsCount > 0 ? 'p-4' : 'p-0'} ${contractsHighlight ? 'contracts-section-highlight' : ''}`}
              style={pendingContractsCount > 0 ? { backgroundColor: 'rgba(255,255,255,0.92)', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' } : { display: 'contents' }}
              data-testid="account-contrats-section"
            >
              {pendingContractsCount > 0 && (
                <h4 className="font-bold uppercase mb-3 flex items-center gap-1.5" style={{ fontSize: '11px', color: '#b91c1c', letterSpacing: '0.08em' }}>
                  <FileSignature size={11} style={{ color: '#b91c1c' }} />
                  Contrats à signer
                  <span className="ml-1 inline-flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full bg-red-600 text-white text-[10px] font-bold">
                    {pendingContractsCount}
                  </span>
                </h4>
              )}
              <ClientPortalContracts
                onCountChange={setPendingContractsCount}
                highlight={contractsHighlight}
                refreshKey={contractsRefreshKey}
              />
            </div>

            <style>{`
              @keyframes contractsSectionPulse {
                0%, 100% { box-shadow: 0 2px 12px rgba(0,0,0,0.06), 0 0 0 0 rgba(220, 38, 38, 0); }
                50%      { box-shadow: 0 2px 12px rgba(0,0,0,0.06), 0 0 0 6px rgba(220, 38, 38, 0.16); }
              }
              .contracts-section-highlight { animation: contractsSectionPulse 1.6s ease-in-out 3; }
            `}</style>

            {/* Mes partenaires favoris — gestion hors réservation */}
            {teeTimeEnabled && <FavoritePartnersCard token={token} />}
            {/* Confidentialité planning */}
            {teeTimeEnabled && <PortalPrivacyCard token={token} playerDisplay={teeTimeSettings?.portal_player_display || 'names'} />}

            {/* Récompenses de parrainage — s'affiche uniquement si le client a des récompenses */}
            <SponsorRewardsPanel />

            {/* Cotisation + Carnet — masqué quand l'appel de cotisation est déjà affiché en haut */}
            {!cotisationCallVisible && (
            <div className="rounded-2xl p-4" style={{ backgroundColor: 'rgba(255,255,255,0.92)', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }} data-testid="account-cotisation-section">
              <h4 className="font-bold uppercase mb-2" style={{ fontSize: '11px', color: '#999', letterSpacing: '0.08em' }}>Cotisation</h4>
              
              <div className="space-y-1.5">
                {client?.cotisation ? (
                  <>
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-medium">{client.displayed_cotisation || client.cotisation}</span>
                      {client?.is_subscription_valid === false ? (
                        <Badge className="bg-red-100 text-red-600 text-[10px]">Expirée</Badge>
                      ) : (
                        <Badge className="bg-primary/10 text-primary text-[10px]">Actif</Badge>
                      )}
                    </div>
                    
                    {(portalSettings?.show_cotisation_end_date !== false) && client?.subscription_expiry && (
                      <div className={`flex items-center gap-1.5 text-xs ${client?.is_subscription_valid === false ? 'text-red-500' : 'text-neutral-500'}`}>
                        <Calendar size={12} />
                        <span>
                          {client?.is_subscription_valid === false ? 'Expirée depuis le ' : 'Expire le '}
                          {format(parseISO(client.subscription_expiry), 'd MMMM yyyy', { locale: fr })}
                        </span>
                      </div>
                    )}
                    
                    {/* Message si cotisation expirée */}
                    {client?.is_subscription_valid === false && (
                      <div className="mt-2 p-2 bg-red-50 rounded text-xs text-red-600">
                        <AlertCircle size={12} className="inline mr-1" />
                        Votre cotisation a expiré. Tarif non-membre appliqué.
                      </div>
                    )}
                  </>
                ) : client?.subscription_status === 'no_subscription' ? (
                  <>
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-medium text-neutral-500">Client Extérieur</span>
                      <Badge className="bg-neutral-100 text-neutral-600 text-[10px]">Non abonné</Badge>
                    </div>
                    <p className="text-xs text-neutral-400">Tarif non-membre appliqué</p>
                  </>
                ) : (
                  <p className="text-sm text-neutral-400">Aucune cotisation</p>
                )}
                
                {/* Groupe collectif */}
                {(portalSettings?.show_groupe_collectif !== false) && client?.cours_collectif && (
                  <div className="flex items-center gap-1.5">
                    <Users size={12} className="text-neutral-400" />
                    <span className="text-xs text-neutral-600">Groupe: {client.cours_collectif}</span>
                  </div>
                )}
                
                {/* Groupe individuel */}
                {(portalSettings?.show_groupe_individuel !== false) && client?.cours_individuel && (
                  <div className="flex items-center gap-1.5">
                    <User size={12} className="text-neutral-400" />
                    <span className="text-xs text-neutral-600">Groupe indiv: {client.cours_individuel}</span>
                  </div>
                )}
              </div>
              
              {/* Bouton payer - visible UNIQUEMENT si show_cotisation est activé */}
              {(portalSettings?.show_cotisation !== false) && (() => {
                const isExterior = client?.subscription_status === 'no_subscription';
                
                if (isExterior) {
                  return (
                    <div className="mt-3">
                      <p className="text-xs text-emerald-700 text-center bg-emerald-50 border border-emerald-200 rounded-lg py-2.5 px-3">
                        Pour toute nouvelle cotisation, prenez contact avec l'accueil
                      </p>
                    </div>
                  );
                }
                
                const hasExpiry = client?.subscription_expiry;
                const expiryDate = hasExpiry ? parseISO(client.subscription_expiry) : null;
                const isExpired = expiryDate && isBefore(expiryDate, new Date());
                const expiresWithin30Days = expiryDate && isBefore(expiryDate, addDays(new Date(), 30));
                const canPay = !hasExpiry || isExpired || expiresWithin30Days;
                
                return (
                  <div className="mt-3">
                    <Button 
                      className={`w-full h-9 text-sm ${canPay ? 'bg-primary hover:bg-primary/90' : 'bg-neutral-200 text-neutral-400 cursor-not-allowed'}`}
                      onClick={() => canPay && handlePaySubscription()}
                      disabled={!canPay || subscriptionPaymentLoading}
                      data-testid="pay-cotisation-button"
                    >
                      {subscriptionPaymentLoading ? (
                        <>
                          <Loader2 size={14} className="mr-1.5 animate-spin" />
                          Chargement...
                        </>
                      ) : (
                        <>
                          <Euro size={14} className="mr-1.5" />
                          {isExpired ? 'Renouveler ma cotisation' : 'Payer ma cotisation'}
                        </>
                      )}
                    </Button>
                    {!canPay && expiryDate && (
                      <p className="text-[10px] text-neutral-400 text-center mt-1.5">
                        Disponible à partir du {format(addDays(expiryDate, -30), 'd MMM yyyy', { locale: fr })}
                      </p>
                    )}
                  </div>
                );
              })()}
              
              {/* Carnet de cours - intégré dans la même section */}
              {(portalSettings?.show_carnet_cours !== false) && (portalSettings?.has_carnet || portalSettings?.carnet_total > 0) && (
                <div className="mt-3 pt-3 border-t border-neutral-100">
                  <h4 className="text-xs font-medium text-neutral-500 uppercase mb-1.5">Carnet de cours individuels</h4>
                  <div className="flex items-center justify-between">
                    <p className="text-lg font-bold text-neutral-900">
                      {portalSettings?.carnet_remaining ?? 0}h
                      <span className="text-xs font-normal text-neutral-400">
                        {' '}restantes
                      </span>
                    </p>
                  </div>
                  {(portalSettings?.carnet_remaining ?? 0) === 0 && (
                    <p className="text-xs text-amber-600 mt-1.5 p-1.5 bg-amber-50 rounded border border-amber-200">
                      Carnet épuisé. Les cours individuels seront payants.
                    </p>
                  )}
                </div>
              )}
            </div>
            )}
            
            {/* Infos Golf */}
            {(client?.handicap || client?.ffg_license) && (
              <div className="bg-white rounded-lg border p-3">
                <h4 className="text-xs font-medium text-neutral-500 uppercase mb-2">Infos golf</h4>
                <div className="grid grid-cols-2 gap-3">
                  {client?.handicap && (
                    <div>
                      <p className="text-[10px] text-neutral-400">Handicap</p>
                      <p className="text-sm font-medium">{client.handicap}</p>
                    </div>
                  )}
                  {client?.ffg_license && (
                    <div>
                      <p className="text-[10px] text-neutral-400">Licence FFGolf</p>
                      <p className="text-sm font-medium">{client.ffg_license}</p>
                    </div>
                  )}
                </div>
              </div>
            )}
            
            {/* Section Documents - visible si paramètre activé */}
            {(portalSettings?.show_documents !== false) && (
            <div className="bg-white rounded-lg border p-3">
              <div className="flex items-center justify-between mb-2">
                <h4 className="text-xs font-medium text-neutral-500 uppercase flex items-center gap-1.5">
                  <FileText size={12} />
                  Mes documents
                </h4>
              </div>
              
              {documentsLoading ? (
                <div className="flex items-center justify-center py-4">
                  <Loader2 size={16} className="animate-spin text-neutral-400" />
                </div>
              ) : documents.length > 0 ? (
                <div className="space-y-1.5">
                  {documents.map((doc) => (
                    <div 
                      key={doc.id} 
                      className="flex items-center justify-between py-2 px-2 bg-neutral-50 rounded hover:bg-neutral-100 transition-colors"
                      data-testid={`document-${doc.id}`}
                    >
                      <div className="flex items-center gap-2 min-w-0 flex-1">
                        <div className="w-8 h-8 rounded bg-emerald-100 flex items-center justify-center flex-shrink-0">
                          <FileText className="w-4 h-4 text-emerald-600" />
                        </div>
                        <div className="min-w-0">
                          <p className="text-xs font-medium truncate">{doc.name || doc.file_name || 'Document'}</p>
                          <p className="text-[10px] text-neutral-400">
                            {doc.created_at ? format(parseISO(doc.created_at), 'd MMM yyyy', { locale: fr }) : ''}
                            {doc.total_amount ? ` • ${doc.total_amount}€` : ''}
                          </p>
                        </div>
                      </div>
                      <Button
                        size="sm"
                        variant="ghost"
                        className="h-7 px-2 text-primary hover:bg-primary/10"
                        onClick={() => handleDownloadDocument(doc)}
                        data-testid={`download-document-${doc.id}`}
                      >
                        <Download size={14} />
                      </Button>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-xs text-neutral-400 text-center py-3">Aucun document disponible</p>
              )}
            </div>
            )}
            
            {/* Section Historique des paiements */}
            <div className="bg-white rounded-lg border p-3">
              <div className="flex items-center justify-between mb-2">
                <h4 className="text-xs font-medium text-neutral-500 uppercase flex items-center gap-1.5">
                  <CreditCard size={12} />
                  Historique des paiements
                </h4>
                <Button
                  size="sm"
                  variant="ghost"
                  className="h-6 px-2 text-[10px]"
                  onClick={loadPaymentHistory}
                  disabled={paymentHistoryLoading}
                >
                  <RefreshCw size={10} className={paymentHistoryLoading ? 'animate-spin' : ''} />
                </Button>
              </div>
              
              {paymentHistoryLoading ? (
                <div className="flex items-center justify-center py-4">
                  <Loader2 size={16} className="animate-spin text-neutral-400" />
                </div>
              ) : paymentHistory.length > 0 ? (
                <div className="space-y-1.5 max-h-96 overflow-y-auto">
                  {paymentHistory.map((payment) => {
                    const typeStyles = {
                      cotisation: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Cotisation' },
                      pack: { bg: 'bg-teal-100', text: 'text-teal-700', label: 'Pack cours' },
                      competition: { bg: 'bg-purple-100', text: 'text-purple-700', label: 'Compétition' },
                      stage: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Stage' },
                      fitting: { bg: 'bg-pink-100', text: 'text-pink-700', label: 'Fitting' },
                      pos_receipt: { bg: 'bg-orange-100', text: 'text-orange-700', label: 'Caisse' },
                      sponsor_credit: { bg: 'bg-[#fdfcf6]', text: 'text-[#8a6d1e]', label: 'Parrainage' },
                    };
                    const baseStyle = typeStyles[payment.type] || { bg: 'bg-neutral-100', text: 'text-neutral-700', label: payment.type };
                    const style = payment.is_deposit ? { ...baseStyle, bg: 'bg-sky-100', text: 'text-sky-700', label: 'Acompte' } : payment.is_deposit_recognition ? { ...baseStyle, label: 'Facture' } : baseStyle;
                    const isSponsor = payment.type === 'sponsor_credit';
                    const isPos = payment.type === 'pos_receipt';

                    // Ouvre la facture pro A4 (ou le reçu 80 mm) dans un nouvel onglet (blob URL avec auth token)
                    const openDoc = (docUrl, label) => async (e) => {
                      e.stopPropagation();
                      try {
                        const token = localStorage.getItem('client_portal_token') || localStorage.getItem('access_token');
                        const res = await fetch(`${API_URL}${docUrl}`, {
                          headers: { Authorization: `Bearer ${token}` },
                        });
                        if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.detail || `${label} indisponible`); }
                        const blob = await res.blob();
                        const url = URL.createObjectURL(blob);
                        window.open(url, '_blank', 'noopener');
                        setTimeout(() => URL.revokeObjectURL(url), 60000);
                      } catch (err) {
                        toast.error(err.message || `Impossible d'ouvrir ${label.toLowerCase()}`);
                      }
                    };
                    const openInvoice = openDoc(payment.invoice_url, 'Facture');
                    const openTicket = openDoc(payment.ticket_url, 'Reçu');

                    return (
                      <div 
                        key={payment.id} 
                        className={`flex items-center justify-between py-2 px-2 rounded transition-colors ${
                          isSponsor
                            ? 'bg-[#fdfcf6] border border-[#d4a850]/40 hover:bg-[#faf6e8]'
                            : isPos
                            ? 'bg-orange-50 border border-orange-200 hover:bg-orange-100'
                            : 'bg-neutral-50 hover:bg-neutral-100'
                        }`}
                        data-testid={`payment-${payment.id}`}
                      >
                        <div className="flex items-center gap-2 min-w-0 flex-1">
                          <div className={`w-8 h-8 rounded ${style.bg} flex items-center justify-center flex-shrink-0`}>
                            {isSponsor ? (
                              <Gift className={`w-4 h-4 ${style.text}`} />
                            ) : isPos ? (
                              <Receipt className={`w-4 h-4 ${style.text}`} />
                            ) : (
                              <CreditCard className={`w-4 h-4 ${style.text}`} />
                            )}
                          </div>
                          <div className="min-w-0">
                            <p className="text-xs font-medium truncate">{payment.product}</p>
                            <div className="flex items-center gap-1.5">
                              <span className={`text-[9px] px-1.5 py-0.5 rounded ${style.bg} ${style.text}`}>
                                {style.label}
                              </span>
                              {isPos && payment.receipt_number && (
                                <span className="text-[9px] text-neutral-400 font-mono">
                                  N° {payment.receipt_number}
                                </span>
                              )}
                              <span className="text-[10px] text-neutral-400">
                                {payment.date ? format(parseISO(payment.date), 'd MMM yyyy', { locale: fr }) : ''}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="text-right flex-shrink-0 ml-2 flex items-center gap-2">
                          <div>
                          {isSponsor && payment.months ? (
                            <>
                              <p className="text-sm font-semibold text-[#b78a1e]">+{payment.months} mois</p>
                              <p className="text-[9px] text-[#8a6d1e] flex items-center justify-end gap-0.5">
                                <Gift size={8} />
                                Crédité
                              </p>
                            </>
                          ) : (
                            <>
                              <p className={`text-sm font-semibold ${isSponsor ? 'text-[#b78a1e]' : isPos ? 'text-orange-700' : 'text-emerald-600'}`}>
                                {isSponsor && payment.amount != null ? `+${payment.amount.toFixed(2)}€` : `${payment.amount}€`}
                              </p>
                              <p className={`text-[9px] flex items-center justify-end gap-0.5 ${isSponsor ? 'text-[#8a6d1e]' : isPos ? 'text-orange-500' : 'text-emerald-500'}`}>
                                {isSponsor ? <Gift size={8} /> : <Check size={8} />}
                                {isSponsor ? 'Crédité' : 'Payé'}
                              </p>
                            </>
                          )}
                          </div>
                          {isPos && payment.invoice_url && (
                            <button
                              type="button"
                              onClick={openInvoice}
                              className="p-1.5 rounded-md bg-emerald-600 hover:bg-emerald-700 text-white text-[10px] font-semibold flex items-center gap-1 flex-shrink-0"
                              title="Télécharger ma facture (PDF)"
                              data-testid={`client-invoice-btn-${payment.id}`}
                            >
                              <FileText size={11} />
                              Facture
                            </button>
                          )}
                          {isPos && !payment.invoice_url && payment.ticket_url && (
                            <button
                              type="button"
                              onClick={openTicket}
                              className="p-1.5 rounded-md border border-emerald-500 text-emerald-800 bg-white hover:bg-emerald-50 text-[10px] font-semibold flex items-center gap-1 flex-shrink-0"
                              title={payment.is_deposit ? "Reçu d'acompte (PDF) — la facture sera disponible après votre venue" : "Reçu de paiement (PDF) — la facture sera disponible dès l'enregistrement du règlement par l'accueil"}
                              data-testid={`client-receipt-btn-${payment.id}`}
                            >
                              <FileText size={11} />
                              Reçu
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="text-xs text-neutral-400 text-center py-3">Aucun paiement enregistré</p>
              )}
            </div>

            {/* Installation PWA — affiché seulement si non-installé */}
            {!isPwaInstalled && (installPromptEvent || iosNeedsPwa) && (
              <div className="bg-gradient-to-r from-emerald-50 to-emerald-100/50 rounded-lg border border-emerald-200 p-3" data-testid="pwa-install-card">
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-start gap-2 flex-1 min-w-0">
                    <div className="w-9 h-9 bg-emerald-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Smartphone className="w-5 h-5 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm font-semibold text-emerald-900">Installez l'application</h4>
                      <p className="text-[11px] text-emerald-800/80 mt-0.5 leading-snug">
                        Accès rapide depuis votre écran d'accueil + notifications push pour vos factures et prélèvements SEPA.
                      </p>
                    </div>
                  </div>
                  {installPromptEvent ? (
                    <button
                      onClick={triggerInstallPwa}
                      className="bg-emerald-600 hover:bg-emerald-700 text-white text-xs px-3 py-2 rounded-lg font-semibold flex-shrink-0 flex items-center gap-1"
                      data-testid="pwa-install-btn"
                    >
                      <Download size={12} />
                      Installer
                    </button>
                  ) : iosNeedsPwa ? (
                    <button
                      onClick={() => {
                        toast.info(
                          'Pour installer sur iPhone/iPad :\n1. Appuyez sur Partager (icône en bas)\n2. Sélectionnez "Sur l\'écran d\'accueil"',
                          { duration: 12000 }
                        );
                      }}
                      className="bg-emerald-600 hover:bg-emerald-700 text-white text-xs px-3 py-2 rounded-lg font-semibold flex-shrink-0 flex items-center gap-1"
                      data-testid="pwa-install-instructions-btn"
                    >
                      <Share size={12} />
                      Voir
                    </button>
                  ) : null}
                </div>
              </div>
            )}
            
            {/* Changer mot de passe - visible si paramètre activé */}
            {(portalSettings?.show_password_change !== false) && (
            <div className="bg-white rounded-lg border p-3">
              <h4 className="text-xs font-medium text-neutral-500 uppercase mb-2">Sécurité</h4>
              
              {!showPasswordChange ? (
                <Button 
                  variant="outline"
                  className="w-full h-9 text-sm"
                  onClick={() => setShowPasswordChange(true)}
                  data-testid="change-password-toggle"
                >
                  <Lock size={14} className="mr-1.5" />
                  Changer mon mot de passe
                </Button>
              ) : (
                <div className="space-y-2">
                  <Input
                    type="password"
                    placeholder="Mot de passe actuel"
                    value={passwordForm.current}
                    onChange={(e) => setPasswordForm({ ...passwordForm, current: e.target.value })}
                    className="h-9 text-sm"
                    data-testid="current-password-input"
                  />
                  <Input
                    type="password"
                    placeholder="Nouveau mot de passe"
                    value={passwordForm.newPassword}
                    onChange={(e) => setPasswordForm({ ...passwordForm, newPassword: e.target.value })}
                    className="h-9 text-sm"
                    data-testid="new-password-input"
                  />
                  <Input
                    type="password"
                    placeholder="Confirmer le nouveau mot de passe"
                    value={passwordForm.confirm}
                    onChange={(e) => setPasswordForm({ ...passwordForm, confirm: e.target.value })}
                    className="h-9 text-sm"
                    data-testid="confirm-password-input"
                  />
                  <div className="flex gap-2">
                    <Button 
                      variant="outline"
                      size="sm"
                      className="flex-1 h-8 text-xs"
                      onClick={() => {
                        setShowPasswordChange(false);
                        setPasswordForm({ current: '', newPassword: '', confirm: '' });
                      }}
                    >
                      Annuler
                    </Button>
                    <Button 
                      size="sm"
                      className="flex-1 h-8 text-xs bg-primary hover:bg-primary/90"
                      onClick={handleChangePassword}
                      disabled={!passwordForm.current || !passwordForm.newPassword || passwordForm.newPassword !== passwordForm.confirm}
                      data-testid="submit-password-change"
                    >
                      Confirmer
                    </Button>
                  </div>
                </div>
              )}
            </div>
            )}
            
            {/* Bouton de déconnexion */}
            <button 
              className="w-full h-10 text-sm font-semibold rounded-2xl flex items-center justify-center gap-2"
              style={{ color: '#EF4444', backgroundColor: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.15)' }}
              onClick={handleLogout}
              data-testid="mobile-logout-button"
            >
              <LogOut size={16} />
              Se déconnecter
            </button>
          </div>
        )}
      </main>

      {/* Session Detail Modal - Optimisé mobile */}
      <Dialog open={showSessionModal} onOpenChange={setShowSessionModal}>
        <DialogContent className="max-w-sm sm:max-w-md mx-2 sm:mx-4 rounded-xl max-h-[85vh] overflow-y-auto p-4 sm:p-6 bg-white border border-neutral-200 shadow-xl" data-testid="session-detail-modal">
          <DialogHeader className="pb-2">
            <DialogTitle className="text-base sm:text-lg leading-tight">{selectedSession?.course_name}</DialogTitle>
            <DialogDescription className="text-xs">Détails du cours</DialogDescription>
          </DialogHeader>
          
          {selectedSession && (
            <div className="space-y-2 sm:space-y-3">
              {/* Date & Heure en ligne sur mobile */}
              <div className="flex gap-2">
                <div className="flex-1 flex items-center gap-2 p-2 sm:p-3 bg-neutral-50 rounded-lg">
                  <Calendar className="w-4 h-4 text-primary shrink-0" />
                  <div className="min-w-0">
                    <p className="text-[10px] text-neutral-500">Date</p>
                    <p className="font-medium text-xs sm:text-sm truncate">
                      {format(parseISO(selectedSession.datetime), 'EEE d MMM', { locale: fr })}
                    </p>
                  </div>
                </div>
                
                <div className="flex-1 flex items-center gap-2 p-2 sm:p-3 bg-neutral-50 rounded-lg">
                  <Clock className="w-4 h-4 text-primary shrink-0" />
                  <div className="min-w-0">
                    <p className="text-[10px] text-neutral-500">Horaire</p>
                    <p className="font-medium text-xs sm:text-sm truncate">
                      {format(parseISO(selectedSession.datetime), 'HH:mm')} • {formatDuration(selectedSession.duration_minutes)}
                    </p>
                  </div>
                </div>
              </div>
              
              {/* Prof & Places en ligne */}
              <div className="flex gap-2">
                {selectedSession.employee_name && (
                  <div className="flex-1 flex items-center gap-2 p-2 sm:p-3 bg-neutral-50 rounded-lg">
                    <div 
                      className="w-6 h-6 sm:w-8 sm:h-8 rounded-full flex items-center justify-center text-white text-xs font-medium shrink-0"
                      style={{ backgroundColor: selectedSession.employee_color || '#1B8066' }}
                    >
                      {selectedSession.employee_name.charAt(0)}
                    </div>
                    <div className="min-w-0">
                      <p className="text-[10px] text-neutral-500">Prof</p>
                      <p className="font-medium text-xs sm:text-sm truncate">{selectedSession.employee_name}</p>
                    </div>
                  </div>
                )}
                
                {selectedSession.course_type !== 'individuel' && (
                  <div className="flex-1 flex items-center gap-2 p-2 sm:p-3 bg-neutral-50 rounded-lg">
                    <Users className="w-4 h-4 text-primary shrink-0" />
                    <div className="min-w-0 flex-1">
                      <p className="text-[10px] text-neutral-500">Disponibilité</p>
                      <p className={`font-medium text-xs sm:text-sm ${selectedSession.max_participants && (selectedSession.registrations_count || 0) >= selectedSession.max_participants ? 'text-red-600' : 'text-emerald-600'}`}>
                        {selectedSession.max_participants && (selectedSession.registrations_count || 0) >= selectedSession.max_participants ? 'Complet' : 'Dispos'}
                      </p>
                    </div>
                  </div>
                )}
              </div>
              
              {/* Tarif */}
              <div className="flex items-center gap-2 p-2 sm:p-3 bg-primary/5 rounded-lg border border-primary/20">
                <Euro className="w-4 h-4 text-primary shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-[10px] text-neutral-500">Tarif</p>
                  {(() => {
                    const isIndiv = selectedSession.session_type === 'individuel' ||
                                   selectedSession.course_type === 'individuel' ||
                                   (selectedSession.course_name || '').toLowerCase().includes('indiv') ||
                                   (selectedSession.course_name || '').toLowerCase().includes('fitting');
                    if (selectedSession.is_free_for_client) {
                      return <p className="font-semibold text-primary text-sm">Gratuit pour vous</p>;
                    }
                    if (isIndiv && (!selectedSession.client_price && !selectedSession.price)) {
                      return <p className="font-semibold text-primary text-sm">Carnet ou paiement</p>;
                    }
                    if ((!selectedSession.client_price && !selectedSession.price) || (selectedSession.client_price === 0 || selectedSession.price === 0)) {
                      return <p className="font-semibold text-primary text-sm">Gratuit</p>;
                    }
                    // iter316.10 — Prix barré si yield appliqué
                    const effectivePrice = selectedSession.client_price ?? selectedSession.price;
                    const originalPrice = selectedSession.is_member_price
                      ? (selectedSession.original_member_price ?? selectedSession.original_price)
                      : (selectedSession.original_non_member_price ?? selectedSession.original_price);
                    const hasYield = selectedSession.yield_applied && originalPrice && originalPrice > effectivePrice;
                    return (
                      <div className="flex items-baseline gap-2 flex-wrap" data-testid="session-modal-tarif">
                        {hasYield && (
                          <span className="text-xs text-neutral-400 line-through" data-testid="session-modal-original-price">{originalPrice}€</span>
                        )}
                        <span className="font-semibold text-primary text-sm" data-testid="session-modal-effective-price">{effectivePrice}€</span>
                        {hasYield && selectedSession.yield_label && (
                          <span
                            className="text-[9px] uppercase tracking-[0.15em] font-medium px-1.5 py-0.5 rounded-sm"
                            style={{ color: '#B8860B', backgroundColor: 'rgba(212, 175, 55, 0.14)', border: '1px solid rgba(212, 175, 55, 0.4)' }}
                            data-testid="session-modal-yield-label"
                          >
                            {selectedSession.yield_label}
                          </span>
                        )}
                      </div>
                    );
                  })()}
                </div>
              </div>
              
              
              {/* Actions */}
              <div className="pt-2 sm:pt-3 border-t">
                {selectedSession.is_registered ? (
                  <div className="text-center p-3 bg-primary/5 rounded-lg">
                    <CheckCircle2 className="w-8 h-8 mx-auto text-primary mb-1" />
                    <p className="font-medium text-primary text-sm">Vous êtes inscrit</p>
                    <p className="text-xs text-neutral-500">Annulez si empêché</p>
                  </div>
                ) : (() => {
                  // Compter seulement les réservations de cours collectifs FUTURS (pas individuels, pas passés)
                  const now = new Date();
                  const collectiveReservationsCount = myRegistrations.filter(reg => {
                    const session = reg.session || {};
                    const sessionDate = session.datetime ? new Date(session.datetime) : null;
                    const isFuture = sessionDate && sessionDate > now;
                    const isIndividual = session.session_type === 'individuel' || 
                                        session.course_type === 'individuel' || 
                                        (session.course_name || '').toLowerCase().includes('indiv') ||
                                        session.max_participants === 1;
                    return isFuture && !isIndividual && reg.status !== 'cancelled';
                  }).length;
                  
                  return collectiveReservationsCount >= (portalSettings?.max_collective_reservations || 3) && selectedSession.is_free_for_client;
                })() ? (
                  <div className="text-center p-3 bg-amber-50 rounded-lg">
                    <AlertCircle className="w-8 h-8 mx-auto text-amber-500 mb-1" />
                    <p className="font-medium text-amber-700 text-sm">Limite de {portalSettings?.max_collective_reservations || 3} réservations cours collectifs atteinte</p>
                    <p className="text-xs text-neutral-500">Annulez-en une pour réserver</p>
                  </div>
                ) : selectedSession.max_participants && selectedSession.registrations_count >= selectedSession.max_participants ? (
                  <div className="text-center p-3 bg-red-50 rounded-lg">
                    <XCircle className="w-8 h-8 mx-auto text-red-500 mb-1" />
                    <p className="font-medium text-red-700 text-sm">Cours complet</p>
                  </div>
                ) : (() => {
                  // Vérifier si c'est un cours individuel avec carnet disponible
                  const isIndividual = selectedSession.session_type === 'individuel' || 
                                       selectedSession.course_type === 'individuel' ||
                                       (selectedSession.course_name || '').toLowerCase().includes('indiv') ||
                                       (selectedSession.course_name || '').toLowerCase().includes('fitting');
                  const sessionHours = calcCarnetDebit(selectedSession.duration_minutes);
                  const carnetAvailable = (portalSettings?.carnet_remaining || 0) >= sessionHours;
                  
                  // Pour les cours individuels, toujours proposer carnet si dispo (même sans prix explicite)
                  if (isIndividual && carnetAvailable) {
                    return 'carnet';
                  }
                  // Cours gratuit (non individuel sans prix, ou explicitement gratuit)
                  if (selectedSession.is_free_for_client || (!isIndividual && (!selectedSession.client_price || selectedSession.client_price === 0))) {
                    return 'free';
                  }
                  // Cours payant
                  return 'paid';
                })() === 'carnet' ? (
                  /* Cours individuel + carnet disponible -> proposer les 2 options */
                  <div className="space-y-2">
                    <Button 
                      className="w-full h-10 sm:h-12 bg-teal-600 hover:bg-teal-700 text-sm sm:text-base font-medium" 
                      onClick={() => handleRegister(selectedSession, true)}
                      disabled={registerLoading}
                      data-testid="register-carnet-button"
                    >
                      {registerLoading ? (
                        <>
                          <Loader2 size={18} className="mr-2 animate-spin" />
                          Traitement...
                        </>
                      ) : (
                        <>
                          <BookOpen size={18} className="mr-2" />
                          Utiliser mon carnet (-{calcCarnetDebit(selectedSession.duration_minutes)}h sur {portalSettings?.carnet_remaining}h)
                        </>
                      )}
                    </Button>
                    {(selectedSession.client_price || selectedSession.price) ? (
                      <Button 
                        variant="outline"
                        className="w-full h-10 text-sm font-medium" 
                        onClick={() => handleRegister(selectedSession, false)}
                        disabled={registerLoading}
                        data-testid="register-pay-button"
                      >
                        <CreditCard size={16} className="mr-2" />
                        Payer {selectedSession.client_price ?? selectedSession.price}€
                      </Button>
                    ) : null}
                  </div>
                ) : (() => {
                  // Re-évaluer pour le rendu final
                  const isIndividual2 = selectedSession.session_type === 'individuel' || 
                                       selectedSession.course_type === 'individuel' ||
                                       (selectedSession.course_name || '').toLowerCase().includes('indiv') ||
                                       (selectedSession.course_name || '').toLowerCase().includes('fitting');
                  if (selectedSession.is_free_for_client || (!isIndividual2 && (!selectedSession.client_price || selectedSession.client_price === 0))) {
                    return 'free';
                  }
                  return 'paid';
                })() === 'free' ? (
                  /* Cours gratuit -> bouton d'inscription simple */
                  <Button 
                    className="w-full h-10 sm:h-12 bg-primary hover:bg-primary/90 text-sm sm:text-base font-medium" 
                    onClick={() => handleRegister(selectedSession, false)}
                    disabled={registerLoading}
                    data-testid="register-button"
                  >
                    {registerLoading ? (
                      <>
                        <Loader2 size={18} className="mr-2 animate-spin" />
                        Traitement...
                      </>
                    ) : (
                      <>
                        <CheckCircle2 size={18} className="mr-2" />
                        S&apos;inscrire
                      </>
                    )}
                  </Button>
                ) : (
                  /* Cours payant sans carnet -> paiement uniquement */
                  <Button 
                    className="w-full h-10 sm:h-12 bg-primary hover:bg-primary/90 text-sm sm:text-base font-medium" 
                    onClick={() => handleRegister(selectedSession, false)}
                    disabled={registerLoading}
                    data-testid="register-button"
                  >
                    {registerLoading ? (
                      <>
                        <Loader2 size={18} className="mr-2 animate-spin" />
                        Traitement...
                      </>
                    ) : (
                      <>
                        <CreditCard size={18} className="mr-2" />
                        Payer {selectedSession.client_price}€
                      </>
                    )}
                  </Button>
                )}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* ===== MODAL RÉSERVATION RESTAURANT ===== */}
      <Dialog open={showRestaurantReserve} onOpenChange={setShowRestaurantReserve}>
        <DialogContent className="max-w-sm p-0 overflow-hidden rounded-2xl" data-testid="restaurant-reserve-modal">
          <div className="bg-amber-600 px-5 py-4 text-white">
            <DialogTitle className="text-white text-lg font-bold flex items-center gap-2">
              <UtensilsCrossed size={20} /> Réserver une table
            </DialogTitle>
          </div>
          <div className="p-5 space-y-4">
            <div>
              <label className="text-xs font-medium text-neutral-500 uppercase mb-1.5 block">Date</label>
              <Input type="date" value={restaurantForm.date} min={format(new Date(), 'yyyy-MM-dd')}
                onChange={e => { setRestaurantForm({...restaurantForm, date: e.target.value, time: ''}); loadRestaurantSlots(e.target.value); }}
                className="h-10" data-testid="restaurant-date" />
            </div>
            {restaurantForm.date && (
              <div>
                <label className="text-xs font-medium text-neutral-500 uppercase mb-1.5 block">Créneau</label>
                {restaurantLoading ? <Loader2 className="animate-spin mx-auto" size={20} /> : (
                  restaurantSlots.length === 0 ? (
                    <p className="text-sm text-neutral-400 text-center py-2">Aucun créneau disponible</p>
                  ) : (
                    <div className="grid grid-cols-4 gap-1.5">
                      {restaurantSlots.map(s => (
                        <button key={s} onClick={() => setRestaurantForm({...restaurantForm, time: s})}
                          className={`py-2 rounded-lg text-sm font-medium transition-all ${restaurantForm.time === s ? 'bg-amber-600 text-white' : 'bg-neutral-100 text-neutral-700 hover:bg-amber-50'}`}
                          data-testid={`slot-${s}`}>{s}</button>
                      ))}
                    </div>
                  )
                )}
              </div>
            )}
            <div>
              <label className="text-xs font-medium text-neutral-500 uppercase mb-1.5 block">Nombre de couverts</label>
              <div className="flex items-center gap-3">
                <button onClick={() => setRestaurantForm({...restaurantForm, covers: Math.max(1, restaurantForm.covers - 1)})}
                  className="w-9 h-9 rounded-full bg-neutral-100 flex items-center justify-center text-lg font-bold">-</button>
                <span className="text-xl font-bold w-8 text-center">{restaurantForm.covers}</span>
                <button onClick={() => setRestaurantForm({...restaurantForm, covers: Math.min(8, restaurantForm.covers + 1)})}
                  className="w-9 h-9 rounded-full bg-neutral-100 flex items-center justify-center text-lg font-bold">+</button>
              </div>
              {restaurantForm.covers >= 8 && (
                <p className="text-xs text-amber-600 mt-1.5">Au-delà de 8 couverts, merci de contacter l'accueil</p>
              )}
            </div>
            <div>
              <label className="text-xs font-medium text-neutral-500 uppercase mb-1.5 block">Note (optionnel)</label>
              <Input value={restaurantForm.note} onChange={e => setRestaurantForm({...restaurantForm, note: e.target.value})}
                placeholder="Allergies, demandes spéciales..." className="h-10" data-testid="restaurant-note" />
            </div>
            <Button className="w-full h-11 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-xl"
              onClick={handleRestaurantReserve} disabled={!restaurantForm.date || !restaurantForm.time || restaurantLoading}
              data-testid="confirm-reservation">
              {restaurantLoading ? <Loader2 size={16} className="animate-spin mr-2" /> : <UtensilsCrossed size={16} className="mr-2" />}
              Confirmer la réservation
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* ===== MODAL CARTE RESTAURANT (tableau à la craie) ===== */}
      <Dialog open={showRestaurantMenu} onOpenChange={setShowRestaurantMenu}>
        <DialogContent className="max-w-md max-h-[90vh] p-0 overflow-y-auto rounded-2xl border-0 [&>button]:hidden" data-testid="restaurant-menu-modal">
          <div style={{ 
            background: 'linear-gradient(145deg, #2d3a2d 0%, #1a2a1a 50%, #2d3a2d 100%)',
            fontFamily: "'Georgia', 'Palatino Linotype', 'Book Antiqua', serif",
            position: 'relative',
            minHeight: '400px'
          }}>
            {/* Chalk dust effect */}
            <div style={{ position: 'absolute', inset: 0, background: 'url("data:image/svg+xml,%3Csvg width=\'100\' height=\'100\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'n\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\'/%3E%3C/filter%3E%3Crect width=\'100\' height=\'100\' filter=\'url(%23n)\' opacity=\'0.03\'/%3E%3C/svg%3E")', opacity: 0.4, pointerEvents: 'none' }} />
            
            {/* Bouton Fermer - sticky */}
            <button onClick={() => setShowRestaurantMenu(false)}
              className="sticky top-2 float-right mr-3 mt-2 z-10 w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-colors"
              data-testid="close-menu-modal">
              <X size={18} className="text-white" />
            </button>

            <div className="relative px-6 py-5">
              {/* Logo + Title */}
              <div className="text-center mb-5">
                {portalSettings?.portal_logo?.data && (
                  <img src={`data:${portalSettings.portal_logo.content_type};base64,${portalSettings.portal_logo.data}`}
                    alt="Logo" className="h-14 w-auto object-contain mx-auto mb-3 drop-shadow-lg" style={{ filter: 'brightness(1.5) contrast(0.9)' }} />
                )}
                <h2 className="text-2xl font-bold text-white tracking-wide" style={{ textShadow: '0 0 8px rgba(255,255,255,0.15)', letterSpacing: '0.05em' }}>
                  La Carte
                </h2>
                <div className="w-24 h-0.5 bg-amber-400/50 mx-auto mt-2 rounded-full" />
              </div>

              {/* Suggestions */}
              {restaurantMenuData?.suggestions?.length > 0 && (
                <div className="mb-5">
                  <h3 className="text-amber-300 text-lg mb-2 text-center italic" style={{ textShadow: '0 0 6px rgba(251,191,36,0.2)' }}>
                    Suggestions du jour
                  </h3>
                  <div className="space-y-2">
                    {restaurantMenuData.suggestions.map((s, i) => (
                      <div key={i} className="flex justify-between items-baseline px-2">
                        <span className="text-white text-sm font-medium">{s.name}</span>
                        {s.price && <span className="text-amber-300 text-sm font-semibold ml-2">{s.price}</span>}
                      </div>
                    ))}
                  </div>
                  <div className="border-b border-white/10 mt-4" />
                </div>
              )}

              {/* Categories */}
              {restaurantMenuData?.categories?.map((cat, ci) => (
                <div key={ci} className="mb-5">
                  <h3 className="text-amber-200 text-base font-semibold mb-2 text-center uppercase tracking-widest">
                    {cat.name}
                  </h3>
                  <div className="space-y-2">
                    {(cat.items || []).map((item, ii) => (
                      <div key={ii} className="px-2">
                        <div className="flex justify-between items-baseline">
                          <span className="text-white text-sm font-medium">{item.name}</span>
                          {item.price && <span className="text-amber-300 text-sm font-semibold ml-2">{item.price}</span>}
                        </div>
                        {item.description && <p className="text-white/60 text-xs mt-0.5 ml-1 italic">{item.description}</p>}
                      </div>
                    ))}
                  </div>
                </div>
              ))}

              {(!restaurantMenuData?.categories?.length && !restaurantMenuData?.suggestions?.length) && (
                <p className="text-white/40 text-center py-8 text-base">La carte n'est pas encore disponible</p>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* iter321 — Pop-up promotionnel saisonnier (1 seul actif, fréquence paramétrable) */}
      <PromoPopup
        endpoint={`${API_URL}/api/client-portal/promo-popup`}
        apiBase={API_URL}
        authToken={token}
        placement="portal"
        onNavigate={(url, popup) => handleDealNavigate({ ...popup, popup_url: url })}
        disabled={!token || arrivedForCotisation}
      />
      {pdfViewer && (
        <PortalPdfViewer url={pdfViewer.url} title={pdfViewer.title} onClose={() => setPdfViewer(null)} />
      )}

    </div>
  );
};

export default ClientPortal;
